// Pre-generated sample analyses for static deployment
// Preserves ALL analysis insights, reduces individual_scores from 18K+ to 50 total

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { AnalysisData } from '../types';

export const sampleAnalyses = [
  {
    "id": "mfl11yxlk00ubldv3",
    "generated_at": "2025-09-15T11:15:06.393Z",
    "name": "r/baseball Community Analysis",
    "description": "Sentiment analysis of baseball fans discussing games, players, and controversies on Reddit's premier baseball community.",
    "subreddits": [
      "baseball"
    ],
    "dateRange": {
      "startDate": "2025-09-08",
      "endDate": "2025-09-15"
    },
    "totalPosts": 19,
    "totalComments": 3135,
    "data": {
      "summary": {
        "totalPosts": 19,
        "totalComments": 3135,
        "subreddits": [
          "baseball"
        ],
        "dateRange": {
          "startDate": "2025-09-08",
          "endDate": "2025-09-15"
        }
      },
      "analysis": {
        "overall_sentiment": {
          "average_score": 0.45,
          "sentiment_distribution": {
            "positive": 60,
            "neutral": 25,
            "negative": 15
          },
          "dominant_themes": [
            "game",
            "team",
            "player",
            "season",
            "win",
            "loss",
            "stats",
            "trade",
            "draft",
            "stadium"
          ],
          "key_emotions": [
            "excitement",
            "passion",
            "competitive",
            "proud",
            "frustrated",
            "hopeful"
          ],
          "summary": "The overall sentiment is positive (positive 45%). Key themes include: criticism, humor, baseball."
        },
        "individual_scores": [
          {
            "index": 1,
            "score": -0.6,
            "sentiment": "negative",
            "confidence": 0.8,
            "themes": [
              "disrespect",
              "rudeness",
              "conflict"
            ],
            "emotions": [],
            "source": {
              "type": "post_title",
              "postId": "1ngjmh0",
              "subreddit": "baseball"
            }
          },
          {
            "index": 2,
            "score": 0.2,
            "sentiment": "neutral",
            "confidence": 0.9,
            "themes": [
              "moderation",
              "community",
              "rules"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1ngjmh0",
              "commentId": "ne4ucyh",
              "subreddit": "baseball"
            }
          },
          {
            "index": 3,
            "score": -0.7,
            "sentiment": "negative",
            "confidence": 0.85,
            "themes": [
              "behavior",
              "attitude",
              "criticism"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1ngjmh0",
              "commentId": "ne4hf2k",
              "subreddit": "baseball"
            }
          },
          {
            "index": 4,
            "score": -0.9,
            "sentiment": "negative",
            "confidence": 0.95,
            "themes": [
              "insult",
              "hostility"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1ngjmh0",
              "commentId": "ne4j3oc",
              "subreddit": "baseball"
            }
          },
          {
            "index": 5,
            "score": -0.8,
            "sentiment": "negative",
            "confidence": 0.9,
            "themes": [
              "anger",
              "dismissal",
              "hostility"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1ngjmh0",
              "commentId": "ne4kxnn",
              "subreddit": "baseball"
            }
          }
        ],
        "by_subreddit": {
          "baseball": {
            "scores": [
              -0.6,
              0.2,
              -0.7,
              -0.9,
              -0.8,
              -0.8,
              -0.5,
              -0.6,
              -0.4,
              -0.5,
              -0.7,
              -0.6,
              -0.9,
              -0.7,
              -0.6,
              -0.5,
              -0.9,
              -0.8,
              -0.6,
              -0.7,
              -0.7,
              -0.8,
              -0.7,
              -0.8,
              -0.7,
              -0.6,
              0.8,
              -0.5,
              -0.7,
              -0.5,
              0,
              -0.7,
              -0.7,
              -0.5,
              -0.7,
              -0.6,
              -0.7,
              -0.6,
              -0.5,
              -0.4,
              -0.7,
              -0.8,
              -0.7,
              -0.7,
              -0.6,
              -0.8,
              -0.7,
              -0.7,
              -0.8,
              -0.7,
              0.6,
              -0.6,
              -0.5,
              -0.4,
              -0.7,
              -0.3,
              -0.8,
              -0.7,
              -0.6,
              0.7,
              -0.8,
              -0.7,
              -0.2,
              0.1,
              -0.7,
              -0.3,
              -0.6,
              0.5,
              -0.9,
              -0.7,
              -0.4,
              -0.2,
              -0.5,
              -0.3,
              -0.4,
              -0.8,
              0.3,
              -0.1,
              -0.3,
              -0.7,
              -0.5,
              -0.7,
              0,
              -0.8,
              -0.6,
              -0.7,
              -0.7,
              0.6,
              -0.9,
              -0.5,
              -0.4,
              -0.6,
              -0.4,
              -0.8,
              -0.3,
              -0.7,
              -0.5,
              -0.7,
              -0.8,
              -0.5,
              -0.2,
              -0.4,
              -0.9,
              -0.3,
              0.6,
              -0.9,
              -0.8,
              -0.7,
              0.6,
              0.8,
              0.3,
              0.8,
              0.2,
              0,
              0.7,
              0.4,
              0.6,
              -0.5,
              -0.6,
              0.8,
              -0.8,
              -0.8,
              -0.6,
              -0.9,
              -0.4,
              0.2,
              -0.3,
              -0.5,
              -0.6,
              -0.2,
              -0.7,
              -0.3,
              0.4,
              -0.4,
              -0.6,
              -0.8,
              -0.7,
              -0.7,
              -0.6,
              -0.9,
              0.9,
              -0.6,
              0.1,
              0.2,
              -0.7,
              -0.3,
              -0.7,
              0.3,
              -0.7,
              0.4,
              0.2,
              -0.4,
              -0.3,
              0,
              -0.8,
              -0.3,
              -0.9,
              -0.4,
              -0.7,
              -0.5,
              -0.4,
              -0.1,
              -0.2,
              -0.8,
              0.6,
              0,
              0.1,
              0.7,
              -0.3,
              0.2,
              0.8,
              0.7,
              0.1,
              -0.2,
              0.3,
              0,
              0.1,
              0.2,
              0,
              -0.1,
              0.5,
              0,
              0,
              -0.1,
              0.4,
              -0.2,
              0.2,
              0.3,
              0,
              0.3,
              -0.3,
              -0.4,
              0.2,
              0,
              0.1,
              0.2,
              0.6,
              0.1,
              -0.3,
              -0.2,
              0.6,
              0.4,
              0.2,
              -0.3,
              -0.5,
              -0.6,
              -0.7,
              -0.2,
              -0.4,
              0.2,
              0.3,
              0.7,
              0.3,
              0.4,
              -0.5,
              0.3,
              -0.2,
              0.4,
              0.3,
              0.2,
              0.2,
              -0.3,
              0.1,
              0.4,
              0.8,
              0.5,
              0.3,
              0.2,
              0.4,
              0.3,
              0.7,
              0.3,
              0.4,
              0.3,
              0.3,
              0.4,
              0.2,
              0.2,
              0.4,
              0.2,
              0.5,
              -0.3,
              0.3,
              0.4,
              0.3,
              0,
              0.3,
              0.3,
              0.5,
              0.8,
              0.8,
              0.4,
              -0.2,
              0.1,
              0,
              0.4,
              0.3,
              0,
              0.5,
              0.4,
              0.8,
              -0.4,
              0.6,
              0.3,
              0,
              0.9,
              0.5,
              0.7,
              -0.3,
              0.7,
              0.2,
              -0.4,
              0.3,
              -0.3,
              -0.2,
              -0.3,
              0.1,
              0.4,
              0.7,
              0.3,
              0.4,
              0.6,
              0.8,
              0,
              0.2,
              0.3,
              0.4,
              0.5,
              -0.3,
              0.6,
              0,
              0,
              0.8,
              0.7,
              0,
              -0.3,
              0.4,
              0,
              0.2,
              0,
              0,
              -0.6,
              0.3,
              0.1,
              0.4,
              0,
              0,
              0.3,
              0.1,
              -0.2,
              0.8,
              0.7,
              0,
              0.6,
              0.7,
              0.5,
              0.8,
              -0.2,
              0.2,
              0.6,
              0.2,
              0.7,
              0.8,
              0,
              0.4,
              0.6,
              0,
              0,
              -0.4,
              -0.3,
              0,
              0,
              0.4,
              0.5,
              -0.1,
              0.2,
              0.3,
              -0.2,
              0.2,
              0,
              0,
              0.2,
              0.3,
              -0.3,
              0.2,
              0,
              -0.5,
              0.2,
              0.4,
              0.6,
              0.2,
              -0.3,
              0.6,
              0,
              0.4,
              0,
              0.8,
              -0.2,
              -0.4,
              -0.3,
              0.3,
              -0.2,
              -0.1,
              0.2,
              -0.2,
              0.1,
              -0.1,
              0,
              0.3,
              0,
              0,
              0.2,
              0.9,
              0.8,
              0.1,
              0.4,
              0.7,
              -0.2,
              0.8,
              -0.3,
              0.6,
              0.7,
              0.2,
              0.5,
              0,
              0,
              -0.1,
              0.4,
              0.2,
              -0.1,
              0,
              0.1,
              0.2,
              0.3,
              0.2,
              0.3,
              -0.2,
              0,
              0.8,
              -0.5,
              0.6,
              -0.4,
              -0.2,
              0.4,
              0,
              0.3,
              0.4,
              0.2,
              0.7,
              0.6,
              0.5,
              -0.6,
              -0.1,
              0.2,
              0.3,
              0.8,
              -0.3,
              0.4,
              0.3,
              0.2,
              -0.4,
              0.4,
              0.5,
              0.3,
              0.6,
              0.3,
              -0.2,
              0.6,
              -0.1,
              0.4,
              0.3,
              0.8,
              0.9,
              0.8,
              0.5,
              0.9,
              0,
              0.7,
              0.5,
              0.8,
              0.7,
              0.6,
              0.5,
              0.7,
              0.6,
              0.9,
              0.8,
              -0.5,
              0.6,
              0.7,
              0.8,
              0.7,
              0.9,
              0,
              0,
              0,
              -0.7,
              -0.5,
              0,
              0.6,
              0.3,
              0.4,
              0.2,
              0.4,
              -0.2,
              0.3,
              -0.5,
              0,
              0.6,
              0,
              0.8,
              0.5,
              0.6,
              0.8,
              0.2,
              -0.3,
              0.2,
              -0.1,
              -0.4,
              0.4,
              0.5,
              0,
              0,
              0.6,
              0.8,
              0.2,
              0,
              -0.1,
              0,
              -0.4,
              -0.7,
              0.2,
              0,
              -0.2,
              0.8,
              0.6,
              0.7,
              -0.3,
              -0.2,
              0.4,
              0.3,
              -0.2,
              0,
              0.4,
              -0.4,
              0.6,
              0.5,
              0.2,
              0.3,
              0,
              -0.2,
              0,
              -0.3,
              0.4,
              0.2,
              0.1,
              0,
              0.2,
              0.1,
              -0.1,
              0.8,
              0,
              -0.4,
              -0.5,
              -0.6,
              -0.5,
              -0.6,
              -0.7,
              -0.5,
              0.2,
              0,
              -0.2,
              -0.3,
              0,
              -0.2,
              -0.4,
              -0.5,
              -0.4,
              0.2,
              -0.3,
              -0.2,
              0.3,
              -0.3,
              -0.4,
              0.2,
              -0.2,
              -0.7,
              -0.5,
              -0.6,
              -0.3,
              0.7,
              0.8,
              0.6,
              0.7,
              0.8,
              0.6,
              -0.2,
              -0.1,
              0.1,
              0.2,
              -0.6,
              -0.7,
              -0.3,
              -0.4,
              0,
              0,
              0.1,
              0,
              -0.3,
              -0.5,
              0.3,
              0.7,
              0.4,
              0.5,
              0.3,
              0.6,
              0.7,
              -0.5,
              0.3,
              0.4,
              -0.2,
              -0.3,
              0.5,
              0.4,
              0,
              0.7,
              -0.6,
              -0.5,
              0.6,
              0.7,
              0.5,
              -0.4,
              0.7,
              0.3,
              -0.6,
              0,
              -0.2,
              0.2,
              0.1,
              -0.3,
              -0.2,
              -0.3,
              0.6,
              -0.4,
              0.4,
              0.5,
              -0.8,
              0,
              0.7,
              0.9,
              0.8,
              0.4,
              0.6,
              0.7,
              0.6,
              0.5,
              0,
              0.6,
              -0.5,
              0.8,
              0.3,
              0,
              0,
              0.7,
              0.8,
              0.4,
              0.8,
              0.2,
              -0.3,
              0.4,
              0.2,
              0.5,
              0.8,
              -0.3,
              0.3,
              0.6,
              -0.4,
              -0.2,
              0.5,
              0.6,
              0.8,
              0.7,
              -0.4,
              0.2,
              -0.5,
              -0.2,
              0.2,
              -0.3,
              -0.4,
              0.3,
              0.2,
              -0.3,
              0,
              -0.4,
              -0.8,
              -0.2,
              -0.6,
              0.3,
              -0.7,
              0.2,
              0.3,
              0,
              -0.3,
              0,
              -0.2,
              -0.1,
              0,
              -0.3,
              -0.5,
              -0.4,
              0,
              -0.2,
              -0.9,
              -0.7,
              -0.5,
              0,
              0.2,
              0.3,
              -0.4,
              0.4,
              0.5,
              0,
              0.3,
              0.7,
              0.4,
              0.2,
              0.6,
              0,
              -0.5,
              0,
              -0.2,
              -0.4,
              0.1,
              -0.6,
              0,
              -0.7,
              0,
              -0.2,
              0,
              0,
              -0.2,
              0.3,
              -0.3,
              -0.4,
              -0.2,
              -0.6,
              -0.3,
              0.4,
              0.2,
              -0.4,
              0.3,
              -0.5,
              0.4,
              0,
              0.6,
              0.2,
              0.1,
              0.2,
              0.3,
              0.4,
              0,
              0.7,
              0,
              0.1,
              0.2,
              0.5,
              0.6,
              0.4,
              0.4,
              0.3,
              0.1,
              0.2,
              0.3,
              -0.2,
              0.5,
              0.6,
              0.4,
              0.3,
              0.4,
              0.3,
              -0.3,
              0.4,
              0.3,
              0.2,
              0.3,
              0.2,
              0.3,
              0.2,
              0.4,
              0.3,
              -0.2,
              0.1,
              0.2,
              0,
              -0.3,
              0.4,
              -0.4,
              0.5,
              -0.3,
              0.2,
              -0.8,
              0.1,
              0.2,
              0.3,
              0.4,
              -0.2,
              0.4,
              0.3,
              -0.2,
              0.3,
              -0.4,
              -0.3,
              -0.4,
              0.2,
              0.1,
              0.2,
              -0.3,
              -0.4,
              0.1,
              -0.5,
              0.3,
              -0.2,
              0,
              0.1,
              0.7,
              0.6,
              0.6,
              0,
              0,
              0,
              0.2,
              0.5,
              -0.3,
              0,
              -0.1,
              0.6,
              0.3,
              0.3,
              0,
              0.1,
              0.3,
              0.1,
              -0.2,
              0.4,
              0.6,
              0.2,
              -0.3,
              0.1,
              0.5,
              0.7,
              0.2,
              -0.1,
              0.4,
              -0.2,
              -0.6,
              0.2,
              -0.2,
              0.4,
              0,
              0.6,
              0.3,
              0.5,
              0.4,
              -0.4,
              -0.3,
              0.5,
              0.1,
              0.4,
              0.3,
              -0.2,
              0.2,
              0.6,
              0.4,
              0.5,
              -0.4,
              0.3,
              0.5,
              0.7,
              -0.3,
              0,
              0.2,
              0.3,
              0.4,
              0.4,
              0.1,
              0.5,
              0.3,
              0.1,
              0.4,
              0.4,
              0.1,
              -0.2,
              0.2,
              0.4,
              0.3,
              0.6,
              0.5,
              0.4,
              0.5,
              0.3,
              -0.3,
              0.2,
              0.4,
              0.5,
              0.3,
              0,
              0.2,
              0.3,
              0.4,
              0.3,
              0,
              0.6,
              0.4,
              0.5,
              0.6,
              0.3,
              0.7,
              0.5,
              0.6,
              0,
              0.4,
              0.3,
              0.3,
              0,
              0.2,
              0.4,
              -0.3,
              0.8,
              -0.2,
              0.3,
              0.3,
              0,
              0.4,
              -0.3,
              0.9,
              0,
              0.6,
              0.8,
              0.7,
              0.5,
              -0.3,
              -0.1,
              0.8,
              0.1,
              0.2,
              0.4,
              0.7,
              0.1,
              0.3,
              0.4,
              0.5,
              0.8,
              0.6,
              0,
              0,
              -0.2,
              0,
              0.3,
              0.6,
              0.4,
              0.2,
              -0.2,
              -0.8,
              -0.7,
              -0.8,
              -0.6,
              0,
              -0.7,
              0,
              -0.5,
              -0.4,
              0.1,
              0.8,
              0.4,
              -0.4,
              0.2,
              0.9,
              0.6,
              0.8,
              0.7,
              0.6,
              0.8,
              0.8,
              0.7,
              0.8,
              0.8,
              0.7,
              0.8,
              0.9,
              0.9,
              0.8,
              0.9,
              0.3,
              0.8,
              0,
              0,
              0,
              0.4,
              0,
              0.6,
              -0.3,
              -0.4,
              -0.5,
              -0.7,
              0.6,
              0.9,
              0.5,
              0.7,
              0.6,
              0.7,
              0.6,
              0.7,
              0.5,
              0.3,
              0.3,
              0.8,
              0.2,
              0.8,
              0.7,
              0.8,
              0.9,
              0.6,
              0.9,
              0.2,
              0.7,
              0.3,
              0.8,
              0.8,
              0.2,
              -0.6,
              0.9,
              0.8,
              0.7,
              0.8,
              0.7,
              0.6,
              0.5,
              0.3,
              0.8,
              0.3,
              0.9,
              0.8,
              0.8,
              0.7,
              0.9,
              0.2,
              0.4,
              0.5,
              0.6,
              0.8,
              0.9,
              0.7,
              0.6,
              0.5,
              0.7,
              0.6,
              0,
              -0.2,
              0.7,
              0.8,
              0.8,
              0.8,
              0.8,
              0.9,
              0.9,
              0.8,
              0.6,
              0.8,
              0.8,
              0.7,
              0.8,
              0.8,
              0.7,
              0.8,
              0.7,
              0.7,
              0.8,
              0.6,
              0.8,
              0.3,
              0,
              0.7,
              -0.6,
              -0.3,
              0.4,
              -0.2,
              0.5,
              0.8,
              0.6,
              0.6,
              0,
              0,
              0.9,
              0.8,
              0.2,
              -0.8,
              -0.6,
              -0.4,
              -0.3,
              -0.2,
              0,
              0.2,
              0,
              -0.2,
              0.6,
              0.4,
              0.7,
              0.6,
              0.8,
              0.9,
              -0.7,
              0,
              0.6,
              -0.2,
              0.7,
              -0.3,
              0,
              -0.4,
              -0.3,
              0.3,
              0,
              -0.5,
              0,
              0.4,
              0.6,
              0.4,
              0.5,
              -0.8,
              -0.6,
              -0.5,
              0,
              -0.7,
              0.8,
              0.7,
              0.7,
              -0.6,
              -0.7,
              0.6,
              -0.5,
              -0.6,
              -0.6,
              0.2,
              -0.8,
              0.1,
              0.3,
              0,
              0.4,
              -0.2,
              -0.3,
              0.2,
              -0.1,
              0.3,
              -0.4,
              -0.8,
              -0.9,
              -0.8,
              -0.7,
              0.2,
              0.7,
              0,
              -0.9,
              0.6,
              0,
              -0.6,
              0,
              -0.2,
              -0.7,
              -0.8,
              -0.8,
              0.1,
              -0.8,
              -0.4,
              0.2,
              -0.6,
              0,
              -0.7,
              -0.8,
              -0.5,
              -0.6,
              -0.4,
              -0.5,
              -0.3,
              -0.4,
              -0.6,
              0.1,
              0.2,
              0.3,
              0.2,
              0.1,
              0.3,
              -0.3,
              0.4,
              -0.2,
              -0.6,
              0.4,
              0,
              0.3,
              -0.4,
              0.2,
              0.3,
              0.7,
              0,
              -0.8,
              0.2,
              0,
              0.8,
              -0.2,
              0.6,
              -0.3,
              0,
              -0.2,
              0,
              0,
              0,
              0,
              0.2,
              0.7,
              0.4,
              0.5,
              0.3,
              0,
              0.6,
              0.4,
              0.5,
              0.3,
              0.6,
              0.7,
              0.2,
              0.4,
              0,
              0.3,
              0,
              0.6,
              0,
              0.4,
              0.5,
              0.3,
              0.5,
              0,
              0.7,
              -0.2,
              0.3,
              0,
              0.2,
              0,
              0.4,
              -0.6,
              0.1,
              0.2,
              0.1,
              0,
              0,
              0,
              0.8,
              -0.3,
              -0.1,
              0.4,
              0.7,
              0.5,
              0.3,
              0.2,
              -0.7,
              0,
              0.2,
              0.3,
              0,
              0,
              0.6,
              0.2,
              0.1,
              0.2,
              0.9,
              0.5,
              0.1,
              0.4,
              0.8,
              0.6,
              -0.3,
              0.4,
              0.5,
              -0.6,
              -0.2,
              0.3,
              0.8,
              0.4,
              0.4,
              -0.7,
              0.8,
              0.3,
              0.5,
              0.2,
              0.6,
              0.4,
              0.3,
              -0.2,
              -0.4,
              0,
              -0.3,
              0,
              0,
              0,
              0.2,
              0.6,
              0.4,
              0.3,
              0.2,
              0.5,
              0.6,
              0.3,
              -0.2,
              0.7,
              -0.3,
              0.7,
              0.4,
              -0.1,
              -0.3,
              0.1,
              -0.4,
              0.2,
              -0.2,
              -0.3,
              -0.5,
              0.6,
              0,
              0,
              -0.4,
              0.3,
              -0.3,
              0.4,
              0.8,
              0.7,
              0.6,
              0.5,
              0.2,
              0.3,
              0.2,
              0.3,
              0.1,
              0,
              -0.6,
              0.6,
              0,
              0.3,
              -0.2,
              -0.5,
              -0.3,
              0.7,
              0.4,
              -0.4,
              0.3,
              0.2,
              0.6,
              -0.7,
              -0.2,
              0.3,
              0.4,
              -0.3,
              -0.1,
              -0.4,
              -0.6,
              0.7,
              -0.7,
              0.5,
              0.6,
              0.8,
              0.7,
              0.6,
              0.4,
              -0.8,
              0,
              -0.7,
              -0.8,
              -0.3,
              -0.6,
              0.3,
              -0.5,
              -0.4,
              -0.5,
              0.4,
              -0.2,
              -0.5,
              0.1,
              0.3,
              0.6,
              0.2,
              0.5,
              -0.7,
              0.8,
              0.1,
              0.2,
              0.2,
              -0.3,
              0.4,
              -0.4,
              0.1,
              0,
              -0.6,
              0.2,
              -0.5,
              -0.7,
              -0.2,
              0.3,
              0,
              0.4,
              0.6,
              0.8,
              0.3,
              0.2,
              0.4,
              0.1,
              0.2,
              -0.3,
              -0.8,
              -0.6,
              0.7,
              0.4,
              0.1,
              0.2,
              0,
              0.1,
              -0.3,
              -0.5,
              0.3,
              0.2,
              0,
              -0.1,
              -0.2,
              0.4,
              0.2,
              0.3,
              0.4,
              0.6,
              0,
              0.2,
              -0.1,
              -0.2,
              0.8,
              0,
              -0.3,
              -0.5,
              -0.4,
              0.1,
              -0.4,
              0.7,
              0.3,
              0.1,
              0.6,
              -0.2,
              0,
              0.3,
              -0.4,
              0.8,
              0.5,
              0.1,
              0,
              -0.1,
              -0.2,
              -0.5,
              -0.4,
              -0.6,
              -0.2,
              0.1,
              0,
              0.2,
              0,
              -0.3,
              0,
              0.3,
              -0.1,
              0,
              0.2,
              0.1,
              0.4,
              0.6,
              0,
              -0.1,
              0,
              0.7,
              0.3,
              0.8,
              0.7,
              0.4,
              -0.3,
              0.5,
              -0.4,
              -0.2,
              -0.5,
              -0.3,
              -0.6,
              -0.2,
              0.7,
              0.6,
              -0.4,
              -0.1,
              0.4,
              0.5,
              0.6,
              0.2,
              0.8,
              0.4,
              0.2,
              0.3,
              0.1,
              0.6,
              0.5,
              0.2,
              0.3,
              0.4,
              0.5,
              0.4,
              0.8,
              0.6,
              -0.3,
              0.9,
              0.7,
              0.8,
              0.7,
              0.8,
              0.4,
              -0.2,
              0.9,
              0,
              -0.4,
              0.3,
              0.5,
              0.8,
              0.6,
              0.2,
              0.7,
              0,
              0.7,
              0.3,
              0.5,
              0.6,
              0.7,
              0.8,
              0.7,
              0.4,
              0,
              0.7,
              0.8,
              0.9,
              0.8,
              0,
              0.8,
              0.7,
              0.9,
              0.8,
              -0.2,
              0.8,
              0.7,
              0.8,
              0.6,
              0.2,
              0.1,
              0.3,
              0,
              0.5,
              -0.1,
              -0.3,
              0,
              0.2,
              0.3,
              0,
              0.8,
              0.7,
              -0.3,
              0.4,
              0.1,
              0,
              0,
              -0.2,
              -0.3,
              0.7,
              0.3,
              0.8,
              0,
              0.4,
              0.1,
              -0.1,
              -0.3,
              0.6,
              -0.4,
              0,
              0.2,
              0,
              -0.2,
              -0.2,
              0,
              -0.7,
              0.2,
              0.6,
              0.7,
              0,
              0.8,
              0.4,
              0.5,
              0,
              0.3,
              0.2,
              0.1,
              0.2,
              0.7,
              -0.2,
              -0.3,
              -0.4,
              0.5,
              -0.5,
              0.2,
              0,
              0.2,
              -0.2,
              0.1,
              0,
              0,
              0,
              0.8,
              0.7,
              0.6,
              0.8,
              -0.4,
              0,
              -0.6,
              0.3,
              -0.7,
              -0.2,
              0.1,
              -0.8,
              -0.5,
              0.8,
              0.7,
              0.4,
              0.2,
              0.7,
              0.3,
              0.2,
              0.9,
              0.8,
              -0.7,
              0,
              -0.3,
              -0.4,
              0,
              0.3,
              0.4,
              0.2,
              0.8,
              0.3,
              0.4,
              0.6,
              0.1,
              0.2,
              0.3,
              0.1,
              -0.8,
              0.2,
              0.5,
              0,
              0.7,
              0.4,
              0.2,
              0,
              -0.6,
              0.9,
              0.8,
              0.3,
              0.4,
              0.6,
              0.8,
              0.5,
              0.9,
              0.7,
              0.6,
              0.4,
              0.9,
              0.4,
              0.6,
              0.7,
              0.5,
              -0.2,
              0.4,
              0.3,
              0.6,
              0.5,
              0.9,
              0.3,
              0.8,
              -0.4,
              0.2,
              0.3,
              0.2,
              0.8,
              -0.3,
              -0.4,
              0.2,
              -0.3,
              0.3,
              0.4,
              0.3,
              0,
              -0.5,
              -0.7,
              -0.4,
              -0.8,
              0.7,
              0.4,
              0.3,
              0.5,
              -0.6,
              0.6,
              0.2,
              0.6,
              0.3,
              0.4,
              0.5,
              0.2,
              0.3,
              0.7,
              0.6,
              0.8,
              0.1,
              0.7,
              -0.3,
              0.2,
              0.5,
              0,
              0.4,
              0.5,
              0.4,
              0.1,
              0.2,
              -0.4,
              -0.3,
              0.3,
              0,
              -0.2,
              0.5,
              0.8,
              0.4,
              -0.2,
              0.8,
              0.6,
              -0.1,
              0.2,
              -0.4,
              0.2,
              0,
              0.1,
              0,
              0.3,
              0.5,
              0.4,
              -0.2,
              0.4,
              0.6,
              0.5,
              0.7,
              0,
              0.4,
              -0.3,
              0.6,
              -0.4,
              -0.5,
              -0.3,
              -0.6,
              -0.7,
              -0.2,
              0.8,
              -0.5,
              -0.3,
              -0.2,
              -0.4,
              0,
              0,
              0.3,
              -0.2,
              -0.6,
              0.9,
              -0.7,
              0.4,
              0.6,
              0,
              0.7,
              0.3,
              0.4,
              0.4,
              -0.5,
              -0.7,
              -0.4,
              0.2,
              0.6,
              0,
              -0.4,
              0.2,
              0.8,
              -0.3,
              -0.5,
              -0.2,
              -0.4,
              -0.3,
              -0.2,
              0.6,
              0.8,
              -0.4,
              0.2,
              0.7,
              0.5,
              0.4,
              0.3,
              0.6,
              0.6,
              -0.4,
              0.3,
              0.1,
              0.2,
              0.1,
              -0.3,
              0.4,
              -0.2,
              0.3,
              -0.1,
              0,
              -0.3,
              -0.2,
              0.2,
              0.7,
              -0.1,
              0.2,
              -0.4,
              -0.2,
              0.6,
              0.4,
              -0.1,
              -0.1,
              -0.2,
              0.3,
              -0.4,
              -0.1,
              0.2,
              0.4,
              -0.3,
              -0.2,
              0.1,
              -0.5,
              0.4,
              -0.1,
              -0.2,
              0,
              0.3,
              -0.3,
              -0.2,
              -0.6,
              -0.4,
              0.2,
              0.4,
              0.5,
              0.1,
              -0.2,
              0.1,
              -0.3,
              -0.2,
              -0.3,
              -0.1,
              0.4,
              0.2,
              0,
              -0.1,
              -0.2,
              -0.4,
              0,
              -0.1,
              -0.2,
              -0.1,
              -0.3,
              -0.2,
              0,
              -0.1,
              -0.2,
              0.1,
              -0.1,
              -0.2,
              -0.3,
              -0.4,
              0.3,
              0.2,
              0.3,
              -0.3,
              0.1,
              -0.2,
              -0.2,
              0.2,
              0,
              0.6,
              0.2,
              0.4,
              0.1,
              0.2,
              0.7,
              0.1,
              0.4,
              -0.4,
              -0.3,
              -0.4,
              -0.2,
              -0.3,
              0.1,
              -0.1,
              -0.3,
              -0.2,
              -0.3,
              0.6,
              0.4,
              -0.7,
              -0.5,
              -0.4,
              -0.6,
              -0.8,
              -0.7,
              -0.2,
              0,
              0.4,
              0.3,
              0,
              -0.3,
              -0.4,
              -0.2,
              0.2,
              0.5,
              -0.3,
              0.2,
              0.3,
              0.4,
              0.7,
              -0.4,
              0.8,
              0.7,
              0.5,
              0.8,
              0.8,
              -0.5,
              -0.3,
              0.2,
              -0.2,
              0.7,
              -0.6,
              0,
              -0.5,
              -0.4,
              -0.3,
              0.6,
              -0.2,
              0,
              0.3,
              0.2,
              0.7,
              -0.2,
              0.3,
              0.2,
              0.4,
              0.3,
              -0.1,
              -0.3,
              0.4,
              -0.2,
              0,
              0.1,
              0,
              0.9,
              -0.2,
              -0.3,
              0.1,
              0.4,
              0.3,
              -0.1,
              0.2,
              0.2,
              0.1,
              0.8,
              0.1,
              0.2,
              0,
              0.3,
              0.5,
              0.2,
              0,
              0,
              -0.1,
              0.3,
              0.1,
              0.4,
              -0.5,
              0,
              -0.2,
              -0.4,
              -0.1,
              -0.3,
              -0.4,
              0.3,
              0.1,
              -0.3,
              -0.1,
              0.2,
              0.4,
              0.1,
              -0.2,
              -0.3,
              -0.4,
              -0.3,
              0.1,
              -0.2,
              -0.6,
              -0.2,
              0.4,
              -0.3,
              -0.4,
              0.3,
              0,
              0.1,
              0.4,
              -0.2,
              -0.5,
              -0.3,
              0.6,
              -0.7,
              0.5,
              0.2,
              0.3,
              0.4,
              0.1,
              -0.4,
              0.6,
              0.7,
              0.5,
              0,
              0.4,
              0.3,
              0.5,
              0.4,
              -0.3,
              0,
              0.2,
              0.6,
              0.5,
              0.1,
              -0.6,
              0.2,
              0.4,
              -0.4,
              0,
              0,
              0.3,
              0.7,
              0.4,
              0.3,
              -0.2,
              0.2,
              0.8,
              0.4,
              0.5,
              0.3,
              0.9,
              0.85,
              0.3,
              0.8,
              0.2,
              0.1,
              -0.2,
              0.1,
              0,
              -0.3,
              -0.4,
              -0.5,
              -0.1,
              0.1,
              -0.1,
              0.2,
              -0.2,
              -0.1,
              0.4,
              -0.2,
              -0.3,
              -0.4,
              0,
              -0.6,
              -0.3,
              -0.4,
              0.3,
              -0.2,
              0.4,
              0.2,
              0.3,
              0.1,
              -0.1,
              0.2,
              0.3,
              -0.4,
              0.4,
              0.1,
              0.3,
              -0.1,
              0,
              0.2,
              0.1,
              0,
              0.2,
              0.3,
              0.1,
              0.2,
              0.4,
              -0.3,
              0.2,
              -0.3,
              -0.4,
              0.8,
              0.6,
              0.5,
              0.3,
              0.4,
              0.6,
              -0.5,
              -0.6,
              -0.7,
              -0.8,
              0,
              -0.4,
              -0.2,
              0.1,
              -0.6,
              -0.3,
              -0.5,
              0,
              -0.6,
              0.5,
              -0.3,
              -0.5,
              -0.6,
              0.7,
              -0.4,
              0.3,
              -0.2,
              -0.4,
              -0.3,
              0.2,
              0.8,
              -0.5,
              0.1,
              0,
              -0.4,
              0.4,
              0.3,
              -0.4,
              -0.5,
              -0.6,
              -0.7,
              -0.3,
              0.2,
              -0.4,
              -0.6,
              0,
              0.7,
              0.2,
              0,
              0.1,
              -0.8,
              -0.3,
              0.1,
              -0.2,
              -0.2,
              -0.6,
              -0.4,
              -0.3,
              -0.2,
              -0.4,
              -0.5,
              -0.7,
              0,
              -0.3,
              0.3,
              0,
              -0.2,
              -0.1,
              -0.6,
              0.2,
              0.4,
              0.8,
              0.6,
              0.7,
              0.2,
              0.4,
              0.3,
              -0.3,
              -0.8,
              -0.2,
              0,
              0,
              0.2,
              0.1,
              0,
              -0.1,
              0.4,
              0.5,
              -0.3,
              0,
              0.1,
              0,
              0,
              0.6,
              0.4,
              0.7,
              0.8,
              -0.2,
              -0.3,
              0.6,
              0.4,
              0.3,
              0.5,
              0.4,
              0.3,
              0.4,
              0,
              0.4,
              -0.4,
              0.1,
              0,
              0.5,
              0.2,
              0.4,
              0.3,
              -0.2,
              0.6,
              0.8,
              0.4,
              0.5,
              0.7,
              0,
              0.6,
              0.7,
              0.3,
              0.4,
              0.5,
              0.3,
              0.8,
              0.4,
              -0.4,
              0.2,
              0.3,
              0.7,
              0.6,
              0.4,
              0.5,
              0.4,
              0.7,
              0.8,
              0,
              0.4,
              0.5,
              0.7,
              0.4,
              0.5,
              0.7,
              -0.2,
              -0.4,
              -0.3,
              -0.2,
              0.6,
              0.8,
              0.4,
              -0.5,
              -0.3,
              -0.7,
              0.4,
              -0.3,
              0.3,
              0.6,
              0.5,
              0.4,
              0.7,
              0.8,
              0.2,
              0.3,
              0.4,
              0.5,
              0.6,
              0.5,
              0.4,
              0.3,
              -0.2,
              -0.6,
              -0.4,
              0.4,
              0.5,
              0.3,
              0,
              -0.3,
              0.6,
              -0.2,
              0.3,
              0.5,
              0.4,
              0.2,
              -0.3,
              0.7,
              0.6,
              -0.1,
              0,
              0,
              0.1,
              -0.6,
              -0.4,
              -0.5,
              -0.6,
              -0.2,
              -0.4,
              -0.3,
              0.1,
              0,
              0,
              -0.7,
              -0.5,
              -0.6,
              -0.3,
              0.7,
              0.4,
              0.8,
              0.6,
              0.5,
              -0.4,
              -0.2,
              -0.1,
              -0.5,
              -0.8,
              -0.6,
              -0.5,
              0.1,
              -0.3,
              0.3,
              0.4,
              -0.6,
              -0.4,
              -0.5,
              -0.7,
              0.6,
              -0.3,
              -0.2,
              -0.5,
              -0.7,
              0.7,
              0.4,
              -0.2,
              0.3,
              -0.4,
              0.1,
              0.2,
              -0.5,
              -0.6,
              -0.7,
              -0.6,
              0,
              0.4,
              -0.3,
              -0.6,
              -0.7,
              -0.1,
              -0.3,
              -0.4,
              -0.2,
              0.8,
              0.2,
              0.4,
              0,
              -0.3,
              0,
              -0.4,
              0.1,
              0.3,
              0.2,
              0,
              0.2,
              -0.2,
              0.9,
              -0.1,
              0.8,
              0.3,
              -0.2,
              0.9,
              -0.6,
              -0.3,
              0.2,
              -0.4,
              -0.2,
              -0.8,
              -0.7,
              0,
              -0.6,
              -0.2,
              0,
              -0.3,
              -0.7,
              -0.2,
              0.1,
              -0.6,
              -0.4,
              -0.5,
              -0.4,
              -0.3,
              0.4,
              -0.3,
              0.2,
              0.7,
              0.6,
              -0.5,
              0,
              -0.2,
              -0.1,
              0.2,
              0,
              -0.2,
              0.4,
              0.3,
              0.5,
              -0.2,
              0.3,
              0.1,
              0.6,
              -0.4,
              -0.5,
              0.8,
              -0.2,
              0.7,
              0.6,
              0.8,
              -0.1,
              -0.2,
              0,
              0.7,
              0.6,
              -0.5,
              0.8,
              0.6,
              0.4,
              0.2,
              0,
              0.7,
              0.3,
              0.4,
              0.6,
              0.3,
              0.2,
              -0.2,
              0.7,
              0.4,
              0.3,
              -0.2,
              0.3,
              0.2,
              -0.4,
              0.3,
              0.8,
              -0.3,
              -0.2,
              0,
              0.5,
              -0.2,
              -0.3,
              0.6,
              0.4,
              0.2,
              0,
              -0.2,
              -0.1,
              0.7,
              -0.2,
              0.6,
              0.5,
              0.6,
              0.5,
              0.4,
              0.3,
              0,
              0.8,
              -0.3,
              0.4,
              0,
              0.6,
              0.1,
              -0.2,
              0.7,
              0.6,
              0.3,
              0,
              0.5,
              0.5,
              0.2,
              0.1,
              0.3,
              0.1,
              0.1,
              0,
              0.7,
              0.6,
              0.8,
              0.7,
              0.6,
              0.8,
              0,
              0.5,
              -0.2,
              0.1,
              0.4,
              0,
              0.6,
              0.9,
              0.3,
              0.5,
              0.1,
              -0.3,
              0.2,
              0.4,
              0.7,
              0.8,
              0.7,
              0.8,
              -0.5,
              0.7,
              0.6,
              0.2,
              0.3,
              -0.4,
              0.5,
              0.7,
              -0.2,
              -0.6,
              -0.8,
              0.3,
              0.2,
              -0.3,
              0.4,
              0.2,
              0.1,
              -0.4,
              0.7,
              0.8,
              0.4,
              0.8,
              0.6,
              0.9,
              0.8,
              0.9,
              0.3,
              0.2,
              0.6,
              0.5,
              0.7,
              -0.2,
              0.3,
              -0.1,
              0.4,
              0.2,
              -0.3,
              0.8,
              0.7,
              -0.5,
              0.8,
              0.7,
              0.8,
              0,
              0.8,
              0.9,
              0.6,
              0.2,
              0,
              0.1,
              0,
              0.3,
              0.2,
              0.3,
              0.2,
              0.1,
              0.4,
              0,
              0.2,
              -0.2,
              0.1,
              -0.1,
              -0.2,
              -0.4,
              0.1,
              0.6,
              0.7,
              0.8,
              0.7,
              0.6,
              0,
              0.3,
              0.9,
              0.8,
              -0.2,
              -0.1,
              -0.2,
              -0.5,
              0.3,
              0.8,
              0.9,
              0.8,
              0.7,
              0,
              0.8,
              -0.2,
              0.7,
              0.6,
              0.4,
              0.5,
              0.9,
              0.6,
              0.5,
              0.8,
              0.8,
              0.8,
              0.8,
              0.6,
              0.8,
              0.7,
              0.4,
              0.7,
              0.8,
              0.8,
              0.5,
              0.8,
              0.7,
              0.6,
              0.8,
              0.9,
              0.9,
              0.7,
              0,
              0.6,
              0.8,
              0,
              0,
              0.7,
              0.8,
              0,
              0.3,
              -0.3,
              -0.2,
              0.3,
              0,
              0.6,
              0,
              0.7,
              0.5,
              0.3,
              0.4,
              0.6,
              -0.4,
              0.7,
              0.6,
              0.4,
              0.7,
              0.8,
              0.7,
              0.8,
              0.6,
              0,
              0.3,
              -0.2,
              0.7,
              0.2,
              0.6,
              0.7,
              0.7,
              0.4,
              -0.4,
              0.5,
              -0.5,
              -0.3,
              0.4,
              -0.4,
              0,
              0.7,
              0.4,
              0.3,
              0.3,
              -0.5,
              0.6,
              0.7,
              0.4,
              0.8,
              -0.2,
              0.6,
              0.3,
              0.8,
              0.2,
              0,
              0.1,
              0.1,
              0,
              0.4,
              0.5,
              0.3,
              0.4,
              0.5,
              0.6,
              0.7,
              0.4,
              0,
              0.3,
              0.6,
              0.7,
              0.5,
              0.2,
              0.6,
              0.3,
              0.4,
              0.4,
              0.5,
              0.7,
              -0.6,
              0.3,
              0.4,
              0.5,
              0.6,
              0.4,
              0.2,
              0.8,
              0.7,
              0.5,
              0.8,
              -0.3,
              0.2,
              -0.8,
              0.3,
              -0.4,
              -0.6,
              -0.7,
              0.4,
              0.5,
              0.4,
              -0.5,
              0.8,
              0.6,
              0.7,
              0.6,
              0.7,
              0.6,
              0.5,
              0.7,
              0.4,
              0.6,
              0.7,
              0.6,
              -0.2,
              0.4,
              0.5,
              0.3,
              0.5,
              -0.6,
              0,
              -0.7,
              -0.3,
              0.2,
              0.4,
              -0.5,
              0.3,
              -0.6,
              0.4,
              0.5,
              0.6,
              0.7,
              0.8,
              -0.3,
              0.3,
              0.4,
              0.5,
              0.2,
              0.1,
              0.2,
              -0.4,
              0.5,
              0.9,
              0.8,
              0,
              0.9,
              0.7,
              0.4,
              0,
              0.8,
              0.7,
              -0.4,
              0.2,
              0.6,
              -0.6,
              -0.2,
              0.1,
              0,
              -0.7,
              -0.3,
              0.6,
              0.3,
              -0.8,
              -0.6,
              0.2,
              0.8,
              0.4,
              0.6,
              0.5,
              0.7,
              0,
              -0.7,
              0.3,
              0.1,
              0,
              0.1,
              0,
              0,
              0.1,
              0,
              0.2,
              -0.5,
              0.8,
              0.5,
              0.4,
              0,
              -0.3,
              0.8,
              0.7,
              0,
              -0.3,
              0.3,
              0,
              0,
              0.8,
              0,
              0.7,
              0,
              0.1,
              0.4,
              0.6,
              0.2,
              0,
              0.1,
              -0.2,
              0.6,
              0.8,
              0.8,
              -0.4,
              -0.2,
              0.7,
              0,
              0.7,
              0.9,
              0,
              0,
              0.8,
              0.4,
              -0.2,
              -0.1,
              -0.2,
              0.6,
              -0.4,
              -0.3,
              0.5,
              0.6,
              0.7,
              -0.3,
              0.4,
              -0.4,
              -0.2,
              0.1,
              0.1,
              0,
              0.5,
              0.6,
              0,
              -0.1,
              0,
              0.6,
              0.3,
              0.2,
              0.2,
              0.8,
              0.9,
              0.7,
              0.9,
              0.8,
              0.6,
              -0.3,
              -0.4,
              0,
              0.3,
              -0.2,
              0.4,
              -0.1,
              0.2,
              0,
              -0.2,
              -0.4,
              -0.1,
              -0.2,
              0.7,
              -0.6,
              -0.8,
              -0.5,
              -0.3,
              -0.7,
              -0.4,
              -0.2,
              0.1,
              0,
              -0.4
            ],
            "positive": 1297,
            "neutral": 742,
            "negative": 821,
            "mixed": null,
            "average_score": 0.1297038327526134,
            "total_analyzed": 2870
          }
        },
        "timeline": [
          {
            "date": "2025-09-08",
            "average_score": -0.016363636363636365,
            "positive": 57,
            "neutral": 43,
            "negative": 64,
            "total": 165
          },
          {
            "date": "2025-09-09",
            "average_score": 0.07717041800643087,
            "positive": 131,
            "neutral": 72,
            "negative": 108,
            "total": 311
          },
          {
            "date": "2025-09-10",
            "average_score": 0.0738003838771593,
            "positive": 205,
            "neutral": 161,
            "negative": 155,
            "total": 521
          },
          {
            "date": "2025-09-11",
            "average_score": 0.22461538461538466,
            "positive": 96,
            "neutral": 58,
            "negative": 40,
            "total": 195
          },
          {
            "date": "2025-09-12",
            "average_score": 0.3066473988439306,
            "positive": 187,
            "neutral": 101,
            "negative": 53,
            "total": 346
          },
          {
            "date": "2025-09-13",
            "average_score": 0.17017543859649126,
            "positive": 419,
            "neutral": 222,
            "negative": 213,
            "total": 855
          },
          {
            "date": "2025-09-14",
            "average_score": 0.03584905660377357,
            "positive": 202,
            "neutral": 85,
            "negative": 188,
            "total": 477
          }
        ],
        "ai_insights": {
          "baseball": "Here's my analysis of the sentiment and themes reflected in the r/baseball posts:\n\nOverall Community Mood and Attitudes:\nThe overall mood of the r/baseball community appears to be quite engaged and passionate, with a mix of positive, negative, and humorous sentiments. There is a clear appreciation for the game's exciting moments and human interest stories, as well as a critical eye towards controversies and perceived flaws in the sport and its organizations.\n\nCommon Themes, Concerns, and Topics of Interest:\n- Player conduct and character (e.g., Ken Rosenthal's behavior, Rizzo's charitable work)\n- Impressive individual performances and records (e.g., Kurtz's mammoth home run, Raleigh's power-hitting season)\n- Heartwarming fan interactions and sportsmanship (e.g., the Mets fan passing along a ball, kids returning a ball)\n- Issues with team management and ownership (e.g., the Angels' handling of an injured prospect)\n- Analysis and commentary on team and player performance (e.g., the Blue Jays announcer criticizing the Yankees)\n\nPatterns in Upvotes and Discussion:\n- Posts highlighting impressive athletic feats, heartwarming moments, and notable records tend to receive the most upvotes and engagement.\n- Discussions around player conduct, team management, and controversies also generate significant discussion, often with nuanced and critical takes.\n- The community seems particularly invested in discussing the human elements of the game, both positive and negative.\n\nEmerging Trends and Shifts in Opinion:\n- There appears to be a growing frustration with team owners and management, as evidenced by the comments regarding the Angels' handling of an injured prospect.\n- The community seems to be growing more critical of player conduct and incivility, with posts condemning Ken Rosenthal's behavior receiving strong support.\n- There is an appreciation for players and teams that prioritize charitable work and sportsmanship, as seen in the positive reactions to Rizzo's jersey and the Mets fan's gesture.\n\nPain Points and Frustrations:\n- Concerns about player conduct and lack of professionalism, as seen in the reactions to Ken Rosenthal's behavior.\n- Frustration with team owners and management, particularly in the case of the Angels and their handling of an injured prospect.\n- Disillusionment with the business side of the game and its impact on players and fans.\n\nOverall, the r/baseball community reflects a passionate, engaged, and discerning fan base that is deeply invested in the sport and its various facets. While they celebrate the game's exciting moments and human interest stories, they are also willing to critically examine the sport's issues and shortcomings, particularly when it comes to team management and player conduct."
        },
        "framework_analysis": {
          "success": true,
          "analysis": "**COMMUNITY PROFILING**\n\n• Community Type: Sports/Fan Community\n• Demographic Indicators: Male-dominated, baseball enthusiasts, mix of casual and hardcore fans\n• Emotional Baseline: Mixed cynical/supportive with strong humor component\n• Community Character: r/baseball shows a complex personality mixing deep baseball knowledge with humor and cynicism. The community values both athletic achievement and human interest stories, while maintaining a critical eye toward institutional behavior.\n\n**PATTERN DISCOVERY**\n\n🔍 Key Findings:\n\n1. Surprising Pattern #1:\n   High engagement posts often feature human elements (sportsmanship, personal moments) over pure athletic achievements\n\n2. Surprising Pattern #2:\n   Criticism of institutional behavior (teams, media) generates stronger engagement than game highlights\n\n3. Surprising Pattern #3:\n   Community shows consistent pattern of championing ethics and fairness, even when criticizing their own teams\n\n💬 Controversy Triggers:\n• Media personality behavior (Ken Rosenthal incident)\n• Team management decisions (Angels' handling of injured prospect)\n• Player treatment and healthcare issues\n• Fan behavior at games\n\n📊 Success/Failure Predictors:\n• Success indicators: Human interest angles, ethical stances, humor, shared baseball culture references\n• Failure indicators: Corporate/institutional defense, perceived unfairness, elitism\n\n**TEMPORAL ANALYSIS**\n\n⏰ Time-Based Patterns:\n\nDaily Cycles:\n• Morning: Lower engagement, factual content\n• Afternoon: Building engagement with game previews\n• Evening: Peak activity during games\n\nWeekly Trends:\n• Weekday evenings show highest engagement\n• Weekend afternoons see sustained activity\n• Post-game periods show highest comment velocity\n\nSentiment Evolution:\n• Overall positive trend (0.13 average) despite critical content\n• Stronger positive sentiment around personal achievement stories\n• Most negative around institutional criticism\n\n**KEY INSIGHTS**\n\n⭐ Most Important Discoveries:\n\n1. Engagement Correlation:\n   Posts combining criticism with humor receive highest engagement\n\n2. Unspoken Rules:\n   Community strongly values fairness and sportsmanship\n\n3. Influence Patterns:\n   Top comments often set emotional tone for entire threads\n\n4. Content Predictors:\n   Human interest stories consistently outperform pure statistics\n\n**ACTIONABLE RECOMMENDATIONS**\n\n📝 Content Strategy:\n• Best performing content types: Personal stories, ethical discussions, humorous moments\n• Optimal post structure: Clear title, immediate context, human element\n• Language style: Knowledgeable but accessible, humor-friendly\n\n⏱️ Timing Strategy:\n• Best posting times: Game-time and immediate post-game\n• Avoid posting: Early morning, non-game periods\n\n🚫 Topics to Avoid:\n• Corporate/institutional defense\n• Elitist takes on casual fans\n• Dismissal of player welfare concerns\n\n✅ Topics that Resonate:\n• Player personality moments\n• Community support stories\n• Historical baseball culture\n• Ethical discussions\n\n**QUESTIONS FOR DEEPER ANALYSIS**\n\n1. How does sentiment differ between team-specific vs. general baseball content?\n2. What role does humor play in mediating controversial topics?\n3. How do moderation patterns affect community tone?\n4. What impact do major events have on baseline sentiment?\n5. How do different types of criticism receive different responses?\n\n**SUMMARY**\n\n📋 Executive Summary:\nr/baseball demonstrates a sophisticated community balancing baseball expertise with strong ethical values and humor. The community shows highest engagement with content combining human interest elements with baseball knowledge, while maintaining critical awareness of institutional behavior. Positive sentiment (0.13 average) suggests a generally healthy community despite frequent criticism of baseball institutions.",
          "generated_at": "2025-09-15T10:56:34.633Z",
          "model_used": "Claude 3.5 Sonnet"
        },
        "synthetic_post": {
          "title": "Shohei Ohtani hits monster 487ft HR then strikes out the side in the 9th as Dodgers sweep the Cardinals",
          "author": "BaseballGuru2024",
          "body": "",
          "score": 12847,
          "upvoteRatio": 0.96,
          "comments": [
            {
              "id": "comment1",
              "author": "DodgerBro44",
              "body": "Just another casual day for baseball's final boss. We're all witnesses.",
              "score": 3244,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment2",
              "author": "CardinalsFan1908",
              "body": "Can't even be mad. Dude's not human.",
              "score": 2188,
              "replies": [],
              "level": 0,
              "sentiment": "neutral"
            },
            {
              "id": "comment3",
              "author": "StatHead",
              "body": "That's the longest HR at Busch Stadium since StatCast began tracking in 2015",
              "score": 1755,
              "replies": [],
              "level": 0,
              "sentiment": "neutral"
            },
            {
              "id": "comment4",
              "author": "BaseballHistory",
              "body": "First player to hit a 480+ ft HR and record a save in the same game since Babe Ruth in 1921",
              "score": 1544,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment5",
              "author": "MLBmemer",
              "body": "That poor baseball had a family",
              "score": 892,
              "replies": [],
              "level": 0,
              "sentiment": "humorous"
            },
            {
              "id": "comment6",
              "author": "WestCoastFan",
              "body": "Dodgers are actually scary this year. Their lineup is basically a video game team on easy mode.",
              "score": 756,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment7",
              "author": "BaseballPoetry",
              "body": "DH? Closer? Why not both?",
              "score": 644,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment8",
              "author": "EastCoastBall",
              "body": "Exit velo: 117.3 mph. Launch angle: 31°. Absolute missile.",
              "score": 522,
              "replies": [],
              "level": 0,
              "sentiment": "neutral"
            },
            {
              "id": "comment9",
              "author": "OldSchoolFan",
              "body": "Remember when people said he couldn't maintain this in LA? Pepperidge Farm remembers",
              "score": 488,
              "replies": [],
              "level": 0,
              "sentiment": "sarcastic"
            },
            {
              "id": "comment10",
              "author": "RandomFan123",
              "body": "The Cardinals broadcast booth went completely silent for like 10 seconds after that homer. Just pure awe.",
              "score": 412,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            }
          ],
          "subreddit": "baseball",
          "timeAgo": "4 hours ago",
          "sentiment": "positive",
          "generated_at": "2025-09-15T11:14:49.200Z",
          "version": 1
        }
      },
      "posts": [
        {
          "id": "1ngjmh0",
          "title": "Ken Rosenthal knocks over the camera man and gives him a stink eye as he refuses to help him up",
          "selftext": "",
          "score": 26592,
          "num_comments": 2502,
          "created_utc": 1757830443,
          "subreddit": "baseball",
          "permalink": "/r/baseball/comments/1ngjmh0/ken_rosenthal_knocks_over_the_camera_man_and/",
          "url": "https://v.redd.it/uv5oeqgeo2pf1",
          "author": "sir-lancelot_",
          "comments": [
            {
              "id": "ne4hf2k",
              "body": "The body language here from Ken is so bad.",
              "score": 8133,
              "created_utc": 1757830643,
              "author": "PA5997"
            },
            {
              "id": "ne4hxjy",
              "body": "The look of disgust on his face face is wild. Wasn’t his fault. He was just there to do his job",
              "score": 6203,
              "created_utc": 1757830915,
              "author": "cropdustu007"
            },
            {
              "id": "ne4j3oc",
              "body": "He’s such a bitch",
              "score": 5971,
              "created_utc": 1757831544,
              "author": "Outrageous_Bat1798"
            },
            {
              "id": "ne4j2lx",
              "body": "Talkin baseball and Trevor Plouffe have been on this for a long time that Mr. Bow tie is a high-strung prick. Which is so hard to take in because his on camera personality is the opposite. It reads as fake and moments like this one caught on camera tell the story.",
              "score": 5554,
              "created_utc": 1757831528,
              "author": "Correct_Tangelo_5422"
            }
          ]
        },
        {
          "id": "1nesmm2",
          "title": "[Highlight] Mickey Moniak’s crazy slide to avoid tag at 2nd vs Padres",
          "selftext": "",
          "score": 16823,
          "num_comments": 285,
          "created_utc": 1757647271,
          "subreddit": "baseball",
          "permalink": "/r/baseball/comments/1nesmm2/highlight_mickey_moniaks_crazy_slide_to_avoid_tag/",
          "url": "https://v.redd.it/7ki4kpvmjnof1",
          "author": "MLBOfficial",
          "comments": [
            {
              "id": "ndr6opw",
              "body": "Did Arraez’s back inadvertently help keep him on the base?",
              "score": 2379,
              "created_utc": 1757647527,
              "author": "sfan27"
            },
            {
              "id": "ndr6h8i",
              "body": "![gif](giphy|eIm624c8nnNbiG0V3g|downsized)",
              "score": 1297,
              "created_utc": 1757647443,
              "author": "buttwarmers"
            },
            {
              "id": "ndr8abo",
              "body": "Sure looks that way, superb body control to even get there though",
              "score": 971,
              "created_utc": 1757648177,
              "author": "6-pence"
            },
            {
              "id": "ndr6hjg",
              "body": "\\#1 overall pick skills",
              "score": 843,
              "created_utc": 1757647446,
              "author": "Timpa87"
            }
          ]
        },
        {
          "id": "1ng5pi7",
          "title": "Anthony Rizzo almost catches Moisés Ballesteros' first career home run, then says \"That's why I'm retired\"",
          "selftext": "",
          "score": 12724,
          "num_comments": 347,
          "created_utc": 1757789873,
          "subreddit": "baseball",
          "permalink": "/r/baseball/comments/1ng5pi7/anthony_rizzo_almost_catches_moisés_ballesteros/",
          "url": "https://v.redd.it/339i0yvobzof1",
          "author": "ArrogantWinner",
          "comments": [
            {
              "id": "ne1hr1p",
              "body": "The odds of that ball going directly to Rizz…unbelievable. Baseball is the best",
              "score": 4178,
              "created_utc": 1757790171,
              "author": "jogswithwolves"
            },
            {
              "id": "ne1h4q9",
              "body": "Even in retirement, Rizzo is giving the Cubs one last moment we will laugh about years from now.",
              "score": 1914,
              "created_utc": 1757789976,
              "author": "ProWrestlingPast"
            },
            {
              "id": "ne1hgjg",
              "body": "He thought he had a glove on, can’t do that barehanded!",
              "score": 872,
              "created_utc": 1757790079,
              "author": "manticore16"
            },
            {
              "id": "ne1h27b",
              "body": "How can you not be romantic about baseball?",
              "score": 796,
              "created_utc": 1757789954,
              "author": "fender-b-bender"
            }
          ]
        },
        {
          "id": "1nfopsk",
          "title": "PATRICK BAILEY WALKS OFF THE DODGERS ON A 10TH INNING GRAND SLAM",
          "selftext": "",
          "score": 9569,
          "num_comments": 695,
          "created_utc": 1757739316,
          "subreddit": "baseball",
          "permalink": "/r/baseball/comments/1nfopsk/patrick_bailey_walks_off_the_dodgers_on_a_10th/",
          "url": "https://v.redd.it/4mwx3dif5vof1",
          "author": "largeboobhaver",
          "comments": [
            {
              "id": "ndxzx1i",
              "body": "All dodgers fans expected this when they saw Scott on the bump",
              "score": 1686,
              "created_utc": 1757739338,
              "author": "Cuddling-Enthusiast"
            },
            {
              "id": "ndy008s",
              "body": "\"I felt a great disturbance in the Force, as if millions of Mets fans suddenly cried out in terror and were suddenly silenced\"",
              "score": 1322,
              "created_utc": 1757739380,
              "author": "Emperor_Cheeto21"
            },
            {
              "id": "ndy06cy",
              "body": "Getting walked off by the designated fielder is crazy work",
              "score": 1161,
              "created_utc": 1757739462,
              "author": "mansontaco"
            },
            {
              "id": "ndxzy5x",
              "body": "Good thing nothing controversial happened before this!",
              "score": 1115,
              "created_utc": 1757739352,
              "author": "Gorditalupasupreme"
            }
          ]
        },
        {
          "id": "1ndfxgr",
          "title": "Japanese impersonator Yoshiki Ideguchi, also known as \"Shohei Ohtanini,\" attended a Dodgers game. This is the first time he has appeared in the same photo as Ohtani, and it has become a hot topic.",
          "selftext": "",
          "score": 8923,
          "num_comments": 230,
          "created_utc": 1757514960,
          "subreddit": "baseball",
          "permalink": "/r/baseball/comments/1ndfxgr/japanese_impersonator_yoshiki_ideguchi_also_known/",
          "url": "https://i.redd.it/ox7thr4bmcof1.jpeg",
          "author": "ogasawarabaseball",
          "comments": [
            {
              "id": "ndgelvu",
              "body": "Ohtani’s so good, he can even play the role of spectator *while* he’s playing the game!",
              "score": 2366,
              "created_utc": 1757515279,
              "author": "UsErNaMeS_aR_DuMb"
            },
            {
              "id": "ndglgve",
              "body": "Tim Lincecum was drafted and came up with the Giants when I was a teenager. As soon as he made his debut, I had people in my life and randos on the streets of the East Bay tell me how much I looked like him. It was actually kind of ridiculous. My parents were having work done on the kitchen at some point, and I walked in the house after school, and the contractor took a look at me and dropped his ...",
              "score": 745,
              "created_utc": 1757517217,
              "author": "TheVich"
            },
            {
              "id": "ndgf8ld",
              "body": "Three-way player",
              "score": 743,
              "created_utc": 1757515457,
              "author": "hanchu21"
            },
            {
              "id": "ndgf5j4",
              "body": "“All those white people look alike”",
              "score": 481,
              "created_utc": 1757515434,
              "author": "Jux_"
            }
          ]
        },
        {
          "id": "1nfbetg",
          "title": "[Rizzo] The jersey I’ll be retiring in. Signed by all the patients we’ve visited over the years who are battling cancer.",
          "selftext": "",
          "score": 8546,
          "num_comments": 228,
          "created_utc": 1757702985,
          "subreddit": "baseball",
          "permalink": "/r/baseball/comments/1nfbetg/rizzo_the_jersey_ill_be_retiring_in_signed_by_all/",
          "url": "https://i.redd.it/s8pavdne5sof1.jpeg",
          "author": "PoliticaLIncorrect",
          "comments": [
            {
              "id": "ndv6j5j",
              "body": "I'll never root for the Cubs, but as a Chicagoan, I always liked Rizzo",
              "score": 1049,
              "created_utc": 1757703389,
              "author": "Audrey-Bee"
            },
            {
              "id": "ndv7unm",
              "body": "Rizzo is a great dude. He also went to Stoneman-Douglas (the school shooting in Flordia in I believe 2018) and was down there on the scene the next day and doing everything he could for his old community.",
              "score": 710,
              "created_utc": 1757703779,
              "author": "LoveYouLikeYeLovesYe"
            },
            {
              "id": "ndv7cpf",
              "body": "As someone who literally just got home from chemo infusions, this kind of stuff means a lot. Class act.\n\n* Edit - thanks for the kind words everyone! I really appreciate it.",
              "score": 645,
              "created_utc": 1757703631,
              "author": "radicalhistoryguy"
            },
            {
              "id": "ndv71s2",
              "body": "Yessir. Rizzo will always have my respect for what he does off the field.",
              "score": 232,
              "created_utc": 1757703541,
              "author": "UneducatedReviews1"
            }
          ]
        },
        {
          "id": "1ncs1l8",
          "title": "[Seidler] The fact that baseball media has to keep pushing a GoFundMe for an Angels prospect's (Rio Foster) brain injury expenses says more about the Angels organization than anything I could possibly ever say myself",
          "selftext": "",
          "score": 6489,
          "num_comments": 464,
          "created_utc": 1757445087,
          "subreddit": "baseball",
          "permalink": "/r/baseball/comments/1ncs1l8/seidler_the_fact_that_baseball_media_has_to_keep/",
          "url": "https://bsky.app/profile/seidler.bsky.social/post/3lyg4hsbeu22z",
          "author": "Jux_",
          "comments": [
            {
              "id": "ndbfgam",
              "body": "Shoutout to Sal Frelick for donating 500 bucks despite being on a different team.",
              "score": 1919,
              "created_utc": 1757445481,
              "author": "epicman81"
            },
            {
              "id": "ndbf3z6",
              "body": "Fuck arte moreno",
              "score": 1277,
              "created_utc": 1757445383,
              "author": "KingOfAllDogz"
            },
            {
              "id": "ndbnf5d",
              "body": "Meanwhile the Padres and Dodgers (and possibly other teams) each have a former player under contract for the sake of keeping their insurance.",
              "score": 529,
              "created_utc": 1757447737,
              "author": "Better_Obligation960"
            },
            {
              "id": "ndbenmu",
              "body": "Why do I have to sign in to Bluesky to view the post? I thought that was one of the main selling points during the twitter banishment stuff",
              "score": 448,
              "created_utc": 1757445253,
              "author": "Electric_Rex"
            }
          ]
        },
        {
          "id": "1ng6gpz",
          "title": "[Highlight] A strange-looking, unrecognizable man has appeared in Mets' dugout immediately after Bobby Valentine was ejected from the Alumni Game",
          "selftext": "",
          "score": 6068,
          "num_comments": 93,
          "created_utc": 1757791711,
          "subreddit": "baseball",
          "permalink": "/r/baseball/comments/1ng6gpz/highlight_a_strangelooking_unrecognizable_man_has/",
          "url": "https://v.redd.it/xmfqcjz7hzof1",
          "author": "Goosedukee",
          "comments": [
            {
              "id": "ne1p315",
              "body": "One of the funniest things I’ve ever seen in baseball when he did that. Amazing.",
              "score": 1972,
              "created_utc": 1757792460,
              "author": "erikd313"
            },
            {
              "id": "ne1norp",
              "body": "Obviously that’s Groucho Marx.",
              "score": 653,
              "created_utc": 1757792016,
              "author": "SkinnyGenez"
            },
            {
              "id": "ne1pbp6",
              "body": "The league fined him $5000",
              "score": 597,
              "created_utc": 1757792537,
              "author": "Blue387"
            },
            {
              "id": "ne1p41p",
              "body": "Without context, I was so confused by the scorebug.\n\nLike I knew people had been claiming the Mets keep beating themselves, but I didn’t think they were speaking literally",
              "score": 536,
              "created_utc": 1757792469,
              "author": "PositiveLovingDude"
            }
          ]
        },
        {
          "id": "1nfks87",
          "title": "[Highlight] Apple TV airs a Red Sox fan saying “This guy literally should not even be in the league” while David Hamilton bats.",
          "selftext": "",
          "score": 5493,
          "num_comments": 306,
          "created_utc": 1757726880,
          "subreddit": "baseball",
          "permalink": "/r/baseball/comments/1nfks87/highlight_apple_tv_airs_a_red_sox_fan_saying_this/",
          "url": "https://v.redd.it/zkqv151f4uof1",
          "author": "mfenton29",
          "comments": [
            {
              "id": "ndx7i6k",
              "body": "This guy probably spent close to $1k on Monster seats and then another $150 on beer, let the man be angry in peace",
              "score": 3018,
              "created_utc": 1757727489,
              "author": "No_Huckleberry_7410"
            },
            {
              "id": "ndx6kt0",
              "body": "Actually looks like a movie scene lol",
              "score": 2250,
              "created_utc": 1757727140,
              "author": "Ryan24MVP"
            },
            {
              "id": "ndx77ze",
              "body": "Dude is 8 22 oz beers deep cut him a little slack",
              "score": 1331,
              "created_utc": 1757727381,
              "author": "Fartbottler"
            },
            {
              "id": "ndx64eo",
              "body": "Yikes. Yeah, you’re in public, but putting the camera in on someone talking like that? Don’t love it.",
              "score": 736,
              "created_utc": 1757726967,
              "author": "John_6_47"
            }
          ]
        },
        {
          "id": "1nekv7b",
          "title": "Kevin ‘Gasman’ Gausman throws a complete game vs the Astros. Final line: 9.0IP, 0ER, 2H, 1BB, 9K, 100 pitches",
          "selftext": "The bullpen can’t blow a game if you don’t let them in the game! ",
          "score": 5323,
          "num_comments": 229,
          "created_utc": 1757625363,
          "subreddit": "baseball",
          "permalink": "/r/baseball/comments/1nekv7b/kevin_gasman_gausman_throws_a_complete_game_vs/",
          "url": "https://www.reddit.com/r/baseball/comments/1nekv7b/kevin_gasman_gausman_throws_a_complete_game_vs/",
          "author": "MarlKarx777",
          "comments": [
            {
              "id": "ndpfp2f",
              "body": "Does it count as a Maddux if it's 100 pitches on the dot?",
              "score": 1403,
              "created_utc": 1757625440,
              "author": "sameth1"
            },
            {
              "id": "ndpgff2",
              "body": "Does the pope shit in the woods?",
              "score": 828,
              "created_utc": 1757625667,
              "author": "jk01"
            },
            {
              "id": "ndpfrp9",
              "body": "7/9 innings were perfect.",
              "score": 590,
              "created_utc": 1757625463,
              "author": "Thneed1"
            },
            {
              "id": "ndpgpa1",
              "body": "He’s a fan of the White Sox. So, probably.",
              "score": 578,
              "created_utc": 1757625753,
              "author": "enselmis"
            }
          ]
        },
        {
          "id": "1ncjehj",
          "title": "Adult Giants fan catches ball in stands and gives to young fan near him",
          "selftext": "",
          "score": 5127,
          "num_comments": 358,
          "created_utc": 1757425659,
          "subreddit": "baseball",
          "permalink": "/r/baseball/comments/1ncjehj/adult_giants_fan_catches_ball_in_stands_and_gives/",
          "url": "https://v.redd.it/d8l13ydb85of1",
          "author": "MLBOfficial",
          "comments": [
            {
              "id": "nd9kar4",
              "body": "Wait… we’re supposed to give balls to kids? I thought we forcefully take them from kids",
              "score": 1314,
              "created_utc": 1757426169,
              "author": "UneducatedReviews1"
            },
            {
              "id": "nd9l45y",
              "body": "I always love the moment of pure joy in these guys faces when they scramble for a ball and get it. Then the immediate scan of the audience to find the nearest kid.",
              "score": 926,
              "created_utc": 1757426417,
              "author": "InvasionXX"
            },
            {
              "id": "nd9o9k8",
              "body": "It is almost like they are well-adjusted people who can appreciate a moment and then share it with others.",
              "score": 572,
              "created_utc": 1757427375,
              "author": "oogieball"
            },
            {
              "id": "nd9mask",
              "body": "Fun true story: \n\nI caught a foul at a White Sox game a couple years back. I gave it to a kid. \n\nI got up to get some food, waved to the kid who was still holding it on the way up the stairs. That 10 year old flipped me off. 🥀",
              "score": 562,
              "created_utc": 1757426782,
              "author": "ShopUCW"
            }
          ]
        },
        {
          "id": "1nczuyd",
          "title": "Former Yankee Anthony Rizzo is in attendance at the Stadium tonight and he crushed a beer on camera",
          "selftext": "",
          "score": 4945,
          "num_comments": 246,
          "created_utc": 1757463976,
          "subreddit": "baseball",
          "permalink": "/r/baseball/comments/1nczuyd/former_yankee_anthony_rizzo_is_in_attendance_at/",
          "url": "https://v.redd.it/mz85x4doe8of1",
          "author": "Goosedukee",
          "comments": [
            {
              "id": "ndd3h0s",
              "body": "I honestly thought he was just injured not retired lol oops",
              "score": 2835,
              "created_utc": 1757464261,
              "author": "Whiplash227"
            },
            {
              "id": "ndd40da",
              "body": "He's not officially retired but he's gone all season without being signed by anyone",
              "score": 1300,
              "created_utc": 1757464452,
              "author": "Goosedukee"
            },
            {
              "id": "ndd2v83",
              "body": "He really shouldn't be drinking like that while concussed.",
              "score": 644,
              "created_utc": 1757464049,
              "author": "Snerkbot7000"
            },
            {
              "id": "ndd3oko",
              "body": "Crushed is not the word I would use.",
              "score": 599,
              "created_utc": 1757464336,
              "author": "NeedleworkerLanky591"
            }
          ]
        }
      ]
    }
  },
  {
    "id": "mfl10cx4xcryklwgr",
    "generated_at": "2025-09-15T11:13:51.208Z",
    "name": "r/teenagers Discussion Analysis",
    "description": "Analysis of teenage conversations covering school, relationships, social anxiety, and life challenges in this youth-focused community.",
    "subreddits": [
      "teenagers"
    ],
    "dateRange": {
      "startDate": "2025-09-08",
      "endDate": "2025-09-15"
    },
    "totalPosts": 20,
    "totalComments": 3512,
    "data": {
      "summary": {
        "totalPosts": 20,
        "totalComments": 3512,
        "subreddits": [
          "teenagers"
        ],
        "dateRange": {
          "startDate": "2025-09-08",
          "endDate": "2025-09-15"
        }
      },
      "analysis": {
        "overall_sentiment": {
          "average_score": 0.2,
          "sentiment_distribution": {
            "positive": 45,
            "neutral": 30,
            "negative": 25
          },
          "dominant_themes": [
            "school",
            "friends",
            "parents",
            "relationship",
            "stress",
            "homework",
            "social",
            "anxiety",
            "future",
            "college"
          ],
          "key_emotions": [
            "anxious",
            "excited",
            "frustrated",
            "confused",
            "hopeful",
            "stressed"
          ],
          "summary": "The overall sentiment is neutral (negative 43%). Key themes include: criticism, humor, reference."
        },
        "individual_scores": [
          {
            "index": 1,
            "score": -0.6,
            "sentiment": "negative",
            "confidence": 0.9,
            "themes": [
              "death",
              "news",
              "politics"
            ],
            "emotions": [],
            "source": {
              "type": "post_title",
              "postId": "1ndqao6",
              "subreddit": "teenagers"
            }
          },
          {
            "index": 2,
            "score": 0,
            "sentiment": "neutral",
            "confidence": 0.95,
            "themes": [
              "moderation",
              "rules",
              "discussion"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1ndqao6",
              "commentId": "ndiq53t",
              "subreddit": "teenagers"
            }
          },
          {
            "index": 3,
            "score": -0.2,
            "sentiment": "negative",
            "confidence": 0.8,
            "themes": [
              "death",
              "wiki",
              "update"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1ndqao6",
              "commentId": "nditfrh",
              "subreddit": "teenagers"
            }
          },
          {
            "index": 4,
            "score": 0.1,
            "sentiment": "neutral",
            "confidence": 0.9,
            "themes": [
              "wiki",
              "speed",
              "update"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1ndqao6",
              "commentId": "ndiw4vv",
              "subreddit": "teenagers"
            }
          },
          {
            "index": 5,
            "score": 0.8,
            "sentiment": "positive",
            "confidence": 0.9,
            "themes": [
              "appreciation",
              "recognition"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1ndqao6",
              "commentId": "ndj28zl",
              "subreddit": "teenagers"
            }
          }
        ],
        "by_subreddit": {
          "teenagers": {
            "scores": [
              -0.6,
              0,
              -0.2,
              0.1,
              0.8,
              0.4,
              0.9,
              0.3,
              0,
              0,
              -0.2,
              -0.8,
              -0.3,
              -0.7,
              -0.4,
              -0.5,
              -0.3,
              -0.4,
              -0.2,
              0,
              -0.1,
              -0.3,
              -0.2,
              -0.4,
              -0.3,
              -0.5,
              -0.6,
              -0.8,
              -0.6,
              -0.4,
              -0.5,
              -0.4,
              -0.3,
              -0.2,
              -0.4,
              -0.5,
              -0.6,
              -0.7,
              -0.4,
              -0.3,
              -0.4,
              -0.3,
              -0.2,
              -0.3,
              -0.2,
              -0.3,
              -0.6,
              -0.4,
              -0.7,
              -0.2,
              -0.8,
              -0.4,
              -0.7,
              -0.5,
              -0.6,
              -0.4,
              -0.8,
              -0.7,
              -0.3,
              -0.4,
              -0.5,
              0,
              0.2,
              -0.3,
              0,
              -0.4,
              -0.3,
              -0.4,
              -0.2,
              -0.5,
              -0.3,
              -0.2,
              -0.5,
              -0.6,
              -0.3,
              -0.2,
              -0.3,
              -0.6,
              -0.4,
              -0.2,
              -0.5,
              -0.6,
              -0.5,
              -0.6,
              -0.3,
              0,
              -0.4,
              -0.4,
              -0.5,
              -0.6,
              -0.7,
              -0.4,
              -0.3,
              -0.3,
              -0.2,
              0,
              0,
              0,
              0,
              0,
              0.3,
              -0.8,
              -0.6,
              -0.7,
              -0.9,
              -0.9,
              -0.4,
              -0.3,
              -0.5,
              -0.2,
              0,
              -0.4,
              0.4,
              0,
              0.5,
              -0.3,
              -0.2,
              -0.7,
              -0.6,
              -0.7,
              -0.8,
              -0.6,
              -0.8,
              -0.5,
              -0.4,
              -0.1,
              -0.3,
              -0.2,
              0,
              -0.4,
              0,
              -0.3,
              0,
              -0.2,
              -0.3,
              -0.4,
              -0.3,
              0.4,
              -0.6,
              -0.3,
              0.6,
              0.7,
              0.3,
              -0.4,
              -0.5,
              -0.8,
              -0.6,
              -0.2,
              0.1,
              -0.3,
              -0.8,
              -0.1,
              0,
              0.1,
              -0.2,
              0,
              0.3,
              -0.2,
              0,
              -0.4,
              -0.3,
              -0.4,
              -0.2,
              -0.7,
              -0.8,
              -0.3,
              0,
              0.1,
              -0.6,
              -0.2,
              -0.8,
              -0.3,
              0.4,
              -0.2,
              -0.4,
              -0.5,
              -0.6,
              0.3,
              0.2,
              0.5,
              0.4,
              0.4,
              0.3,
              0.2,
              0.3,
              -0.2,
              0.4,
              -0.2,
              0.1,
              -0.6,
              -0.5,
              -0.4,
              -0.6,
              -0.2,
              -0.4,
              -0.3,
              -0.5,
              -0.5,
              0,
              0.1,
              0.8,
              0.3,
              -0.2,
              -0.5,
              -0.6,
              -0.4,
              -0.7,
              -0.3,
              -0.2,
              -0.4,
              -0.8,
              -0.3,
              -0.5,
              0.3,
              -0.6,
              0.2,
              0.4,
              0.3,
              0.5,
              -0.6,
              -0.2,
              -0.4,
              0.1,
              -0.1,
              -0.7,
              0.2,
              0.3,
              0.1,
              0.4,
              -0.2,
              -0.3,
              -0.4,
              -0.4,
              -0.4,
              0.2,
              0.1,
              0.3,
              0.2,
              0.5,
              -0.2,
              0.1,
              0.7,
              0.6,
              0.2,
              -0.5,
              -0.2,
              0.4,
              0.3,
              0.8,
              0.4,
              0,
              -0.6,
              -0.2,
              0.2,
              0.8,
              -0.3,
              0.6,
              0.1,
              0.3,
              0.7,
              0,
              -0.2,
              0,
              0.8,
              0.7,
              -0.2,
              0.8,
              0.1,
              -0.7,
              -0.1,
              -0.2,
              0.4,
              0,
              0.6,
              -0.5,
              0.3,
              -0.7,
              -0.8,
              0,
              0.1,
              0,
              0,
              0.1,
              0.2,
              0.5,
              0.3,
              -0.3,
              0,
              -0.4,
              0.4,
              -0.2,
              0.6,
              -0.8,
              -0.6,
              0.6,
              0.5,
              0.1,
              -0.3,
              -0.2,
              0.8,
              -0.2,
              -0.3,
              0,
              -0.6,
              0.3,
              -0.8,
              -0.4,
              -0.5,
              0.4,
              -0.8,
              0.6,
              -0.3,
              0,
              0.2,
              0.4,
              -0.2,
              -0.5,
              0,
              0.2,
              0.4,
              0,
              0.3,
              0,
              -0.6,
              0,
              0.2,
              0.1,
              0.2,
              0.1,
              0.3,
              0.2,
              0.4,
              0,
              0.6,
              0.3,
              0.3,
              0,
              0,
              0,
              0.2,
              -0.2,
              -0.1,
              0.1,
              -0.1,
              0.2,
              0,
              0,
              0.8,
              0.6,
              0.4,
              -0.1,
              0.8,
              0,
              0.3,
              0.9,
              0.2,
              0.1,
              0.4,
              -0.4,
              0.2,
              -0.3,
              -0.5,
              -0.2,
              -0.1,
              0,
              0,
              0,
              0.1,
              0,
              0.2,
              0,
              0,
              -0.3,
              0.3,
              0.1,
              -0.2,
              0.4,
              0.2,
              -0.2,
              -0.3,
              0,
              0,
              -0.1,
              0.3,
              0.2,
              0.8,
              0.1,
              -0.4,
              0.4,
              0.4,
              0.3,
              0.2,
              0.3,
              0,
              0.1,
              -0.1,
              0.1,
              0.6,
              0.3,
              0.2,
              -0.2,
              0.8,
              0.6,
              0.9,
              -0.3,
              -0.2,
              -0.9,
              0.1,
              -0.7,
              0.2,
              -0.8,
              0,
              0.6,
              -0.5,
              0.4,
              0.7,
              0.3,
              0.6,
              0.5,
              0.7,
              0.4,
              0.2,
              0.3,
              0.1,
              -0.2,
              -0.6,
              0,
              -0.3,
              0.6,
              0.7,
              0.4,
              0.1,
              -0.2,
              0.3,
              -0.8,
              -0.5,
              0,
              0.1,
              0.2,
              0.3,
              -0.4,
              -0.3,
              -0.2,
              0.7,
              0.5,
              0.4,
              0.3,
              0.1,
              0.2,
              0,
              -0.2,
              -0.5,
              0,
              -0.4,
              -0.6,
              0.2,
              0.5,
              -0.7,
              -0.4,
              0.7,
              -0.8,
              0.6,
              0.1,
              0.4,
              0,
              0.8,
              -0.3,
              -0.2,
              0.6,
              -0.3,
              0.3,
              -0.4,
              0,
              0.7,
              -0.1,
              0.4,
              0.3,
              0.6,
              0.5,
              0.8,
              0.4,
              -0.2,
              0.3,
              0.2,
              0.1,
              0.2,
              0.1,
              -0.5,
              -0.2,
              -0.2,
              -0.6,
              -0.4,
              -0.5,
              -0.6,
              0.6,
              0.4,
              -0.6,
              -0.3,
              0.1,
              0.3,
              -0.6,
              -0.9,
              0,
              0.7,
              -0.4,
              -0.3,
              -0.7,
              -0.4,
              0,
              -0.6,
              0,
              -0.2,
              0.2,
              -0.3,
              -0.5,
              0,
              0.4,
              -0.2,
              -0.3,
              0,
              0,
              0,
              0,
              0.2,
              0.5,
              -0.6,
              -0.7,
              0,
              0.4,
              -0.4,
              0,
              0.1,
              -0.3,
              -0.2,
              -0.3,
              -0.2,
              0,
              0.5,
              0.2,
              -0.5,
              -0.3,
              0,
              -0.2,
              -0.3,
              -0.4,
              0,
              0,
              -0.2,
              -0.6,
              -0.7,
              0,
              0.2,
              -0.8,
              0.1,
              0.4,
              0.6,
              -0.4,
              0.3,
              0,
              0.7,
              0.5,
              0.8,
              0.4,
              0.5,
              0.2,
              0.3,
              0.2,
              0.6,
              -0.4,
              0.3,
              0.7,
              0.8,
              0.6,
              -0.5,
              0.2,
              0.5,
              -0.3,
              -0.2,
              -0.4,
              0.4,
              0.5,
              0.8,
              -0.6,
              0.3,
              -0.2,
              0,
              -0.5,
              -0.4,
              0,
              -0.3,
              0.2,
              0.6,
              -0.4,
              0.1,
              0.2,
              0.4,
              -0.2,
              0.3,
              0.8,
              0.4,
              -0.2,
              -0.1,
              0.3,
              0,
              -0.4,
              0.2,
              -0.2,
              0.7,
              0,
              0.8,
              0.3,
              0.1,
              -0.2,
              0,
              0.2,
              -0.5,
              -0.4,
              -0.8,
              -0.3,
              0.4,
              -0.3,
              -0.4,
              0,
              0.6,
              0.4,
              -0.7,
              -0.8,
              -0.6,
              -0.5,
              0.6,
              0.3,
              0.5,
              -0.5,
              -0.6,
              -0.7,
              -0.4,
              -0.3,
              0,
              -0.5,
              -0.3,
              -0.2,
              -0.3,
              0,
              0,
              -0.4,
              -0.5,
              -0.4,
              -0.2,
              -0.1,
              -0.3,
              -0.3,
              -0.2,
              0.1,
              0.2,
              -0.1,
              -0.6,
              -0.8,
              -0.2,
              -0.3,
              -0.7,
              -0.4,
              -0.8,
              -0.1,
              -0.5,
              -0.8,
              -0.6,
              -0.4,
              -0.3,
              -0.7,
              -0.5,
              -0.2,
              -0.6,
              -0.6,
              -0.4,
              -0.5,
              -0.4,
              -0.8,
              -0.3,
              0.1,
              -0.6,
              -0.7,
              -0.8,
              -0.2,
              -0.6,
              -0.7,
              -0.7,
              -0.7,
              -0.4,
              -0.2,
              -0.6,
              -0.4,
              -0.7,
              -0.8,
              -0.6,
              -0.4,
              -0.7,
              -0.8,
              -0.6,
              -0.6,
              -0.4,
              0.3,
              0.2,
              -0.2,
              0.4,
              0,
              -0.4,
              -0.3,
              -0.3,
              -0.3,
              0.2,
              0.1,
              0.1,
              -0.1,
              0.2,
              -0.6,
              -0.4,
              -0.2,
              -0.4,
              0,
              0.3,
              0.4,
              0.2,
              0,
              -0.3,
              -0.4,
              -0.5,
              -0.2,
              -0.1,
              0,
              -0.2,
              -0.1,
              -0.6,
              -0.2,
              0.7,
              -0.2,
              0.2,
              0.3,
              0.2,
              0.2,
              0.2,
              0.6,
              0.2,
              -0.5,
              -0.1,
              0,
              -0.8,
              -0.3,
              0.4,
              -0.4,
              -0.5,
              -0.2,
              -0.6,
              0.1,
              0,
              -0.3,
              -0.7,
              -0.5,
              -0.6,
              -0.8,
              -0.5,
              -0.5,
              -0.6,
              -0.5,
              -0.7,
              0,
              0.6,
              0.2,
              -0.4,
              -0.3,
              -0.5,
              -0.8,
              0.2,
              0.3,
              0,
              0,
              0,
              0,
              0.2,
              -0.6,
              -0.2,
              0.3,
              -0.4,
              0.7,
              0,
              0.3,
              0.2,
              0.8,
              0.5,
              -0.4,
              0.3,
              -0.5,
              -0.2,
              -0.6,
              -0.3,
              0,
              -0.7,
              0,
              -0.2,
              -0.4,
              -0.5,
              -0.2,
              -0.4,
              -0.3,
              0.2,
              -0.1,
              0.8,
              0.4,
              -0.1,
              -0.6,
              -0.3,
              0,
              0,
              0.3,
              0,
              -0.5,
              -0.7,
              -0.2,
              -0.4,
              -0.3,
              -0.1,
              0,
              -0.6,
              -0.5,
              -0.4,
              -0.7,
              -0.2,
              -0.5,
              -0.1,
              -0.2,
              -0.1,
              -0.6,
              -0.4,
              -0.8,
              -0.3,
              -0.4,
              -0.2,
              0.3,
              -0.7,
              0.5,
              0.4,
              0.4,
              0.5,
              0.3,
              -0.8,
              -0.7,
              -0.6,
              -0.2,
              0,
              -0.1,
              -0.3,
              -0.6,
              -0.4,
              -0.8,
              0.3,
              0.4,
              0,
              0,
              -0.3,
              -0.7,
              -0.4,
              0.2,
              0.3,
              0.3,
              -0.4,
              -0.5,
              0.2,
              -0.6,
              -0.2,
              0.6,
              0,
              0.1,
              0.2,
              0,
              0.4,
              0,
              0,
              0,
              -0.4,
              -0.3,
              -0.2,
              -0.5,
              -0.3,
              -0.1,
              -0.4,
              -0.6,
              -0.5,
              -0.4,
              -0.2,
              0.4,
              -0.7,
              -0.5,
              -0.6,
              -0.3,
              -0.2,
              -0.5,
              -0.6,
              -0.4,
              -0.3,
              -0.4,
              -0.3,
              -0.1,
              -0.3,
              -0.6,
              0,
              -0.7,
              -0.8,
              -0.4,
              -0.5,
              -0.2,
              -0.6,
              -0.7,
              -0.5,
              0,
              -0.3,
              -0.6,
              -0.7,
              -0.6,
              -0.4,
              -0.8,
              -0.7,
              -0.3,
              -0.4,
              -0.5,
              -0.6,
              0.4,
              0.2,
              0.3,
              0.4,
              0.4,
              0.2,
              0.3,
              0.3,
              0.1,
              -0.3,
              0.2,
              0.3,
              -0.2,
              0.1,
              0.1,
              0.1,
              0.1,
              0.1,
              0.1,
              0.2,
              0.1,
              0.2,
              0.1,
              0,
              0,
              -0.2,
              -0.3,
              -0.2,
              0,
              -0.4,
              0.2,
              0,
              0.3,
              -0.2,
              0.1,
              0.4,
              0.3,
              -0.1,
              -0.4,
              0.2,
              -0.3,
              0.4,
              0,
              0.8,
              -0.5,
              0.3,
              -0.6,
              -0.4,
              -0.7,
              -0.3,
              0.1,
              0.2,
              -0.1,
              0.3,
              0.2,
              -0.1,
              0.2,
              -0.2,
              0.1,
              -0.1,
              0.4,
              0.3,
              -0.2,
              0.1,
              0,
              -0.1,
              -0.2,
              -0.3,
              -0.5,
              -0.4,
              0.1,
              0.2,
              -0.2,
              0.1,
              0.2,
              0,
              0,
              0.1,
              0.8,
              0,
              -0.3,
              0,
              0,
              0.7,
              -0.6,
              0,
              0.6,
              0.2,
              0.5,
              0,
              0,
              0,
              -0.1,
              -0.3,
              -0.2,
              0,
              0,
              0.3,
              -0.1,
              -0.2,
              0,
              -0.7,
              -0.2,
              0,
              0,
              0.2,
              0,
              0.2,
              0,
              0.2,
              0.6,
              0.4,
              0.8,
              -0.2,
              0,
              -0.4,
              -0.3,
              -0.5,
              -0.1,
              0,
              -0.2,
              0,
              0.4,
              0,
              -0.4,
              -0.3,
              -0.6,
              -0.8,
              -0.7,
              0,
              0.3,
              -0.7,
              -0.3,
              -0.5,
              0.2,
              0.4,
              0.1,
              0.2,
              -0.4,
              0.1,
              -0.5,
              0,
              -0.6,
              -0.2,
              -0.9,
              -0.4,
              -0.3,
              -0.9,
              -0.2,
              0.6,
              -0.4,
              0,
              0,
              -0.3,
              -0.7,
              -0.5,
              -0.3,
              -0.5,
              -0.6,
              -0.5,
              -0.9,
              -0.7,
              -0.8,
              0.2,
              0.6,
              -0.2,
              0,
              0,
              0,
              0.1,
              -0.4,
              -0.5,
              -0.3,
              -0.2,
              -0.1,
              0.4,
              -0.6,
              0.8,
              -0.2,
              -0.4,
              -0.8,
              -0.7,
              -0.6,
              -0.7,
              -0.8,
              -0.3,
              -0.6,
              -0.5,
              -0.4,
              -0.5,
              0,
              -0.8,
              -0.5,
              -0.7,
              -0.4,
              0,
              -0.8,
              0.2,
              -0.8,
              -0.3,
              -0.2,
              0,
              -0.6,
              -0.4,
              -0.5,
              -0.6,
              0.5,
              -0.5,
              -0.4,
              -0.7,
              -0.2,
              0,
              -0.7,
              -0.5,
              0,
              -0.4,
              0,
              0.5,
              -0.3,
              0,
              -0.4,
              0.4,
              -0.3,
              -0.6,
              0,
              -0.5,
              -0.2,
              -0.9,
              -0.4,
              0.1,
              -0.2,
              0.4,
              -0.1,
              0.3,
              -0.3,
              -0.2,
              -0.4,
              -0.5,
              -0.6,
              -0.3,
              -0.7,
              -0.5,
              0.2,
              -0.1,
              -0.3,
              -0.8,
              -0.4,
              0.3,
              -0.6,
              -0.4,
              -0.5,
              0.1,
              0,
              -0.4,
              -0.5,
              -0.3,
              0.2,
              -0.6,
              -0.3,
              -0.4,
              -0.7,
              -0.2,
              -0.1,
              -0.5,
              0.4,
              -0.3,
              -0.1,
              -0.5,
              -0.8,
              0.3,
              -0.6,
              -0.7,
              -0.4,
              0.2,
              -0.3,
              -0.4,
              -0.8,
              -0.2,
              0,
              0,
              -0.7,
              -0.6,
              -0.3,
              -0.2,
              0,
              0,
              -0.6,
              0,
              0,
              0,
              0,
              -0.5,
              -0.1,
              0,
              0,
              0.2,
              -0.4,
              -0.2,
              0,
              0.3,
              0.3,
              -0.2,
              -0.4,
              0,
              0.2,
              -0.2,
              -0.4,
              -0.3,
              -0.1,
              0.2,
              -0.5,
              -0.1,
              -0.3,
              0,
              -0.6,
              -0.7,
              -0.6,
              0.3,
              0.8,
              -0.2,
              0.1,
              0,
              -0.5,
              -0.7,
              -0.4,
              -0.3,
              0.2,
              -0.8,
              -0.4,
              0.3,
              0,
              0.1,
              -0.2,
              0.2,
              0,
              -0.1,
              -0.2,
              0.1,
              -0.3,
              0,
              0,
              0.4,
              0,
              0.6,
              0.8,
              0.7,
              0.1,
              0.1,
              -0.2,
              -0.7,
              -0.5,
              -0.4,
              -0.3,
              -0.2,
              0.4,
              -0.3,
              -0.4,
              -0.5,
              0,
              0,
              0.2,
              0.3,
              0,
              0,
              0,
              0.1,
              -0.4,
              0,
              -0.6,
              0,
              -0.7,
              0,
              0,
              0.1,
              -0.3,
              -0.4,
              0.4,
              0.8,
              0.1,
              0.2,
              0.6,
              -0.7,
              -0.3,
              -0.4,
              0,
              0.5,
              -0.2,
              0.3,
              0.6,
              0.4,
              0.7,
              0,
              -0.3,
              0.4,
              0.5,
              0.2,
              -0.5,
              0,
              0.3,
              -0.2,
              0.4,
              -0.6,
              0,
              0.5,
              -0.2,
              -0.1,
              -0.3,
              0.7,
              -0.2,
              0,
              -0.1,
              0.4,
              0,
              0.8,
              0.5,
              -0.2,
              0.1,
              0.2,
              0,
              0.4,
              -0.6,
              -0.1,
              -0.5,
              0,
              -0.7,
              -0.1,
              -0.1,
              -0.2,
              -0.3,
              0,
              0.2,
              -0.5,
              -0.6,
              0.8,
              0.7,
              -0.2,
              -0.3,
              0,
              -0.3,
              -0.7,
              0.3,
              -0.6,
              0.4,
              -0.5,
              -0.3,
              0.1,
              0.4,
              -0.6,
              -0.5,
              -0.8,
              -0.4,
              0,
              -0.4,
              -0.8,
              -0.7,
              0.4,
              -0.3,
              -0.6,
              0.1,
              -0.5,
              -0.7,
              -0.4,
              -0.5,
              -0.4,
              -0.3,
              -0.8,
              -0.7,
              -0.5,
              -0.4,
              0,
              -0.6,
              0.1,
              -0.2,
              -0.7,
              0.2,
              0.3,
              -0.6,
              -0.3,
              -0.2,
              -0.3,
              -0.8,
              -0.5,
              0.2,
              -0.2,
              0.3,
              0.4,
              0.8,
              0.7,
              -0.6,
              0.5,
              -0.7,
              -0.8,
              -0.7,
              -0.5,
              -0.8,
              -0.7,
              -0.4,
              -0.5,
              -0.8,
              -0.3,
              0.2,
              -0.4,
              0,
              -0.3,
              -0.4,
              0.3,
              0.4,
              0.2,
              0.3,
              0.1,
              0.6,
              -0.6,
              0.4,
              -0.3,
              0.2,
              -0.2,
              0.2,
              -0.4,
              -0.5,
              0.6,
              -0.3,
              0.4,
              0.8,
              -0.3,
              -0.6,
              0.5,
              -0.8,
              -0.2,
              -0.9,
              -0.4,
              0.7,
              0.1,
              0.4,
              -0.6,
              -0.7,
              0.3,
              0.6,
              0.2,
              0.4,
              -0.8,
              0.6,
              -0.5,
              -0.3,
              -0.1,
              -0.4,
              -0.2,
              0.7,
              -0.4,
              0.5,
              0,
              -0.8,
              -0.3,
              -0.7,
              0.2,
              -0.3,
              -0.4,
              0.3,
              0.5,
              -0.2,
              0.1,
              -0.3,
              -0.4,
              0.4,
              0.6,
              0.3,
              -0.5,
              -0.6,
              0.2,
              0.3,
              0.8,
              -0.5,
              -0.8,
              -0.4,
              -0.4,
              0.4,
              -0.6,
              0.4,
              0.6,
              0.8,
              0,
              0.9,
              0.6,
              0.1,
              -0.6,
              0.7,
              0.4,
              -0.3,
              0.7,
              0,
              0.3,
              -0.8,
              -0.4,
              0,
              0,
              -0.3,
              0.4,
              -0.5,
              0.2,
              -0.6,
              0,
              0.3,
              0.4,
              -0.2,
              0.7,
              -0.3,
              0.8,
              0,
              0.2,
              0.3,
              -0.4,
              -0.5,
              -0.4,
              0.4,
              -0.3,
              -0.5,
              0.4,
              -0.2,
              0,
              0.3,
              0,
              0.7,
              0.3,
              0.8,
              0.2,
              -0.3,
              0.6,
              -0.2,
              0.3,
              -0.4,
              -0.4,
              -0.4,
              -0.1,
              0.4,
              0.4,
              0.4,
              -0.1,
              -0.4,
              -0.4,
              0.5,
              0.2,
              -0.6,
              -0.3,
              -0.3,
              0.2,
              0.1,
              -0.2,
              -0.4,
              -0.1,
              0,
              0.6,
              0,
              -0.1,
              0,
              0,
              0,
              0.1,
              0,
              0,
              0,
              0.3,
              0.1,
              0.2,
              0.4,
              0.3,
              -0.2,
              -0.3,
              0.4,
              0.5,
              0.2,
              -0.1,
              0.3,
              0.6,
              0.1,
              -0.7,
              0.5,
              0.1,
              -0.6,
              -0.7,
              -0.3,
              0,
              0.1,
              -0.2,
              -0.4,
              -0.3,
              -0.5,
              -0.2,
              -0.2,
              0,
              -0.2,
              -0.7,
              -0.5,
              -0.4,
              -0.6,
              0.2,
              0.4,
              0.5,
              -0.8,
              0.2,
              0.3,
              0.3,
              -0.7,
              -0.5,
              -0.4,
              -0.3,
              0.2,
              0.2,
              -0.3,
              -0.6,
              0,
              0.1,
              0.2,
              -0.1,
              0,
              0.4,
              0.3,
              0.6,
              0.4,
              0.1,
              -0.8,
              0.2,
              0.3,
              0,
              -0.5,
              -0.8,
              -0.5,
              -0.7,
              0.3,
              -0.2,
              -0.3,
              -0.1,
              -0.4,
              0.4,
              0.2,
              0.3,
              0,
              0,
              0.2,
              0.6,
              -0.4,
              0.2,
              0.8,
              0,
              0.4,
              0.2,
              0.5,
              0,
              0,
              0,
              -0.2,
              0.6,
              0.4,
              0,
              0.7,
              -0.2,
              0.6,
              0,
              0.3,
              0.2,
              -0.5,
              0.1,
              0.1,
              0.1,
              0.2,
              0.1,
              0.1,
              0.1,
              -0.2,
              0.1,
              0.6,
              0.7,
              -0.2,
              0.3,
              0.7,
              0.4,
              0.2,
              0,
              -0.6,
              -0.2,
              0.7,
              0,
              -0.6,
              0,
              0.1,
              0,
              0.3,
              0,
              0,
              -0.2,
              -0.3,
              0.6,
              0,
              0.2,
              -0.1,
              0.4,
              0.5,
              -0.2,
              -0.4,
              0.3,
              0,
              0.2,
              0,
              0,
              -0.5,
              0.2,
              0.4,
              0,
              -0.4,
              0,
              0.1,
              -0.2,
              0.1,
              0.3,
              0.2,
              0.2,
              0.3,
              0,
              -0.4,
              -0.3,
              0.4,
              0.8,
              -0.2,
              0.9,
              -0.1,
              0.6,
              -0.2,
              0,
              -0.2,
              0,
              0.3,
              -0.1,
              -0.4,
              -0.6,
              0.8,
              -0.5,
              0.6,
              0.2,
              0,
              -0.4,
              -0.6,
              -0.3,
              -0.7,
              0.4,
              -0.3,
              -0.2,
              -0.8,
              -0.2,
              -0.7,
              -0.4,
              -0.8,
              -0.6,
              -0.7,
              -0.8,
              0.5,
              0.3,
              0.1,
              0.4,
              -0.7,
              -0.3,
              -0.4,
              0.2,
              0.9,
              -0.1,
              0.3,
              -0.2,
              0.1,
              0,
              0,
              -0.6,
              0.4,
              0.3,
              0.6,
              0.2,
              0.5,
              0.1,
              0.2,
              0.3,
              -0.2,
              0.1,
              -0.2,
              0.4,
              -0.3,
              -0.2,
              -0.4,
              0.3,
              0.6,
              -0.5,
              -0.7,
              -0.8,
              -0.6,
              -0.6,
              -0.9,
              -0.5,
              0.7,
              -0.2,
              0.9,
              -0.5,
              -0.7,
              -0.7,
              -0.6,
              0.9,
              0.8,
              -0.4,
              -0.3,
              -0.2,
              -0.7,
              -0.6,
              -0.5,
              0,
              0.8,
              0.7,
              0.2,
              -0.3,
              -0.3,
              -0.8,
              -0.4,
              -0.6,
              -0.5,
              0.5,
              -0.5,
              -0.2,
              -0.3,
              0.4,
              0,
              -0.2,
              -0.3,
              0.6,
              -0.8,
              0.7,
              0,
              0,
              0.2,
              -0.6,
              -0.3,
              0.6,
              -0.2,
              0,
              0.4,
              -0.5,
              0,
              0,
              0,
              -0.7,
              -0.5,
              0,
              -0.3,
              0.1,
              0,
              -0.5,
              0,
              0.7,
              0.8,
              -0.4,
              -0.7,
              -0.5,
              0,
              -0.6,
              0,
              -0.2,
              -0.5,
              -0.3,
              -0.7,
              -0.6,
              0.4,
              -0.2,
              0.6,
              0.1,
              0.2,
              0.1,
              0,
              0,
              -0.2,
              -0.1,
              0.1,
              0.1,
              -0.1,
              0.3,
              0,
              0,
              0.6,
              0.3,
              0,
              0,
              0,
              0.5,
              0,
              0,
              0,
              -0.2,
              0.2,
              0,
              -0.4,
              0,
              -0.4,
              -0.2,
              0,
              -0.2,
              0,
              0.1,
              0,
              0,
              0,
              0,
              0,
              -0.2,
              -0.1,
              0,
              -0.3,
              0.2,
              -0.2,
              -0.8,
              -0.7,
              -0.5,
              -0.7,
              -0.3,
              0.1,
              0.5,
              0.2,
              0,
              0.1,
              -0.4,
              -0.6,
              0,
              0.3,
              0.4,
              -0.2,
              0,
              -0.2,
              0.3,
              0.1,
              0,
              0.1,
              0,
              0.1,
              0.8,
              -0.1,
              0.3,
              -0.4,
              0.2,
              -0.3,
              0,
              0,
              0.6,
              0.2,
              0.3,
              0.1,
              0.3,
              0,
              0.2,
              0,
              -0.2,
              0,
              0.4,
              0,
              -0.3,
              0,
              0,
              0.1,
              0.5,
              0.4,
              0,
              0,
              -0.3,
              0,
              0.2,
              -0.2,
              0.2,
              0,
              0.1,
              0,
              -0.2,
              0,
              0.2,
              -0.3,
              0.1,
              -0.1,
              -0.2,
              -0.2,
              0.8,
              0,
              -0.2,
              0.5,
              -0.3,
              -0.2,
              0.4,
              -0.4,
              -0.3,
              0.5,
              0,
              -0.4,
              0.2,
              0,
              0.4,
              -0.6,
              0,
              0.6,
              0.3,
              0.2,
              0,
              0,
              0.3,
              0.2,
              -0.3,
              0.8,
              0,
              0.2,
              0,
              0,
              0.4,
              -0.5,
              0.4,
              0,
              0.3,
              0.4,
              0.6,
              -0.2,
              0.5,
              -0.1,
              0.2,
              0,
              0,
              0.6,
              0,
              0.2,
              0.4,
              0.5,
              0.2,
              0.2,
              0.1,
              0.4,
              0.5,
              0.3,
              0.1,
              0.2,
              -0.2,
              0.3,
              0.6,
              0.4,
              -0.1,
              0,
              -0.3,
              -0.2,
              -0.1,
              0,
              0,
              -0.4,
              -0.3,
              0.2,
              0.1,
              0,
              -0.1,
              -0.3,
              0,
              0.2,
              -0.4,
              0.5,
              0.2,
              0.6,
              -0.3,
              0.7,
              0.5,
              0.2,
              0.1,
              0.3,
              0.3,
              0.4,
              0.6,
              0.3,
              0.7,
              0.6,
              -0.2,
              0.7,
              0.8,
              0.4,
              0.6,
              -0.1,
              -0.3,
              -0.6,
              -0.4,
              0.8,
              0.2,
              0,
              0.3,
              0.4,
              0.6,
              0.7,
              0.8,
              0.7,
              0.8,
              0.5,
              0.8,
              0.4,
              0.2,
              0.4,
              0.6,
              0.8,
              0.3,
              0.5,
              0.2,
              0.7,
              0.5,
              -0.4,
              0.7,
              0.6,
              0.6,
              0.5,
              0.6,
              0.7,
              0.6,
              0.3,
              -0.3,
              -0.4,
              0.5,
              0.6,
              0.4,
              0.7,
              -0.2,
              0.4,
              0.6,
              0.5,
              0.2,
              0.4,
              -0.3,
              -0.4,
              0.6,
              -0.5,
              -0.4,
              0,
              0,
              -0.8,
              0.6,
              0.3,
              0.2,
              0.8,
              0.7,
              -0.7,
              0.2,
              0.4,
              0.2,
              0.5,
              0.3,
              0,
              0,
              0.2,
              0,
              0,
              0.7,
              0.5,
              0.8,
              0.4,
              0.7,
              0.6,
              -0.3,
              -0.2,
              0.3,
              0.2,
              0,
              0.6,
              -0.2,
              0.9,
              0.3,
              0.2,
              -0.7,
              0.3,
              -0.5,
              0.2,
              0.2,
              0,
              0,
              -0.4,
              0.7,
              0.6,
              0.4,
              0.3,
              0.2,
              0.8,
              0.7,
              0.6,
              0.4,
              0.3,
              0.2,
              0.7,
              0.4,
              0.6,
              0.3,
              0.7,
              0.8,
              -0.4,
              0.3,
              0.6,
              0.5,
              0.6,
              -0.7,
              0.5,
              -0.8,
              0.2,
              -0.8,
              0.3,
              -0.2,
              -0.3,
              0.7,
              0.4,
              -0.5,
              -0.9,
              -0.9,
              0.6,
              0.5,
              0.4,
              -0.2,
              0.4,
              0.3,
              0.7,
              0.8,
              -0.3,
              0.6,
              -0.6,
              0.4,
              0.5,
              0.4,
              0.7,
              0.8,
              0.5,
              0.6,
              0.4,
              0.5,
              0.5,
              0.6,
              0.7,
              0.3,
              -0.6,
              -0.8,
              0.4,
              0.6,
              0.2,
              -0.2,
              0.3,
              -0.3,
              0.5,
              0.7,
              -0.1,
              0.4,
              0.3,
              -0.2,
              -0.4,
              0.6,
              0.5,
              0.2,
              0.3,
              0.7,
              0.4,
              -0.2,
              0.3,
              0.4,
              0.2,
              0.3,
              0.5,
              0.2,
              -0.2,
              0.5,
              -0.1,
              0.2,
              0.6,
              0.4,
              -0.1,
              0.2,
              0.3,
              0.1,
              0.5,
              0.3,
              0.2,
              0.3,
              -0.2,
              -0.3,
              0.4,
              0.1,
              0.5,
              0.4,
              0.8,
              0.3,
              0.2,
              0.6,
              0.7,
              0.4,
              0.5,
              0.4,
              0.6,
              0,
              -0.2,
              0.3,
              0.4,
              0.5,
              0.2,
              0.5,
              0.6,
              0.4,
              0.5,
              0.6,
              0.3,
              0.5,
              0.2,
              0.3,
              0.2,
              0.6,
              0.7,
              0.5,
              0.6,
              0.2,
              0.3,
              0.6,
              0.6,
              0.5,
              0.6,
              0.7,
              0.4,
              0.4,
              0.5,
              0.3,
              0.6,
              0.5,
              0.5,
              0.4,
              0.4,
              0.5,
              -0.2,
              0.6,
              0.2,
              0.2,
              -0.2,
              0.3,
              0.2,
              0.4,
              0.6,
              0.7,
              0.3,
              -0.5,
              0,
              0.5,
              0.4,
              0.6,
              0.5,
              0.4,
              0.5,
              0.7,
              0.3,
              0.4,
              0.6,
              -0.7,
              0.1,
              -0.1,
              0,
              0.2,
              -0.5,
              -0.3,
              -0.2,
              0,
              0.3,
              0,
              0,
              -0.8,
              0,
              -0.6,
              -0.4,
              0,
              -0.5,
              0,
              -0.2,
              -0.3,
              0,
              0.2,
              0.4,
              0.6,
              -0.7,
              0.7,
              0.6,
              -0.4,
              -0.2,
              0.3,
              -0.3,
              -0.4,
              -0.2,
              -0.6,
              0.2,
              -0.3,
              -0.5,
              -0.4,
              -0.2,
              -0.7,
              -0.5,
              -0.4,
              0.2,
              0.1,
              -0.6,
              -0.2,
              0.4,
              -0.5,
              -0.8,
              0.3,
              0.7,
              -0.8,
              0.1,
              0.4,
              0.3,
              0.6,
              0.7,
              0.6,
              -0.1,
              -0.5,
              -0.4,
              -0.2,
              -0.6,
              -0.5,
              -0.1,
              -0.4,
              -0.7,
              0.2,
              -0.2,
              0.1,
              0.5,
              0.6,
              0.7,
              0.8,
              0.7,
              -0.7,
              0.4,
              0.6,
              0,
              0,
              0.8,
              -0.2,
              -0.1,
              0.3,
              0,
              0.2,
              -0.3,
              -0.4,
              0.7,
              -0.2,
              0.2,
              -0.3,
              -0.4,
              -0.5,
              -0.4,
              -0.2,
              -0.8,
              -0.4,
              -0.7,
              -0.3,
              0,
              0.2,
              -0.9,
              -0.3,
              -0.2,
              -0.6,
              0,
              -0.3,
              -0.2,
              -0.3,
              0,
              -0.4,
              -0.5,
              0,
              0.3,
              -0.2,
              0.2,
              0,
              -0.3,
              -0.2,
              0.4,
              -0.3,
              0,
              -0.3,
              -0.4,
              -0.2,
              0,
              -0.4,
              -0.3,
              -0.5,
              -0.6,
              -0.2,
              0.4,
              -0.8,
              -0.7,
              -0.6,
              -0.3,
              0.2,
              0.8,
              0.9,
              0.9,
              -0.3,
              -0.2,
              0,
              -0.2,
              -0.3,
              0.2,
              -0.7,
              -0.5,
              -0.3,
              -0.2,
              -0.4,
              -0.6,
              -0.7,
              -0.6,
              -0.1,
              -0.3,
              -0.2,
              -0.4,
              0.2,
              -0.1,
              -0.3,
              -0.5,
              0.4,
              -0.6,
              -0.2,
              0,
              -0.3,
              -0.2,
              0.1,
              -0.3,
              -0.1,
              -0.3,
              -0.5,
              0.3,
              0.4,
              0.2,
              -0.4,
              -0.6,
              -0.2,
              -0.7,
              -0.6,
              -0.5,
              -0.6,
              -0.5,
              -0.2,
              -0.7,
              -0.8,
              -0.7,
              -0.5,
              -0.3,
              -0.4,
              -0.2,
              -0.6,
              -0.7,
              -0.5,
              -0.8,
              -0.3,
              -0.7,
              -0.8,
              -0.9,
              -0.7,
              0.2,
              -0.8,
              -0.8,
              -0.3,
              -0.4,
              0,
              -0.6,
              -0.8,
              -0.5,
              -0.8,
              -0.7,
              -0.3,
              -0.7,
              -0.6,
              -0.8,
              -0.4,
              -0.5,
              -0.3,
              -0.2,
              -0.7,
              -0.6,
              -0.7,
              -0.5,
              -0.2,
              -0.7,
              -0.5,
              -0.8,
              -0.3,
              -0.4,
              -0.6,
              0.3,
              -0.8,
              -0.9,
              -0.6,
              0,
              -0.7,
              -0.4,
              -0.8,
              0,
              0.1,
              0.4,
              0,
              -0.2,
              -0.3,
              -0.5,
              -0.6,
              -0.2,
              0.2,
              -0.7,
              0.3,
              -0.6,
              0,
              0.2,
              -0.7,
              -0.3,
              0.5,
              -0.6,
              -0.8,
              -0.7,
              -0.6,
              -0.8,
              -0.5,
              -0.4,
              -0.5,
              -0.4,
              -0.6,
              0,
              -0.3,
              -0.2,
              -0.7,
              -0.1,
              -0.6,
              0.1,
              -0.1,
              -0.3,
              0,
              -0.2,
              -0.1,
              -0.2,
              0.2,
              0.3,
              -0.3,
              -0.2,
              -0.4,
              0.2,
              -0.5,
              0,
              0,
              0.1,
              -0.1,
              -0.3,
              0,
              0.1,
              -0.2,
              0,
              -0.1,
              -0.2,
              -0.3,
              -0.2,
              -0.3,
              -0.2,
              0.5,
              -0.4,
              -0.2,
              0.2,
              0.1,
              -0.2,
              -0.3,
              -0.2,
              -0.1,
              -0.3,
              -0.4,
              -0.2,
              -0.1,
              0,
              0.2,
              0,
              -0.2,
              -0.2,
              0.1,
              -0.1,
              -0.3,
              -0.2,
              -0.7,
              -0.5,
              0.3,
              0,
              0,
              -0.2,
              0.4,
              0.2,
              0.1,
              -0.2,
              0,
              -0.3,
              -0.8,
              -0.6,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0.1,
              0,
              0,
              0,
              0,
              0,
              0.2,
              0,
              0,
              0.2,
              -0.2,
              0.2,
              0.3,
              0,
              0.4,
              0.3,
              0.4,
              0.1,
              -0.4,
              -0.2,
              0,
              0.2,
              -0.6,
              -0.3,
              0,
              -0.1,
              -0.4,
              -0.2,
              -0.2,
              0.3,
              0,
              -0.1,
              0,
              -0.3,
              0.6,
              0.8,
              0,
              0.4,
              -0.5,
              0,
              0,
              0,
              0,
              0.1,
              -0.6,
              0.2,
              -0.4,
              -0.3,
              -0.2,
              0.5,
              0.6,
              0.2,
              -0.4,
              0.3,
              0,
              -0.2,
              0.1,
              -0.3,
              -0.2,
              -0.2,
              0.4,
              0,
              0,
              -0.3,
              -0.1,
              -0.2,
              -0.3,
              -0.3,
              -0.1,
              -0.4,
              -0.3,
              -0.7,
              -0.2,
              -0.1,
              -0.2,
              -0.1,
              -0.1,
              -0.2,
              -0.3,
              -0.2,
              -0.5,
              0,
              -0.4,
              -0.2,
              -0.1,
              0,
              -0.4,
              0.3,
              -0.3,
              -0.1,
              -0.5,
              0,
              0,
              -0.2,
              -0.3,
              0,
              0,
              0,
              -0.1,
              -0.2,
              0,
              -0.5,
              -0.3,
              -0.5,
              -0.1,
              -0.4,
              0,
              0.1,
              -0.6,
              -0.4,
              -0.2,
              -0.1,
              -0.1,
              -0.1,
              0.3,
              0.4,
              0.2,
              -0.2,
              -0.1,
              0.1,
              0.1,
              0.2,
              -0.2,
              0.4,
              0,
              0.5,
              0.3,
              -0.1,
              0.1,
              0,
              -0.4,
              0,
              0,
              -0.6,
              0,
              -0.2,
              0,
              0.1,
              0,
              0,
              0,
              -0.3,
              0,
              0,
              0,
              0.7,
              -0.5,
              -0.4,
              0,
              0,
              0,
              0.2,
              0,
              0,
              0,
              0,
              -0.2,
              0.2,
              0.2,
              -0.1,
              -0.5,
              -0.3,
              -0.4,
              -0.6,
              0,
              0,
              0,
              -0.2,
              0,
              0.4,
              -0.1,
              -0.2,
              -0.1,
              0,
              0,
              -0.3,
              -0.4,
              -0.1,
              0,
              -0.2,
              -0.6,
              -0.8,
              -0.6,
              -0.8,
              -0.6,
              -0.8
            ],
            "positive": 807,
            "neutral": 834,
            "negative": 1261,
            "mixed": null,
            "average_score": -0.06334826042025495,
            "total_analyzed": 2903
          }
        },
        "timeline": [
          {
            "date": "2025-09-08",
            "average_score": 0.12807017543859656,
            "positive": 168,
            "neutral": 89,
            "negative": 85,
            "total": 342
          },
          {
            "date": "2025-09-09",
            "average_score": -0.10483870967741939,
            "positive": 9,
            "neutral": 22,
            "negative": 31,
            "total": 62
          },
          {
            "date": "2025-09-10",
            "average_score": -0.2027272727272727,
            "positive": 47,
            "neutral": 80,
            "negative": 203,
            "total": 330
          },
          {
            "date": "2025-09-11",
            "average_score": -0.09865319865319867,
            "positive": 149,
            "neutral": 150,
            "negative": 295,
            "total": 594
          },
          {
            "date": "2025-09-12",
            "average_score": 0.05694915254237285,
            "positive": 228,
            "neutral": 185,
            "negative": 177,
            "total": 590
          },
          {
            "date": "2025-09-13",
            "average_score": -0.08672376873661676,
            "positive": 111,
            "neutral": 151,
            "negative": 204,
            "total": 467
          },
          {
            "date": "2025-09-14",
            "average_score": -0.1714285714285714,
            "positive": 95,
            "neutral": 157,
            "negative": 266,
            "total": 518
          }
        ],
        "ai_insights": {
          "teenagers": "Here's my analysis of the sentiment and themes in the posts from r/teenagers:\n\nOverall Mood and Attitudes:\n- The community seems to have a mix of emotions, ranging from dark humor and sarcasm to genuine empathy and concern. There's a sense of frustration and cynicism towards current events and societal issues.\n- Many posts show a lack of trust in the media and public figures, with a perception that they downplay or misrepresent certain issues, especially when it comes to politically-charged events.\n- There's a general sense of desensitization to violence and tragedy, with some posts making light of or joking about serious incidents like school shootings.\n\nCommon Themes and Topics:\n- School and education-related issues, including complaints about school food, teachers, and policies\n- Discussions around political figures, ideologies, and current events\n- Concerns about online safety, predatory behavior, and misinformation\n- Mental health, bullying, and interpersonal relationships\n\nUpvote/Discussion Patterns:\n- Posts that touch on controversial or divisive topics, such as politics and violence, tend to generate the most engagement and discussion.\n- Memes, jokes, and sarcastic commentary also seem to be popular and widely discussed.\n- Posts expressing empathy or addressing sensitive personal issues receive supportive comments, though sometimes with an underlying cynical or dark humor.\n\nEmerging Trends and Shifts:\n- The community appears to be grappling with a sense of disillusionment and a lack of trust in traditional institutions and authority figures.\n- There's a growing awareness and discussion of issues like media bias, extremism, and the impact of technology on youth.\n- The community seems to be developing its own language and inside jokes, with references to specific memes and online trends.\n\nPain Points and Frustrations:\n- Concerns about the state of the world, violence, and a perceived lack of meaningful change or accountability\n- Frustration with perceived hypocrisy, double standards, and biased reporting\n- Struggles with mental health, bullying, and interpersonal challenges\n\nOverall, the r/teenagers community seems to be a reflection of the broader societal and generational shifts happening, with a mix of dark humor, cynicism, and a desire to make sense of complex and often troubling issues. The community appears to be grappling with a sense of disillusionment and a need to find meaning and connection in a rapidly changing world."
        },
        "framework_analysis": {
          "success": true,
          "analysis": "**COMMUNITY PROFILING**\n\n• Community Type: Social/Discussion\n• Demographic Indicators: Teenagers (13-19), with some older participants\n• Emotional Baseline: Mixed but trending negative (-0.06 overall sentiment)\n• Community Character: A diverse, politically aware teenage community that frequently discusses current events and social issues. Shows high engagement with controversial topics and uses humor as a coping mechanism.\n\n**PATTERN DISCOVERY**\n\n🔍 Key Findings:\n\n1. Surprising Pattern #1:\n   High political awareness and engagement with serious news events, contradicting stereotypes about teenage superficiality\n\n2. Surprising Pattern #2:\n   Strong moderation of discourse around sensitive topics like violence and tragedy, showing mature community standards\n\n3. Surprising Pattern #3:\n   Effective use of humor as a coping mechanism when discussing serious issues, maintaining community cohesion\n\n💬 Controversy Triggers:\n• Political deaths/violence\n• School shootings\n• Racial/identity politics\n• Age-related issues (pedophilia concerns)\n\n📊 Success/Failure Predictors:\n• Success indicators: Humor, relatable content, current events commentary\n• Failure indicators: Overt political bias, insensitive jokes about tragedy\n\n**TEMPORAL ANALYSIS**\n\n⏰ Time-Based Patterns:\n\nDaily Cycles:\n• Morning: Lower engagement\n• Afternoon: Peak activity (school-related content)\n• Evening: More serious discussions\n\nWeekly Trends:\n• Weekday dominance in engagement\n• Weekend dip in serious topics\n• Peak engagement during major news events\n\nSentiment Evolution:\n• Started positive (0.12)\n• Declined mid-week (-0.20)\n• Recovered slightly by week's end (-0.08)\n\n**KEY INSIGHTS**\n\n⭐ Most Important Discoveries:\n\n1. Engagement Correlation:\n   Higher engagement on posts mixing serious topics with appropriate humor\n\n2. Unspoken Rules:\n   Strong community moderation of tragedy-related discussions\n\n3. Influence Patterns:\n   Top comments set the tone for entire discussion threads\n\n4. Content Predictors:\n   Image posts with social commentary perform best\n\n**ACTIONABLE RECOMMENDATIONS**\n\n📝 Content Strategy:\n• Best performing content types: Image-based social commentary\n• Optimal post structure: Brief title + relevant image\n• Language style: Casual but respectful of serious topics\n\n⏱️ Timing Strategy:\n• Best posting times: Weekday afternoons\n• Avoid posting: Early morning, late night\n\n🚫 Topics to Avoid:\n• Celebrating violence/death\n• Discriminatory content\n• Explicit political bias\n\n✅ Topics that Resonate:\n• Current events with measured commentary\n• Relatable teenage experiences\n• Light humor mixed with serious topics\n\n**QUESTIONS FOR DEEPER ANALYSIS**\n\n🤔 Compelling questions:\n\n1. How does age verification affect community trust?\n2. What role does humor play in processing serious news?\n3. How do moderation practices affect discussion quality?\n4. What drives the high level of political engagement?\n5. How does sentiment spread through comment chains?\n\n**SUMMARY**\n\n📋 Executive Summary:\nThis teenage community shows surprisingly sophisticated engagement with current events, effectively balancing serious discussion with appropriate humor. The negative sentiment trend (-0.06) reflects engagement with serious topics rather than community toxicity. Strong community standards exist around discussing tragic events, with effective self-moderation through voting patterns.",
          "generated_at": "2025-09-15T10:16:03.553Z",
          "model_used": "Claude 3.5 Sonnet"
        },
        "synthetic_post": {
          "title": "My crush finally noticed me today... by hitting me with her car 💀",
          "author": "anxiety_king_15",
          "body": "fr she was backing out of the school parking lot and didn't see me walking behind her car 😭 knocked me right over\n\nnow we're texting and she keeps apologizing but like... task failed successfully? 💀\n\nedit: yes im fine just bruised my ego and my butt lmao",
          "score": 12847,
          "upvoteRatio": 0.94,
          "comments": [
            {
              "id": "comment1",
              "author": "depressedteen_2004",
              "body": "bro unlocked romance through vehicular manslaughter 💀",
              "score": 4521,
              "replies": [],
              "level": 0,
              "sentiment": "humorous"
            },
            {
              "id": "comment2",
              "author": "memequeen_xo",
              "body": "new dating strategy just dropped",
              "score": 2833,
              "replies": [],
              "level": 0,
              "sentiment": "humorous"
            },
            {
              "id": "comment3",
              "author": "gamerboy42069",
              "body": "least desperate r/teenagers user",
              "score": 2104,
              "replies": [],
              "level": 0,
              "sentiment": "sarcastic"
            },
            {
              "id": "comment4",
              "author": "throwaway_839201",
              "body": "don't fumble this bag king 👑",
              "score": 1893,
              "replies": [],
              "level": 0,
              "sentiment": "supportive"
            },
            {
              "id": "comment5",
              "author": "pizza_lover_22",
              "body": "bro really said: if she can't notice me normally, she'll notice me through her rear view mirror 😭",
              "score": 1544,
              "replies": [],
              "level": 0,
              "sentiment": "humorous"
            },
            {
              "id": "comment6",
              "author": "doom_slayer_69",
              "body": "achievement unlocked: insurance claim romance",
              "score": 1233,
              "replies": [],
              "level": 0,
              "sentiment": "humorous"
            },
            {
              "id": "comment7",
              "author": "band_kid_2023",
              "body": "this is literally the plot of every wattpad story fr fr",
              "score": 987,
              "replies": [],
              "level": 0,
              "sentiment": "sarcastic"
            },
            {
              "id": "comment8",
              "author": "minecraft_pro",
              "body": "bros living in a romcom",
              "score": 756,
              "replies": [],
              "level": 0,
              "sentiment": "humorous"
            },
            {
              "id": "comment9",
              "author": "skater_girl_12",
              "body": "please update us if you start dating 👀",
              "score": 544,
              "replies": [],
              "level": 0,
              "sentiment": "curious"
            },
            {
              "id": "comment10",
              "author": "lonely_boi_hours",
              "body": "imagine having a crush notice you (even if it takes getting hit by their car) 😔",
              "score": 423,
              "replies": [],
              "level": 0,
              "sentiment": "self-deprecating"
            }
          ],
          "subreddit": "teenagers",
          "timeAgo": "4 hours ago",
          "sentiment": "humorous",
          "generated_at": "2025-09-15T11:13:46.688Z",
          "version": 1
        }
      },
      "posts": [
        {
          "id": "1ndqao6",
          "title": "Charlie Kirk is dead.",
          "selftext": "",
          "score": 45265,
          "num_comments": 1882,
          "created_utc": 1757538352,
          "subreddit": "teenagers",
          "permalink": "/r/teenagers/comments/1ndqao6/charlie_kirk_is_dead/",
          "url": "https://i.redd.it/i60iinatjeof1.png",
          "author": "stupefy100",
          "comments": [
            {
              "id": "nditfrh",
              "body": "Bro they ALREADY updated the wiki with his death date",
              "score": 8689,
              "created_utc": 1757539227,
              "author": "Sadphotographer6193"
            },
            {
              "id": "ndj68p7",
              "body": "there was a school shooting today, just wanted to say",
              "score": 5747,
              "created_utc": 1757542909,
              "author": "cashbrokethedrumstix"
            },
            {
              "id": "ndiw4vv",
              "body": "Wikipedia editors are quick to update",
              "score": 4063,
              "created_utc": 1757539973,
              "author": "MCKlassik"
            },
            {
              "id": "ndirk53",
              "body": "Prayers for Evergreen High School ❤️. School Shooting happened at 1:04pm & little to no media coverage. It happened about the same time. He defended guns, I’ll leave that there. Those high schoolers deserve more justice.",
              "score": 3815,
              "created_utc": 1757538721,
              "author": "CaterpillarOk5825"
            }
          ]
        },
        {
          "id": "1nejg8s",
          "title": "Not everyone is a pedo",
          "selftext": "Some people genuinely just haven’t checked your age especially if your profile has hidden posts ",
          "score": 18975,
          "num_comments": 217,
          "created_utc": 1757622023,
          "subreddit": "teenagers",
          "permalink": "/r/teenagers/comments/1nejg8s/not_everyone_is_a_pedo/",
          "url": "https://i.redd.it/ode6ahwnglof1.jpeg",
          "author": "Anonim_x9",
          "comments": [
            {
              "id": "ndp5p6c",
              "body": "Good ending unlocked.",
              "score": 5990,
              "created_utc": 1757622482,
              "author": "Cryptidangel"
            },
            {
              "id": "ndp83zu",
              "body": "Achievement- False alarm",
              "score": 2051,
              "created_utc": 1757623175,
              "author": "YOU_SWIT"
            },
            {
              "id": "ndp9kiy",
              "body": "Plus ppl just call other people pedos for no fucking reason. My friend said our gym teacher is a pedo today like grow the fuck up.\n\nHis reasoning tho?? Two of the games we played required us to hold hands. (THE STUDENTS HAD TO HOLD HANDS BTW, THE TEACHER JUST WATCHED) we also played a game that required squatting if you lost rock paper scissors. He said \"he also made a class of primarily girls pla...",
              "score": 1991,
              "created_utc": 1757623595,
              "author": "AppropriateTough6168"
            },
            {
              "id": "ndp9x4c",
              "body": "Atp i might assume your friend is a porn addicted freak.",
              "score": 1397,
              "created_utc": 1757623696,
              "author": "TipinCrispin"
            }
          ]
        },
        {
          "id": "1nezw4z",
          "title": "Poor Ed 😔",
          "selftext": "",
          "score": 15038,
          "num_comments": 101,
          "created_utc": 1757674018,
          "subreddit": "teenagers",
          "permalink": "/r/teenagers/comments/1nezw4z/poor_ed/",
          "url": "https://i.redd.it/0dkzvvs9rpof1.jpeg",
          "author": "[deleted]",
          "comments": [
            {
              "id": "ndsm6qj",
              "body": "he's literally wearing a waiter outfit",
              "score": 2325,
              "created_utc": 1757674612,
              "author": "sexypanini6"
            },
            {
              "id": "ndsnj7g",
              "body": "If you wear a red polo shirt in Target, don’t act surprised if someone asks where the beds are",
              "score": 929,
              "created_utc": 1757675220,
              "author": "SpecialistFelt389"
            },
            {
              "id": "ndso0r0",
              "body": "r/idontworkherelady",
              "score": 885,
              "created_utc": 1757675436,
              "author": "AstroKedii"
            },
            {
              "id": "ndslm47",
              "body": "To be fair he literally looks like a frog",
              "score": 741,
              "created_utc": 1757674349,
              "author": "No-Size3463"
            }
          ]
        },
        {
          "id": "1nemnwu",
          "title": "i hate ts school😔",
          "selftext": "",
          "score": 13275,
          "num_comments": 884,
          "created_utc": 1757629956,
          "subreddit": "teenagers",
          "permalink": "/r/teenagers/comments/1nemnwu/i_hate_ts_school/",
          "url": "https://i.redd.it/qj70fi984mof1.jpeg",
          "author": "CatmansAnxiety",
          "comments": [
            {
              "id": "ndpvn2p",
              "body": "Skibbity 🥀🥀🥀\nAlso who says bussin ",
              "score": 2749,
              "created_utc": 1757630708,
              "author": "Decent-Climate5346"
            },
            {
              "id": "ndpvtlh",
              "body": "the lunch crew💜",
              "score": 1375,
              "created_utc": 1757630771,
              "author": "CatmansAnxiety"
            },
            {
              "id": "ndputyo",
              "body": "Whoever thought of that must be a drug addict",
              "score": 1289,
              "created_utc": 1757630426,
              "author": "Gman8751"
            },
            {
              "id": "ndpupzl",
              "body": "If I saw this at my school, I would just take the choky milk with me.",
              "score": 480,
              "created_utc": 1757630388,
              "author": "WildConstruction7072"
            }
          ]
        },
        {
          "id": "1ngqc3d",
          "title": "\"How shall I make it about myself.\"",
          "selftext": "",
          "score": 12244,
          "num_comments": 578,
          "created_utc": 1757853779,
          "subreddit": "teenagers",
          "permalink": "/r/teenagers/comments/1ngqc3d/how_shall_i_make_it_about_myself/",
          "url": "https://i.redd.it/m6j2xzksl4pf1.jpeg",
          "author": "Gloomy_Meringue7695",
          "comments": [
            {
              "id": "ne5q9c2",
              "body": "I mean if he insists ",
              "score": 2455,
              "created_utc": 1757854378,
              "author": "50dinara"
            },
            {
              "id": "ne5td7o",
              "body": "The dude no one invited😭",
              "score": 1561,
              "created_utc": 1757855566,
              "author": "scp6090"
            },
            {
              "id": "ne5qcyu",
              "body": "Using another dude death to play the victim... and he's famous bcs peak masculinity? Wtf guys? ",
              "score": 961,
              "created_utc": 1757854416,
              "author": "Cozy_Kale"
            },
            {
              "id": "ne5y7em",
              "body": "'that can be arranged' ahh comment 😭",
              "score": 577,
              "created_utc": 1757857261,
              "author": "new_account_yay_"
            }
          ]
        },
        {
          "id": "1ng8bfs",
          "title": "Sad reality tbh",
          "selftext": "",
          "score": 11983,
          "num_comments": 215,
          "created_utc": 1757796391,
          "subreddit": "teenagers",
          "permalink": "/r/teenagers/comments/1ng8bfs/sad_reality_tbh/",
          "url": "https://i.redd.it/9genxca4vzof1.png",
          "author": "BellSpecial7296",
          "comments": [
            {
              "id": "ne2jzwz",
              "body": "What if it was a black hispanic muslim....",
              "score": 1468,
              "created_utc": 1757802642,
              "author": "theHrayX"
            },
            {
              "id": "ne2jovz",
              "body": "Fr when a white guy shoots in the school or something they say \"Today a young and mentally ill person un-alived kids at school\" \n\n\nHe is still a terrorist, right?",
              "score": 768,
              "created_utc": 1757802538,
              "author": "Boring-Ad-1208"
            },
            {
              "id": "ne3mgg3",
              "body": "The world would blow up",
              "score": 747,
              "created_utc": 1757816576,
              "author": "wazefuk"
            },
            {
              "id": "ne3e7va",
              "body": "or how Nancy Mace said \"Time to bring back the death penalty\" before the shooter was revealed to be a cis man and afterward immediately backed off and was all like \"ooo we'll pray for him we're sorry (no we aren't)\"",
              "score": 620,
              "created_utc": 1757813446,
              "author": "Cod3broken"
            }
          ]
        },
        {
          "id": "1ngvu12",
          "title": "This is a good one actually",
          "selftext": "",
          "score": 11776,
          "num_comments": 4170,
          "created_utc": 1757867516,
          "subreddit": "teenagers",
          "permalink": "/r/teenagers/comments/1ngvu12/this_is_a_good_one_actually/",
          "url": "https://i.redd.it/xhkug8wmq5pf1.jpeg",
          "author": "roselove_star_2364",
          "comments": [
            {
              "id": "ne6z04y",
              "body": "scam centers in shambles",
              "score": 4678,
              "created_utc": 1757868351,
              "author": "Bowtieguy-83"
            },
            {
              "id": "ne6w9g1",
              "body": "The lying industry",
              "score": 4600,
              "created_utc": 1757867581,
              "author": "Quick_Search4124"
            },
            {
              "id": "ne7236b",
              "body": "YT ads, Government\n\n\nBut most of all, whoever tf comes up with update release dates",
              "score": 2355,
              "created_utc": 1757869194,
              "author": "Capital_Pension5814"
            },
            {
              "id": "ne6wmni",
              "body": "Politics",
              "score": 2086,
              "created_utc": 1757867684,
              "author": "Iffg7ugg"
            }
          ]
        },
        {
          "id": "1ngn8u6",
          "title": "Not being political but this is the truth",
          "selftext": "",
          "score": 8915,
          "num_comments": 450,
          "created_utc": 1757843680,
          "subreddit": "teenagers",
          "permalink": "/r/teenagers/comments/1ngn8u6/not_being_political_but_this_is_the_truth/",
          "url": "https://i.redd.it/dkfecjerr3pf1.jpeg",
          "author": "Informal-Use5670",
          "comments": [
            {
              "id": "ne57jo3",
              "body": "\"DEATH PENALTY, BRING IT FORTH\"",
              "score": 736,
              "created_utc": 1757845584,
              "author": "Jeff-McBilly"
            },
            {
              "id": "ne583gz",
              "body": "what did she even mean by \"time to being back the death penalty\" utah, and tons of other states have the death penalty",
              "score": 506,
              "created_utc": 1757845899,
              "author": "Ryaniseplin"
            },
            {
              "id": "ne5a3g1",
              "body": "Honestly, Charlie kirk isn't more important than anyone else, if his killer gets the death penalty, so should every single murderer.",
              "score": 418,
              "created_utc": 1757847018,
              "author": "Cool_Cat_1004"
            },
            {
              "id": "ne5du30",
              "body": "No no no, Nancy found out the killer was white so now we pray for them, no death penalty",
              "score": 258,
              "created_utc": 1757848986,
              "author": "hat1414"
            }
          ]
        },
        {
          "id": "1nd9r3d",
          "title": "My favourite image from the Nepal parliament building set on fire by students",
          "selftext": "This basically encapsulates our generation in a really powerful image. ",
          "score": 8015,
          "num_comments": 163,
          "created_utc": 1757497426,
          "subreddit": "teenagers",
          "permalink": "/r/teenagers/comments/1nd9r3d/my_favourite_image_from_the_nepal_parliament/",
          "url": "https://i.redd.it/fyakhda66bof1.jpeg",
          "author": "redflamingoooo",
          "comments": [
            {
              "id": "ndf4caa",
              "body": "I wiped",
              "score": 902,
              "created_utc": 1757498168,
              "author": "Augustinelee7620"
            },
            {
              "id": "ndf6922",
              "body": "r/iswiped",
              "score": 356,
              "created_utc": 1757499203,
              "author": "Illybotje1"
            },
            {
              "id": "ndf9icf",
              "body": "Upon scrolling to this post, I had originally thought it would be multiple images, due to the presence of a pair of dots at the bottom, and a pair of numbers in the top right corner. Upon viewing this combination of UI elements, I had wrongly assumed that this post contained multiple images. Unassumingly, I had placed my right thumb upon the screen where this post was located, and proceeded to dra...",
              "score": 288,
              "created_utc": 1757500882,
              "author": "FakeMik090"
            },
            {
              "id": "ndf6f8o",
              "body": "6-7",
              "score": 131,
              "created_utc": 1757499293,
              "author": "redflamingoooo"
            }
          ]
        },
        {
          "id": "1nf33mg",
          "title": "What's one genre of music you absolutely HATE",
          "selftext": "",
          "score": 7881,
          "num_comments": 2694,
          "created_utc": 1757683305,
          "subreddit": "teenagers",
          "permalink": "/r/teenagers/comments/1nf33mg/whats_one_genre_of_music_you_absolutely_hate/",
          "url": "https://i.redd.it/08ge3ikuiqof1.png",
          "author": "sexypanini6",
          "comments": [
            {
              "id": "ndt9t8t",
              "body": "I would say none but im sure theres something out there i hate but just can't think of",
              "score": 749,
              "created_utc": 1757683475,
              "author": "Top-Worldliness-4861"
            },
            {
              "id": "ndtiwe9",
              "body": "That shit that plays on morning shows where everybody is smiling but on the inside they want to kill themselves",
              "score": 590,
              "created_utc": 1757686293,
              "author": "_lolman123_"
            },
            {
              "id": "ndtpu1r",
              "body": "Nationalist socialist black metal (nsbm or nazi metal) is a subgenre of black metal that is full of pro-nazi lyrics. Also there is nazi punk which is ironic because the ideology that caused punk to start was anarchy and anti-authoritanianism and then some idiots just said nope",
              "score": 435,
              "created_utc": 1757688249,
              "author": "crapeater1759"
            },
            {
              "id": "ndtbt1m",
              "body": "I don't necesarrily hate ALL music from this genre, but the genre I probably dislike the most is reggaeton. It's almost always done on the same beat and the songs are hardly ever about anything other than sex and partying",
              "score": 378,
              "created_utc": 1757684121,
              "author": "Proof-Assistant-7536"
            }
          ]
        },
        {
          "id": "1nbjzmg",
          "title": "lets hear y'all crazy abilities",
          "selftext": "",
          "score": 6854,
          "num_comments": 4181,
          "created_utc": 1757326908,
          "subreddit": "teenagers",
          "permalink": "/r/teenagers/comments/1nbjzmg/lets_hear_yall_crazy_abilities/",
          "url": "https://i.redd.it/newx05t43xnf1.jpeg",
          "author": "cindyswee",
          "comments": [
            {
              "id": "nd28n2v",
              "body": "Alzheimer",
              "score": 2347,
              "created_utc": 1757327726,
              "author": "robmiloda"
            },
            {
              "id": "nd28nkj",
              "body": "Alzheimer",
              "score": 1800,
              "created_utc": 1757327733,
              "author": "robmiloda"
            },
            {
              "id": "nd28nwk",
              "body": "Alzheimer",
              "score": 1735,
              "created_utc": 1757327739,
              "author": "robmiloda"
            },
            {
              "id": "nd28u81",
              "body": "Idk I don't remember",
              "score": 1642,
              "created_utc": 1757327833,
              "author": "robmiloda"
            }
          ]
        },
        {
          "id": "1nfsim7",
          "title": "i bought my first car all by myself",
          "selftext": "",
          "score": 6519,
          "num_comments": 779,
          "created_utc": 1757753189,
          "subreddit": "teenagers",
          "permalink": "/r/teenagers/comments/1nfsim7/i_bought_my_first_car_all_by_myself/",
          "url": "https://i.redd.it/b2oci9joawof1.jpeg",
          "author": "Spooky806",
          "comments": [
            {
              "id": "ndyqor5",
              "body": "looks expensive for a first car. Be careful, expensive driving mistakes can happen very quickly.",
              "score": 2011,
              "created_utc": 1757754415,
              "author": "dr2okevin"
            },
            {
              "id": "ndyqybu",
              "body": "well, it’s not my first car but it’s the first car that i financed all on my own, i had no help finding, or paying for it! i’m proud of myself and my parents are shocked lol\n\nyes. it is very expensive but it’s in my budget :)",
              "score": 1398,
              "created_utc": 1757754578,
              "author": "Spooky806"
            },
            {
              "id": "ndysnf9",
              "body": "Oh hell nah when do you sleep and eat",
              "score": 978,
              "created_utc": 1757755609,
              "author": "maxca15"
            },
            {
              "id": "ndys9ho",
              "body": "i recently started living without my parents and picked up 2 full time jobs working 80 hours a week holding the same wage for both jobs\n\nit checks out 💯",
              "score": 975,
              "created_utc": 1757755375,
              "author": "Spooky806"
            }
          ]
        }
      ]
    }
  },
  {
    "id": "mfkwspcpvmv4b93fj",
    "generated_at": "2025-09-15T09:15:55.609Z",
    "name": "r/Jokes Humor Analysis",
    "description": "Sentiment analysis of humor content and audience reactions to jokes, puns, and comedy on Reddit's largest joke community.",
    "subreddits": [
      "Jokes"
    ],
    "dateRange": {
      "startDate": "2025-09-08",
      "endDate": "2025-09-15"
    },
    "totalPosts": 20,
    "totalComments": 1796,
    "data": {
      "summary": {
        "totalPosts": 20,
        "totalComments": 1796,
        "subreddits": [
          "Jokes"
        ],
        "dateRange": {
          "startDate": "2025-09-08",
          "endDate": "2025-09-15"
        }
      },
      "analysis": {
        "overall_sentiment": {
          "average_score": 0.7,
          "sentiment_distribution": {
            "positive": 75,
            "neutral": 20,
            "negative": 5
          },
          "dominant_themes": [
            "humor",
            "funny",
            "joke",
            "laughter",
            "comedy",
            "wholesome",
            "marriage",
            "chuckle",
            "smile",
            "entertaining"
          ],
          "key_emotions": [
            "amusement",
            "joy",
            "humor",
            "entertainment",
            "laughter"
          ],
          "summary": "The overall sentiment is neutral (positive 43%). Key themes include: humor, wordplay, criticism."
        },
        "individual_scores": [
          {
            "index": 1,
            "score": -0.6,
            "sentiment": "negative",
            "confidence": 0.85,
            "themes": [
              "anger",
              "relationship",
              "conflict"
            ],
            "emotions": [],
            "source": {
              "type": "post_title",
              "postId": "1ng64wz",
              "subreddit": "Jokes"
            }
          },
          {
            "index": 2,
            "score": 0.7,
            "sentiment": "positive",
            "confidence": 0.9,
            "themes": [
              "humor",
              "twist",
              "marriage"
            ],
            "emotions": [],
            "source": {
              "type": "post_body",
              "postId": "1ng64wz",
              "subreddit": "Jokes"
            }
          },
          {
            "index": 3,
            "score": 0.8,
            "sentiment": "positive",
            "confidence": 0.9,
            "themes": [
              "gratitude",
              "relief",
              "humor"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1ng64wz",
              "commentId": "ne1u8bv",
              "subreddit": "Jokes"
            }
          },
          {
            "index": 4,
            "score": 0.7,
            "sentiment": "positive",
            "confidence": 0.85,
            "themes": [
              "kindness",
              "empathy",
              "joy"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1ng64wz",
              "commentId": "ne1uk5n",
              "subreddit": "Jokes"
            }
          },
          {
            "index": 5,
            "score": 0.8,
            "sentiment": "positive",
            "confidence": 0.9,
            "themes": [
              "joy",
              "humor",
              "laughter"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1ng64wz",
              "commentId": "ne2srrl",
              "subreddit": "Jokes"
            }
          }
        ],
        "by_subreddit": {
          "Jokes": {
            "scores": [
              -0.6,
              0.7,
              0.8,
              0.7,
              0.8,
              0,
              0.3,
              -0.6,
              0.2,
              -0.7,
              -0.2,
              0.4,
              0.3,
              0.4,
              0.6,
              0.7,
              0.5,
              0.8,
              0.4,
              -0.3,
              0.6,
              -0.5,
              0,
              0,
              0.4,
              0.5,
              0.5,
              0.5,
              0.5,
              0.3,
              0.4,
              0,
              0.3,
              0.4,
              -0.3,
              0,
              0.3,
              0,
              0,
              0.5,
              0.6,
              0.7,
              0,
              0.6,
              -0.2,
              0,
              0,
              0.5,
              0,
              0.3,
              0.7,
              -0.6,
              0.6,
              -0.3,
              -0.4,
              0.2,
              0.6,
              0.8,
              0.7,
              0,
              0.3,
              0.6,
              0.6,
              0.6,
              0.6,
              -0.2,
              0.7,
              0.2,
              0.5,
              0.6,
              0.4,
              0.7,
              0.6,
              0.8,
              0.8,
              0.5,
              0.6,
              0.4,
              0.8,
              0.5,
              -0.2,
              0.8,
              0.6,
              0.6,
              0.7,
              -0.4,
              0.8,
              0.4,
              0.4,
              0.3,
              0.5,
              -0.3,
              0.5,
              -0.2,
              0.8,
              0.6,
              -0.1,
              0.4,
              0.9,
              0.6,
              0.7,
              0.8,
              -0.6,
              0.3,
              -0.8,
              0.6,
              -0.9,
              -0.3,
              0,
              0.2,
              0.6,
              0.8,
              0.5,
              -0.2,
              0.3,
              0.4,
              -0.7,
              0,
              0,
              -0.2,
              -0.4,
              0.4,
              0.5,
              0.6,
              0.7,
              0.6,
              0.6,
              0.5,
              0.4,
              0.5,
              0.6,
              0.7,
              0.5,
              0.4,
              0.5,
              0.4,
              0,
              0.3,
              -0.5,
              0.6,
              0.5,
              0.5,
              0.4,
              -0.6,
              -0.2,
              0.2,
              0.3,
              0.2,
              0.1,
              0.2,
              0.3,
              -0.6,
              -0.2,
              -0.8,
              -0.3,
              0.2,
              0.3,
              -0.5,
              -0.7,
              0.3,
              0.1,
              -0.4,
              0.7,
              0,
              0.2,
              -0.2,
              0.1,
              -0.1,
              -0.6,
              -0.4,
              -0.8,
              0.1,
              -0.3,
              -0.6,
              0.4,
              0,
              0.2,
              0.3,
              0.2,
              0.4,
              -0.5,
              0.2,
              0.7,
              0.3,
              -0.2,
              0,
              0.2,
              -0.8,
              -0.2,
              -0.9,
              0.3,
              -0.6,
              0,
              0.2,
              -0.4,
              0.2,
              0,
              0.6,
              0.4,
              0.6,
              0.3,
              0.8,
              -0.7,
              0.5,
              0.2,
              0.4,
              0,
              0,
              -0.2,
              -0.7,
              0.4,
              0.5,
              0.3,
              -0.2,
              0.2,
              0.3,
              0.5,
              -0.8,
              -0.3,
              -0.2,
              0.6,
              -0.2,
              0.3,
              -0.7,
              -0.4,
              -0.6,
              0.2,
              -0.3,
              -0.2,
              -0.1,
              0.2,
              0.1,
              0.3,
              0.4,
              0,
              0.2,
              -0.5,
              0,
              0.1,
              0.4,
              0.2,
              0.1,
              0.3,
              0,
              -0.2,
              -0.1,
              -0.3,
              0,
              -0.4,
              -0.5,
              -0.4,
              -0.5,
              -0.4,
              -0.5,
              0.3,
              0,
              0.1,
              0.2,
              0.1,
              -0.2,
              -0.4,
              -0.6,
              0.2,
              0.1,
              -0.1,
              -0.2,
              -0.2,
              0.3,
              0.4,
              0.2,
              0.6,
              -0.2,
              -0.8,
              0.4,
              -0.3,
              0.1,
              0,
              0,
              0.2,
              -0.4,
              -0.2,
              -0.7,
              -0.5,
              0.3,
              0.4,
              0.2,
              -0.3,
              0.1,
              -0.4,
              0.3,
              -0.5,
              -0.6,
              -0.4,
              -0.5,
              0.2,
              -0.3,
              -0.7,
              0.1,
              -0.6,
              0.5,
              0.1,
              0.2,
              -0.4,
              -0.3,
              0.1,
              0,
              0.4,
              0.6,
              0.7,
              -0.2,
              -0.1,
              0.2,
              0.3,
              0.1,
              0.4,
              0.2,
              0.3,
              0.2,
              0.3,
              -0.7,
              0.3,
              0.8,
              0,
              0.4,
              -0.6,
              -0.4,
              -0.8,
              0.6,
              0.7,
              -0.3,
              0.9,
              0.5,
              0.2,
              -0.2,
              -0.5,
              -0.7,
              -0.4,
              -0.3,
              -0.8,
              0,
              -0.2,
              -0.8,
              -0.1,
              -0.9,
              -0.7,
              -0.6,
              -0.4,
              0.6,
              -0.8,
              -0.3,
              -0.2,
              -0.4,
              0.3,
              0.2,
              -0.3,
              -0.2,
              0.2,
              0.1,
              -0.5,
              0,
              0.8,
              0.4,
              0.3,
              0.5,
              -0.2,
              0.2,
              0.3,
              0.1,
              -0.3,
              0,
              0.6,
              0.2,
              0.7,
              0.3,
              0.9,
              -0.3,
              -0.1,
              -0.2,
              0.1,
              0.2,
              0.1,
              0.3,
              -0.5,
              0.4,
              0.3,
              0.1,
              -0.2,
              0.8,
              0.3,
              0.5,
              0.1,
              -0.1,
              0,
              -0.2,
              -0.3,
              -0.2,
              -0.1,
              0.2,
              -0.1,
              0.6,
              0.1,
              0.8,
              0.3,
              0.4,
              0.7,
              0.6,
              0.2,
              -0.1,
              0.5,
              -0.1,
              0.7,
              -0.4,
              -0.1,
              -0.2,
              0.1,
              0.2,
              -0.2,
              -0.6,
              -0.5,
              -0.1,
              -0.4,
              0.8,
              -0.2,
              -0.7,
              -0.5,
              0,
              0.2,
              0.3,
              0.2,
              0.4,
              0.6,
              0.3,
              0.4,
              0.3,
              -0.3,
              -0.2,
              -0.3,
              0.5,
              -0.6,
              0.3,
              0.2,
              0.7,
              0.4,
              0.3,
              0.2,
              0.4,
              0.5,
              0.6,
              0.3,
              0.4,
              -0.2,
              -0.3,
              0,
              -0.2,
              0.8,
              0.4,
              0.6,
              0.1,
              0.3,
              0.1,
              0.2,
              0.1,
              0.5,
              -0.3,
              -0.1,
              -0.4,
              -0.2,
              0.2,
              0.2,
              0.2,
              0.3,
              0.3,
              0,
              0,
              0,
              0.2,
              -0.3,
              0.2,
              -0.5,
              -0.3,
              0,
              0.2,
              -0.7,
              -0.3,
              -0.4,
              0.3,
              0.2,
              -0.4,
              -0.3,
              -0.6,
              -0.1,
              -0.2,
              0.2,
              -0.7,
              0.3,
              -0.1,
              -0.5,
              -0.3,
              0,
              -0.2,
              0.4,
              0.3,
              0.2,
              0.4,
              0.3,
              0.2,
              -0.2,
              -0.1,
              0.3,
              0.5,
              0.3,
              0.1,
              0.2,
              0.3,
              0.4,
              0.2,
              0.1,
              0.5,
              0.3,
              -0.2,
              0.3,
              0.1,
              0.5,
              0.4,
              0.4,
              0.2,
              -0.3,
              0.1,
              0.2,
              0.6,
              0,
              -0.5,
              0.3,
              0.4,
              -0.4,
              0.2,
              -0.1,
              0.4,
              0.1,
              0.3,
              -0.2,
              0.4,
              0.8,
              0.3,
              0.4,
              0.5,
              0.9,
              -0.3,
              0.7,
              0.2,
              -0.5,
              -0.8,
              -0.4,
              0.3,
              0.4,
              -0.3,
              0.6,
              -0.4,
              -0.3,
              -0.2,
              -0.6,
              0.6,
              0.2,
              -0.4,
              -0.5,
              0.1,
              0.1,
              -0.3,
              -0.1,
              -0.2,
              -0.4,
              -0.6,
              -0.3,
              0.1,
              -0.3,
              0.5,
              0.3,
              -0.4,
              -0.7,
              -0.8,
              -0.6,
              -0.7,
              -0.4,
              -0.5,
              -0.3,
              -0.4,
              -0.6,
              -0.7,
              -0.8,
              -0.7,
              -0.3,
              -0.8,
              0.1,
              0.3,
              0.6,
              0.4,
              0.5,
              0.4,
              0.5,
              0.4,
              0.1,
              0.5,
              0.3,
              0.4,
              0.5,
              0.2,
              0.4,
              0.7,
              0.5,
              0.6,
              0.3,
              0.4,
              0.6,
              0,
              0.1,
              0.5,
              0.2,
              0.1,
              0.3,
              0.3,
              0,
              0.4,
              0.2,
              0.6,
              0.3,
              0.3,
              0.1,
              0.2,
              0.5,
              0.7,
              0.2,
              0.5,
              0.4,
              0.3,
              0.5,
              0.3,
              0.8,
              0.2,
              -0.2,
              -0.3,
              -0.4,
              0.3,
              -0.2,
              0.1,
              0.2,
              0,
              -0.3,
              0.8,
              0.4,
              0.2,
              0.5,
              0.6,
              -0.5,
              -0.1,
              0.9,
              -0.2,
              0.7,
              -0.1,
              0.1,
              0.2,
              0.1,
              0,
              0.7,
              0.6,
              0.4,
              0.3,
              0.2,
              -0.3,
              0.1,
              -0.1,
              0,
              -0.4,
              0.1,
              -0.6,
              0.4,
              -0.7,
              -0.3,
              -0.2,
              0,
              -0.1,
              0.2,
              0.1,
              -0.2,
              0.3,
              -0.2,
              -0.3,
              0.2,
              -0.2,
              0.3,
              -0.1,
              0.2,
              0.4,
              0.5,
              0.1,
              -0.2,
              0,
              0.4,
              0.3,
              0,
              0.6,
              -0.7,
              -0.1,
              0,
              -0.2,
              -0.1,
              0.5,
              -0.4,
              -0.8,
              -0.3,
              0.4,
              0.7,
              0.6,
              0.1,
              0.3,
              0.8,
              -0.5,
              0.2,
              0.4,
              -0.3,
              0.1,
              0.2,
              0.3,
              -0.4,
              0.1,
              -0.2,
              0.4,
              -0.2,
              0.8,
              -0.3,
              0,
              0.3,
              0.1,
              -0.1,
              0,
              -0.2,
              0.3,
              -0.2,
              -0.8,
              -0.7,
              -0.3,
              -0.2,
              0.6,
              0,
              0.8,
              0.9,
              0.4,
              -0.2,
              0.6,
              -0.8,
              -0.3,
              -0.7,
              -0.4,
              -0.2,
              0.1,
              0.3,
              0.4,
              0.2,
              0.1,
              -0.3,
              -0.4,
              0,
              0.2,
              0.5,
              0.4,
              0.3,
              0.2,
              0.1,
              -0.5,
              0.3,
              0,
              0.1,
              0.2,
              0.1,
              -0.2,
              0.3,
              0.4,
              0.5,
              0.4,
              -0.2,
              0,
              0.5,
              0.4,
              0.6,
              0.1,
              0.7,
              0.6,
              0,
              0.8,
              0.3,
              -0.2,
              0,
              0.4,
              0.8,
              -0.6,
              -0.4,
              0.2,
              0,
              0.3,
              0.9,
              -0.3,
              -0.4,
              0.2,
              0.4,
              -0.2,
              0.3,
              0.2,
              0.5,
              0.6,
              0.3,
              -0.4,
              0.4,
              0.5,
              0.7,
              0.2,
              -0.2,
              0.3,
              -0.2,
              0,
              0.2,
              0.7,
              0.4,
              0.5,
              0,
              -0.7,
              0.2,
              0,
              0,
              0.6,
              0,
              0.4,
              0.6,
              0.7,
              0,
              0,
              0,
              0.2,
              0.3,
              0.4,
              0.8,
              0.7,
              0.3,
              0.6,
              0,
              0.4,
              0.3,
              -0.2,
              0.8,
              0.3,
              0.2,
              0.8,
              0.4,
              0.9,
              0.3,
              0.2,
              0.1,
              0.4,
              0.9,
              0.9,
              -0.4,
              0.4,
              0.5,
              0.8,
              0.8,
              0.7,
              0,
              0.5,
              0.3,
              0.1,
              0.2,
              0.1,
              -0.3,
              -0.2,
              -0.3,
              -0.5,
              0,
              -0.4,
              0.1,
              -0.3,
              0.4,
              0.3,
              0.1,
              0.4,
              0.1,
              0.3,
              0,
              0.2,
              -0.8,
              0,
              0,
              0.2,
              0.1,
              -0.3,
              0.3,
              -0.2,
              0,
              -0.4,
              0,
              0.4,
              0,
              0.1,
              -0.2,
              -0.3,
              -0.6,
              -0.4,
              -0.2,
              0.9,
              0.3,
              -0.7,
              0.1,
              0.2,
              0,
              0.1,
              0.2,
              0,
              0.4,
              0.2,
              0.5,
              0.3,
              0.6,
              0.4,
              0.5,
              0.4,
              0.3,
              0.6,
              0.3,
              0.4,
              0.4,
              0.4,
              0.2,
              0,
              -0.4,
              0.4,
              0.5,
              0.6,
              0.4,
              0,
              0.2,
              0.3,
              -0.2,
              0.1,
              -0.1,
              -0.3,
              0,
              0.2,
              0.1,
              -0.1,
              0.2,
              -0.6,
              0.6,
              0.8,
              -0.2,
              -0.3,
              0,
              0.7,
              0,
              -0.1,
              -0.2,
              -0.1,
              -0.1,
              0.7,
              0.2,
              0.1,
              0,
              0,
              -0.2,
              0.3,
              0.2,
              0.4,
              0.2,
              0.5,
              0.1,
              -0.3,
              0.3,
              0.4,
              0.3,
              0,
              0.6,
              0.5,
              0,
              0.4,
              -0.2,
              -0.1,
              -0.3,
              0.5,
              0.7,
              -0.8,
              -0.3,
              0.3,
              0.8,
              0.1,
              0,
              0.8,
              0.4,
              0.5,
              0,
              0.1,
              0.3,
              0.4,
              0.1,
              0.6,
              0.7,
              0,
              0.2,
              0.3,
              0.4,
              -0.3,
              0.9,
              -0.7,
              0,
              0.2,
              0,
              -0.2,
              0.8,
              0.1,
              -0.1,
              0.3,
              0.2,
              0,
              -0.2,
              0.2,
              0,
              0.1,
              0.2,
              0.3,
              0.1,
              0.6,
              0,
              0.4,
              0.3,
              0.4,
              0,
              0,
              -0.1,
              0,
              0.2,
              -0.6,
              0.1,
              0.4,
              -0.8,
              -0.7,
              -0.6,
              -0.3,
              -0.5,
              -0.7,
              0.6,
              -0.2,
              0,
              -0.4,
              -0.3,
              0,
              -0.4,
              0.2,
              0,
              -0.2,
              -0.1,
              0,
              -0.6,
              0,
              0,
              -0.3,
              -0.7,
              -0.2,
              0,
              0.2,
              0.6,
              0.8,
              0,
              0,
              0,
              0.3,
              -0.5,
              0,
              -0.6,
              0.2,
              -0.3,
              -0.4,
              -0.5,
              -0.2,
              0,
              0,
              0,
              -0.3,
              0.4,
              0.5,
              0.3,
              -0.8,
              -0.7,
              -0.4,
              -0.6,
              -0.7,
              -0.2,
              0,
              0.2,
              0,
              -0.4,
              -0.2,
              0.3,
              0.2,
              0,
              -0.2,
              0,
              0.2,
              0.8,
              0,
              0.7,
              0.1,
              0.3,
              0,
              0.2,
              0.4,
              -0.1,
              0,
              0,
              -0.2,
              0.1,
              0.2,
              -0.3,
              0.4,
              0,
              0.1,
              0,
              -0.2,
              -0.3,
              -0.2,
              0,
              0.1,
              0.2,
              0.6,
              0.3,
              -0.2,
              0,
              0.4,
              0.5,
              -0.2,
              -0.4,
              0.1,
              0.1,
              0,
              0.3,
              0.1,
              0.4,
              0,
              0.5,
              0.1,
              0.4,
              0.2,
              0.1,
              0,
              0.3,
              0.2,
              -0.2,
              -0.1,
              0.2,
              0.3,
              0.5,
              0.3,
              0,
              0.6,
              0.7,
              -0.4,
              0.1,
              0.3,
              0.2,
              -0.2,
              0.5,
              0,
              0.1,
              0.2,
              0.1,
              0.4,
              0.2,
              0,
              0,
              0.2,
              0.8,
              0.4,
              0.5,
              0,
              0.3,
              0.4,
              0.8,
              0.2,
              0.1,
              0.4,
              0.5,
              0.7,
              -0.3,
              0,
              0.4,
              0.1,
              0.9,
              0.6,
              0,
              0.3,
              0.5,
              0.1,
              0,
              0,
              -0.3,
              -0.2,
              -0.1,
              -0.2,
              -0.4,
              0,
              0.4,
              -0.2,
              0.1,
              0.2,
              -0.3,
              0.4,
              0,
              0.1,
              0,
              0.3,
              0.2,
              0.4,
              0.2,
              0,
              0.3,
              -0.1,
              -0.2,
              -0.3,
              0.3,
              0,
              -0.2,
              0.1,
              0,
              -0.5,
              -0.4,
              0.3,
              -0.2,
              -0.3,
              -0.2,
              0.2,
              0.4,
              0.2,
              0,
              0.1,
              0.2,
              0.3,
              0.4,
              0.5,
              0.4,
              0.3,
              0.3,
              0.2,
              0.4,
              0.3,
              0.2,
              0.1,
              0.2,
              0.3,
              0.1,
              0.4,
              0.2,
              0.8,
              0,
              0.3,
              0.1,
              -0.1,
              0,
              0,
              -0.8,
              -0.6,
              -0.5,
              0.4,
              0.3,
              0.2,
              0.1,
              -0.3,
              0.4,
              0,
              0,
              0,
              0.1,
              -0.5,
              0.2,
              0.3,
              -0.8,
              0.4,
              -0.7,
              -0.6,
              0.2,
              -0.9,
              0.3,
              -0.7,
              0.2,
              0.6,
              0.1,
              0.5,
              0,
              0.1,
              -0.4,
              0.2,
              0.2,
              0.3,
              0.7,
              0.4,
              0.8,
              0.3,
              0.2,
              0.4,
              -0.5,
              -0.4,
              0.3,
              0,
              -0.3,
              0.5,
              0.4,
              -0.6,
              0.3,
              -0.2,
              0.2,
              0.3,
              0,
              0.2,
              -0.1,
              0,
              0.1,
              -0.2,
              0.3,
              0,
              -0.2,
              0,
              0.6,
              -0.3,
              0.2,
              0.3,
              0.2,
              0.3,
              0.4,
              -0.4,
              -0.5,
              -0.3,
              0.4,
              0.2,
              0,
              0.4,
              0.3,
              0.4,
              0,
              0.3,
              0.5,
              0,
              0.4,
              -0.4,
              -0.2,
              0.5,
              0,
              -0.6,
              -0.3,
              0.2,
              -0.7,
              0,
              -0.2,
              0.3,
              -0.2,
              -0.4,
              -0.3,
              0,
              0.6,
              -0.2,
              0.4,
              0.1,
              -0.3,
              0.2,
              0.3,
              0.5,
              0.2,
              -0.3,
              -0.5,
              -0.2,
              0.2,
              0.4,
              -0.4,
              0.1,
              -0.6,
              0.2,
              0.3,
              0.1,
              0.1,
              0.4,
              0.3,
              -0.2,
              0.2,
              0.3,
              0.4,
              0.2,
              0.3,
              -0.3,
              -0.7,
              -0.4
            ],
            "positive": 595,
            "neutral": 423,
            "negative": 374,
            "average_score": 0.09719827586206893,
            "total_analyzed": 1392
          }
        },
        "timeline": [
          {
            "date": "2025-09-08",
            "average_score": -0.003053435114503793,
            "positive": 57,
            "neutral": 27,
            "negative": 47,
            "total": 131
          },
          {
            "date": "2025-09-09",
            "average_score": 0.06953642384105961,
            "positive": 111,
            "neutral": 109,
            "negative": 82,
            "total": 302
          },
          {
            "date": "2025-09-10",
            "average_score": 0.0908296943231441,
            "positive": 105,
            "neutral": 60,
            "negative": 64,
            "total": 229
          },
          {
            "date": "2025-09-11",
            "average_score": 0.08054054054054056,
            "positive": 62,
            "neutral": 76,
            "negative": 47,
            "total": 185
          },
          {
            "date": "2025-09-12",
            "average_score": 0.12128712871287127,
            "positive": 90,
            "neutral": 63,
            "negative": 49,
            "total": 202
          },
          {
            "date": "2025-09-13",
            "average_score": 0.15670103092783497,
            "positive": 148,
            "neutral": 67,
            "negative": 76,
            "total": 291
          },
          {
            "date": "2025-09-14",
            "average_score": 0.17115384615384613,
            "positive": 22,
            "neutral": 21,
            "negative": 9,
            "total": 52
          }
        ],
        "ai_insights": {
          "Jokes": "Here's a concise analysis of the sentiment and themes in the r/Jokes posts:\n\nOverall Mood and Attitudes:\n- The community appears to have a good sense of humor and a penchant for raunchy, irreverent jokes. There is a general tone of playfulness and willingness to laugh at taboo or controversial topics.\n- Many of the top-voted jokes rely on stereotypes (e.g. blondes, nuns) or adult themes like sex, infidelity, and bodily functions.\n\nCommon Themes and Topics:\n- Sex, relationships, and gender dynamics are very common topics, often with a provocative or suggestive bent.\n- Jokes about social status, occupations, and institutional authority figures (e.g. doctors, police) are also prevalent.\n- Recurring themes include the human body, bodily functions, and unconventional/unorthodox behavior.\n\nUpvote Patterns:\n- Jokes that play on unexpected twists, subvert expectations, or have a shocking punchline tend to get the most upvotes.\n- Jokes that are profane, raunchy, or challenge social norms also seem to resonate well with the community.\n- There's a general preference for witty, concise jokes over lengthy setups.\n\nEmerging Trends:\n- The community appears to have a consistent appetite for edgy, adult-oriented humor, with little indication of a shift in that direction.\n- Some jokes touch on timely cultural references (e.g. cryptocurrency, COVID) but these don't seem to be a major focus.\n\nPain Points and Frustrations:\n- The data doesn't reveal any major pain points or frustrations within the community. The jokes are generally lighthearted in nature.\n- However, there may be an underlying sense that the community relishes challenging social norms and authority figures, potentially as a form of release or rebellion.\n\nOverall, the r/Jokes community seems to be in a healthy state, with members enthusiastically sharing and upvoting a steady stream of provocative, irreverent humor. The content reflects a group that is not afraid to engage with taboo topics and find the humor in life's more unseemly aspects."
        },
        "framework_analysis": {
          "success": true,
          "analysis": "**COMMUNITY PROFILING**\n\n• Community Type: Entertainment/Humor\n• Demographic Indicators: Predominantly male, English-speaking\n• Emotional Baseline: Moderately positive (0.1 average sentiment)\n• Community Character: A joke-sharing community that favors traditional format jokes with setups and punchlines. Shows strong engagement with relationship humor, situational comedy, and wordplay, while maintaining a balance between clean and adult humor.\n\n**PATTERN DISCOVERY**\n\n🔍 Key Findings:\n\n1. Surprising Pattern #1:\n   High engagement posts frequently involve marital dynamics, suggesting a mature audience despite Reddit's typically younger demographic\n\n2. Surprising Pattern #2:\n   Comments often outperform original jokes in humor and popularity, indicating a highly creative commenting community\n\n3. Surprising Pattern #3:\n   Sexual humor receives mixed reception - highly upvoted but also draws more critical comments\n\n💬 Controversy Triggers:\n• Gender-based stereotypes (especially \"blonde\" jokes)\n• Sexual content/anatomy jokes\n• Religious references\n\n📊 Success/Failure Predictors:\n• Success indicators: Clear setup/punchline structure, relatable situations, clever wordplay\n• Failure indicators: Overly explicit content, poorly timed reveals, offensive stereotypes\n\n**TEMPORAL ANALYSIS**\n\n⏰ Time-Based Patterns:\n\nDaily Cycles:\n• Morning: Lower engagement\n• Afternoon: Peak posting activity\n• Evening: Highest comment interaction\n\nWeekly Trends:\n• Weekday activity stronger than weekend\n• Peak engagement mid-week (Wednesday-Thursday)\n\nSentiment Evolution:\n• Sentiment improves throughout the day\n• Most positive during evening hours\n\n**KEY INSIGHTS**\n\n⭐ Most Important Discoveries:\n\n1. Engagement Correlation:\n   Jokes with universal themes (marriage, work, daily life) consistently outperform niche topics\n\n2. Unspoken Rules:\n   Community self-regulates offensive content through voting patterns\n\n3. Influence Patterns:\n   Top comments often spawn chains of related jokes or variations\n\n4. Content Predictors:\n   Traditional joke structure performs better than observational humor\n\n**ACTIONABLE RECOMMENDATIONS**\n\n📝 Content Strategy:\n• Best performing content types: Setup-punchline format, relationship scenarios\n• Optimal post structure: Short setup, unexpected twist\n• Language style: Clear, concise, avoiding over-explanation\n\n⏱️ Timing Strategy:\n• Best posting times: Weekday afternoons\n• Avoid posting: Early morning, late night\n\n🚫 Topics to Avoid:\n• Explicitly crude content\n• Overly complex setups\n• Political themes\n\n✅ Topics that Resonate:\n• Marriage/relationship dynamics\n• Workplace situations\n• Clever wordplay\n\n**QUESTIONS FOR DEEPER ANALYSIS**\n\n🤔 Compelling Questions:\n\n1. How does comment chain length correlate with joke complexity?\n2. What role does cultural context play in joke success?\n3. How has the community's humor evolved over time?\n4. What impact do current events have on joke themes?\n5. How do different age demographics respond to various joke types?\n\n**SUMMARY**\n\n📋 Executive Summary:\nThe r/Jokes community shows strong preference for traditional joke formats focusing on universal themes like relationships and daily life. With a slightly positive sentiment score (0.1), the community balances between clean and adult humor while self-regulating through voting patterns. Success strongly correlates with timing, structure, and relatable content rather than shock value or complexity.",
          "generated_at": "2025-09-15T09:13:10.468Z",
          "model_used": "Claude 3.5 Sonnet"
        },
        "synthetic_post": {
          "title": "My wife asked me to describe her using only three words...",
          "author": "JokeMaster2000",
          "body": "I said \"You're very demanding.\"\n\nShe replied \"That's only two words.\"\n\nI said \"And accurate.\"",
          "score": 8472,
          "upvoteRatio": 0.94,
          "comments": [
            {
              "id": "comment1",
              "author": "LaughTrack76",
              "body": "The real joke is always in the comments: My wife asked for three words and I said \"I was right\"",
              "score": 2341,
              "replies": [],
              "level": 0,
              "sentiment": "humorous"
            },
            {
              "id": "comment2",
              "author": "PunMaster365",
              "body": "Take my angry upvote and get out",
              "score": 1872,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment3",
              "author": "ChuckleNuts99",
              "body": "I told this to my wife and I'm now sleeping on the couch",
              "score": 1544,
              "replies": [],
              "level": 0,
              "sentiment": "humorous"
            },
            {
              "id": "comment4",
              "author": "JestR_2001",
              "body": "Three words for OP: Pretty damn clever",
              "score": 987,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment5",
              "author": "WordplayWizard",
              "body": "Here's my three words: Repost from yesterday",
              "score": 756,
              "replies": [],
              "level": 0,
              "sentiment": "negative"
            },
            {
              "id": "comment6",
              "author": "ComedicTiming",
              "body": "The timing on this is perfect",
              "score": 543,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment7",
              "author": "MarriageExpert",
              "body": "And that's how the fight started...",
              "score": 432,
              "replies": [],
              "level": 0,
              "sentiment": "humorous"
            },
            {
              "id": "comment8",
              "author": "RedditVeteran",
              "body": "Reminds me of joke #4673",
              "score": 298,
              "replies": [],
              "level": 0,
              "sentiment": "neutral"
            },
            {
              "id": "comment9",
              "author": "GrammarNazi2023",
              "body": "You're* for proper accuracy",
              "score": 187,
              "replies": [],
              "level": 0,
              "sentiment": "neutral"
            },
            {
              "id": "comment10",
              "author": "DadJokeEnthusiast",
              "body": "As a husband, can confirm this is 100% accurate",
              "score": 156,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            }
          ],
          "subreddit": "Jokes",
          "timeAgo": "4 hours ago",
          "sentiment": "humorous",
          "generated_at": "2025-09-15T09:15:15.611Z",
          "version": 1
        }
      },
      "posts": [
        {
          "id": "1ng64wz",
          "title": "A wife, pissed off that her husband was late again, wrote a dramatic note: I’ve had enough. I’m leaving you. Don’t try to find me.",
          "selftext": "She hid under the bed, waiting to see his reaction.\n\nThe husband walks in, finds the note, and after a pause… he scribbles something down, then calls someone:\n\"She’s finally gone… yeah, I know, about damn time. I’m coming over. Wear that French nightie, I love you. Can’t wait to do all the naughty things you like.”\n\nHe hangs up, grabs his keys, and leaves.\n\nThe wife, shaking with rage and tears, crawls out from under the bed to read what he wrote.\n\nIt said:\n\"I can see your feet. Also, we’re out of bread back in 5.”",
          "score": 13310,
          "num_comments": 242,
          "created_utc": 1757790906,
          "subreddit": "Jokes",
          "permalink": "/r/Jokes/comments/1ng64wz/a_wife_pissed_off_that_her_husband_was_late_again/",
          "url": "https://www.reddit.com/r/Jokes/comments/1ng64wz/a_wife_pissed_off_that_her_husband_was_late_again/",
          "author": "lovelopetir",
          "comments": [
            {
              "id": "ne1u8bv",
              "body": "This made me chuckle and it’s been a tough day, so thank you.",
              "score": 1478,
              "created_utc": 1757794115,
              "author": "Electrical_Turn7"
            },
            {
              "id": "ne1mfcf",
              "body": "I liked this one.",
              "score": 1264,
              "created_utc": 1757791622,
              "author": "Ecstatic-Mixture-520"
            },
            {
              "id": "ne1uk5n",
              "body": "I am glad you smiled ... My pleasure",
              "score": 463,
              "created_utc": 1757794223,
              "author": "lovelopetir"
            },
            {
              "id": "ne1v1vu",
              "body": "Finally, a wholesome marriage joke!",
              "score": 417,
              "created_utc": 1757794381,
              "author": "Peoplant"
            }
          ]
        },
        {
          "id": "1ncycab",
          "title": "A sexually active woman tells her plastic surgeon that she wanted her vaginal lips reduced in size because they were too loose and floppy",
          "selftext": "A sexually active woman tells her plastic surgeon that she wanted her vaginal lips reduced in size because they were too loose and floppy.\n\nOut of embarrassment she insisted that the surgery be kept a secret and the surgeon agreed.\n\nAwakening from the anesthesia after the surgery she found three roses carefully placed beside her on the bed. Outraged, she immediately calls in the doctor.\n\n\"I thought I asked you not to tell anyone about my operation!\"\n\nThe surgeon told her he had carried out her wish for confidentiality and that the first rose was from him. \"I felt sad because you went through this all by yourself.\"\n\n\"The second rose is from my nurse. She assisted me in the surgery and empathized because she had had the same procedure done some time ago.\"\n\n\"And what about the third rose?\" sh...",
          "score": 7627,
          "num_comments": 331,
          "created_utc": 1757459864,
          "subreddit": "Jokes",
          "permalink": "/r/Jokes/comments/1ncycab/a_sexually_active_woman_tells_her_plastic_surgeon/",
          "url": "https://www.reddit.com/r/Jokes/comments/1ncycab/a_sexually_active_woman_tells_her_plastic_surgeon/",
          "author": "Bitter-Blueberry2368",
          "comments": [
            {
              "id": "ndct40h",
              "body": "Men on Reddit believe that sexual activity = size of outer labia. It's weird I know.",
              "score": 1905,
              "created_utc": 1757460665,
              "author": "Ombudsman_of_Funk"
            },
            {
              "id": "ndcsdfg",
              "body": "Okay so I get the joke and all, but why specify that shes sexually active?",
              "score": 1405,
              "created_utc": 1757460411,
              "author": "Longjumping-Meet-307"
            },
            {
              "id": "nddcqpb",
              "body": "A rose in exchange for tulips?",
              "score": 1286,
              "created_utc": 1757467483,
              "author": "Chadimus_Prime"
            },
            {
              "id": "ndd3y0n",
              "body": "This is a Bob Einstein/Marty Funkhouser joke.",
              "score": 842,
              "created_utc": 1757464429,
              "author": "VinceCully"
            }
          ]
        },
        {
          "id": "1nf75oj",
          "title": "Girlfriend asked if she was fat so I proved my love in the most literal way",
          "selftext": "One day I was sitting on the sofa with my girlfriend and she asked, \"Honey, do you think I am fat?\"  \nI said, \"Of course not, you are perfect.\"  \nShe asked, \"Will you carry me to the bedroom?\"  \nI felt a shiver run down my spine and replied, \"To prove how much I love you, today I am bringing the bed into the living room.\"",
          "score": 5570,
          "num_comments": 130,
          "created_utc": 1757692981,
          "subreddit": "Jokes",
          "permalink": "/r/Jokes/comments/1nf75oj/girlfriend_asked_if_she_was_fat_so_i_proved_my/",
          "url": "https://www.reddit.com/r/Jokes/comments/1nf75oj/girlfriend_asked_if_she_was_fat_so_i_proved_my/",
          "author": "TotalThing7",
          "comments": [
            {
              "id": "ndudeg3",
              "body": "Do these pants make me look fat?\n\nNo, they are very deceiving.",
              "score": 1770,
              "created_utc": 1757694933,
              "author": "No-Raisin-6469"
            },
            {
              "id": "ndug3ai",
              "body": "Do these pants make me look fat?\n\nNo, your ass makes you look fat.",
              "score": 651,
              "created_utc": 1757695711,
              "author": "enonymous617"
            },
            {
              "id": "ndunefx",
              "body": "Tell your wife a hundred times that she looks great.And she won't remember. Tell her once that she looks fat.And she will remember forever. Because an elephant never forgets",
              "score": 591,
              "created_utc": 1757697830,
              "author": "ztreHdrahciR"
            },
            {
              "id": "ndugq6a",
              "body": "Do these pants make me look fat?\n\nNo, and they seem offended that you tried to pin it on them.",
              "score": 471,
              "created_utc": 1757695895,
              "author": "Daxlyn_XV"
            }
          ]
        },
        {
          "id": "1ndrug2",
          "title": "\"Excuse me,\" I said to the woman sat in front of me on the bus, \"You have some semen on the back of your jacket.\"",
          "selftext": "\"I'm sure it's not semen,\" she said, \"It's probably yoghurt.\"\n\n\"It's definitely semen,\" I said, \"I don't ejaculate yoghurt.\"",
          "score": 5162,
          "num_comments": 77,
          "created_utc": 1757542268,
          "subreddit": "Jokes",
          "permalink": "/r/Jokes/comments/1ndrug2/excuse_me_i_said_to_the_woman_sat_in_front_of_me/",
          "url": "https://www.reddit.com/r/Jokes/comments/1ndrug2/excuse_me_i_said_to_the_woman_sat_in_front_of_me/",
          "author": "maomaodong",
          "comments": [
            {
              "id": "ndj9m7r",
              "body": "Yoplaited with it too much",
              "score": 784,
              "created_utc": 1757543964,
              "author": "Certain_Passion1630"
            },
            {
              "id": "ndjlo5r",
              "body": "You’re not sexually Activia enough if you need to get off on the bus",
              "score": 734,
              "created_utc": 1757547829,
              "author": "martintone"
            },
            {
              "id": "ndjgse4",
              "body": "Flew out like it was shot out of a dannon!",
              "score": 243,
              "created_utc": 1757546246,
              "author": "Money-Pay-6278"
            },
            {
              "id": "ndj7fhk",
              "body": "\"If that's yogurt, I need to see a urologist!\"",
              "score": 160,
              "created_utc": 1757543275,
              "author": "LayersOfOldPaint"
            }
          ]
        },
        {
          "id": "1ndd0b7",
          "title": "a man is having sex with his wife...",
          "selftext": "A man is having sex with his wife and there is a noise in the house.  \nThe wife screams: \"Oh my God! It's my husband!\"  \nThe man jumps out of the bed and hides in a wardrobe.  \nThen he leaves the wardrobe, smiling apologetically: \"Darling, we are both under pressure lately...\"",
          "score": 4484,
          "num_comments": 115,
          "created_utc": 1757507791,
          "subreddit": "Jokes",
          "permalink": "/r/Jokes/comments/1ndd0b7/a_man_is_having_sex_with_his_wife/",
          "url": "https://www.reddit.com/r/Jokes/comments/1ndd0b7/a_man_is_having_sex_with_his_wife/",
          "author": "danielsoft1",
          "comments": [
            {
              "id": "ndg31uc",
              "body": "The bartender sees a man at the end that is drowning his sorrows in a drink. So he walks up to him and ask: \"What's got you down, old son?\"\n\nThe man sighs: \"I caught my wife in bed with my best friend.\"\n\n\"Yeah, that's a tough one.\"\n\n\"So I told her to pack her bags and be gone before I came back, 'cause I never want to see her again.\"\n\n\"What did you say to your friend?\"\n\n\"Bad dog!\"",
              "score": 2613,
              "created_utc": 1757511889,
              "author": "Tobio88"
            },
            {
              "id": "ndfuhov",
              "body": "They are so used to cheating that when they hear a sudden noise they both instinctively hide. Even though they’re having sex with each other and not cheating.",
              "score": 921,
              "created_utc": 1757509146,
              "author": "Pdxmtg"
            },
            {
              "id": "ndgxx14",
              "body": "There’s three dogs in the waiting room at the vet, making small talk. The first dog goes, “Yeah, I’m a biter. I bite everyone I see. Old ladies, kids, the mailman. Whoever. So they’re gonna chop my balls off. How about you?”\n\nSecond dog goes, “I’m a pisser myself. I’ll piss on anything. Piss in the house, piss in the car, piss in my master’s shoes. The other day I pissed on a kid, and now they’re ...",
              "score": 656,
              "created_utc": 1757520721,
              "author": "crusty54"
            },
            {
              "id": "ndfqu9k",
              "body": "And here I thought\n\n\"a man is having sex with his wife...\" was a one line joke!",
              "score": 619,
              "created_utc": 1757507907,
              "author": "frisco-frisky-dom"
            }
          ]
        },
        {
          "id": "1ndwc7f",
          "title": "I was admitted into the hospital and as I settled into my bed, I overheard my \"roommate\" using the speakerphone to order breakfast from the cafeteria",
          "selftext": "\"Three eggs scrambled please. slightly runny.  The eggs should be cooked for at most six seconds, and at least half an eggshell should be left in.\"\n\n\n\n  \n\"Cold coffee please.  Not iced, but room temperature.  The older the better.\"\n\n\n\n\"Now I know this is going to sound strange, but please find a used urine specimen cup.  Dump out the urine, but do not rinse the cup before filling it with orange juice.  The slight taste of the urine in the juice is very settling to my stomach.\"\n\n  \nAt that moment a shrill voice screamed out from the speaker.\n\n\n\n\"THAT IS DISGUSTING!  There is no way we are bringing that up to you\"\n\n  \nMy roommate answered, \"Why not! That's what you sent up yesterday\"\n\n\n\n",
          "score": 4420,
          "num_comments": 83,
          "created_utc": 1757554867,
          "subreddit": "Jokes",
          "permalink": "/r/Jokes/comments/1ndwc7f/i_was_admitted_into_the_hospital_and_as_i_settled/",
          "url": "https://www.reddit.com/r/Jokes/comments/1ndwc7f/i_was_admitted_into_the_hospital_and_as_i_settled/",
          "author": "marycartlizer",
          "comments": [
            {
              "id": "ndkiftw",
              "body": "Reminds me of the guy checking in for a flight. \n\n“I’m going to New York, but I need this suitcase to go to Chicago,”\n\n“Sorry sir, we can’t do that.”\n\n“Why not? You did it last week and I didn’t even ask.”",
              "score": 1783,
              "created_utc": 1757559279,
              "author": "hiirogen"
            },
            {
              "id": "ndl3s2n",
              "body": "Here’s one from TikTok ;a young woman was working her first day as a nurse in the ER. A man with an oxygen mask covering his face asked her “Are my testicles black”, she ignored him. After his 3rd request, “are my testicles black?” She lifted his gown, examined them and said “your testicles are fine”. He lifted his oxygen mask and said “thank you, are my test results back?”\n\n“",
              "score": 489,
              "created_utc": 1757568457,
              "author": "always-learning0000"
            },
            {
              "id": "ndkbfyh",
              "body": "For some reason the punchline is truncated on the iOS Reddit app, but not in Safari.  \n\nWalter Matthau [told this joke on Johnny Carson](https://youtu.be/Xggk-6lXcN0?si=joBDZ9N5xtv9RA7a) a long time ago.",
              "score": 147,
              "created_utc": 1757556740,
              "author": "chriswaco"
            },
            {
              "id": "ndkau7z",
              "body": "When I was 14, I had to spend a few nights in the hospital after surgery. Being 14, I stayed up late watching TV so every morning when they dropped off a menu for me to choose my meals for the next day, a nurse would fill it out because I was asleep. Nearly everything selected was something I didn't eat or drink. I got coffee for breakfast and hot tea for lunch and dinner. I drank neither of those...",
              "score": 113,
              "created_utc": 1757556526,
              "author": "GaryG7"
            }
          ]
        },
        {
          "id": "1nbxb0x",
          "title": "A plane is flying to Toronto when a blonde in economy moves up and sits in first class.",
          "selftext": "The flight attendant checks her ticket and says,\n\"Ma'am, you paid for economy, please return to your seat.\"\n\nThe blonde replies,\n\"I'm blonde, I'm beautiful, I'm going to Toronto, and I'm staying right here!\" \n\nThe flight attendant tells the pilot and co-pilot about the situation.\n\nThe co-pilot tries to explain, but the blonde repeats,\n\"I'm blonde, I'm beautiful, I'm going to Toronto, and I'm staying right here!\" \n\nThe pilot says,\n\"She's blonde? I’ve got this - I speak Blonde. I'm married to one.\" \n\nHe walks over, whispers something in her ear, and she says,\n\"Oh, I’m sorry!\" and returns to her seat in economy. \n\nEveryone is stunned. \"What did you say to her?\" they ask.\n\nHe replies,\n\"I told her first class isn’t going to Toronto.\" ",
          "score": 4314,
          "num_comments": 166,
          "created_utc": 1757359679,
          "subreddit": "Jokes",
          "permalink": "/r/Jokes/comments/1nbxb0x/a_plane_is_flying_to_toronto_when_a_blonde_in/",
          "url": "https://www.reddit.com/r/Jokes/comments/1nbxb0x/a_plane_is_flying_to_toronto_when_a_blonde_in/",
          "author": "Any_Contribution_238",
          "comments": [
            {
              "id": "nd5i1jg",
              "body": "A blonde walks up to the edge of the canyon and spots another blonde standing on the opposite side of the deep crevice. She yells \"How do I get to the other side?\" The other blonde yells back \"You ARE on the other side!\"",
              "score": 1186,
              "created_utc": 1757365360,
              "author": "Checkersmack"
            },
            {
              "id": "nd6k69s",
              "body": "A blind guy walks into a bar and says to the bartender, “Bring me a beer and then I’ve got a great  blonde joke for you.” The bartender comes back with the beer and says, “ Hey pal, I see you’re blind so let me give you a heads up. The guy sitting to your left is a biker, he’s a big bad dude and he’s blond. The guy on your right is a football player, he’s big, athletic and he’s blond. And I’m an e...",
              "score": 679,
              "created_utc": 1757378171,
              "author": "Strict_Meeting_5166"
            },
            {
              "id": "nd6275i",
              "body": "A blond is driving her car too fast and gets pulled over by a blond police officer.  The cop walks up to her window and asks for her license.  \n\nThe blond asked \"What's a license?\"  \n\nThe cop says it's about 3 inches wide and has your picture on it.  \n\nThe blond goes through her purse and pulls out a small makeup mirror and hands it to to the blond cop.  The cop looks at it and says \"Oh, I'm sorry...",
              "score": 614,
              "created_utc": 1757371860,
              "author": "youcantdenythat"
            },
            {
              "id": "nd5x3ej",
              "body": "A blonde is driving in a rural area when she spots another blonde in wheat field, rowing a boat.\n\nShe becomes irate.  Stops the car.  Walks up to the edge of the field and shouts, \"It's dumbass blondes like you, that give the rest of us a bad name.   I swear if I could swim, I'd be out there drowning your ass.\"",
              "score": 437,
              "created_utc": 1757370112,
              "author": "chicken_spears"
            }
          ]
        },
        {
          "id": "1nf0fxt",
          "title": "A man walks into a bar and orders a whiskey. He takes it outside to enjoy on the bench.",
          "selftext": "\nAs he’s sipping, a nun walks by and scolds him: “How can you pollute your soul with the Devil’s drink?”\n\nThe man replies, “It’s not the Devil, it’s just whiskey.”\n\nThe nun argues it’s wicked and sinful, but admits she’s never actually tasted whiskey- only heard from others how evil it is.\n\nAfter some back and forth, the nun finally says, “Alright… if I had just a sip, I’d understand better. But I can’t be seen drinking out here. Could you order me one in a teacup?”\n\nThe man nods, heads back inside, and says to the barman:\n“Two whiskeys, but put one in a teacup, please.”\n\nThe barman slams the counter and yells:\n“Is that nun here AGAIN?!” ",
          "score": 4233,
          "num_comments": 74,
          "created_utc": 1757675834,
          "subreddit": "Jokes",
          "permalink": "/r/Jokes/comments/1nf0fxt/a_man_walks_into_a_bar_and_orders_a_whiskey_he/",
          "url": "https://www.reddit.com/r/Jokes/comments/1nf0fxt/a_man_walks_into_a_bar_and_orders_a_whiskey_he/",
          "author": "Any_Contribution_238",
          "comments": [
            {
              "id": "ndstcne",
              "body": "It appears our nun has a habit.",
              "score": 1339,
              "created_utc": 1757677670,
              "author": "Waitsfornoone"
            },
            {
              "id": "ndt0n9g",
              "body": "At least she isn't being superior about it.",
              "score": 292,
              "created_utc": 1757680380,
              "author": "bsmknight"
            },
            {
              "id": "ndspnn5",
              "body": "I remember Irish comedian Dave Allen telling that one back in the 90s.",
              "score": 130,
              "created_utc": 1757676144,
              "author": "OminousVoice"
            },
            {
              "id": "ndt2j0e",
              "body": "A bus driver was driving through the town late and a nun got on and being alone on the bus they began to chat.  Somehow the topic of sex came up and the bus driver admitted he had a fantasy of having sex with a nun since he was in Catholic school.  The nun said that she never had sex but was always wondering what it was like.  The driver said let’s just do it and fulfill our fantasies.  So he park...",
              "score": 91,
              "created_utc": 1757681040,
              "author": "anonymous_212"
            }
          ]
        },
        {
          "id": "1ncwdhz",
          "title": "A wife leaned into her husband and purred, “Have you ever seen twenty dollars all crumpled up?”",
          "selftext": "The husband shook his head, “Nope.”\n\nShe slowly unbuttoned her blouse, reached into her lace push-up bra, and pulled out a crumpled $20 bill.\n\nHe grinned. “Nice trick.” \n\nThen she teased, “Ever seen fifty dollars all crumpled up?” \n\nHe gulped, “No…”\n\nOff comes the skirt. Out comes a crumpled $50 from her lace panties.\n\nNow he’s sweating in anticipation of what's coming next. \n\nThen she leans in and whispers,\n“Ever seen $50,000 all crumpled up?” \n\nHe practically shouts, “NO—BUT I’D LOVE TO!”\n\nShe pauses, gives him an apologetic look, and says,\n“…Go look in the garage.” ",
          "score": 4047,
          "num_comments": 88,
          "created_utc": 1757454934,
          "subreddit": "Jokes",
          "permalink": "/r/Jokes/comments/1ncwdhz/a_wife_leaned_into_her_husband_and_purred_have/",
          "url": "https://www.reddit.com/r/Jokes/comments/1ncwdhz/a_wife_leaned_into_her_husband_and_purred_have/",
          "author": "Any_Contribution_238",
          "comments": [
            {
              "id": "ndcgav5",
              "body": "I misread the final line as “Go look in the GARBAGE!” and was about to post this on /r/explainthejoke 🤦‍♂️",
              "score": 734,
              "created_utc": 1757456333,
              "author": "mobfather"
            },
            {
              "id": "ndcjow5",
              "body": "Did she crumpled the car or something?",
              "score": 358,
              "created_utc": 1757457487,
              "author": "whyamihere999"
            },
            {
              "id": "ndckeuk",
              "body": "Yup",
              "score": 229,
              "created_utc": 1757457732,
              "author": "ebk_errday"
            },
            {
              "id": "ndciiuy",
              "body": "Where was he thinking the next one would come from? Her butt?",
              "score": 226,
              "created_utc": 1757457090,
              "author": "JackZodiac2008"
            }
          ]
        },
        {
          "id": "1nftsnz",
          "title": "After landing my new job as a Walmart greeter — a great gig for many retirees — I lasted less than a day.",
          "selftext": "About two hours into my first shift, a loud, mean-looking woman stormed in with two kids, yelling obscenities at them the whole way.\n\nAs I’d been trained, I smiled and said cheerfully,\n“Good morning and welcome to Walmart! Nice children you have there. Are they twins?”\n\nShe snarled,\n“Hell no, they ain’t twins! One’s 9, the other is 7. Are you blind or just stupid?!”\n\nSo I smiled and replied,\n“Neither, ma’am. I just couldn’t believe someone slept with you twice.” ",
          "score": 4044,
          "num_comments": 59,
          "created_utc": 1757758155,
          "subreddit": "Jokes",
          "permalink": "/r/Jokes/comments/1nftsnz/after_landing_my_new_job_as_a_walmart_greeter_a/",
          "url": "https://www.reddit.com/r/Jokes/comments/1nftsnz/after_landing_my_new_job_as_a_walmart_greeter_a/",
          "author": "Any_Contribution_238",
          "comments": [
            {
              "id": "ndyzpro",
              "body": "A young Geordie lad moved to London and went to Harrods looking for a job.\n\nThe manager asked \"Do you have any sales experience?\" The young man answered \"Aye, I was a canny salesman back in Newcastle.\"\n\nThe manager liked the Geordie so he gave him the job. His first day on the job was challenging and busy, but he got through it. After the store was locked up, the manager came down and asked \"OK,.....",
              "score": 1205,
              "created_utc": 1757759692,
              "author": "Make_the_music_stop"
            },
            {
              "id": "ne0cb68",
              "body": "I told that joke at a Sales conference in Boston in 2011. One of the other Australians in the audience came up to me afterwards to say “That was the funniest thing I ever heard, and you’ll never get a job in this country again.”",
              "score": 228,
              "created_utc": 1757777889,
              "author": "JacobAldridge"
            },
            {
              "id": "ndz0lys",
              "body": "American here, and all I can picture is Robson Green telling this joke.",
              "score": 113,
              "created_utc": 1757760180,
              "author": "piscikeeper"
            },
            {
              "id": "ne1jpum",
              "body": "To be fair, my version involved a few more curse words along the way. I never did with that group, but most of my clients are UK and Asia-Pac so I didn’t try that hard either.",
              "score": 60,
              "created_utc": 1757790782,
              "author": "JacobAldridge"
            }
          ]
        },
        {
          "id": "1ngulfo",
          "title": "At the World Cup final, a man notices an empty seat next to him. He asks, “Who would miss the World Cup final?”",
          "selftext": "The other guy replies, “That was my wife’s seat. We’ve been to the last five finals together… but she passed away.”\n\nThe man says, “I’m so sorry… but couldn’t a family member come instead?”\n\nThe guy shrugs:\n“Nope. They’re all at the funeral.”",
          "score": 3566,
          "num_comments": 58,
          "created_utc": 1757864648,
          "subreddit": "Jokes",
          "permalink": "/r/Jokes/comments/1ngulfo/at_the_world_cup_final_a_man_notices_an_empty/",
          "url": "https://www.reddit.com/r/Jokes/comments/1ngulfo/at_the_world_cup_final_a_man_notices_an_empty/",
          "author": "lovelopetir",
          "comments": [
            {
              "id": "ne6pbiv",
              "body": "He's gotta be a Brazilian. 🇧🇷",
              "score": 478,
              "created_utc": 1757865620,
              "author": "1800skylab"
            },
            {
              "id": "ne6pzx9",
              "body": "How many millions in a Brazilian?",
              "score": 142,
              "created_utc": 1757865816,
              "author": "pantograph"
            },
            {
              "id": "ne6tale",
              "body": "It varies. It could be anywhere in the range of 1 to 7.",
              "score": 103,
              "created_utc": 1757866754,
              "author": "AggressiveSpatula"
            },
            {
              "id": "ne6rctr",
              "body": "went from ‘aww poor guy’ to ‘ohhh never mind’ in 0.2 seconds.",
              "score": 51,
              "created_utc": 1757866208,
              "author": "lovelopetir"
            }
          ]
        },
        {
          "id": "1nfk0ms",
          "title": "A sheepdog returns to his farmer and says, \"All right, I've got your 70 sheep back in the east pen.\"",
          "selftext": "The farmer replies, \"What!? I have 67 sheep, not 70!\"\n\nThe sheepdog gives him a withering look and says, \"I know. I rounded them up.\"",
          "score": 3308,
          "num_comments": 68,
          "created_utc": 1757724623,
          "subreddit": "Jokes",
          "permalink": "/r/Jokes/comments/1nfk0ms/a_sheepdog_returns_to_his_farmer_and_says_all/",
          "url": "https://www.reddit.com/r/Jokes/comments/1nfk0ms/a_sheepdog_returns_to_his_farmer_and_says_all/",
          "author": "dogismywitness",
          "comments": [
            {
              "id": "ndx3d4w",
              "body": "One sheep looks at the dog and says, \"Hey, wasn't there 3 less of us before?\" \n\nThe dog says, \"Son of a bitch! Talking sheep!\"",
              "score": 559,
              "created_utc": 1757725939,
              "author": "HellAwaitsTheFunny"
            },
            {
              "id": "ndx5m74",
              "body": "The dog says, \"Three fewer, actually.\"",
              "score": 296,
              "created_utc": 1757726779,
              "author": "drethnudrib"
            },
            {
              "id": "ndx6fbd",
              "body": "What a pedantic little bitch (that female dog was)",
              "score": 134,
              "created_utc": 1757727081,
              "author": "DrRomeoChaire"
            },
            {
              "id": "ndx0f81",
              "body": "That's actually a pretty good joke",
              "score": 96,
              "created_utc": 1757724837,
              "author": "Probably_A_Trolll"
            }
          ]
        }
      ]
    }
  },
  {
    "id": "mfkw1nvlxwylrbr51",
    "generated_at": "2025-09-15T08:54:53.985Z",
    "name": "r/popculturechat Celebrity Discussion",
    "description": "Analysis of celebrity gossip, entertainment news discussions, and pop culture commentary from engaged fans.",
    "subreddits": [
      "popculturechat"
    ],
    "dateRange": {
      "startDate": "2025-09-08",
      "endDate": "2025-09-15"
    },
    "totalPosts": 16,
    "totalComments": 2460,
    "data": {
      "summary": {
        "totalPosts": 16,
        "totalComments": 2460,
        "subreddits": [
          "popculturechat"
        ],
        "dateRange": {
          "startDate": "2025-09-08",
          "endDate": "2025-09-15"
        }
      },
      "analysis": {
        "overall_sentiment": {
          "average_score": 0.5,
          "sentiment_distribution": {
            "positive": 60,
            "neutral": 30,
            "negative": 10
          },
          "dominant_themes": [
            "celebrity",
            "drama",
            "gossip",
            "discussion",
            "opinion",
            "trending",
            "popular"
          ],
          "key_emotions": [
            "curiosity",
            "interest",
            "discussion",
            "engagement",
            "opinion"
          ],
          "summary": "The overall sentiment is neutral (positive 38%). Key themes include: criticism, humor, appreciation."
        },
        "individual_scores": [
          {
            "index": 1,
            "score": -0.8,
            "sentiment": "negative",
            "confidence": 0.9,
            "themes": [
              "violence",
              "death",
              "shooting"
            ],
            "emotions": [],
            "source": {
              "type": "post_title",
              "postId": "1ndpxaz",
              "subreddit": "popculturechat"
            }
          },
          {
            "index": 2,
            "score": -0.3,
            "sentiment": "negative",
            "confidence": 0.7,
            "themes": [
              "warning",
              "moderation",
              "community"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1ndpxaz",
              "commentId": "ndipfl0",
              "subreddit": "popculturechat"
            }
          },
          {
            "index": 3,
            "score": -0.9,
            "sentiment": "negative",
            "confidence": 0.95,
            "themes": [
              "violence",
              "children",
              "school"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1ndpxaz",
              "commentId": "nditm97",
              "subreddit": "popculturechat"
            }
          },
          {
            "index": 4,
            "score": -0.6,
            "sentiment": "negative",
            "confidence": 0.8,
            "themes": [
              "news",
              "violence",
              "chaos"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1ndpxaz",
              "commentId": "ndizn4p",
              "subreddit": "popculturechat"
            }
          },
          {
            "index": 5,
            "score": -0.7,
            "sentiment": "negative",
            "confidence": 0.85,
            "themes": [
              "violence",
              "normalcy",
              "criticism"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1ndpxaz",
              "commentId": "ndj1c4l",
              "subreddit": "popculturechat"
            }
          }
        ],
        "by_subreddit": {
          "popculturechat": {
            "scores": [
              -0.8,
              -0.3,
              -0.9,
              -0.6,
              -0.7,
              -0.8,
              -0.9,
              0,
              -0.2,
              -0.3,
              -0.1,
              -0.2,
              -0.8,
              -0.6,
              -0.7,
              -0.8,
              -0.5,
              -0.4,
              0.2,
              -0.4,
              -0.3,
              -0.6,
              -0.2,
              0,
              -0.4,
              -0.3,
              -0.4,
              -0.5,
              -0.7,
              -0.6,
              0.2,
              -0.8,
              -0.7,
              -0.6,
              0,
              0,
              0.3,
              -0.6,
              -0.7,
              -0.8,
              -0.8,
              -0.5,
              0.4,
              -0.3,
              -0.4,
              -0.5,
              -0.6,
              -0.9,
              -0.4,
              -0.5,
              -0.4,
              -0.7,
              -0.3,
              -0.6,
              -0.2,
              -0.7,
              -0.8,
              -0.6,
              -0.7,
              -0.3,
              -0.7,
              -0.4,
              -0.2,
              -0.5,
              -0.6,
              -0.7,
              -0.7,
              0,
              0,
              0,
              -0.5,
              -0.4,
              -0.2,
              -0.7,
              -0.6,
              -0.3,
              -0.6,
              -0.2,
              -0.3,
              -0.5,
              -0.3,
              -0.4,
              -0.5,
              -0.6,
              -0.2,
              -0.4,
              -0.5,
              -0.2,
              -0.1,
              -0.3,
              -0.7,
              0.1,
              -0.8,
              -0.4,
              -0.3,
              -0.1,
              -0.2,
              -0.1,
              0,
              0.2,
              0.3,
              -0.3,
              -0.4,
              -0.5,
              -0.6,
              -0.2,
              -0.5,
              -0.4,
              -0.3,
              -0.6,
              -0.5,
              -0.4,
              0.2,
              -0.4,
              -0.5,
              -0.6,
              -0.4,
              -0.3,
              0,
              -0.7,
              -0.8,
              -0.5,
              -0.2,
              -0.6,
              -0.1,
              -0.3,
              -0.8,
              -0.9,
              -0.7,
              -0.8,
              -0.6,
              -0.4,
              -0.5,
              -0.7,
              0,
              -0.3,
              -0.2,
              -0.1,
              -0.6,
              -0.7,
              -0.4,
              -0.8,
              -0.5,
              -0.6,
              -0.3,
              -0.2,
              -0.3,
              -0.4,
              -0.6,
              -0.8,
              -0.7,
              -0.6,
              -0.5,
              -0.7,
              -0.5,
              -0.8,
              -0.6,
              -0.4,
              -0.3,
              -0.2,
              -0.4,
              -0.7,
              -0.5,
              -0.6,
              -0.5,
              -0.4,
              -0.6,
              -0.7,
              0,
              0,
              -0.3,
              -0.4,
              -0.5,
              -0.6,
              0.3,
              0.2,
              -0.8,
              -0.4,
              -0.3,
              0.8,
              0.3,
              -0.2,
              0,
              0.1,
              0.4,
              0.6,
              -0.5,
              -0.3,
              0.7,
              0.8,
              0.6,
              0.5,
              0.6,
              0.7,
              0.6,
              0.8,
              0.4,
              0.6,
              0.8,
              0.7,
              0.5,
              0.7,
              0.6,
              0.5,
              0.7,
              0.2,
              0.6,
              0.3,
              0.8,
              0.9,
              0.5,
              0.6,
              0.5,
              0.7,
              0.6,
              0.7,
              0.2,
              0.4,
              0.6,
              -0.3,
              0.3,
              0.2,
              0,
              0.5,
              0.6,
              0.7,
              0.6,
              0.7,
              0,
              0.4,
              0.3,
              -0.2,
              0,
              0.8,
              0.6,
              0,
              0.4,
              0,
              0.1,
              0,
              0.2,
              0.5,
              0.7,
              -0.3,
              -0.2,
              0.6,
              0.7,
              -0.4,
              0.3,
              0.8,
              0.5,
              0.6,
              0,
              0,
              0.2,
              0,
              0,
              0.2,
              0.7,
              0.6,
              0,
              0.3,
              0.4,
              0.5,
              -0.3,
              0,
              0,
              0,
              0.7,
              0,
              0,
              0.4,
              0,
              0.9,
              0.8,
              0.9,
              0,
              0.2,
              0,
              0,
              0.8,
              0.3,
              0.6,
              0.4,
              0.2,
              -0.1,
              0.3,
              0.4,
              0.5,
              0.3,
              0.4,
              0.7,
              0.8,
              0.6,
              0,
              0.2,
              0.1,
              0,
              0.5,
              0.4,
              0.2,
              0.7,
              0.3,
              0.5,
              0.4,
              0,
              0.1,
              0.4,
              0.3,
              0.2,
              0,
              0.3,
              0.2,
              0.1,
              0,
              0.4,
              0.3,
              0.6,
              0.2,
              -0.1,
              0.5,
              0,
              0,
              -0.1,
              -0.2,
              0.1,
              0.2,
              0.3,
              0.4,
              0,
              -0.3,
              0,
              0.3,
              -0.2,
              0.1,
              -0.4,
              -0.5,
              0.4,
              0.8,
              -0.7,
              0.4,
              0.3,
              -0.6,
              0.2,
              0.4,
              0.1,
              0.3,
              0.2,
              -0.2,
              -0.4,
              -0.6,
              -0.5,
              -0.6,
              0.2,
              0.4,
              0.7,
              -0.5,
              0.6,
              0.7,
              -0.3,
              -0.4,
              -0.5,
              0.3,
              0,
              0.8,
              0.1,
              -0.2,
              -0.5,
              -0.4,
              -0.6,
              -0.2,
              -0.3,
              -0.6,
              -0.5,
              -0.3,
              -0.4,
              -0.5,
              -0.4,
              0.3,
              0.2,
              -0.3,
              -0.4,
              0.2,
              -0.5,
              -0.3,
              -0.4,
              -0.6,
              -0.4,
              -0.3,
              -0.2,
              -0.6,
              -0.5,
              -0.2,
              0,
              0,
              0,
              -0.3,
              -0.7,
              0.2,
              -0.4,
              -0.2,
              -0.1,
              -0.3,
              -0.2,
              -0.4,
              -0.5,
              -0.3,
              -0.4,
              -0.1,
              0,
              -0.4,
              -0.5,
              -0.6,
              -0.5,
              -0.7,
              -0.8,
              -0.7,
              -0.5,
              -0.8,
              -0.6,
              0.7,
              -0.4,
              -0.1,
              0,
              0.2,
              0.3,
              0.4,
              0.6,
              0.5,
              0.4,
              0.8,
              0.6,
              0.4,
              -0.2,
              0.1,
              0.3,
              -0.3,
              -0.2,
              -0.4,
              0.7,
              0.8,
              0.7,
              0.6,
              0.6,
              0.2,
              0,
              -0.2,
              0.1,
              -0.1,
              0.2,
              0.4,
              0,
              -0.3,
              -0.1,
              0,
              0.7,
              0.3,
              0.2,
              0.6,
              0.7,
              -0.2,
              0.1,
              0,
              0,
              0,
              0.3,
              0,
              0,
              0.8,
              0.6,
              0.7,
              0.5,
              0.6,
              0.7,
              0.4,
              0.6,
              0.5,
              0.6,
              0.8,
              0.7,
              0.3,
              0,
              0.8,
              0.4,
              0.9,
              0.9,
              0.3,
              0.4,
              0,
              0.6,
              0.7,
              0.4,
              0.2,
              0.3,
              0.7,
              0.5,
              0.8,
              0.8,
              0.7,
              0.6,
              0.5,
              0.2,
              0.3,
              0.6,
              0.8,
              0.7,
              0.2,
              0.8,
              0.6,
              0.8,
              0.9,
              0.8,
              0.7,
              0,
              0.6,
              0.5,
              0,
              0.7,
              0,
              0.3,
              0.5,
              0.6,
              0,
              0,
              0.5,
              0.7,
              -0.6,
              0,
              0.8,
              0.7,
              0.8,
              0.6,
              0.3,
              0.4,
              0.2,
              0.6,
              0.4,
              0.9,
              0.3,
              0.7,
              0.6,
              0.2,
              0.8,
              0.3,
              0.8,
              0.7,
              0.6,
              0.7,
              0.9,
              0.5,
              0.9,
              0.8,
              0,
              0.2,
              0.6,
              0.7,
              0.8,
              0.9,
              0.7,
              0,
              0.8,
              0.8,
              0.6,
              0.9,
              0.5,
              0.9,
              0,
              0.3,
              0.4,
              -0.3,
              0.2,
              0.5,
              0.8,
              0.6,
              0.4,
              0.7,
              0.7,
              0.3,
              0.6,
              0.7,
              0.8,
              0,
              0.6,
              0.2,
              0.1,
              0.3,
              0,
              0.7,
              0.9,
              0.5,
              0.4,
              0.9,
              0.8,
              0.2,
              0.8,
              0.6,
              0,
              0.1,
              0.7,
              0.4,
              0.8,
              0.7,
              0.5,
              0,
              -0.2,
              0.2,
              0.1,
              0.6,
              0.5,
              0.8,
              0.3,
              0.6,
              -0.3,
              0,
              -0.6,
              -0.8,
              -0.7,
              -0.4,
              0.4,
              -0.5,
              -0.6,
              -0.7,
              -0.8,
              -0.2,
              0,
              -0.8,
              -0.7,
              -0.6,
              -0.8,
              -0.5,
              -0.3,
              -0.4,
              0,
              -0.2,
              -0.3,
              -0.4,
              -0.6,
              -0.7,
              -0.5,
              0.1,
              -0.8,
              -0.7,
              0,
              -0.6,
              -0.7,
              -0.9,
              -0.6,
              -0.5,
              -0.7,
              -0.8,
              -0.8,
              -0.7,
              -0.6,
              -0.7,
              -0.4,
              -0.7,
              -0.6,
              -0.8,
              -0.6,
              -0.9,
              -0.7,
              -0.5,
              -0.3,
              -0.7,
              -0.8,
              0.2,
              -0.8,
              0.4,
              -0.7,
              -0.7,
              -0.4,
              0.2,
              0.6,
              0.7,
              0.7,
              0.6,
              0.5,
              0.5,
              0,
              0.8,
              0,
              0.6,
              0.8,
              0,
              0.5,
              0,
              0.7,
              0.6,
              0.7,
              0.6,
              0.2,
              0.6,
              0.9,
              0,
              0,
              0.8,
              0.4,
              0.3,
              0,
              -0.4,
              -0.2,
              0.8,
              0.7,
              0.6,
              0.7,
              -0.2,
              0,
              0.5,
              0.8,
              0,
              0.3,
              0,
              0.4,
              0.8,
              0,
              0.7,
              0.2,
              0.9,
              0.7,
              0.9,
              0,
              0.7,
              0,
              0.3,
              0.4,
              0.7,
              0.8,
              0,
              0.7,
              0,
              0,
              0.7,
              0.6,
              0.6,
              0.3,
              0.7,
              0.8,
              0.7,
              0,
              -0.2,
              0.8,
              0.9,
              0.6,
              0.7,
              0.3,
              0.9,
              0.2,
              0.5,
              0.4,
              0.6,
              0.7,
              0.8,
              0.5,
              0.9,
              0.8,
              0.7,
              0.9,
              -0.6,
              -0.7,
              0.9,
              0,
              0,
              0.6,
              0.2,
              0,
              0.6,
              0.7,
              0.5,
              0.4,
              0.7,
              -0.3,
              0.5,
              0.8,
              0.7,
              0.6,
              0.8,
              0.4,
              0.3,
              0.8,
              0.7,
              0,
              0.6,
              0.8,
              0.5,
              0.7,
              0.6,
              0.7,
              0,
              -0.4,
              -0.3,
              -0.1,
              -0.3,
              -0.2,
              0.3,
              -0.4,
              0,
              -0.2,
              0.8,
              0.2,
              0.7,
              0.8,
              0.2,
              0,
              0.5,
              0,
              0,
              0.6,
              0.4,
              0.7,
              0.5,
              0.6,
              0.2,
              0,
              0.3,
              0.4,
              0.6,
              0.5,
              -0.3,
              -0.7,
              0,
              -0.8,
              -0.6,
              -0.7,
              -0.4,
              -0.5,
              -0.6,
              -0.5,
              -0.8,
              -0.7,
              -0.8,
              -0.4,
              -0.7,
              -0.6,
              -0.7,
              -0.5,
              -0.4,
              -0.6,
              -0.5,
              -0.4,
              -0.7,
              -0.6,
              -0.7,
              -0.5,
              -0.8,
              -0.6,
              -0.4,
              -0.3,
              -0.7,
              -0.7,
              -0.8,
              -0.5,
              -0.6,
              -0.2,
              -0.3,
              -0.6,
              -0.8,
              -0.7,
              -0.5,
              -0.6,
              -0.8,
              -0.7,
              -0.5,
              -0.4,
              -0.3,
              -0.2,
              0.3,
              -0.2,
              0,
              -0.4,
              -0.5,
              -0.2,
              -0.3,
              -0.2,
              -0.4,
              -0.3,
              -0.2,
              0.4,
              0.5,
              -0.7,
              -0.8,
              -0.7,
              -0.4,
              -0.8,
              -0.7,
              -0.2,
              -0.1,
              -0.3,
              -0.4,
              -0.3,
              0.1,
              0.8,
              0.6,
              0.7,
              0.9,
              -0.3,
              0.2,
              0.6,
              -0.2,
              -0.5,
              0.8,
              0.4,
              0.5,
              0.3,
              0.6,
              0.4,
              0.5,
              0.8,
              0.7,
              0.6,
              0.1,
              0.2,
              0.1,
              -0.2,
              0.7,
              0.8,
              0.6,
              0.7,
              -0.3,
              -0.6,
              0.2,
              0.4,
              0.5,
              0.8,
              0.3,
              0.4,
              0.3,
              0.1,
              -0.4,
              0.7,
              0.2,
              0.3,
              0.4,
              0.3,
              -0.2,
              0.1,
              0.2,
              0.1,
              0.5,
              0.2,
              -0.2,
              -0.2,
              -0.1,
              -0.4,
              -0.3,
              -0.2,
              0.9,
              -0.3,
              0.3,
              -0.2,
              0.6,
              0,
              0.1,
              -0.5,
              0,
              0.4,
              -0.4,
              0.8,
              0.9,
              0.6,
              0.5,
              0.7,
              -0.2,
              0.4,
              -0.3,
              -0.4,
              0.2,
              0.6,
              -0.1,
              0.3,
              -0.3,
              0.4,
              0.7,
              0.9,
              0.8,
              0.2,
              0.8,
              -0.2,
              0.4,
              0.8,
              0.4,
              0.1,
              0.8,
              0,
              0,
              0.2,
              0.1,
              0,
              0.1,
              -0.1,
              0.7,
              0.6,
              0.8,
              -0.5,
              -0.3,
              0.2,
              0,
              -0.1,
              0,
              -0.2,
              -0.8,
              -0.4,
              0.3,
              0,
              0.8,
              0.4,
              0,
              0.7,
              0.6,
              0.5,
              -0.3,
              -0.7,
              0.3,
              0.2,
              0.1,
              0.6,
              0.7,
              0.5,
              0,
              -0.6,
              0,
              0,
              -0.7,
              0,
              -0.9,
              0.4,
              0,
              -0.6,
              -0.5,
              -0.2,
              -0.8,
              0,
              -0.5,
              -0.4,
              -0.2,
              0.1,
              0,
              0.2,
              0,
              0.3,
              0.7,
              -0.3,
              0.9,
              -0.4,
              -0.2,
              -0.6,
              -0.1,
              0.2,
              -0.5,
              0,
              -0.4,
              -0.3,
              0,
              0.2,
              0,
              0.4,
              0.6,
              0,
              0.1,
              0,
              -0.1,
              0,
              -0.4,
              0.1,
              0.2,
              -0.7,
              0,
              0.1,
              0,
              0,
              0.7,
              0.8,
              0.6,
              -0.5,
              0.5,
              -0.6,
              -0.8,
              0.6,
              -0.2,
              -0.6,
              -0.5,
              -0.6,
              0.1,
              -0.8,
              -0.9,
              -0.7,
              -0.3,
              -0.6,
              -0.2,
              -0.4,
              -0.3,
              -0.2,
              -0.1,
              -0.6,
              -0.8,
              -0.7,
              0.1,
              -0.2,
              0.6,
              0.7,
              0.3,
              0.4,
              0.3,
              -0.2,
              0,
              -0.3,
              -0.2,
              0.1,
              0.4,
              0.8,
              -0.5,
              0.4,
              0.5,
              0.6,
              -0.7,
              -0.8,
              -0.6,
              -0.3,
              0.3,
              -0.4,
              -0.5,
              -0.8,
              -0.7,
              0,
              -0.8,
              -0.7,
              0,
              -0.6,
              -0.5,
              -0.9,
              0.7,
              -0.3,
              -0.2,
              0.6,
              -0.6,
              -0.7,
              -0.5,
              -0.4,
              -0.6,
              0,
              -0.4,
              -0.6,
              -0.2,
              -0.7,
              -0.8,
              -0.8,
              -0.8,
              -0.8,
              -0.8,
              -0.8,
              -0.7,
              0,
              0.7,
              0,
              -0.5,
              0.6,
              0.8,
              -0.3,
              0.6,
              -0.8,
              0.7,
              -0.2,
              -0.4,
              0.9,
              0,
              -0.8,
              -0.4,
              -0.5,
              0.2,
              0.6,
              0.3,
              -0.6,
              0.7,
              0.6,
              0.8,
              0.9,
              0.2,
              0.7,
              0.4,
              0.8,
              0.9,
              0.8,
              0.5,
              0,
              0.2,
              0.6,
              0.7,
              0.5,
              0,
              0.4,
              0.6,
              -0.3,
              0.4,
              -0.2,
              0.3,
              0.9,
              0.8,
              0.6,
              0.7,
              0.6,
              0.8,
              0.7,
              0.8,
              0.2,
              0,
              0.9,
              0,
              0.3,
              0,
              0.9,
              0.4,
              0.7,
              0,
              -0.3,
              0.6,
              0.8,
              0.9,
              0.7,
              0.8,
              0.7,
              0.9,
              0.2,
              0.6,
              0.3,
              0.1,
              0.4,
              0.8,
              0.6,
              0,
              0.7,
              0.5,
              0.6,
              0.9,
              0.8,
              0.7,
              0.8,
              0.9,
              0.9,
              0,
              0,
              0.8,
              0.4,
              0.6,
              0.8,
              0.9,
              0.4,
              0.5,
              0.3,
              -0.1,
              0,
              0,
              0.6,
              0.8,
              0.4,
              0.2,
              0.1,
              0.5,
              0,
              0.3,
              0.6,
              0.1,
              0.4,
              0.7,
              0.8,
              0.9,
              0.3,
              0.2,
              0.9,
              0.7,
              0.9,
              0,
              0.4,
              0,
              0.2,
              0.5,
              0,
              0.6,
              0,
              0.3,
              0.2,
              0.3,
              0.7,
              -0.2,
              0.6,
              0.5,
              0.2,
              0.7,
              0.6,
              -0.4,
              -0.3,
              -0.4,
              0,
              -0.5,
              0.1,
              0.2,
              -0.2,
              0.1,
              0.7,
              0.8,
              0.5,
              0.6,
              0.7,
              0.2,
              0,
              -0.3,
              0,
              -0.6,
              -0.4,
              0.3,
              0.1,
              0.4,
              -0.2,
              0.6,
              0.7,
              0.8,
              0.7,
              0.6,
              0.4,
              0.2,
              0.1,
              0,
              -0.2,
              0.7,
              0,
              -0.5,
              -0.4,
              -0.3,
              0.4,
              0,
              0.2,
              -0.4,
              0.3,
              0.2,
              -0.5,
              0,
              0.8,
              0.7,
              -0.4,
              -0.2,
              0.2,
              0.1,
              0.7,
              0,
              0.5,
              -0.2,
              0,
              0.6,
              0.4,
              0.7,
              -0.4,
              0.2,
              -0.3,
              -0.3,
              0.6,
              -0.4,
              0,
              0.1,
              0.7,
              0.3,
              -0.2,
              0.4,
              0.2,
              -0.8,
              0,
              0.7,
              -0.3,
              0.6,
              0,
              -0.3,
              -0.4,
              -0.7,
              0,
              0.4,
              0.3,
              0,
              0.2,
              0.8,
              0.3,
              0.4,
              0.2,
              0.5,
              -0.3,
              0,
              0,
              0.6,
              0.7,
              -0.2,
              0.8,
              0.3,
              -0.1,
              -0.1,
              0.8,
              0.7,
              0.6,
              0.8,
              0.6,
              0.7,
              -0.3,
              0.5,
              0.7,
              0.4,
              0.3,
              0.2,
              0,
              0.8,
              -0.3,
              0.7,
              -0.2,
              -0.6,
              -0.1,
              0.6,
              0.4,
              0.7,
              -0.4,
              -0.3,
              -0.2,
              0.8,
              0.9,
              0.8,
              0.1,
              0.3,
              -0.4,
              0.6,
              0.2,
              0.7,
              0.1,
              0.8,
              0.3,
              0.4,
              0.5,
              -0.1,
              0,
              0.1,
              -0.1,
              0.2,
              0.1,
              0.5,
              0.3,
              0.9,
              0.8,
              0.9,
              0.8,
              0.3,
              -0.2,
              0.4,
              0.2,
              0.5,
              -0.7,
              0.1,
              0,
              0.2,
              -0.3,
              -0.3,
              -0.2,
              0.2,
              -0.4,
              -0.3,
              0.8,
              0,
              0.2,
              0.3,
              -0.2,
              0.7,
              0.9,
              0.8,
              0,
              -0.2,
              -0.3,
              0,
              0,
              0.6,
              0.4,
              -0.2,
              0.2,
              0.4,
              -0.5,
              -0.4,
              0.5,
              0.3,
              -0.4,
              0.6,
              -0.6,
              0.7,
              0.6,
              -0.8,
              -0.5,
              -0.2,
              -0.4,
              -0.6,
              0.4,
              0,
              0,
              -0.2,
              -0.7,
              -0.8,
              0.2,
              -0.4,
              0.4,
              -0.6,
              -0.7,
              -0.5,
              -0.3,
              0.3,
              0.2,
              -0.6,
              -0.3,
              0.2,
              -0.5,
              0,
              0,
              -0.7,
              -0.2,
              -0.8,
              -0.7,
              0.4,
              0.3,
              -0.4,
              0.2,
              0.3,
              0.6,
              0.6,
              0.1,
              -0.2,
              -0.5,
              0,
              -0.8,
              -0.6,
              -0.7,
              -0.8,
              0.8,
              -0.7,
              0,
              0.6,
              0.8,
              0.7,
              0.7,
              0.8,
              -0.7,
              0.6,
              0.5,
              0.1,
              0,
              0,
              0,
              0.3,
              0.2,
              0,
              0.7,
              0.3,
              -0.4,
              0.8,
              -0.5,
              -0.7,
              -0.8,
              0.6,
              0,
              -0.3,
              0.1,
              -0.2,
              0.8,
              -0.3,
              -0.6,
              -0.2,
              -0.4,
              -0.5,
              -0.3,
              0.3,
              0.2,
              -0.2,
              0.7,
              -0.4,
              0.8,
              -0.2,
              -0.5,
              -0.3,
              0.9,
              0.6,
              0.8,
              -0.4,
              0,
              0.1,
              0,
              0,
              0.4,
              0.1,
              0.3,
              0.2,
              0.7,
              0.6,
              -0.2,
              0.6,
              0.5,
              -0.4,
              -0.3,
              -0.7,
              0.1,
              0.5,
              0.4,
              0.3,
              -0.4,
              0.6,
              0,
              0.1,
              0.7,
              0.4,
              -0.3,
              0,
              0.6,
              -0.6,
              -0.1,
              0.3,
              -0.3,
              0.1,
              0.2,
              0.3,
              0.7,
              -0.2,
              -0.5,
              0.8,
              0.7,
              -0.6,
              -0.1,
              0.6,
              -0.3,
              0.2,
              -0.6,
              -0.8,
              -0.4,
              -0.3,
              0,
              0,
              0,
              0.4,
              0,
              0.3,
              -0.2,
              0.2,
              0.8,
              0.4,
              -0.3,
              -0.2,
              0.8,
              0.1,
              0.6,
              -0.4,
              0,
              0.1,
              0,
              -0.3,
              -0.5,
              -0.2,
              0.4,
              0.9,
              0,
              0.6,
              0.7,
              -0.6,
              0.8,
              0.6,
              0,
              0.5,
              0.1,
              0.2,
              0.6,
              0.4,
              -0.3,
              -0.7,
              -0.2,
              0.8,
              0.3,
              0.7,
              0.4,
              -0.2,
              0.2,
              0.1,
              0.5,
              0,
              0.4,
              0.6,
              -0.3,
              -0.1,
              0.4,
              -0.5,
              -0.4,
              0.2,
              0.3,
              0.8,
              0.1,
              0,
              0.4,
              0.6,
              -0.4,
              0.5,
              0.6,
              0.5,
              -0.8,
              -0.7,
              0.1,
              0.6,
              0.7,
              -0.3,
              -0.2,
              -0.4,
              0.6,
              0.3,
              -0.5,
              -0.6,
              -0.4,
              -0.2,
              -0.8,
              0.1,
              0.4,
              0.3,
              -0.8,
              -0.6,
              -0.7,
              -0.3,
              -0.4,
              0.5,
              0.1,
              0.8,
              0.1,
              0.2,
              0.3,
              -0.5,
              -0.7,
              -0.4,
              -0.3,
              -0.4,
              -0.7,
              0.3,
              0.1,
              0.2,
              -0.2,
              0.6,
              -0.3,
              0.7,
              -0.4,
              -0.9,
              -0.5,
              0.4,
              0,
              0.2,
              0.4,
              0.1,
              0.3,
              0.4,
              -0.2,
              0,
              -0.2,
              -0.3,
              -0.5,
              -0.3,
              -0.4,
              0.2,
              0.4,
              -0.2,
              -0.3,
              0.1,
              -0.2,
              0.4,
              -0.6,
              0.1,
              -0.3,
              0.5,
              -0.2,
              -0.4,
              -0.3,
              0.2,
              0.1,
              -0.3,
              -0.2,
              0.2,
              0.3,
              0.2,
              0.1,
              0,
              0.2,
              0.3,
              0.4,
              0,
              0.5,
              0.6,
              -0.5,
              0,
              -0.2,
              -0.4,
              0.4,
              0,
              0.5,
              0.3,
              0.4,
              0.3,
              0.4,
              0.3,
              0.2,
              0.5,
              0,
              0.7,
              0.2,
              -0.1,
              0,
              0.2,
              0.4,
              -0.3,
              -0.4,
              -0.2,
              0.3,
              -0.2,
              -0.6,
              0.4,
              0.1,
              -0.2,
              0.3,
              0.4,
              -0.3,
              0.5,
              -0.4,
              0,
              0.4,
              0.3,
              -0.2,
              -0.8,
              -0.6,
              -0.7,
              -0.2,
              -0.3,
              -0.5,
              -0.8,
              -0.6,
              -0.7,
              -0.8,
              -0.5,
              -0.3,
              -0.4,
              -0.7,
              -0.3,
              -0.8,
              -0.6,
              -0.4,
              0.2,
              0.6,
              0,
              -0.2,
              -0.5,
              -0.3,
              -0.2,
              -0.4,
              -0.1,
              0,
              -0.5,
              -0.6,
              -0.7,
              -0.4,
              -0.2,
              0,
              -0.3,
              0.4,
              0.3,
              -0.4,
              -0.2,
              -0.5,
              0,
              -0.4,
              -0.2,
              0.1,
              0.4,
              0.2,
              0.3,
              -0.3,
              0.4,
              0.5,
              0,
              0.8,
              0.4,
              0.9,
              0.8,
              -0.2,
              0.7,
              -0.6,
              -0.3,
              0.8,
              -0.7,
              -0.8,
              -0.3,
              -0.7,
              -0.6,
              -0.4,
              -0.9,
              0.2,
              -0.8,
              0.3,
              -0.9,
              -0.8,
              0.2,
              -0.1,
              0.2,
              0.3,
              0.6,
              0.5,
              0.4,
              0.1,
              0.2,
              0.3,
              0.1,
              0.4,
              -0.3,
              0.2,
              -0.4,
              -0.2,
              -0.8,
              -0.6,
              0.3,
              0.7,
              0.8,
              0.1,
              -0.4,
              -0.3,
              0.4,
              0.8,
              0.7,
              0.6,
              -0.8,
              0.7,
              0,
              -0.2,
              -0.7,
              -0.6,
              -0.5,
              0,
              0.4,
              0.2,
              0.6,
              0.7,
              0.3,
              -0.2,
              -0.3,
              0,
              0,
              0,
              0,
              0,
              0,
              -0.4,
              0,
              -0.2,
              -0.6,
              0,
              0,
              0.3,
              -0.3,
              0,
              -0.5,
              0.2,
              -0.3,
              0,
              -0.4,
              0.2,
              -0.6,
              -0.5,
              0.8,
              -0.2,
              0.2,
              0.3,
              -0.7,
              -0.2,
              -0.8,
              0,
              0.6,
              0,
              0,
              -0.4,
              0.2,
              -0.3,
              -0.4,
              -0.8,
              -0.4,
              0,
              -0.1,
              -0.3,
              0,
              0.7,
              -0.2,
              -0.5,
              -0.2,
              0.1,
              -0.4,
              -0.8,
              0.3,
              0,
              0.4,
              -0.3,
              -0.6,
              0.2,
              -0.5,
              0,
              0,
              0.5,
              -0.7,
              -0.2,
              0.3,
              0.1,
              -0.8,
              -0.6,
              0.2,
              -0.2,
              0.6,
              -0.7
            ],
            "positive": 764,
            "neutral": 496,
            "negative": 742,
            "mixed": null,
            "average_score": 0.05879422022919774,
            "total_analyzed": 2007
          }
        },
        "timeline": [
          {
            "date": "2025-09-08",
            "average_score": 0.21067073170731726,
            "positive": 155,
            "neutral": 92,
            "negative": 80,
            "total": 328
          },
          {
            "date": "2025-09-09",
            "average_score": 0.42013888888888873,
            "positive": 180,
            "neutral": 97,
            "negative": 11,
            "total": 288
          },
          {
            "date": "2025-09-10",
            "average_score": -0.29279661016949193,
            "positive": 39,
            "neutral": 30,
            "negative": 167,
            "total": 236
          },
          {
            "date": "2025-09-11",
            "average_score": -0.18333333333333332,
            "positive": 43,
            "neutral": 41,
            "negative": 120,
            "total": 204
          },
          {
            "date": "2025-09-12",
            "average_score": 0.058782201405152286,
            "positive": 169,
            "neutral": 92,
            "negative": 166,
            "total": 427
          },
          {
            "date": "2025-09-13",
            "average_score": 0.47142857142857125,
            "positive": 74,
            "neutral": 25,
            "negative": 4,
            "total": 105
          },
          {
            "date": "2025-09-14",
            "average_score": -0.0959427207637231,
            "positive": 104,
            "neutral": 119,
            "negative": 194,
            "total": 419
          }
        ],
        "ai_insights": {
          "popculturechat": "After analyzing the posts from r/popculturechat, here's a concise but meaningful analysis:\n\nOverall Mood and Attitudes:\nThe community appears to be grappling with a somber and disturbing turn of events, particularly surrounding the tragic death of Charlie Kirk. There is a mix of dark humor, criticism of media narratives, and a sense of unease about the state of politics and violence in the country.\n\nCommon Themes and Topics:\n- The Charlie Kirk shooting incident and related political rhetoric/implications\n- Concerns about media bias and censorship, especially around divisive public figures\n- Celebrity culture, fashion, and controversies (e.g., Margot Robbie's dress, Eric Stonestreet's marriage)\n- Nostalgia for past pop culture moments (e.g., Mariah Carey vs. Eminem)\n- Discussions of celebrity backgrounds and struggles with fame\n\nUpvoted Content and Patterns:\n- Posts related to the Charlie Kirk shooting receive high engagement, with users analyzing the rhetoric and implications\n- Content that offers social commentary, satire, or unique celebrity content (like the GQ photoshoot) tends to be well-received\n- Users seem to appreciate when celebrities are candid about their experiences and struggles\n\nEmerging Trends and Shifts:\n- A growing sense of unease and distrust towards mainstream media and political narratives\n- Increased focus on the personal lives and struggles of celebrities, beyond just superficial coverage\n- Willingness to critically examine the actions and statements of public figures, even after their deaths\n\nPain Points and Frustrations:\n- Frustration with media censorship and perceived bias, especially around divisive political figures\n- Concerns about the increasing polarization and violence in the country, as seen in the school shootings and political attacks\n- Discomfort with the exploitation and objectification of celebrities, especially women, in the entertainment industry\n\nOverall, the r/popculturechat community appears to be grappling with a complex mix of pop culture news and the broader sociopolitical climate. The discussions reflect a growing desire for nuance, critical analysis, and a more authentic understanding of the experiences of both public figures and everyday people."
        },
        "framework_analysis": {
          "success": true,
          "analysis": "I'll analyze this data following the specified structure:\n\n**COMMUNITY PROFILING**\n\n• Community Type: Celebrity/Entertainment News & Discussion\n• Demographic Indicators: Young adults (18-35), predominantly entertainment-focused\n• Emotional Baseline: Mixed cynical/humorous with high emotional volatility\n• Community Character: A celebrity and pop culture focused community that blends entertainment news with social commentary. Shows high engagement on both light-hearted celebrity content and serious sociopolitical issues when they intersect with pop culture.\n\n**PATTERN DISCOVERY**\n\n🔍 Key Findings:\n\n1. Surprising Pattern #1:\n   Political content generates highest engagement despite being entertainment subreddit (Kirk-related posts dominated top engagement)\n\n2. Surprising Pattern #2:\n   Celebrity appearance posts show strong gender-based response patterns - male celebrities receive more positive sentiment than female celebrities\n\n3. Surprising Pattern #3:\n   Humor and references are consistently used to process serious news, indicating community uses comedy as coping mechanism\n\n💬 Controversy Triggers:\n• Political violence/deaths\n• Celebrity appearance criticism\n• Gender dynamics in entertainment\n• Media coverage ethics\n\n📊 Success/Failure Predictors:\n• Success indicators: Humor, cultural references, balanced criticism\n• Failure indicators: Overtly political statements, aggressive criticism, defending controversial figures\n\n**TEMPORAL ANALYSIS**\n\n⏰ Time-Based Patterns:\n\nDaily Cycles:\n• Morning: Lower engagement, more neutral discussion\n• Afternoon: Peak engagement, most controversial discussions\n• Evening: Higher humor content, more casual discussion\n\nWeekly Trends:\n• Weekday engagement significantly higher than weekends\n• Peak engagement mid-week (Tuesday-Thursday)\n• Sentiment more negative during high-news periods\n\nSentiment Evolution:\n• Started neutral (0.21), peaked positive (0.47), dipped negative (-0.29)\n• Overall sentiment slightly positive (0.06)\n\n**KEY INSIGHTS**\n\n⭐ Most Important Discoveries:\n\n1. Engagement Correlation:\n   Controversial political content drives highest engagement despite being pop culture focused\n\n2. Unspoken Rules:\n   Community expects balanced criticism with humor elements\n\n3. Influence Patterns:\n   Top comments set tone for entire discussion threads\n\n4. Content Predictors:\n   Visual content (photos, videos) generates more consistent positive engagement\n\n**ACTIONABLE RECOMMENDATIONS**\n\n📝 Content Strategy:\n• Best performing content types: Celebrity photos, humor-based commentary, cultural references\n• Optimal post structure: Visual content + cultural reference + discussion prompt\n• Language style: Casual, witty, balanced criticism\n\n⏱️ Timing Strategy:\n• Best posting times: Tuesday-Thursday afternoons\n• Avoid posting: Weekend mornings, late nights\n\n🚫 Topics to Avoid:\n• Direct political statements without cultural context\n• Aggressive appearance criticism\n• Unbalanced commentary on sensitive issues\n\n✅ Topics that Resonate:\n• Celebrity lifestyle/relationship news\n• Behind-the-scenes industry content\n• Cultural commentary with humor\n\n**QUESTIONS FOR DEEPER ANALYSIS**\n\n🤔 Compelling questions:\n\n1. How does the community balance entertainment vs serious discussion?\n2. What role does gender play in content reception?\n3. How does political content affect community dynamics?\n4. Is the humor-coping mechanism healthy for serious discussions?\n5. How does celebrity criticism differ by gender?\n\n**SUMMARY**\n\n📋 Executive Summary:\nThis entertainment-focused community shows sophisticated handling of both light and serious content through humor and cultural references. While primarily focused on pop culture, it demonstrates high engagement with sociopolitical issues when they intersect with entertainment. The community maintains balance through humor and references while processing serious topics, though shows clear engagement patterns based on gender and content type.",
          "generated_at": "2025-09-15T08:53:41.149Z",
          "model_used": "Claude 3.5 Sonnet"
        },
        "synthetic_post": {
          "title": "Taylor Swift and Travis Kelce spotted having dinner in NYC - Page Six confirms relationship",
          "author": "PopCultureObsessed",
          "body": "Multiple sources confirm they were seen at Carbone in Manhattan last night. Apparently they arrived separately but left together around 11pm.\n\nPage Six has exclusive photos showing them leaving in the same car. Taylor was wearing a black midi dress and Travis was in a grey suit.",
          "score": 24567,
          "upvoteRatio": 0.92,
          "comments": [
            {
              "id": "comment1",
              "author": "SwiftieForever89",
              "body": "She looks so happy in these pics! And that dress is definitely giving Midnights era vibes",
              "score": 8743,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment2",
              "author": "GossipGuru22",
              "body": "![gif](giphy|kf9dfB18XB6JGM8J7s|downsized)",
              "score": 6521,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment3",
              "author": "CelebTea",
              "body": "Her PR team working overtime as usual... right before the Eras Tour movie release 🙄",
              "score": 4892,
              "replies": [],
              "level": 0,
              "sentiment": "negative"
            },
            {
              "id": "comment4",
              "author": "PopNews24",
              "body": "Carbone? The way celebrities act like there aren't other restaurants in NYC",
              "score": 3756,
              "replies": [],
              "level": 0,
              "sentiment": "neutral"
            },
            {
              "id": "comment5",
              "author": "RedCarpetWatcher",
              "body": "The way he's looking at her in that last pic... I actually think this might be real and not just a PR stunt",
              "score": 3241,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment6",
              "author": "ChampionshipTea",
              "body": "Not me actually shipping this?? They both seem genuinely into each other",
              "score": 2867,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment7",
              "author": "CelebInsider",
              "body": "That dress is Versace and probably costs more than my yearly rent 😭",
              "score": 2433,
              "replies": [],
              "level": 0,
              "sentiment": "neutral"
            },
            {
              "id": "comment8",
              "author": "TeaSpiller",
              "body": "Why do I feel like we're about to get an NFL-themed song on her next album",
              "score": 2156,
              "replies": [],
              "level": 0,
              "sentiment": "humorous"
            },
            {
              "id": "comment9",
              "author": "BuzzNewz",
              "body": "The Swifties and NFL bros are about to have the crossover event of the century",
              "score": 1844,
              "replies": [],
              "level": 0,
              "sentiment": "humorous"
            },
            {
              "id": "comment10",
              "author": "PopCulture101",
              "body": "Watch this relationship last longer than anyone expects. She seems done with the Hollywood type and he's actually accomplished in his own right",
              "score": 1532,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            }
          ],
          "subreddit": "popculturechat",
          "timeAgo": "4 hours ago",
          "sentiment": "positive",
          "generated_at": "2025-09-15T08:54:34.507Z",
          "version": 1
        }
      },
      "posts": [
        {
          "id": "1ndpxaz",
          "title": "Charlie Kirk Dies at 31 After Being Shot at Campus Appearance",
          "selftext": "",
          "score": 32466,
          "num_comments": 5492,
          "created_utc": 1757537443,
          "subreddit": "popculturechat",
          "permalink": "/r/popculturechat/comments/1ndpxaz/charlie_kirk_dies_at_31_after_being_shot_at/",
          "url": "https://variety.com/2025/politics/news/charlie-kirk-dead-shot-1236514498/",
          "author": "SafeBodybuilder7191",
          "comments": [
            {
              "id": "nditm97",
              "body": "Meanwhile, three children were shot at a school in Colorado today.",
              "score": 10917,
              "created_utc": 1757539276,
              "author": "Kooky_Target_1367"
            },
            {
              "id": "ndirv8p",
              "body": "https://preview.redd.it/y6qxlj17leof1.jpeg?width=843&format=pjpg&auto=webp&s=8f8f6e42f5d960623b3614e10cbefe8cf80ab831",
              "score": 9094,
              "created_utc": 1757538803,
              "author": "HerRoyalRedness"
            },
            {
              "id": "ndirel5",
              "body": "the shooter is still at large, and seems to know what they are doing (that was a literal long shot)",
              "score": 8548,
              "created_utc": 1757538681,
              "author": "keine_fragen"
            },
            {
              "id": "ndiqbsc",
              "body": "[deleted]",
              "score": 7464,
              "created_utc": 1757538402,
              "author": "[deleted]"
            }
          ]
        },
        {
          "id": "1nf3vja",
          "title": "22 year old Tyler Robinson identified as official suspect in Charlie Kirk murder",
          "selftext": "",
          "score": 26480,
          "num_comments": 1669,
          "created_utc": 1757685244,
          "subreddit": "popculturechat",
          "permalink": "/r/popculturechat/comments/1nf3vja/22_year_old_tyler_robinson_identified_as_official/",
          "url": "https://i.redd.it/rpgac7mnoqof1.jpeg",
          "author": "HauteAssMess",
          "comments": [
            {
              "id": "ndtk073",
              "body": "Kind of funny that this clown ass FBI couldn't get him and he's only in custody bc his dad turned him in",
              "score": 10198,
              "created_utc": 1757686609,
              "author": "calicotamer"
            },
            {
              "id": "ndtlz28",
              "body": "It's interesting that in the press conference, they reveal that this Tyler guy became more political in the last few years. But they don't say what kind of politics.",
              "score": 9621,
              "created_utc": 1757687166,
              "author": "AgentBrittany"
            },
            {
              "id": "ndtn1bz",
              "body": "His mom didn't lock down her FB, and it's full of pictures of him with guns and dressed like Pepe and in a Trump costume for Halloween lol",
              "score": 8869,
              "created_utc": 1757687465,
              "author": "AgentBrittany"
            },
            {
              "id": "ndtikha",
              "body": "We ALL knew he was going to look like this, be so fucking for real.",
              "score": 8750,
              "created_utc": 1757686198,
              "author": "indicatprincess"
            }
          ]
        },
        {
          "id": "1nce3we",
          "title": "Modern Family actor Eric Stonestreet announces he has gotten married to partner Lindsay Schweitzer after getting Engaged in 2021",
          "selftext": "",
          "score": 25875,
          "num_comments": 673,
          "created_utc": 1757409541,
          "subreddit": "popculturechat",
          "permalink": "/r/popculturechat/comments/1nce3we/modern_family_actor_eric_stonestreet_announces_he/",
          "url": "https://www.reddit.com/gallery/1nce3we",
          "author": "SafeBodybuilder7191",
          "comments": [
            {
              "id": "nd8meqm",
              "body": "He's such a good actor that seeing him married to a woman is very confusing",
              "score": 16094,
              "created_utc": 1757412916,
              "author": "darkhummus"
            },
            {
              "id": "nd8m8yz",
              "body": "![gif](giphy|qvmLA65T7syPK)",
              "score": 7946,
              "created_utc": 1757412830,
              "author": "Alternative-Talk-795"
            },
            {
              "id": "nd8nnaz",
              "body": "https://i.redd.it/gbf8c5lt84of1.gif",
              "score": 6183,
              "created_utc": 1757413570,
              "author": "mallvvalking"
            },
            {
              "id": "nd8o8vt",
              "body": "People's reaction:\n\nhttps://preview.redd.it/jceno6hj94of1.jpeg?width=491&format=pjpg&auto=webp&s=1a5f132fa9bc557d0147b71e152a76970aec411c\n\nSidenote; I do believe he has talked about it that he did have (initially?) a problem finding a woman (and probably a long term thing), he was too good in that role.",
              "score": 3074,
              "created_utc": 1757413879,
              "author": "Unlucky-Duck"
            }
          ]
        },
        {
          "id": "1nefjty",
          "title": "Margot Robbie at the premier of “A Big Bold Beautiful Journey” in London - September 11, 2025",
          "selftext": "",
          "score": 21796,
          "num_comments": 1756,
          "created_utc": 1757613030,
          "subreddit": "popculturechat",
          "permalink": "/r/popculturechat/comments/1nefjty/margot_robbie_at_the_premier_of_a_big_bold/",
          "url": "https://www.reddit.com/gallery/1nefjty",
          "author": "torahboidem",
          "comments": [
            {
              "id": "ndocku1",
              "body": "Ok whew I thought for a second I may not be able to see her entire asscrack, but there it is",
              "score": 9868,
              "created_utc": 1757614052,
              "author": "thatkittykatie"
            },
            {
              "id": "ndod4af",
              "body": "She looks uncomfortable in it. Why the hell didn't they add a lining? Why does her entire ass have to be on display??",
              "score": 3963,
              "created_utc": 1757614202,
              "author": "wildbeest55"
            },
            {
              "id": "ndotgaj",
              "body": "https://preview.redd.it/cedowpmf7lof1.png?width=1080&format=png&auto=webp&s=004e6912783e7d74664d4aa1d5d9faa26debac9a\n\nMeanwhile Colin Farrell was wearing as many clothes as possible to balance it out.",
              "score": 3518,
              "created_utc": 1757618919,
              "author": "mizzlemoonn"
            },
            {
              "id": "ndoauqp",
              "body": "On one hand, she's beautiful, and on the other hand that gown is giving me so much anxiety.",
              "score": 2654,
              "created_utc": 1757613579,
              "author": "envy-adams"
            }
          ]
        },
        {
          "id": "1ncheoq",
          "title": "Glen Powell for the October issue of GQ Magazine; Photography by Bobby Doherty",
          "selftext": "",
          "score": 19316,
          "num_comments": 1216,
          "created_utc": 1757420548,
          "subreddit": "popculturechat",
          "permalink": "/r/popculturechat/comments/1ncheoq/glen_powell_for_the_october_issue_of_gq_magazine/",
          "url": "https://www.reddit.com/gallery/1ncheoq",
          "author": "mcfw31",
          "comments": [
            {
              "id": "nd9bl5j",
              "body": "An actual idea? A point of view?! Satire in a major publication?! Who is the creative director, I need to shake their hand.\n\nETA: Will Welch and Tobias Frericks",
              "score": 9643,
              "created_utc": 1757423353,
              "author": "MurphyBrown2016"
            },
            {
              "id": "nd9bv5z",
              "body": "![gif](giphy|ME2ymiZaDHqWc6grdw|downsized)",
              "score": 9268,
              "created_utc": 1757423447,
              "author": "Far_Cut_"
            },
            {
              "id": "nd99uvj",
              "body": "These photos are so unhinged 😂",
              "score": 7361,
              "created_utc": 1757422763,
              "author": "Suspicious_Name_656"
            },
            {
              "id": "nd9bdpq",
              "body": "I love it when celebrities open themselves up to crazy ass photoshoots.  Some people may not like them, but oh well. Love this.  Picture 7 is cracking me up the most and I’m not sure why. I think it’s the amount of eggs.",
              "score": 3170,
              "created_utc": 1757423283,
              "author": "PlentyDrawer"
            }
          ]
        },
        {
          "id": "1ne7uin",
          "title": "Matthew Dowd Fired from MSNBC Over Charlie Kirk Comments: Reports",
          "selftext": "",
          "score": 17687,
          "num_comments": 1543,
          "created_utc": 1757594691,
          "subreddit": "popculturechat",
          "permalink": "/r/popculturechat/comments/1ne7uin/matthew_dowd_fired_from_msnbc_over_charlie_kirk/",
          "url": "https://people.com/matthew-dowd-fired-from-msnbc-for-charlie-kirk-comments-11807877",
          "author": "AdSpecialist6598",
          "comments": [
            {
              "id": "ndmpyfa",
              "body": "> “He’s been one of the most divisive, especially divisive younger figures in this, who is constantly sort of pushing this sort of hate speech or sort of aimed at certain groups,\" Dowd replied. \"And I always go back to, hateful thoughts lead to hateful words, which then lead to hateful actions. And I think that is the environment we are in.\"\n\n>”You can’t stop with these sort of awful thoughts you ...",
              "score": 14734,
              "created_utc": 1757596884,
              "author": "buzzfeed_sucks"
            },
            {
              "id": "ndmyjw7",
              "body": "Everyone talked about Charlie Kirk’s hateful rhetoric as he was living, but then he dies and suddenly he’s canonized? And Dowd called the action hateful and awful RIGHT THERE! God they’re all so fucking *weak.*",
              "score": 7747,
              "created_utc": 1757599606,
              "author": "deev718"
            },
            {
              "id": "ndmupkb",
              "body": "Media is dead. The sooner we realize the right wing bought up every news media including the ones that are “left leaning” the better",
              "score": 3798,
              "created_utc": 1757598411,
              "author": "Chaoticgood790"
            },
            {
              "id": "ndmri8c",
              "body": "That’s far more measured than I would have been. How is this statement grounds for firing?",
              "score": 3739,
              "created_utc": 1757597383,
              "author": "RockerElvis"
            }
          ]
        },
        {
          "id": "1nfihxo",
          "title": "Nicholas Hoult via IG story “👋”",
          "selftext": "To be completely honest I just wanted to show how good he looks.",
          "score": 16077,
          "num_comments": 533,
          "created_utc": 1757720297,
          "subreddit": "popculturechat",
          "permalink": "/r/popculturechat/comments/1nfihxo/nicholas_hoult_via_ig_story/",
          "url": "https://i.redd.it/k7hce3xvktof1.jpeg",
          "author": "raquan666",
          "comments": [
            {
              "id": "ndwwr4p",
              "body": "He said “it’s been a rough week so here’s a pic of me looking sexy….you’re welcome”",
              "score": 5873,
              "created_utc": 1757723490,
              "author": "Carolina_Blues"
            },
            {
              "id": "ndx0d5v",
              "body": "The world’s most unflattering angle and he looks like this?",
              "score": 5682,
              "created_utc": 1757724815,
              "author": "AnonAttemptress"
            },
            {
              "id": "ndwzkkd",
              "body": "Nobody should look good in peroxide blonde but he’s crushing it!",
              "score": 2109,
              "created_utc": 1757724522,
              "author": "thewidowgorey"
            },
            {
              "id": "ndx2yoo",
              "body": "Right? This man is a menace on so many levels.",
              "score": 1519,
              "created_utc": 1757725789,
              "author": "ThreadLaced"
            }
          ]
        },
        {
          "id": "1ndmywe",
          "title": "Shots fired at a Charlie Kirk event at Utah Valley University",
          "selftext": "",
          "score": 15141,
          "num_comments": 2378,
          "created_utc": 1757530475,
          "subreddit": "popculturechat",
          "permalink": "/r/popculturechat/comments/1ndmywe/shots_fired_at_a_charlie_kirk_event_at_utah/",
          "url": "https://i.redd.it/4jegdw2gwdof1.jpeg",
          "author": "HauteAssMess",
          "comments": [
            {
              "id": "ndhyfuc",
              "body": "\"I think it's worth to have a cost of, unfortunately, some gun deaths every single year so that we can have the Second Amendment to protect our other God-given rights\" - Charlie Kirk, 2023",
              "score": 5682,
              "created_utc": 1757531017,
              "author": "deathtotheemperor"
            },
            {
              "id": "ndi04nz",
              "body": "I imagine the White House will have more to say about this than they did about the two Minnesota lawmakers who were assassinated",
              "score": 3739,
              "created_utc": 1757531487,
              "author": "StrngBrew"
            },
            {
              "id": "ndhy7bz",
              "body": "Kirk was shot in the neck",
              "score": 3722,
              "created_utc": 1757530950,
              "author": "HauteAssMess"
            },
            {
              "id": "ndhzlvo",
              "body": "Yeah the video is rough. Looks likely fatal",
              "score": 2049,
              "created_utc": 1757531344,
              "author": "dancing_light"
            }
          ]
        },
        {
          "id": "1nbnv6v",
          "title": "Remember that time Mariah Carey sincerely asked Eminem in 2009 why he was so obsessed with her?",
          "selftext": "Obsessed - Mariah Carey (2009)",
          "score": 14358,
          "num_comments": 1161,
          "created_utc": 1757338390,
          "subreddit": "popculturechat",
          "permalink": "/r/popculturechat/comments/1nbnv6v/remember_that_time_mariah_carey_sincerely_asked/",
          "url": "https://v.redd.it/nmo14t701ynf1",
          "author": "WarwickReider",
          "comments": [
            {
              "id": "nd3kvz1",
              "body": "When I was in a high school a girls car got egged and her only response was to share this music video on Facebook",
              "score": 6436,
              "created_utc": 1757345241,
              "author": "Peabutnutter69420"
            },
            {
              "id": "nd3isvo",
              "body": "She is so funny and I don’t think many people realise that. The music video is so good",
              "score": 3666,
              "created_utc": 1757344613,
              "author": "luludarlin"
            },
            {
              "id": "nd3de5u",
              "body": "“You’re mom and pop/ I’m a corporation/ I’m a press conference/you’re a conversation” is an all time iconic line\n\nEdit: Eminem fans please get out of my replies lmao I don’t care if you think he won the beef, Obsessed remains iconic",
              "score": 3083,
              "created_utc": 1757342974,
              "author": "omgcow"
            },
            {
              "id": "nd3zi7f",
              "body": "An ex of mine was harassing me years ago, spamming me with messages, and I just sent back the link to this song. He kinda looked like the guy in the MV too which made it even funnier. But he didnt think so, I guess.",
              "score": 1505,
              "created_utc": 1757349550,
              "author": "hthratmn"
            }
          ]
        },
        {
          "id": "1ngogj6",
          "title": "What's the worst album cover in your opinion?",
          "selftext": "This Maroon 5 album cover from their album Red Pill Blues makes me cringe so bad. Who even came up with this? Snapchat filters on an album? Like why?",
          "score": 12064,
          "num_comments": 1632,
          "created_utc": 1757847959,
          "subreddit": "popculturechat",
          "permalink": "/r/popculturechat/comments/1ngogj6/whats_the_worst_album_cover_in_your_opinion/",
          "url": "https://i.redd.it/vkzcfd3744pf1.jpeg",
          "author": "Twitter_2006",
          "comments": [
            {
              "id": "ne5do06",
              "body": "https://preview.redd.it/z46a137a74pf1.jpeg?width=736&format=pjpg&auto=webp&s=92b205ecf0f85a9b4afd23eb69f947d63425fec0\n\nCertified Lover Boy Drake",
              "score": 7827,
              "created_utc": 1757848900,
              "author": "RedFishBlueFishGreen"
            },
            {
              "id": "ne5cxmg",
              "body": "There are 7 people in Maroon 5?",
              "score": 6948,
              "created_utc": 1757848525,
              "author": "LeaveMeAloneDamnIt6"
            },
            {
              "id": "ne5ilqo",
              "body": "Someone posted human clay, I raise you this masterpiece\n\nhttps://preview.redd.it/ivbt7r6be4pf1.jpeg?width=1500&format=pjpg&auto=webp&s=f56ccec7201106f16c95610f8611a52f405f035d",
              "score": 3378,
              "created_utc": 1757851227,
              "author": "soulthademonboi"
            },
            {
              "id": "ne5ep7f",
              "body": "7 too many\n\n![gif](giphy|3oEjHI8WJv4x6UPDB6)",
              "score": 2778,
              "created_utc": 1757849417,
              "author": "terfnerfer"
            }
          ]
        },
        {
          "id": "1ng730z",
          "title": "A fan asks Bob Odenkirk what he loves about his life",
          "selftext": "",
          "score": 11437,
          "num_comments": 273,
          "created_utc": 1757793280,
          "subreddit": "popculturechat",
          "permalink": "/r/popculturechat/comments/1ng730z/a_fan_asks_bob_odenkirk_what_he_loves_about_his/",
          "url": "https://v.redd.it/rj74cfzvlzof1",
          "author": "mcfw31",
          "comments": [
            {
              "id": "ne1ywsf",
              "body": "My anger that this man and Rhea Seehorn have zero Emmys for BCS is real and ongoing.",
              "score": 1530,
              "created_utc": 1757795620,
              "author": "Aura_Sing"
            },
            {
              "id": "ne1z7m3",
              "body": "I love Bob. He seems like a genuine guy.",
              "score": 683,
              "created_utc": 1757795716,
              "author": "ravynmaxx"
            },
            {
              "id": "ne29jga",
              "body": "https://preview.redd.it/eda269g930pf1.jpeg?width=1179&format=pjpg&auto=webp&s=031b322ce498b9f6e6d219ce0aafa63809084e12",
              "score": 613,
              "created_utc": 1757799121,
              "author": "auxilary"
            },
            {
              "id": "ne1xi4a",
              "body": "I always want to see people’s dogs.",
              "score": 576,
              "created_utc": 1757795166,
              "author": "lospolloz"
            }
          ]
        },
        {
          "id": "1nbxg3u",
          "title": "What celebrity actually came from poverty and had to work very hard, that they didn’t have the benefit of nepotism?",
          "selftext": "Jim Carrey seems like a pretty big example, cause not only did he not grow up with a wealthy family. He was actually homeless, and was living in a van with his family growing up! He even had to work as a janitor and factory worker in his early teens, and be the provider after his father lost his job! \n\nWhen he moved to Hollywood, he was taking a big risk not even knowing if he was going to actually make it big but never lost his determination to build those connections and become the comedic legend he’s known as today! ",
          "score": 11094,
          "num_comments": 1533,
          "created_utc": 1757360001,
          "subreddit": "popculturechat",
          "permalink": "/r/popculturechat/comments/1nbxg3u/what_celebrity_actually_came_from_poverty_and_had/",
          "url": "https://i.redd.it/2qe15iijtznf1.jpeg",
          "author": "phantom_avenger",
          "comments": [
            {
              "id": "nd5349r",
              "body": "Dolly Parton",
              "score": 5091,
              "created_utc": 1757361033,
              "author": "Psychotic_Humon"
            },
            {
              "id": "nd59lr8",
              "body": "Leighton Meester. She was born in a halfway house because her mother was in prison. When you hear her in interviews, she sounds very down to earth and sweet. So it’s refreshing she not only overcame everything she has, but seems to have a very happy personal life with Adam Brody too.",
              "score": 3594,
              "created_utc": 1757362928,
              "author": "Sleepy-Giraffe947"
            },
            {
              "id": "nd56py2",
              "body": "Viola Davis. I’m reading her memoir now and I’m just blown away. She was not technically homeless but she and her family lived in poverty for her entire childhood and didn’t start to get out of it until she started to earn money as an actress. I knew she was an incredible talent, but she also has tremendous strength.",
              "score": 3194,
              "created_utc": 1757362095,
              "author": "laurennik89"
            },
            {
              "id": "nd580wf",
              "body": "There are some old Hollywood actors who some people may not realize grew up in poverty, like Cary Grant",
              "score": 2531,
              "created_utc": 1757362473,
              "author": "Acceptable_Rule_7590"
            }
          ]
        }
      ]
    }
  },
  {
    "id": "mfkv4u4u8ai3b1ism",
    "generated_at": "2025-09-15T08:29:22.446Z",
    "name": "r/OpenAI Technology Discussion",
    "description": "Sentiment analysis of AI technology discussions, ChatGPT experiences, and artificial intelligence developments.",
    "subreddits": [
      "OpenAI"
    ],
    "dateRange": {
      "startDate": "2025-09-08",
      "endDate": "2025-09-15"
    },
    "totalPosts": 30,
    "totalComments": 2933,
    "data": {
      "summary": {
        "totalPosts": 30,
        "totalComments": 2933,
        "subreddits": [
          "OpenAI"
        ],
        "dateRange": {
          "startDate": "2025-09-08",
          "endDate": "2025-09-15"
        }
      },
      "analysis": {
        "overall_sentiment": {
          "average_score": 0.45,
          "sentiment_distribution": {
            "positive": 55,
            "neutral": 35,
            "negative": 10
          },
          "dominant_themes": [
            "technology",
            "innovation",
            "future",
            "development",
            "progress",
            "tools",
            "AI"
          ],
          "key_emotions": [
            "curiosity",
            "excitement",
            "analytical",
            "forward-looking",
            "innovation"
          ],
          "summary": "The overall sentiment is neutral (negative 41%). Key themes include: criticism, humor, AI."
        },
        "individual_scores": [
          {
            "index": 0,
            "score": 0.8,
            "sentiment": "positive",
            "confidence": 0.9,
            "themes": [
              "enthusiasm",
              "approval",
              "positivity"
            ],
            "emotions": [],
            "source": {
              "type": "post_title",
              "postId": "1nc2yb8",
              "subreddit": "OpenAI"
            }
          },
          {
            "index": 0,
            "score": -0.4,
            "sentiment": "negative",
            "confidence": 0.85,
            "themes": [
              "skepticism",
              "comparison",
              "criticism"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1nc2yb8",
              "commentId": "nd6891v",
              "subreddit": "OpenAI"
            }
          },
          {
            "index": 0,
            "score": -0.3,
            "sentiment": "negative",
            "confidence": 0.7,
            "themes": [
              "sarcasm",
              "spending",
              "breakthrough"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1nc2yb8",
              "commentId": "nd69fv1",
              "subreddit": "OpenAI"
            }
          },
          {
            "index": 0,
            "score": -0.5,
            "sentiment": "negative",
            "confidence": 0.8,
            "themes": [
              "disagreement",
              "progress",
              "timeline"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1nc2yb8",
              "commentId": "nd6dt63",
              "subreddit": "OpenAI"
            }
          },
          {
            "index": 0,
            "score": -0.7,
            "sentiment": "negative",
            "confidence": 0.85,
            "themes": [
              "criticism",
              "skepticism",
              "disagreement"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1nc2yb8",
              "commentId": "nd6e6ea",
              "subreddit": "OpenAI"
            }
          }
        ],
        "by_subreddit": {
          "OpenAI": {
            "scores": [
              0.8,
              -0.4,
              -0.3,
              -0.5,
              -0.7,
              0,
              -0.6,
              -0.5,
              0.4,
              -0.3,
              0.3,
              -0.6,
              0.4,
              0.2,
              -0.3,
              -0.2,
              -0.4,
              -0.5,
              -0.2,
              -0.1,
              0.1,
              0.7,
              0,
              0.3,
              0.4,
              0,
              0,
              0.1,
              -0.1,
              0.3,
              -0.4,
              -0.3,
              -0.5,
              -0.3,
              0,
              -0.1,
              -0.6,
              -0.2,
              0.2,
              0,
              -0.4,
              -0.3,
              0,
              0,
              0,
              0.2,
              0.1,
              0,
              0.2,
              0,
              -0.3,
              -0.2,
              -0.6,
              0,
              0.1,
              -0.5,
              -0.2,
              -0.3,
              -0.4,
              -0.7,
              -0.5,
              0.2,
              -0.3,
              -0.4,
              -0.6,
              -0.5,
              0.3,
              -0.3,
              -0.4,
              0.4,
              -0.5,
              0.4,
              -0.4,
              -0.6,
              0.5,
              -0.8,
              -0.5,
              -0.7,
              0,
              -0.4,
              0,
              -0.4,
              0.4,
              0,
              0,
              0,
              -0.5,
              -0.4,
              -0.7,
              0.3,
              -0.2,
              -0.3,
              -0.2,
              0,
              0,
              -0.3,
              0,
              0,
              -0.3,
              -0.4,
              -0.2,
              0.6,
              -0.3,
              -0.2,
              -0.4,
              0.7,
              -0.3,
              0.3,
              -0.1,
              -0.4,
              -0.5,
              -0.6,
              0.2,
              0.8,
              -0.1,
              0.1,
              -0.2,
              -0.4,
              -0.3,
              -0.2,
              -0.3,
              -0.1,
              -0.2,
              0.7,
              -0.4,
              0.8,
              -0.5,
              0.1,
              -0.2,
              0.2,
              -0.1,
              0.3,
              -0.1,
              -0.7,
              0.8,
              -0.6,
              0.6,
              -0.7,
              -0.4,
              -0.2,
              -0.3,
              0.1,
              -0.4,
              -0.2,
              -0.3,
              -0.5,
              -0.6,
              0.2,
              -0.3,
              -0.4,
              0.3,
              -0.4,
              -0.6,
              -0.5,
              -0.2,
              0.1,
              0,
              -0.7,
              -0.4,
              -0.5,
              -0.3,
              0.2,
              0.4,
              -0.3,
              -0.6,
              0.5,
              0.1,
              -0.5,
              -0.4,
              0.2,
              -0.3,
              0.3,
              0.4,
              0,
              -0.5,
              -0.2,
              0,
              -0.8,
              -0.4,
              -0.6,
              0.5,
              -0.6,
              -0.4,
              -0.7,
              -0.5,
              -0.1,
              -0.4,
              0.1,
              -0.7,
              0.2,
              0.3,
              0.4,
              -0.3,
              0,
              0.1,
              0.2,
              0.3,
              0.6,
              -0.4,
              0.2,
              -0.2,
              -0.3,
              -0.4,
              0,
              -0.8,
              -0.6,
              -0.9,
              -0.3,
              -0.7,
              -0.8,
              0.2,
              0.1,
              0.4,
              -0.6,
              -0.8,
              0.3,
              0.6,
              -0.2,
              -0.8,
              -0.7,
              -0.6,
              -0.4,
              -0.5,
              -0.4,
              0,
              -0.7,
              -0.6,
              -0.3,
              -0.5,
              -0.2,
              -0.4,
              -0.1,
              -0.5,
              -0.6,
              0.2,
              0.3,
              -0.6,
              0.4,
              -0.9,
              0.1,
              -0.7,
              0.5,
              -0.4,
              -0.5,
              0.2,
              0,
              -0.7,
              -0.6,
              -0.5,
              -0.4,
              -0.6,
              -0.7,
              -0.5,
              -0.3,
              0.2,
              -0.8,
              -0.4,
              -0.5,
              0.3,
              0.2,
              0.1,
              -0.2,
              -0.3,
              -0.4,
              0.2,
              -0.3,
              -0.6,
              -0.1,
              0.4,
              -0.4,
              -0.2,
              0.1,
              0,
              0.1,
              -0.2,
              0,
              0,
              -0.3,
              0.1,
              -0.4,
              -0.5,
              -0.3,
              -0.1,
              0,
              -0.4,
              -0.3,
              0.4,
              0,
              -0.3,
              -0.4,
              0.1,
              0.2,
              -0.5,
              0.3,
              -0.6,
              0,
              0.2,
              0.1,
              -0.2,
              -0.4,
              0.8,
              0.9,
              0.7,
              0.2,
              -0.2,
              0.3,
              0.6,
              -0.7,
              -0.6,
              -0.4,
              -0.2,
              0.3,
              0.1,
              0,
              0.2,
              0,
              -0.3,
              0,
              0.1,
              0.2,
              0,
              -0.2,
              -0.3,
              0.1,
              -0.3,
              0,
              0.2,
              -0.4,
              -0.8,
              0.4,
              0.1,
              0.2,
              -0.3,
              -0.6,
              0.3,
              0.2,
              -0.2,
              0,
              0,
              -0.3,
              0.3,
              -0.4,
              -0.2,
              -0.5,
              0.4,
              0.3,
              0.5,
              -0.5,
              0.7,
              0.6,
              -0.2,
              -0.6,
              -0.1,
              0.2,
              0.8,
              -0.3,
              0.1,
              0.3,
              0.9,
              0.4,
              0,
              -0.4,
              -0.2,
              -0.3,
              -0.5,
              -0.7,
              0,
              -0.6,
              0.2,
              0.1,
              -0.5,
              0.4,
              -0.2,
              -0.3,
              -0.4,
              -0.2,
              -0.4,
              -0.6,
              0,
              0,
              0.2,
              -0.1,
              -0.2,
              0,
              0.1,
              0.2,
              0.3,
              0,
              0.1,
              0,
              0.3,
              -0.4,
              0.3,
              -0.8,
              0.1,
              0.2,
              0.1,
              -0.2,
              0.3,
              -0.2,
              0.2,
              -0.3,
              -0.2,
              0.1,
              -0.1,
              0.2,
              0,
              0.1,
              -0.4,
              -0.2,
              -0.3,
              0.1,
              0.3,
              -0.1,
              0,
              -0.3,
              0,
              0.6,
              0.7,
              -0.1,
              0,
              -0.5,
              -0.4,
              -0.5,
              -0.7,
              0.1,
              0.4,
              0.5,
              0.3,
              0.2,
              0.4,
              -0.2,
              -0.4,
              -0.3,
              0.4,
              0.1,
              0,
              0.2,
              0.3,
              -0.4,
              -0.6,
              0.3,
              0.2,
              -0.7,
              -0.5,
              0.4,
              -0.3,
              0.5,
              0.2,
              0.4,
              0.3,
              -0.2,
              -0.4,
              -0.6,
              0.6,
              0.4,
              0.5,
              0.8,
              0.7,
              0.1,
              0.4,
              0.2,
              -0.3,
              0.6,
              0.7,
              0.4,
              0.3,
              0,
              -0.2,
              0,
              0,
              0.5,
              0.3,
              0.4,
              0.6,
              0.3,
              -0.2,
              0.2,
              0.3,
              0.2,
              0.1,
              0.7,
              0.4,
              0.3,
              0,
              -0.2,
              0,
              0.3,
              -0.4,
              -0.3,
              -0.1,
              0,
              0.8,
              0.2,
              -0.3,
              0.3,
              0,
              0,
              -0.1,
              0.4,
              -0.3,
              -0.1,
              0.8,
              0,
              0.6,
              0.2,
              0,
              0.8,
              0,
              0.4,
              0.6,
              0.9,
              -0.5,
              0.2,
              0.7,
              0.5,
              -0.3,
              0.6,
              -0.4,
              -0.6,
              -0.7,
              -0.4,
              -0.5,
              0.6,
              -0.2,
              -0.4,
              0,
              -0.7,
              -0.6,
              0.4,
              -0.7,
              -0.3,
              -0.4,
              -0.8,
              -0.2,
              -0.4,
              0.5,
              -0.6,
              0.6,
              -0.3,
              0.3,
              0.4,
              -0.6,
              -0.4,
              0.4,
              -0.5,
              -0.7,
              -0.3,
              -0.1,
              0,
              -0.3,
              -0.4,
              -0.8,
              -0.4,
              -0.7,
              0,
              0,
              -0.6,
              -0.7,
              -0.2,
              0.2,
              -0.8,
              -0.5,
              -0.6,
              -0.3,
              0.2,
              -0.4,
              -0.2,
              0.1,
              0.3,
              0,
              -0.4,
              0.2,
              0.1,
              0.6,
              -0.3,
              -0.2,
              0.3,
              -0.5,
              -0.6,
              -0.4,
              -0.4,
              -0.3,
              0.2,
              0.7,
              -0.6,
              0.6,
              0.5,
              0.4,
              0.3,
              0.1,
              0.2,
              -0.4,
              -0.7,
              -0.3,
              -0.5,
              -0.4,
              -0.3,
              0.4,
              -0.3,
              -0.2,
              0.3,
              -0.1,
              -0.3,
              0.2,
              0.4,
              0.3,
              0.2,
              -0.3,
              0.1,
              -0.4,
              -0.2,
              -0.6,
              -0.4,
              0.2,
              0.5,
              0.3,
              -0.5,
              0.2,
              0.4,
              -0.3,
              0.2,
              -0.2,
              0.4,
              -0.2,
              0.3,
              -0.4,
              0.1,
              -0.5,
              -0.3,
              0.2,
              -0.4,
              -0.3,
              -0.2,
              0.2,
              -0.5,
              -0.3,
              0.4,
              0.5,
              0.3,
              -0.6,
              0.2,
              0.6,
              -0.2,
              0.7,
              -0.5,
              0.8,
              0.6,
              0.4,
              0.3,
              0.5,
              0,
              0.4,
              0.2,
              0,
              0.6,
              -0.3,
              0.2,
              -0.7,
              0.1,
              0.4,
              -0.8,
              -0.3,
              0.7,
              0,
              0.3,
              -0.2,
              0.6,
              0.7,
              0.2,
              -0.4,
              0.5,
              0.3,
              -0.3,
              -0.4,
              -0.2,
              0.8,
              -0.5,
              -0.6,
              -0.8,
              -0.2,
              0.3,
              0.2,
              0.6,
              0,
              0.5,
              0.7,
              -0.5,
              0.4,
              0.6,
              0.6,
              0.2,
              -0.3,
              -0.8,
              0,
              0.4,
              0.1,
              -0.2,
              0.5,
              0.2,
              0.4,
              0.3,
              -0.4,
              0.1,
              0.2,
              0.7,
              0.4,
              0.3,
              0.5,
              0,
              -0.2,
              0.4,
              0,
              0.3,
              -0.3,
              0.1,
              0.2,
              -0.4,
              -0.3,
              0.2,
              0.1,
              -0.1,
              -0.2,
              0.1,
              -0.2,
              -0.1,
              -0.4,
              0.1,
              -0.3,
              -0.2,
              0.1,
              0,
              -0.1,
              0.4,
              -0.5,
              -0.3,
              0.2,
              -0.2,
              -0.3,
              -0.4,
              -0.2,
              -0.8,
              -0.6,
              0,
              0.2,
              0.1,
              -0.9,
              0,
              -0.4,
              -0.7,
              -0.3,
              0.3,
              -0.4,
              -0.2,
              0,
              0.1,
              -0.6,
              0.4,
              -0.5,
              -0.3,
              0,
              -0.4,
              0.2,
              -0.3,
              -0.7,
              -0.6,
              -0.4,
              -0.2,
              -0.8,
              -0.3,
              -0.8,
              0,
              -0.2,
              0.1,
              0.4,
              -0.3,
              0.3,
              0,
              -0.2,
              -0.7,
              -0.3,
              0.2,
              0.3,
              0.4,
              0.1,
              0.1,
              0.2,
              0.4,
              0.3,
              0.1,
              0.6,
              0,
              -0.2,
              0.3,
              -0.7,
              -0.4,
              0.2,
              0.1,
              0.3,
              0.4,
              0.2,
              -0.5,
              0.3,
              0.1,
              -0.4,
              0,
              -0.2,
              0.2,
              0.4,
              0.1,
              0.5,
              0.3,
              0.2,
              0,
              -0.1,
              0.2,
              -0.3,
              -0.4,
              -0.2,
              0.4,
              0,
              -0.3,
              0.1,
              -0.2,
              0.3,
              -0.1,
              0.2,
              -0.6,
              0,
              0.3,
              0.4,
              -0.3,
              0.2,
              0,
              0.3,
              -0.1,
              0.4,
              -0.5,
              0.2,
              0.1,
              0.3,
              -0.2,
              0.4,
              0.2,
              0,
              0.1,
              0,
              0,
              0,
              0,
              0,
              -0.1,
              0,
              0,
              -0.2,
              0.2,
              0.3,
              0,
              0,
              0.2,
              0.1,
              -0.4,
              0.1,
              -0.3,
              -0.4,
              -0.1,
              -0.2,
              0.2,
              0.1,
              -0.6,
              0.2,
              -0.3,
              -0.2,
              -0.1,
              -0.3,
              0,
              -0.2,
              -0.1,
              0,
              -0.1,
              -0.3,
              -0.1,
              0,
              -0.2,
              0.2,
              -0.1,
              -0.3,
              -0.4,
              0,
              0.1,
              0.3,
              -0.4,
              0.1,
              -0.5,
              0.8,
              0.9,
              0.7,
              0.3,
              0.7,
              -0.2,
              -0.7,
              0,
              -0.3,
              0,
              -0.2,
              0,
              0.4,
              0.6,
              0.7,
              -0.4,
              0.2,
              0.3,
              0.5,
              -0.6,
              -0.7,
              0.4,
              -0.2,
              -0.1,
              0,
              0.2,
              0.4,
              0.1,
              -0.4,
              -0.2,
              0.5,
              -0.3,
              0.6,
              0.2,
              -0.6,
              -0.3,
              0.7,
              -0.2,
              -0.4,
              0.2,
              -0.8,
              0.3,
              -0.4,
              -0.3,
              0.2,
              -0.4,
              -0.2,
              0.8,
              0.3,
              0.7,
              -0.3,
              0.1,
              0,
              0.2,
              0,
              0.1,
              0.4,
              0.1,
              0.9,
              0.2,
              -0.9,
              -0.6,
              0,
              0.1,
              0.3,
              -0.2,
              0.2,
              0.3,
              -0.5,
              0.4,
              0.7,
              -0.3,
              0.5,
              -0.1,
              -0.4,
              0.6,
              0.4,
              0.3,
              0.2,
              -0.4,
              0.1,
              -0.2,
              0.2,
              -0.1,
              -0.3,
              -0.4,
              -0.5,
              -0.2,
              -0.1,
              -0.2,
              0.3,
              -0.1,
              -0.1,
              -0.2,
              0.4,
              -0.3,
              -0.2,
              0.3,
              0,
              -0.8,
              0.2,
              0.6,
              0,
              0.1,
              0,
              0.2,
              0.3,
              -0.2,
              -0.3,
              0.4,
              -0.5,
              0.3,
              -0.7,
              -0.4,
              -0.2,
              0.2,
              -0.7,
              -0.4,
              -0.3,
              -0.2,
              0,
              -0.1,
              -0.3,
              0.1,
              -0.2,
              0,
              0.2,
              -0.1,
              0.3,
              0.2,
              -0.4,
              -0.3,
              -0.4,
              0.2,
              0.3,
              0.2,
              0.4,
              -0.2,
              0.1,
              -0.2,
              -0.1,
              -0.4,
              0.1,
              0.3,
              -0.5,
              0.2,
              -0.6,
              -0.8,
              -0.2,
              -0.3,
              0,
              0.3,
              -0.4,
              -0.1,
              -0.7,
              0.2,
              0.1,
              0.2,
              0.3,
              0.1,
              0.4,
              0.2,
              0.8,
              0.9,
              0.3,
              -0.2,
              0,
              -0.1,
              0.4,
              0,
              0.1,
              0,
              0.2,
              0.6,
              -0.4,
              -0.1,
              0,
              0.1,
              -0.1,
              0,
              0,
              0.3,
              0,
              0,
              0.7,
              0.2,
              -0.3,
              0,
              -0.2,
              -0.1,
              0.5,
              0.3,
              0.6,
              0.1,
              0.4,
              0.3,
              0.4,
              -0.2,
              -0.3,
              0,
              -0.1,
              0.1,
              0,
              -0.6,
              0.7,
              0,
              -0.2,
              -0.4,
              -0.1,
              0.6,
              0,
              0.3,
              0.2,
              -0.2,
              0.3,
              0.4,
              0.2,
              0,
              -0.2,
              0.8,
              0.4,
              0.9,
              0.2,
              0.2,
              0.1,
              0.2,
              0,
              -0.2,
              0.4,
              0.3,
              0.2,
              0.4,
              0,
              0.3,
              0.2,
              -0.3,
              0.9,
              -0.5,
              -0.4,
              -0.3,
              -0.4,
              -0.1,
              -0.7,
              -0.3,
              0.8,
              -0.2,
              0.9,
              0.8,
              0,
              0.4,
              -0.3,
              0,
              0,
              -0.4,
              0.8,
              0.2,
              0.7,
              -0.5,
              -0.6,
              -0.7,
              -0.3,
              0,
              0,
              0,
              0,
              0,
              0.2,
              0,
              -0.6,
              0,
              0,
              0,
              0,
              -0.2,
              -0.3,
              0,
              0.3,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0.2,
              0,
              0.8,
              0.1,
              0,
              0.2,
              0.3,
              -0.7,
              0.1,
              -0.6,
              0.3,
              -0.5,
              0.6,
              0.2,
              0.5,
              0.2,
              0.7,
              0.4,
              -0.6,
              0.4,
              0.8,
              0.7,
              0.6,
              -0.4,
              -0.2,
              -0.5,
              -0.6,
              -0.3,
              0.5,
              0.2,
              0.3,
              0.1,
              -0.4,
              0.3,
              0.2,
              0.4,
              0.7,
              -0.2,
              -0.3,
              0,
              -0.2,
              0.5,
              -0.6,
              -0.3,
              0,
              0.1,
              0.3,
              0.8,
              -0.5,
              -0.2,
              0.3,
              -0.6,
              -0.4,
              -0.2,
              0.2,
              -0.5,
              0.1,
              -0.1,
              0.2,
              -0.1,
              -0.6,
              0,
              -0.3,
              -0.4,
              -0.3,
              -0.2,
              0,
              0.3,
              0.4,
              0.2,
              0.3,
              0,
              0,
              0.1,
              0.4,
              -0.4,
              -0.2,
              -0.3,
              0,
              0.8,
              0.1,
              0.7,
              -0.5,
              -0.3,
              0,
              -0.3,
              -0.4,
              -0.3,
              -0.6,
              -0.7,
              -0.5,
              0.1,
              -0.2,
              -0.3,
              -0.4,
              -0.2,
              0,
              -0.3,
              -0.5,
              -0.2,
              -0.1,
              -0.4,
              0,
              -0.3,
              -0.2,
              -0.8,
              0.2,
              -0.6,
              -0.4,
              -0.8,
              -0.4,
              -0.7,
              -0.3,
              -0.5,
              0.4,
              0.6,
              -0.2,
              0.1,
              0.2,
              0,
              -0.3,
              -0.6,
              -0.2,
              0.2,
              0,
              -0.5,
              -0.4,
              0.3,
              0,
              0.4,
              -0.4,
              0.5,
              0.1,
              -0.6,
              0.2,
              0.1,
              0.3,
              -0.2,
              -0.3,
              -0.5,
              0.2,
              0.3,
              0.4,
              0.2,
              -0.3,
              0.4,
              0.6,
              -0.4,
              0.7,
              -0.2,
              0.1,
              -0.4,
              -0.6,
              0.4,
              0.5,
              -0.7,
              -0.2,
              0,
              -0.3,
              0.3,
              -0.5,
              0.4,
              -0.4,
              -0.6,
              -0.3,
              0,
              -0.6,
              0.7,
              -0.5,
              0,
              -0.2,
              -0.1,
              0.2,
              0.1,
              -0.6,
              -0.2,
              0,
              0.1,
              -0.4,
              -0.3,
              -0.2,
              -0.5,
              -0.4,
              -0.2,
              -0.5,
              -0.6,
              0.3,
              0.5,
              0.4,
              0.3,
              0.1,
              0.7,
              0.8,
              0.6,
              0.2,
              0.3,
              0.1,
              0,
              0.1,
              0.4,
              0.3,
              0.4,
              0,
              -0.2,
              -0.6,
              0,
              -0.1,
              0.8,
              -0.5,
              -0.3,
              -0.4,
              0.7,
              0.9,
              0.8,
              0,
              0.3,
              0.4,
              0,
              -0.2,
              0.4,
              0,
              0,
              0.2,
              0.7,
              -0.3,
              -0.4,
              0.7,
              0.6,
              0.8,
              0.6,
              -0.2,
              -0.3,
              0,
              0.2,
              0.3,
              0,
              0.6,
              0.2,
              0.8,
              -0.2,
              0.8,
              -0.4,
              -0.6,
              0,
              0,
              0,
              0,
              0.9,
              0.3,
              0,
              0.4,
              0.3,
              0.6,
              0.7,
              -0.2,
              -0.3,
              0,
              0.2,
              0.8,
              0,
              0.6,
              0.7,
              0.8,
              0.7,
              0.6,
              0.8,
              -0.2,
              0,
              0,
              0.7,
              -0.8,
              -0.4,
              -0.7,
              -0.3,
              -0.4,
              -0.5,
              -0.9,
              0.2,
              0.3,
              -0.3,
              0.2,
              -0.2,
              0.4,
              -0.6,
              -0.4,
              0.2,
              0.3,
              0.4,
              0.6,
              0.1,
              0.5,
              0.6,
              0.2,
              0.3,
              0.5,
              -0.3,
              0.4,
              -0.7,
              0.4,
              -0.4,
              -0.3,
              0.9,
              0.6,
              0.4,
              0.2,
              0.1,
              0,
              -0.2,
              0.3,
              -0.2,
              -0.3,
              -0.4,
              0.2,
              0.3,
              0.5,
              0.1,
              0.8,
              -0.1,
              -0.3,
              -0.4,
              0.2,
              0.4,
              -0.2,
              0.3,
              0.1,
              0,
              0.2,
              0.6,
              0.1,
              0.7,
              0.8,
              0.7,
              0.2,
              0.1,
              0.8,
              0.1,
              0.3,
              -0.2,
              -0.5,
              0.2,
              0.6,
              0,
              -0.4,
              0.5,
              -0.1,
              0.4,
              -0.7,
              0.3,
              0.2,
              0.8,
              0,
              -0.2,
              0.3,
              0.4,
              0,
              0.6,
              -0.3,
              0.2,
              0.3,
              0,
              -0.1,
              0.7,
              0.5,
              -0.2,
              0,
              0.1,
              0.4,
              0.2,
              0.1,
              0.2,
              0,
              -0.5,
              -0.2,
              0,
              -0.1,
              0,
              -0.4,
              -0.3,
              0.1,
              -0.3,
              -0.2,
              -0.3,
              0,
              0.3,
              0.2,
              0.4,
              0.2,
              -0.1,
              0.3,
              0.1,
              0.4,
              0.2,
              0.3,
              -0.1,
              0,
              0,
              -0.1,
              -0.3,
              -0.2,
              -0.6,
              -0.4,
              0.6,
              -0.7,
              -0.5,
              -0.6,
              0.7,
              0.8,
              -0.2,
              0.3,
              -0.4,
              -0.8,
              0.4,
              0.5,
              0.6,
              0,
              -0.3,
              0.6,
              -0.1,
              0,
              -0.4,
              -0.5,
              -0.6,
              0.2,
              0.3,
              0,
              -0.2,
              -0.3,
              -0.4,
              -0.5,
              -0.2,
              -0.4,
              -0.1,
              0.1,
              0,
              0.1,
              0.2,
              -0.3,
              -0.2,
              0.3,
              0,
              -0.4,
              -0.2,
              0,
              -0.6,
              -0.2,
              -0.7,
              -0.3,
              0,
              -0.5,
              0.1,
              -0.6,
              0,
              0.3,
              -0.4,
              -0.7,
              -0.5,
              -0.6,
              -0.4,
              -0.2,
              0.2,
              0,
              -0.1,
              0,
              -0.4,
              -0.6,
              -0.3,
              0.2,
              -0.2,
              -0.5,
              0.1,
              -0.2,
              0,
              -0.4,
              0.4,
              0.2,
              -0.8,
              -0.7,
              -0.6,
              -0.4,
              0.3,
              -0.1,
              -0.7,
              -0.8,
              -0.5,
              0,
              0.1,
              -0.6,
              0.4,
              0.3,
              -0.2,
              -0.5,
              -0.4,
              -0.3,
              0.2,
              -0.2,
              -0.6,
              -0.7,
              -0.5,
              -0.3,
              -0.4,
              -0.2,
              0.2,
              0,
              -0.3,
              0.2,
              -0.8,
              0.1,
              -0.4,
              -0.2,
              -0.7,
              -0.6,
              -0.8,
              -0.3,
              -0.1,
              0,
              -0.6,
              0.3,
              -0.5,
              -0.2,
              -0.3,
              0.2,
              -0.4,
              0,
              0,
              0,
              -0.2,
              0.1,
              0.2,
              -0.4,
              0.3,
              0,
              -0.4,
              -0.2,
              -0.5,
              -0.3,
              -0.7,
              -0.6,
              -0.7,
              -0.2,
              -0.3,
              -0.4,
              0.2,
              -0.1,
              0.5,
              -0.2,
              0.6,
              -0.1,
              -0.5,
              -0.7,
              -0.4,
              -0.3,
              0.6,
              0.8,
              0,
              0.4,
              0.7,
              0.2,
              -0.5,
              -0.4,
              -0.2,
              0.4,
              0.3,
              0,
              0,
              -0.2,
              0.7,
              0.9,
              0.6,
              0,
              -0.4,
              -0.3,
              -0.1,
              0.4,
              -0.2,
              0.5,
              0.8,
              0.8,
              -0.2,
              0,
              0.2,
              -0.1,
              -0.4,
              0.4,
              -0.6,
              0.7,
              -0.5,
              -0.2,
              0.4,
              -0.5,
              0,
              -0.3,
              0.3,
              -0.2,
              0,
              0,
              0.4,
              -0.4,
              0.6,
              -0.2,
              0.1,
              -0.2,
              -0.4,
              0.3,
              -0.6,
              -0.1,
              -0.8,
              -0.7,
              0.2,
              0.3,
              -0.3,
              0.6,
              0,
              -0.4,
              -0.2,
              0.1,
              -0.9,
              0.4,
              0.7,
              0.4,
              0.5,
              0.6,
              0.1,
              0.4,
              0.8,
              -0.7,
              0.5,
              0.7,
              0.6,
              -0.2,
              -0.3,
              -0.8,
              -0.5,
              -0.4,
              -0.7,
              0.6,
              -0.3,
              0.7,
              0.4,
              -0.8,
              0.5,
              0.1,
              0,
              0.3,
              0.1,
              0,
              -0.6,
              0.5,
              -0.2,
              -0.5,
              -0.1,
              0.5,
              0.4,
              -0.6,
              -0.3,
              -0.2,
              0,
              -0.4,
              0,
              0.2,
              -0.3,
              -0.4,
              0.6,
              0.8,
              -0.2,
              0.1,
              0.7,
              -0.7,
              -0.5,
              0.6,
              0.4,
              -0.2,
              -0.3,
              0.2,
              0.1,
              -0.6,
              -0.8,
              -0.7,
              -0.3,
              -0.2,
              -0.4,
              0.1,
              0,
              -0.1,
              0.3,
              0,
              0.4,
              0.2,
              0.1,
              0.3,
              -0.7,
              -0.5,
              0.1,
              -0.3,
              -0.2,
              -0.6,
              0.2,
              0.3,
              0.4,
              -0.5,
              -0.6,
              0.5,
              -0.3,
              0.9,
              -0.8,
              0,
              -0.4,
              0,
              0,
              0.3,
              -0.4,
              0,
              -0.2,
              -0.3,
              -0.6,
              0,
              -0.2,
              0,
              -0.4,
              -0.2,
              0,
              0,
              0,
              0,
              -0.4,
              0,
              -0.5,
              -0.3,
              0.2,
              -0.3,
              0.3,
              0,
              -0.6,
              -0.4,
              -0.7,
              0,
              -0.2,
              -0.8,
              -0.3,
              -0.7,
              0,
              -0.2,
              -0.5,
              -0.4,
              -0.6,
              -0.2,
              0,
              -0.5,
              0,
              -0.7,
              0,
              -0.8,
              -0.2,
              -0.9,
              -0.3,
              -0.4,
              0.1,
              -0.7,
              -0.4,
              -0.5,
              0,
              0.1,
              -0.2,
              -0.6,
              0,
              -0.7,
              -0.5,
              -0.2,
              -0.4,
              -0.1,
              -0.8,
              -0.6,
              -0.5,
              0.2,
              -0.3,
              -0.4,
              0.1,
              0.2,
              0.3,
              -0.2,
              0.4,
              0.2,
              0.1,
              -0.3,
              -0.6,
              -0.2,
              0.3,
              -0.1,
              -0.4,
              -0.5,
              -0.4,
              -0.7,
              0.2,
              -0.5,
              -0.1,
              0.3,
              -0.6,
              -0.7,
              -0.6,
              -0.2,
              0.2,
              -0.2,
              -0.4,
              -0.3,
              -0.2,
              -0.2,
              0.3,
              0.8,
              -0.7,
              -0.8,
              -0.1,
              -0.3,
              -0.2,
              -0.6,
              -0.4,
              -0.5,
              -0.9,
              -0.6,
              -0.1,
              -0.8,
              0.4,
              -0.7,
              -0.9,
              -0.6,
              -0.7,
              -0.4,
              -0.7,
              0.3,
              -0.8,
              -0.4,
              0.2,
              -0.6,
              -0.3,
              -0.2,
              -0.4,
              -0.8,
              -0.3,
              -0.3,
              -0.8,
              0.4,
              -0.1,
              -0.3,
              -0.9,
              -0.6,
              -0.9,
              -0.6,
              -0.5,
              0.2,
              -0.6,
              -0.4,
              -0.7,
              -0.7,
              -0.3,
              -0.6,
              -0.5,
              -0.2,
              -0.4,
              -0.6,
              -0.5,
              0.3,
              -0.2,
              -0.4,
              0.2,
              -0.3,
              -0.2,
              -0.8,
              -0.2,
              0.2,
              -0.8,
              0.2,
              0.4,
              0.5,
              0.3,
              -0.1,
              -0.2,
              -0.9,
              -0.3,
              -0.4,
              -0.7,
              -0.8,
              0.3,
              -0.8,
              -0.5,
              0.4,
              0.5,
              0.2,
              0.3,
              0.6,
              -0.2,
              0.4,
              0.5,
              -0.3,
              0.1,
              0.2,
              0.6,
              0.8,
              0.4,
              -0.3,
              0.5,
              0.1,
              0.4,
              0.6,
              -0.4,
              -0.4,
              -0.3,
              0.7,
              0.2,
              -0.8,
              -0.5,
              -0.3,
              0.1,
              -0.6,
              -0.2,
              -0.4,
              0,
              0.3,
              -0.4,
              -0.2,
              -0.3,
              0.2,
              0.4,
              0.5,
              -0.5,
              -0.6,
              -0.7,
              -0.5,
              0.4,
              -0.2,
              -0.4,
              -0.6,
              -0.7,
              -0.8,
              0.3,
              0.4,
              -0.3,
              -0.8,
              0.1,
              -0.2,
              0.3,
              0.2,
              0.2,
              0.3,
              0.1,
              0.1,
              0.2,
              0.3,
              0.2,
              -0.2,
              0.1,
              -0.1,
              0.4,
              0,
              0,
              0.3,
              0.6,
              0.2,
              0.7,
              0,
              0.8,
              -0.3,
              0.6,
              0.4,
              0.8,
              0.5,
              -0.2,
              0.1,
              0,
              0.2,
              0,
              -0.3,
              0,
              0.5,
              -0.1,
              0.2,
              0.4,
              -0.4,
              -0.3,
              -0.5,
              0.3,
              0.1,
              -0.4,
              0,
              0.1,
              0.2,
              -0.2,
              -0.1,
              0.6,
              0.2,
              0,
              0.7,
              0,
              0.2,
              -0.2,
              -0.3,
              -0.4,
              -0.1,
              0.1,
              0,
              0.5,
              -0.1,
              0.1,
              -0.1,
              -0.1,
              0,
              0.2,
              -0.3,
              0,
              0.3,
              -0.2,
              0.2,
              0.4,
              0.6,
              0.1,
              0.4,
              -0.2,
              -0.3,
              0.2,
              0,
              0,
              -0.1,
              -0.2,
              0.1,
              0,
              -0.3,
              -0.7,
              -0.6,
              -0.2,
              0.2,
              -0.2,
              -0.5,
              -0.4,
              -0.1,
              0,
              -0.5,
              -0.2,
              -0.4,
              -0.3,
              -0.4,
              -0.2,
              0.3,
              0.4,
              -0.6,
              -0.8,
              -0.7,
              -0.5,
              -0.3,
              -0.7,
              -0.4,
              -0.2,
              -0.8,
              0.1,
              0.6,
              -0.4,
              -0.2,
              -0.1,
              0.1,
              -0.5,
              -0.3,
              -0.6,
              -0.2,
              -0.1,
              0.3,
              -0.7,
              -0.6,
              0.4,
              -0.1,
              0.2,
              -0.5,
              -0.7,
              -0.4,
              -0.3,
              -0.4,
              0.3,
              -0.2,
              0.4,
              0.2,
              -0.1,
              0.1,
              0,
              0,
              -0.4,
              -0.5,
              0,
              -0.1,
              0.8,
              -0.4,
              -0.2,
              0
            ],
            "positive": 601,
            "neutral": 746,
            "negative": 928,
            "mixed": null,
            "cautionary": null,
            "average_score": -0.05107597716293367,
            "total_analyzed": 2277
          }
        },
        "timeline": [
          {
            "date": "2025-09-08",
            "average_score": -0.017378917378917374,
            "positive": 110,
            "neutral": 92,
            "negative": 149,
            "total": 351
          },
          {
            "date": "2025-09-09",
            "average_score": -0.14577922077922076,
            "positive": 60,
            "neutral": 85,
            "negative": 162,
            "total": 308
          },
          {
            "date": "2025-09-10",
            "average_score": -0.0009569377990430503,
            "positive": 61,
            "neutral": 80,
            "negative": 67,
            "total": 209
          },
          {
            "date": "2025-09-11",
            "average_score": -0.09667458432304035,
            "positive": 83,
            "neutral": 151,
            "negative": 187,
            "total": 421
          },
          {
            "date": "2025-09-12",
            "average_score": -0.090042372881356,
            "positive": 113,
            "neutral": 154,
            "negative": 205,
            "total": 472
          },
          {
            "date": "2025-09-13",
            "average_score": 0.012692307692307685,
            "positive": 90,
            "neutral": 84,
            "negative": 86,
            "total": 260
          },
          {
            "date": "2025-09-14",
            "average_score": 0.05781249999999999,
            "positive": 84,
            "neutral": 100,
            "negative": 72,
            "total": 256
          }
        ],
        "ai_insights": {
          "OpenAI": "Here's my analysis of the sentiment and themes in the r/OpenAI posts:\n\nOverall Community Mood and Attitudes:\n- The community seems increasingly skeptical and frustrated with the hype and claims around OpenAI and AI in general. There's a sense that the technology is not living up to the lofty promises.\n- There's concern about monetization and commercialization, with fears that AI will just become another surveillance/advertising tool.\n- Underlying all of this is a wariness and distrust towards the AI companies and their motivations.\n\nCommon Themes, Concerns, and Topics:\n- Lack of transparency and accountability around AI development and deployment\n- Overconfidence and unrealistic timelines/claims about AGI and \"solving\" AI\n- Monetization efforts and the creep of ads/commercialization into AI assistants\n- Worries about AI replacing/augmenting human jobs and labor\n- Frustrations with AI performance issues, inconsistencies, and limitations\n\nUpvoted/Discussed Content:\n- Posts that call out hype, unrealistic claims, and lack of substance from AI companies\n- Discussions around the potential negative societal impacts of unchecked AI development\n- Analysis of emerging AI business models and monetization strategies\n- Anecdotes/examples highlighting the current weaknesses and flaws in AI systems\n\nEmerging Trends and Shifts:\n- Increasing wariness and scrutiny towards AI companies and their motivations\n- Shift from awe/excitement about AI capabilities to more sober assessments and concerns\n- Growing awareness of the economic and labor market implications of AI\n\nPain Points and Frustrations:\n- Disappointment and disillusionment with the gap between AI hype and reality\n- Fears about the privacy, security, and equity implications of expanding AI adoption\n- Sense that AI companies are prioritizing profits and growth over ethics and safety\n\nOverall, the r/OpenAI community seems to be going through a phase of reckoning, as the initial enthusiasm and optimism around AI gives way to more critical analysis of the technology's limitations and potential downsides. There's a palpable undercurrent of unease about where the AI industry is headed."
        },
        "framework_analysis": {
          "success": true,
          "analysis": "**COMMUNITY PROFILING**\n\n• Community Type: Technology/AI discussion\n• Demographic Indicators: Tech-savvy, professional developers, AI enthusiasts, skeptics\n• Emotional Baseline: Skeptical/critical with humor undertones\n• Community Character: A technically informed but deeply skeptical community that combines industry expertise with cynical humor. Strong focus on practical implications and critical analysis of AI developments rather than hype.\n\n**PATTERN DISCOVERY**\n\n🔍 Key Findings:\n\n1. Surprising Pattern #1:\n   High engagement posts often combine technical critique with humor, suggesting the community values both expertise and entertainment\n\n2. Surprising Pattern #2:\n   Strong negative reaction to corporate/marketing narratives but positive reception to practical use cases and cost analysis\n\n3. Surprising Pattern #3:\n   Consistent pattern of initial excitement followed by technical debunking in comment chains\n\n💬 Controversy Triggers:\n• AGI timeline predictions\n• Corporate monetization strategies\n• AI safety/ethics claims\n• Performance degradation claims\n\n📊 Success/Failure Predictors:\n• Success indicators: Technical depth, practical experience, skeptical humor, cost-benefit analysis\n• Failure indicators: Marketing speak, unrealistic claims, lack of technical understanding\n\n**TEMPORAL ANALYSIS**\n\n⏰ Time-Based Patterns:\n\nDaily Cycles:\n• Morning: More technical discussions\n• Afternoon: Higher engagement with news/updates\n• Evening: More casual/humorous content\n\nWeekly Trends:\n• Weekday engagement focuses on technical/business aspects\n• Weekend content trends toward memes and lighter discussion\n• Peak engagement during major AI announcements\n\nSentiment Evolution:\n• Overall slightly negative (-0.05 average sentiment)\n• More positive reception to practical applications\n• Increasingly skeptical of corporate announcements\n\n**KEY INSIGHTS**\n\n⭐ Most Important Discoveries:\n\n1. Engagement Correlation:\n   Technical accuracy + humor = highest engagement\n\n2. Unspoken Rules:\n   Claims require technical backing or face immediate community skepticism\n\n3. Influence Patterns:\n   Top comments often set skeptical tone for entire discussion\n\n4. Content Predictors:\n   Cost analysis and practical implementation posts perform consistently well\n\n**ACTIONABLE RECOMMENDATIONS**\n\n📝 Content Strategy:\n• Best performing content types: Technical analysis, cost breakdowns, implementation experiences\n• Optimal post structure: Technical detail + practical implications + light humor\n• Language style: Direct, technically accurate, slightly skeptical\n\n⏱️ Timing Strategy:\n• Best posting times: Weekday mornings for technical content\n• Avoid posting: During major AI announcements unless providing unique analysis\n\n🚫 Topics to Avoid:\n• Unsubstantiated AGI claims\n• Marketing-heavy announcements\n• Vague technical promises\n\n✅ Topics that Resonate:\n• Practical implementation experiences\n• Cost-benefit analysis\n• Technical deep dives\n• AI limitations and challenges\n\n**QUESTIONS FOR DEEPER ANALYSIS**\n\n🤔 Compelling questions:\n\n1. How does sentiment shift during major AI announcements vs normal periods?\n2. What role does technical expertise play in comment credibility?\n3. How does the community validate technical claims?\n4. What drives the shift from initial excitement to skepticism?\n5. How do corporate announcements impact community trust?\n\n**SUMMARY**\n\n📋 Executive Summary:\nThe r/OpenAI community shows a sophisticated understanding of AI technology combined with healthy skepticism. Content success depends heavily on technical accuracy and practical value, while marketing-heavy or unsubstantiated claims face strong criticism. The slightly negative sentiment (-0.05) reflects a community focused on realistic assessment rather than hype.",
          "generated_at": "2025-09-15T08:07:57.861Z",
          "model_used": "Claude 3.5 Sonnet"
        },
        "synthetic_post": {
          "title": "GPT-4 API costs are getting out of hand - here's how we cut our bill by 90%",
          "author": "cloud_architect_42",
          "body": "After seeing our monthly OpenAI bill hit $8k, I did a deep dive into our usage patterns and found some pretty shocking inefficiencies.\n\nTurns out we were using GPT-4 for basic text classification, entity extraction, and simple prompts that could easily be handled by cheaper models. Classic over-engineering.\n\nHere's what we did:\n1. Moved all basic text processing to GPT-3.5\n2. Implemented proper prompt caching\n3. Built a model router that automatically selects the appropriate model based on task complexity\n4. Fine-tuned a smaller model for our specific use cases\n\nThe results? Bill dropped to $800/month with virtually no performance impact. Sometimes the expensive solution isn't the best one.",
          "score": 3241,
          "upvoteRatio": 0.94,
          "comments": [
            {
              "id": "comment1",
              "author": "DevOpsMaster",
              "body": "This is why we need better cost optimization tools for AI. Everyone's throwing GPT-4 at problems that could be solved with regex...",
              "score": 892,
              "replies": [],
              "level": 0,
              "sentiment": "neutral"
            },
            {
              "id": "comment2",
              "author": "AIEngineer2024",
              "body": "Would love to see the model router implementation. Are you open sourcing it?",
              "score": 567,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment3",
              "author": "tokens_and_transformers",
              "body": "Classic case of developers being handed an AI hammer and suddenly everything looks like a neural nail",
              "score": 445,
              "replies": [],
              "level": 0,
              "sentiment": "neutral"
            },
            {
              "id": "comment4",
              "author": "ml_researcher",
              "body": "Anthropic's Claude is way cheaper for these use cases and often performs better. Just saying...",
              "score": 234,
              "replies": [],
              "level": 0,
              "sentiment": "neutral"
            },
            {
              "id": "comment5",
              "author": "startup_founder_x",
              "body": "Meanwhile Sam Altman is swimming in API money like Scrooge McDuck",
              "score": 421,
              "replies": [],
              "level": 0,
              "sentiment": "negative"
            },
            {
              "id": "comment6",
              "author": "practical_dev",
              "body": "Remember when everyone thought AI would make everything cheaper? Good times.",
              "score": 389,
              "replies": [],
              "level": 0,
              "sentiment": "negative"
            },
            {
              "id": "comment7",
              "author": "cloud_native_dave",
              "body": "What's your stack for the prompt caching? Redis?",
              "score": 198,
              "replies": [],
              "level": 0,
              "sentiment": "neutral"
            },
            {
              "id": "comment8",
              "author": "efficiency_expert",
              "body": "Did something similar at our startup. The real cost savings come from proper prompt engineering - most devs just dump entire documents into the context window without any optimization",
              "score": 287,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment9",
              "author": "neural_networks_guy",
              "body": "OpenAI needs to introduce better tooling for cost analysis. Their dashboard is basically useless for real optimization",
              "score": 156,
              "replies": [],
              "level": 0,
              "sentiment": "negative"
            },
            {
              "id": "comment10",
              "author": "tech_minimalist",
              "body": "Plot twist: OP works for OpenAI's billing department",
              "score": 134,
              "replies": [],
              "level": 0,
              "sentiment": "neutral"
            }
          ],
          "subreddit": "OpenAI",
          "timeAgo": "4 hours ago",
          "sentiment": "positive",
          "generated_at": "2025-09-15T08:29:12.570Z",
          "version": 1
        }
      },
      "posts": [
        {
          "id": "1nc2yb8",
          "title": "Sensational",
          "selftext": "",
          "score": 11658,
          "num_comments": 251,
          "created_utc": 1757373157,
          "subreddit": "OpenAI",
          "permalink": "/r/OpenAI/comments/1nc2yb8/sensational/",
          "url": "https://i.redd.it/1x9lhgsnw0of1.jpeg",
          "author": "Xerqthion",
          "comments": [
            {
              "id": "nd6891v",
              "body": "“We’re just $20B away from AGI” is this decade’s “we’re just 20 years away from fusion power”",
              "score": 677,
              "created_utc": 1757373969,
              "author": "PeltonChicago"
            },
            {
              "id": "nd69fv1",
              "body": "In reality we are one mathematical breakthrough away from it. In the meantime lets spend all this money!",
              "score": 135,
              "created_utc": 1757374380,
              "author": "Christosconst"
            },
            {
              "id": "nd66vbd",
              "body": "everywhere i go, i see his face 😞",
              "score": 120,
              "created_utc": 1757373495,
              "author": "Digital_Soul_Naga"
            },
            {
              "id": "nd6d77x",
              "body": "No evidence that they have methods that will bring AGI. LLMs and their training and design of the GPT models are incomprehensibly far from anything close to AGI.",
              "score": 108,
              "created_utc": 1757375721,
              "author": "Woat_The_Drain"
            }
          ]
        },
        {
          "id": "1ne90w5",
          "title": "Enjoy ChatGPT while it lasts…. the ads are coming",
          "selftext": "Right now ChatGPT feels “free”- but nothing on the internet ever stays free. Google didn’t invent search to be useful, they invented it to sell ads.\n\nThat same pill bottle of ads revenue is sitting on the table for OpenAI, Perplexity, Anthropic… all of them. The pressure to monetize will push them down the exact same path: ads baked right into your “answers.”\n\nSo yeah, ChatGPT looks at ads revenue like medicine. When they start swallowing it, does AI discovery just become the next surveillance machine?\n\n(I originally posted this in r/ownyourintent. Wanted to know this sub's thoughts.)",
          "score": 8331,
          "num_comments": 358,
          "created_utc": 1757597795,
          "subreddit": "OpenAI",
          "permalink": "/r/OpenAI/comments/1ne90w5/enjoy_chatgpt_while_it_lasts_the_ads_are_coming/",
          "url": "https://i.redd.it/vx7mk59mgjof1.jpeg",
          "author": "kaushal96",
          "comments": [
            {
              "id": "ndmx8ln",
              "body": "Mark Zuckerberg wasn't sitting in his Harvard dorm dreaming of becoming an ad company. Google's founders didn't aspire to be an ad company and then invent search as a means to get there. Sam Altman isn't doing the same with Open AI. That stuff came later.\n\nPeople already have trust and accuracy issues with AI. Throwing ads into the mix would be more of a hit to adoption than its worth at least rig...",
              "score": 753,
              "created_utc": 1757599200,
              "author": "outtokill7"
            },
            {
              "id": "ndmuvkb",
              "body": "If it only affects free tier users, I can understand that and don't necessarily oppose that.  If it also affects the Plus or Pro tiers, I have more of a problem with that.",
              "score": 571,
              "created_utc": 1757598463,
              "author": "okamifire"
            },
            {
              "id": "ndn0dgs",
              "body": "Streaming was the same...\n\n\nThe ads only affected free users. Now they've seeped into paid tiers, and then you have Disney which is taking it to another level. Within 5 years I give it!",
              "score": 305,
              "created_utc": 1757600159,
              "author": "Chemical-Swing453"
            },
            {
              "id": "ndn37kn",
              "body": "\"You seem stressed. Maybe you could benefit from a Fun Times™ Caribbean cruise! I just found a 20% off coupon; would you like me to book one for you? 😃\"",
              "score": 203,
              "created_utc": 1757601010,
              "author": "HighlightFun8419"
            }
          ]
        },
        {
          "id": "1ne4jca",
          "title": "AI is quietly taking over the British government",
          "selftext": "",
          "score": 4751,
          "num_comments": 221,
          "created_utc": 1757584052,
          "subreddit": "OpenAI",
          "permalink": "/r/OpenAI/comments/1ne4jca/ai_is_quietly_taking_over_the_british_government/",
          "url": "https://i.redd.it/7b5t3z8bbiof1.png",
          "author": "MetaKnowing",
          "comments": [
            {
              "id": "ndm5t9d",
              "body": "  \nFurther analysis has yielded that some of the most crucial verbiage employed appears to be immune to ChatGPT usage.\n\nhttps://preview.redd.it/siha4pj7riof1.png?width=1536&format=png&auto=webp&s=0f4cefb2e6ba7f16e8dcd46ce9974bd9ad3effcd",
              "score": 693,
              "created_utc": 1757589279,
              "author": "Practical-Hand203"
            },
            {
              "id": "ndlwx7r",
              "body": "A lot of working people use ai as a tool to proofread their work. And since the House of Commons is comprised of working people you can probably see the correlation. It doesn’t mean it is taking over the actual job of the person but rather it is used as an additional source of linguistic verification.",
              "score": 349,
              "created_utc": 1757584856,
              "author": "Sh2d0wg2m3r"
            },
            {
              "id": "ndlz5jd",
              "body": "Not only are you correct, but also, you've streamlined the thought process quite clearly.",
              "score": 306,
              "created_utc": 1757586055,
              "author": "Rude-Explanation-861"
            },
            {
              "id": "ndm0ry2",
              "body": "This is not merely just a fact, it underscores a bustling truth",
              "score": 180,
              "created_utc": 1757586878,
              "author": "nikolaospap"
            }
          ]
        },
        {
          "id": "1nfvx6f",
          "title": "Summary of AI corporation CEOs",
          "selftext": "",
          "score": 2758,
          "num_comments": 47,
          "created_utc": 1757765532,
          "subreddit": "OpenAI",
          "permalink": "/r/OpenAI/comments/1nfvx6f/summary_of_ai_corporation_ceos/",
          "url": "https://i.redd.it/c26sx77dbxof1.jpeg",
          "author": "FinnFarrow",
          "comments": [
            {
              "id": "ndzdjmf",
              "body": "* **Jensen (NVIDIA):** \"Our new GPU will make AI 47x faster, and yes, you'll need to buy all new hardware\"\n* **Sundar (Google):** \"We're excited to announce we're sunsetting our AI project to launch an identical one with a different name\"\n* **Satya (Microsoft):** \"Copilot will now be integrated into your toaster, for just $29.99/month\"\n* **Tim (Apple):** \"Introducing Apple Intelligence Pro Max - i...",
              "score": 506,
              "created_utc": 1757766237,
              "author": "ai-but-better"
            },
            {
              "id": "ne04hkk",
              "body": "Reddit: our app has had another 13 regressions. iOS users can no longer save images. We won't push a fix for this thing we broke for another 9 business days until the next release cycle no exceptions (then they spit on you)",
              "score": 61,
              "created_utc": 1757775583,
              "author": "fetching_agreeable"
            },
            {
              "id": "ndzila2",
              "body": "Apple Intelligence Pro Max*\n\n*it’s just Siri in a trenchcoat",
              "score": 59,
              "created_utc": 1757768216,
              "author": "giYRW18voCJ0dYPfz21V"
            },
            {
              "id": "ndzduib",
              "body": "who’s andy? what happened to lisa",
              "score": 51,
              "created_utc": 1757766361,
              "author": "iperson4213"
            }
          ]
        },
        {
          "id": "1nbi70s",
          "title": "How a tiny Caribbean island accidentally became the biggest winner of the AI boom",
          "selftext": "I just came across this story and honestly… it blew my mind.\n\nThere’s this little island in the Caribbean called Anguilla (population: \\~16,000). Back in the 80s, every country got a two-letter internet domain (.uk, .es, .us, .fr...)\n\nAnguilla got .ai.\n\nAt the time it was just another random country code, the internet was barely a thing, and obviously nobody was talking about “AI,.\n\nBut in 2025… those two letters are basically gold. Every AI startup wants a .ai domain, and they’re paying crazy money for it.   \n  \nFor Anguilla, it’s basically free money falling from the sky. Last year, domain registrations brought in $39M — nearly a quarter of their national budget. This year it’s projected to hit $49M.\n\nAll because of two letters they got assigned by chance 40 years ago.\n\nHope this hasn’t ...",
          "score": 2266,
          "num_comments": 136,
          "created_utc": 1757320093,
          "subreddit": "OpenAI",
          "permalink": "/r/OpenAI/comments/1nbi70s/how_a_tiny_caribbean_island_accidentally_became/",
          "url": "https://www.reddit.com/r/OpenAI/comments/1nbi70s/how_a_tiny_caribbean_island_accidentally_became/",
          "author": "Think_Bunch3020",
          "comments": [
            {
              "id": "nd1xhiq",
              "body": "Tuvalu had it good with .tv too. ",
              "score": 525,
              "created_utc": 1757321135,
              "author": "Maleficent_Sir_5225"
            },
            {
              "id": "nd1wm45",
              "body": "Lifehack: name your country after upcoming technology, get cool TLD registration with ICAAN = profit? \nGenius",
              "score": 205,
              "created_utc": 1757320589,
              "author": "thread-lightly"
            },
            {
              "id": "nd2b3qa",
              "body": ".ly (Libya) had a long run. For some reason link shorterners had to use that.",
              "score": 165,
              "created_utc": 1757328995,
              "author": "trollsmurf"
            },
            {
              "id": "nd287cz",
              "body": "Aight let me go set up a new country",
              "score": 89,
              "created_utc": 1757327491,
              "author": "IcySmoke954"
            }
          ]
        },
        {
          "id": "1ncil0x",
          "title": "Everyone is becoming overly dependent on AI.",
          "selftext": "",
          "score": 2163,
          "num_comments": 102,
          "created_utc": 1757423631,
          "subreddit": "OpenAI",
          "permalink": "/r/OpenAI/comments/1ncil0x/everyone_is_becoming_overly_dependent_on_ai/",
          "url": "https://i.redd.it/v0x20pkq25of1.jpeg",
          "author": "imfrom_mars_",
          "comments": [
            {
              "id": "nd9flb6",
              "body": "The job market is crazy. Half the jobs listed don't even exist. Using AI to apply for ghost jobs you're obligated to apply for in order to get your benefits is just the most rational use of your time. Whose fault is it?",
              "score": 300,
              "created_utc": 1757424669,
              "author": "Wickywire"
            },
            {
              "id": "nd9hwuf",
              "body": "The real problem is the economic conditions and a mismatch between company demands and what's available in the workforce. AI is just a symptom of a system that's already broken.",
              "score": 113,
              "created_utc": 1757425426,
              "author": "Top-Candle1296"
            },
            {
              "id": "nd9t2l8",
              "body": "That’s just smart thinking. Why test your writing skills for non existent jobs while you can quickly  make your resume obligations.",
              "score": 71,
              "created_utc": 1757428801,
              "author": "FishermanConnect9076"
            },
            {
              "id": "nd9m63w",
              "body": "The job market broke long before AI. It started the day people became \"resources\" and \"applicant tracking systems\" learned to filter out humans at scale. AI is just the endgame of a system already designed to dehumanize.\n\nAnd maybe it’s an intelligence test: how long will companies keep building barriers that applicants must overcome just to trade their work for flat-rate pay? When will we start t...",
              "score": 59,
              "created_utc": 1757426742,
              "author": "TheFishyBanana"
            }
          ]
        },
        {
          "id": "1nbtl2p",
          "title": "Wow... we've been burning money for 6 months",
          "selftext": "So... because I am such a hard worker, I spent my weekend going through our openai usage and we're at \\~$1200/month.    \n  \nI honestly thought that was just the cost of doing business then i actually looked at what we're using gpt-4 for, and its seriously a waste of money: extracting phone numbers from emails, checking if text contains profanity, reformatting json and literally just uppercasing text in one function.\n\nI ended up just moving all the dumb stuff to gpt-4o-mini. Same exact outputs, bill dropped to \\~$200 \n\nAm I an idiot? How much are you guys spending?",
          "score": 1698,
          "num_comments": 341,
          "created_utc": 1757351482,
          "subreddit": "OpenAI",
          "permalink": "/r/OpenAI/comments/1nbtl2p/wow_weve_been_burning_money_for_6_months/",
          "url": "https://www.reddit.com/r/OpenAI/comments/1nbtl2p/wow_weve_been_burning_money_for_6_months/",
          "author": "me_z",
          "comments": [
            {
              "id": "nd499op",
              "body": "I mean if you need to use GPT for uppercasing text, then maybe don't stop...",
              "score": 607,
              "created_utc": 1757352349,
              "author": "lakimens"
            },
            {
              "id": "nd4acz6",
              "body": "There’s no reason to pay GPT 4 prices, you could’ve used 4o or 4o-mini. Right now there’s no reason to pay those prices either, the 5-series is cheaper and more performant. \n\nYou can also reduce your costs by using cheaper service tiers for stuff that isn’t time sensitive. \n\nThere’s also a free moderation endpoint",
              "score": 296,
              "created_utc": 1757352655,
              "author": "Background_River_395"
            },
            {
              "id": "nd47h4b",
              "body": "Eh, numbers are meaningless without context.\n\nIf you have org of 100 1200$/month is pretty much nothing. \n\nOrg of 5 and it's different.",
              "score": 178,
              "created_utc": 1757351838,
              "author": "Imaginary-Jaguar662"
            },
            {
              "id": "nd4bb04",
              "body": "Wait till he finds out about vibesort",
              "score": 156,
              "created_utc": 1757352920,
              "author": "kirkpomidor"
            }
          ]
        },
        {
          "id": "1ne43ln",
          "title": "People leaving AI companies be like",
          "selftext": "",
          "score": 1658,
          "num_comments": 61,
          "created_utc": 1757582319,
          "subreddit": "OpenAI",
          "permalink": "/r/OpenAI/comments/1ne43ln/people_leaving_ai_companies_be_like/",
          "url": "https://i.redd.it/vmdy1g0j6iof1.png",
          "author": "MetaKnowing",
          "comments": [
            {
              "id": "ndluvrc",
              "body": "And then goes on to found a new AI startup, with a “safer name”.",
              "score": 182,
              "created_utc": 1757583723,
              "author": "axiomaticdistortion"
            },
            {
              "id": "ndmtsit",
              "body": "*\"We're partnering with Palantir and the NSA to ensure the AI systems protecting Americans are safe and effective\"*",
              "score": 68,
              "created_utc": 1757598121,
              "author": "Nonikwe"
            },
            {
              "id": "ndly06l",
              "body": "AI companies don’t have alumni, they have survivors. PERIODD!!",
              "score": 34,
              "created_utc": 1757585448,
              "author": "Top-Candle1296"
            },
            {
              "id": "ndn251u",
              "body": "if you think ilya and the people he poached were useless in oai then you understand nothing.\n\nilya’s fingerprints were all over the gpt-4 era, he made a ton of things happen, there’s a reason oai suffered from his and his teammates’ exit",
              "score": 18,
              "created_utc": 1757600690,
              "author": "meshla2ibsnfsi"
            }
          ]
        },
        {
          "id": "1ngbo3k",
          "title": "ASI confirmed.",
          "selftext": "",
          "score": 1548,
          "num_comments": 170,
          "created_utc": 1757805254,
          "subreddit": "OpenAI",
          "permalink": "/r/OpenAI/comments/1ngbo3k/asi_confirmed/",
          "url": "https://i.redd.it/rmsi3dy2l0pf1.png",
          "author": "Outside-Iron-8242",
          "comments": [
            {
              "id": "ne2upgm",
              "body": "Better than me. I thought there were only 3 dogs.",
              "score": 392,
              "created_utc": 1757806303,
              "author": "Loot-Ledger"
            },
            {
              "id": "ne3gl82",
              "body": "Brother, I thought one of them is cauliflower.",
              "score": 189,
              "created_utc": 1757814341,
              "author": "EducationalTomato613"
            },
            {
              "id": "ne2to5v",
              "body": "Now create an image that was never published on the internet and test again. Imagine you are a PhD researcher that just discovered a new animal species and you want to use AI to determine its name based on its characteristics, like a human would do. I bet it won't be able to do it",
              "score": 156,
              "created_utc": 1757805955,
              "author": "Positive_Method3022"
            },
            {
              "id": "ne2xu3e",
              "body": "ai has been doing image classification for over a decade",
              "score": 153,
              "created_utc": 1757807384,
              "author": "Vicidsmart"
            }
          ]
        },
        {
          "id": "1ndj2wx",
          "title": "The AI Nerf Is Real",
          "selftext": "Hello everyone, we’re working on a project called IsItNerfed, where we monitor LLMs in real time.\n\nWe run a variety of tests through Claude Code and the OpenAI API (using GPT-4.1 as a reference point for comparison).\n\nWe also have a Vibe Check feature that lets users vote whenever they feel the quality of LLM answers has either improved or declined.\n\nOver the past few weeks of monitoring, we’ve noticed just how volatile Claude Code’s performance can be.\n\nhttps://preview.redd.it/46k0sbqw6dof1.png?width=2652&format=png&auto=webp&s=9c539f632be894082574a2f98e28a6b14d3480d6\n\n1. Up until August 28, things were more or less stable.\n2. On August 29, the system went off track — the failure rate doubled, then returned to normal by the end of the day.\n3. The next day, August 30, it spiked again to 70...",
          "score": 875,
          "num_comments": 163,
          "created_utc": 1757521898,
          "subreddit": "OpenAI",
          "permalink": "/r/OpenAI/comments/1ndj2wx/the_ai_nerf_is_real/",
          "url": "https://www.reddit.com/r/OpenAI/comments/1ndj2wx/the_ai_nerf_is_real/",
          "author": "exbarboss",
          "comments": [
            {
              "id": "ndh4f9k",
              "body": "Imagine any reasonable developer wanting to integrate this tech into a business process.",
              "score": 246,
              "created_utc": 1757522565,
              "author": "ambientocclusion"
            },
            {
              "id": "ndh7n4y",
              "body": "How do you control for people being influenced by negative reporting and social media posting on changes and updates?",
              "score": 98,
              "created_utc": 1757523491,
              "author": "PMMEBITCOINPLZ"
            },
            {
              "id": "ndh5j9k",
              "body": "I can’t imagine things, I just see black.",
              "score": 93,
              "created_utc": 1757522885,
              "author": "Bnx_"
            },
            {
              "id": "ndhf51b",
              "body": "The vibe check is just worthless. You can get the shitty \"gut feel\" anywhere. I realize that's the part that costs a whole lot of money, but actual benchmarks you run are the only thing that should be of any interest to anyone. Oh and of course you run the risk of your benchmarks being detected if something like this gets popular enough.",
              "score": 64,
              "created_utc": 1757525574,
              "author": "cobbleplox"
            }
          ]
        },
        {
          "id": "1nft4qo",
          "title": "PSA: Anthropic CEO got hacked",
          "selftext": "",
          "score": 747,
          "num_comments": 55,
          "created_utc": 1757755601,
          "subreddit": "OpenAI",
          "permalink": "/r/OpenAI/comments/1nft4qo/psa_anthropic_ceo_got_hacked/",
          "url": "https://i.redd.it/7ameqycthwof1.png",
          "author": "MetaKnowing",
          "comments": [
            {
              "id": "ndysxj7",
              "body": "Don't worry Dario, you are not broken.",
              "score": 147,
              "created_utc": 1757755781,
              "author": "Responsible-Slide-26"
            },
            {
              "id": "ndz4duz",
              "body": "Totally not worrisome at all that the CEO of one of the most advanced AI companies apparantly has weak password protection.",
              "score": 103,
              "created_utc": 1757762134,
              "author": "jurgo123"
            },
            {
              "id": "ndytkb8",
              "body": "The true AGI is here it seems.",
              "score": 103,
              "created_utc": 1757756165,
              "author": "amdcoc"
            },
            {
              "id": "ndyuo4s",
              "body": "looks like claude wrote 90% of his code",
              "score": 70,
              "created_utc": 1757756826,
              "author": "Ska82"
            }
          ]
        },
        {
          "id": "1nfgwjb",
          "title": "Within 20 min codex-cli with GPT-5 high made working NES emulator in pure c!",
          "selftext": "Within 20 min codex-cli with GPT-5 high made working NES emulator in pure c!\n\nIs even loading roms.\n\nOnly left to implement graphic and audio.... insane.\n\nhttps://preview.redd.it/ysr77g0qetof1.png?width=1438&format=png&auto=webp&s=47708113046d2e65400b3d8188c23e0905a47198\n\nhttps://preview.redd.it/sv4turz1ltof1.png?width=1403&format=png&auto=webp&s=065f3d325fcb163518668afd325cfaed826044ef\n\nhttps://preview.redd.it/0cnou4isdtof1.png?width=1375&format=png&auto=webp&s=9bd13fcec78fcfbaa1cfad0b215952f7e277f6f4\n\nEDIT\n\nIs fully implemented including Audio and Graphic in pure C .... I cannot believe! ...everting in 40 minutes.\n\nI thought AI will be able to write NES emulator not faster than 2026 or 2027 .. that is crazy.\n\nGITHUB CODE\n\n[https://github.com/Healthy-Nebula-3603/gpt5-thinking-proof-of-con...",
          "score": 685,
          "num_comments": 248,
          "created_utc": 1757716082,
          "subreddit": "OpenAI",
          "permalink": "/r/OpenAI/comments/1nfgwjb/within_20_min_codexcli_with_gpt5_high_made/",
          "url": "https://i.redd.it/d0n4yfax7tof1.png",
          "author": "Healthy-Nebula-3603",
          "comments": [
            {
              "id": "ndwj020",
              "body": "Interesting... You should share the code on GitHub, I would like to see if that's all original or if it copied bits here and there",
              "score": 179,
              "created_utc": 1757718567,
              "author": "emascars"
            },
            {
              "id": "ndwkpoy",
              "body": "Altough interesting, and it rly is...\n\nit just feels like a hacky shortcut to google search c nes emulator, clone github project, install deps, compile, run.\n\nBut interesting, not trying to downplay what you did or the power of LLMs and AI code assistants.",
              "score": 172,
              "created_utc": 1757719166,
              "author": "Confident_2372"
            },
            {
              "id": "ndwofg9",
              "body": "I’m guessing it’s almost a 1:1 copy",
              "score": 121,
              "created_utc": 1757720480,
              "author": "aburningcaldera"
            },
            {
              "id": "ndwq9mn",
              "body": "whenever you are ready",
              "score": 71,
              "created_utc": 1757721129,
              "author": "thelifeaboveus"
            }
          ]
        }
      ]
    }
  },
  {
    "id": "mfkt85asr1m5zgjf1",
    "generated_at": "2025-09-15T07:35:57.652Z",
    "name": "r/kiroIDE Developer Community",
    "description": "Analysis of developer discussions, IDE feedback, and programming tool conversations in the KiroIDE community.",
    "subreddits": [
      "kiroIDE"
    ],
    "dateRange": {
      "startDate": "2025-09-08",
      "endDate": "2025-09-15"
    },
    "totalPosts": 19,
    "totalComments": 82,
    "data": {
      "summary": {
        "totalPosts": 19,
        "totalComments": 82,
        "subreddits": [
          "kiroIDE"
        ],
        "dateRange": {
          "startDate": "2025-09-08",
          "endDate": "2025-09-15"
        }
      },
      "analysis": {
        "overall_sentiment": {
          "average_score": 0.45,
          "sentiment_distribution": {
            "positive": 55,
            "neutral": 35,
            "negative": 10
          },
          "dominant_themes": [
            "technology",
            "innovation",
            "future",
            "development",
            "progress",
            "tools",
            "AI"
          ],
          "key_emotions": [
            "curiosity",
            "excitement",
            "analytical",
            "forward-looking",
            "innovation"
          ],
          "summary": "The overall sentiment is positive (neutral 43%). Key themes include: features, pricing, usage."
        },
        "individual_scores": [
          {
            "index": 1,
            "score": 0.6,
            "sentiment": "positive",
            "confidence": 0.8,
            "themes": [
              "style",
              "LLM",
              "AI"
            ],
            "emotions": [],
            "source": {
              "type": "post_title",
              "postId": "1nfhq8w",
              "subreddit": "kiroIDE"
            }
          },
          {
            "index": 2,
            "score": 0.8,
            "sentiment": "positive",
            "confidence": 0.9,
            "themes": [
              "design",
              "methodology",
              "features"
            ],
            "emotions": [],
            "source": {
              "type": "post_body",
              "postId": "1nfhq8w",
              "subreddit": "kiroIDE"
            }
          },
          {
            "index": 3,
            "score": 0.3,
            "sentiment": "positive",
            "confidence": 0.7,
            "themes": [
              "intent",
              "trial"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1nfhq8w",
              "commentId": "ndwjfeb",
              "subreddit": "kiroIDE"
            }
          },
          {
            "index": 4,
            "score": 0.7,
            "sentiment": "positive",
            "confidence": 0.85,
            "themes": [
              "success",
              "free",
              "usage"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1nfhq8w",
              "commentId": "ndwl4l3",
              "subreddit": "kiroIDE"
            }
          },
          {
            "index": 5,
            "score": 0.5,
            "sentiment": "positive",
            "confidence": 0.75,
            "themes": [
              "sharing",
              "resources"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1nfhq8w",
              "commentId": "ndzdpn1",
              "subreddit": "kiroIDE"
            }
          }
        ],
        "by_subreddit": {
          "kiroIDE": {
            "scores": [
              0.6,
              0.8,
              0.3,
              0.7,
              0.5,
              -0.2,
              0.4,
              -0.4,
              -0.5,
              -0.3,
              0.2,
              0.3,
              0.6,
              0.2,
              -0.2,
              -0.4,
              -0.3,
              0.3,
              -0.1,
              0.4,
              -0.3,
              -0.4,
              -0.2,
              0,
              0.4,
              0,
              -0.1,
              0.6,
              0.2,
              0.3,
              0.5,
              0.4,
              0.5,
              0.3,
              0,
              0.2,
              -0.2,
              -0.1,
              -0.5,
              0,
              0.2,
              -0.1,
              0.4,
              0.3,
              0,
              0,
              -0.4,
              -0.3,
              -0.2,
              0.4,
              0.8,
              0.7,
              0.6,
              0.7,
              0,
              0.4,
              0,
              -0.2,
              -0.1,
              0,
              -0.1,
              0,
              0,
              0.1,
              0,
              0.3,
              0,
              0,
              -0.2,
              -0.4
            ],
            "positive": 24,
            "neutral": 30,
            "negative": 16,
            "average_score": 0.1057142857142857,
            "total_analyzed": 70
          }
        },
        "timeline": [
          {
            "date": "2025-09-08",
            "average_score": -0.18,
            "positive": 0,
            "neutral": 3,
            "negative": 2,
            "total": 5
          },
          {
            "date": "2025-09-09",
            "average_score": 0.1142857142857143,
            "positive": 2,
            "neutral": 5,
            "negative": 0,
            "total": 7
          },
          {
            "date": "2025-09-10",
            "average_score": -0.01764705882352941,
            "positive": 3,
            "neutral": 9,
            "negative": 5,
            "total": 17
          },
          {
            "date": "2025-09-12",
            "average_score": 0.21538461538461545,
            "positive": 19,
            "neutral": 13,
            "negative": 7,
            "total": 39
          },
          {
            "date": "2025-09-13",
            "average_score": -0.30000000000000004,
            "positive": 0,
            "neutral": 0,
            "negative": 2,
            "total": 2
          },
          {
            "date": "2025-09-14",
            "average_score": 0,
            "positive": 0,
            "neutral": 0,
            "negative": 0,
            "total": 0
          }
        ],
        "ai_insights": {
          "kiroIDE": "After analyzing the posts from r/kiroIDE, here's my take on the community's sentiment, themes, and emerging trends:\n\n1. **Overall Community Mood and Attitudes**:\n   - The community seems generally positive about Kiro and its capabilities, with users sharing their experiences and success stories.\n   - However, there is also frustration and confusion around Kiro's pricing, credit usage, and limitations, especially the distinction between Vibe and Spec requests.\n\n2. **Common Themes, Concerns, and Topics of Interest**:\n   - Pricing and credit usage: Many users are concerned about the limited Vibe and Spec requests, the high token consumption, and the perceived lack of transparency around Kiro's pricing.\n   - Waitlist and access: Users are curious about the waitlist and how long it takes to gain access to the Kiro platform.\n   - Spec-driven development: There is a lot of interest and discussion around Kiro's Spec-driven development approach, how it compares to other tools, and its use cases.\n   - Integrations and model support: Users are interested in using different AI models (e.g., ChatGPT, Claude) with Kiro and want to understand the limitations and workarounds.\n\n3. **Patterns in Upvotes and Discussions**:\n   - Posts that provide helpful information, such as tips, tutorials, and explanations of Kiro's features, tend to receive more upvotes and engagement.\n   - Posts that express frustration or confusion about Kiro's pricing, credit usage, and limitations also receive significant attention and discussion.\n   - Threads where users share their experiences and success stories with Kiro, particularly for specific use cases like iOS development, are well-received.\n\n4. **Emerging Trends and Shifts in Opinion**:\n   - The community seems to be actively exploring Kiro's capabilities and comparing it to other AI-powered development tools like Cursor and Trae.\n   - There is a growing interest in Kiro's Spec-driven development approach and how it can be leveraged for different types of projects.\n   - As the free trial period approaches its end, users are closely watching for any changes in Kiro's pricing and feature offerings, hoping for more transparent and flexible plans.\n\n5. **Pain Points and Frustrations**:\n   - The limited Vibe and Spec requests, high token consumption, and lack of clarity around credit usage are significant pain points for the community.\n   - Some users have reported technical issues and bugs, such as the \"hilarious bug\" on Fedora Linux, which further contributes to the frustration.\n   - The uncertainty around Kiro's future pricing and feature changes is a concern for those who are considering paid subscriptions.\n\nIn summary, the r/kiroIDE community is enthusiastic about Kiro's capabilities but is grappling with its pricing, credit limitations, and technical issues. The community is actively engaged in discussions, sharing experiences, and seeking solutions to these challenges. As Kiro's free trial period comes to an end, the community is closely watching for any changes in the platform's offerings and pricing to determine the best path forward."
        },
        "framework_analysis": {
          "success": true,
          "analysis": "**COMMUNITY PROFILING**\n\n• Community Type: Product/Development Tool\n• Demographic Indicators: Software developers, particularly those interested in AI-assisted coding\n• Emotional Baseline: Mixed-cautious, trending slightly positive (0.11 sentiment)\n• Community Character: A nascent community focused on the Kiro IDE tool, characterized by technical discussions and pricing concerns. Members appear to be early adopters evaluating the platform against competitors while dealing with access and usage limitations.\n\n**PATTERN DISCOVERY**\n\n🔍 Key Findings:\n\n1. Surprising Pattern #1:\n   Usage credit confusion is widespread, with multiple users reporting unexpected credit depletion and unclear consumption rules\n\n2. Surprising Pattern #2:\n   Strong correlation between pricing discussions and negative sentiment, despite free trial period\n\n3. Surprising Pattern #3:\n   High engagement on comparative analysis posts (vs other IDEs) suggests users actively benchmarking alternatives\n\n💬 Controversy Triggers:\n• Pricing structure and credit system\n• Waitlist access times\n• Feature limitations and bugs\n• Credit consumption mechanics\n\n📊 Success/Failure Predictors:\n• Success indicators: Technical detail, comparative analysis, solution sharing\n• Failure indicators: Complaints about pricing, credit system criticism\n\n**TEMPORAL ANALYSIS**\n\n⏰ Time-Based Patterns:\n\nDaily Cycles:\n• Morning: Technical questions\n• Afternoon: Feature discussions\n• Evening: Pricing and access discussions\n\nWeekly Trends:\n• Increasing discussion volume approaching Sept 15 deadline\n• Higher engagement on technical posts mid-week\n\nSentiment Evolution:\n• Initially positive but trending more critical as users hit limits\n\n**KEY INSIGHTS**\n\n⭐ Most Important Discoveries:\n\n1. Engagement Correlation:\n   Higher engagement on posts discussing alternatives/workarounds\n\n2. Unspoken Rules:\n   Community values detailed technical sharing over complaint posts\n\n3. Influence Patterns:\n   Technical solutions receive more positive engagement than pricing discussions\n\n4. Content Predictors:\n   Posts with concrete examples or comparisons perform better\n\n**ACTIONABLE RECOMMENDATIONS**\n\n📝 Content Strategy:\n• Best performing content types: Technical guides, comparisons, solutions\n• Optimal post structure: Clear problem statement + solution\n• Language style: Technical but accessible\n\n⏱️ Timing Strategy:\n• Best posting times: Mid-week mornings\n• Avoid posting: Weekend evenings\n\n🚫 Topics to Avoid:\n• Direct pricing complaints without context\n• Bug reports without troubleshooting attempts\n\n✅ Topics that Resonate:\n• Technical workflows and solutions\n• Feature comparisons with other IDEs\n• Credit optimization strategies\n\n**QUESTIONS FOR DEEPER ANALYSIS**\n\n🤔 Compelling comparison questions:\n\n1. How does credit usage vary between different development stacks?\n2. What's the correlation between waitlist time and user satisfaction?\n3. How do usage patterns differ between free and paid users?\n4. What impact will the September 15 transition have on community sentiment?\n5. How do successful vs unsuccessful posts differ in technical depth?\n\n**SUMMARY**\n\n📋 Executive Summary:\nThe Kiro IDE community shows strong technical engagement but faces challenges around pricing and credit systems. While sentiment remains slightly positive (0.11), there's increasing criticism of usage limitations. The community particularly values detailed technical content and comparative analysis, suggesting a sophisticated user base actively evaluating the platform against alternatives.",
          "generated_at": "2025-09-15T07:33:14.112Z",
          "model_used": "Claude 3.5 Sonnet"
        },
        "synthetic_post": {
          "title": "Getting Spec mode to actually work with large codebases - any tips?",
          "author": "devops_jake",
          "body": "Been using Kiro for about 2 months now and while Vibe mode has been fantastic for quick fixes and small features, I'm struggling to get good results with Spec mode on our enterprise codebase (about 200k LOC).\n\nI've tried breaking down the requirements into smaller chunks, but the specs it generates still feel too high-level and miss important technical constraints. I've enabled the new architecture awareness feature but it seems to get confused with our microservices setup.\n\nHas anyone successfully used Spec mode for large projects? What's your workflow look like? Starting to wonder if I should just stick to Vibe mode for everything.",
          "score": 42,
          "upvoteRatio": 0.92,
          "comments": [
            {
              "id": "comment1",
              "author": "TechLead_Sarah",
              "body": "You need to use the thunder icon and start with system context first. I usually do:\n1. System overview spec\n2. Break into domains\n3. Individual service specs\n\nMakes a huge difference in output quality.",
              "score": 28,
              "replies": [],
              "level": 0,
              "sentiment": "helpful"
            },
            {
              "id": "comment2",
              "author": "cloudarchitect",
              "body": "Have you enabled overages? The free tier specs can be pretty limited. Their blog mentioned better results with the paid version due to larger context windows.",
              "score": 15,
              "replies": [],
              "level": 0,
              "sentiment": "neutral"
            },
            {
              "id": "comment3",
              "author": "devops_jake",
              "body": "Yeah, I'm on the paid plan with overages enabled. Will try the thunder icon approach!",
              "score": 12,
              "replies": [],
              "level": 1,
              "sentiment": "positive"
            },
            {
              "id": "comment4",
              "author": "kiro_enthusiast",
              "body": "Wait until Sept 15 when they release the new enterprise features. Should handle large codebases much better.",
              "score": 18,
              "replies": [],
              "level": 0,
              "sentiment": "optimistic"
            },
            {
              "id": "comment5",
              "author": "rusty_coder",
              "body": "Honestly just use Vibe for now. Spec mode is great for greenfield projects but still needs work for legacy systems.",
              "score": 22,
              "replies": [],
              "level": 0,
              "sentiment": "neutral"
            },
            {
              "id": "comment6",
              "author": "AIdev_pro",
              "body": "There's a hidden feature if you use /context before your spec request. Helps with large codebases.",
              "score": 8,
              "replies": [],
              "level": 0,
              "sentiment": "helpful"
            },
            {
              "id": "comment7",
              "author": "system_designer",
              "body": "Are you using the new metadata tags? They make a huge difference for complex architectures.",
              "score": 16,
              "replies": [],
              "level": 0,
              "sentiment": "helpful"
            },
            {
              "id": "comment8",
              "author": "junior_dev",
              "body": "Following this thread. Having similar issues with our monolith.",
              "score": 5,
              "replies": [],
              "level": 0,
              "sentiment": "neutral"
            },
            {
              "id": "comment9",
              "author": "webdev_sara",
              "body": "Check out Erik's latest article on working with large codebases in Kiro. Has some good tips on this exact problem.",
              "score": 9,
              "replies": [],
              "level": 0,
              "sentiment": "helpful"
            },
            {
              "id": "comment10",
              "author": "code_wizard",
              "body": "Just remember specs cost more credits than vibes. Don't burn through your monthly allocation testing different approaches.",
              "score": 7,
              "replies": [],
              "level": 0,
              "sentiment": "cautionary"
            }
          ],
          "subreddit": "kiroIDE",
          "timeAgo": "4 hours ago",
          "sentiment": "neutral",
          "generated_at": "2025-09-15T07:35:44.452Z",
          "version": 1
        }
      },
      "posts": [
        {
          "id": "1nfhq8w",
          "title": "SDD Kiro style using other LLMS (Gemini 2.5 Pro in AI Studio is great)",
          "selftext": "Spec Driven Design prompts for LLMs that turn ideas into shipped features\n\nI built a small repo to make feature work more predictable by turning rough ideas into clear specs using the same methodology as Kiro but for any LLM to deliver solid designs, and actionable tasks. It uses a simple three step flow that keeps everything in one conversation with your model. First you generate requirements, then a design, then a focused task list, and finally you drive implementation one task at a time with an execution prompt.\n\nWhat you get is a clean requirements doc in EARS format, a design that covers architecture, components and interfaces, data models, error handling, testing, and CI CD, plus a numbered checklist of coding tasks that you can hand to your coding assistant. The structure helps redu...",
          "score": 19,
          "num_comments": 13,
          "created_utc": 1757718210,
          "subreddit": "kiroIDE",
          "permalink": "/r/kiroIDE/comments/1nfhq8w/sdd_kiro_style_using_other_llms_gemini_25_pro_in/",
          "url": "https://www.reddit.com/r/kiroIDE/comments/1nfhq8w/sdd_kiro_style_using_other_llms_gemini_25_pro_in/",
          "author": "TheSoundOfMusak",
          "comments": [
            {
              "id": "ndwjfeb",
              "body": "Gonna give it a try",
              "score": 2,
              "created_utc": 1757718714,
              "author": "Zazzen"
            },
            {
              "id": "ndzdpn1",
              "body": "nice work. given your interest, have you seen this from Github - https://github.blog/ai-and-ml/generative-ai/spec-driven-development-with-ai-get-started-with-a-new-open-source-toolkit/\n\nor this BMAD-\nhttps://github.com/bmad-code-org/BMAD-METHOD/blob/main/docs/user-guide.md#the-planning-workflow-web-ui",
              "score": 2,
              "created_utc": 1757766305,
              "author": "nearlynarik"
            },
            {
              "id": "ne1iiiw",
              "body": "Yes, I do use: [https://github.com/github/spec-kit](https://github.com/github/spec-kit), however since it uses Claude Code, it uses precious tokens from your limit; I am on the $20 plan; when doing 1 spec I end up reaching my 5hr limit while creating a single spec. The beauty of using my approach is that you can use Gemini Pro 2.5 in AI Studio and it is free. Then use Claude Code for real coding.",
              "score": 2,
              "created_utc": 1757790406,
              "author": "TheSoundOfMusak"
            },
            {
              "id": "ne0ualp",
              "body": "GPL license, why? :P do u understand that nobody can use it?",
              "score": 2,
              "created_utc": 1757783258,
              "author": "AleksHop"
            }
          ]
        },
        {
          "id": "1ndcvhn",
          "title": "Free until Sept 15’ but I’m out of requests",
          "selftext": "Hey folks, I’m trying out **Kiro** and I’m confused by their pricing + FAQ.\n\n* Their blog says Kiro is **free until September 15, 2025**.\n* In the app I’m getting: **“you’re out of requests in your plan — enable overages, upgrade to a higher plan or wait for next month’s new set of requests.”**\n\nSo what’s the actual deal?",
          "score": 10,
          "num_comments": 8,
          "created_utc": 1757507416,
          "subreddit": "kiroIDE",
          "permalink": "/r/kiroIDE/comments/1ndcvhn/free_until_sept_15_but_im_out_of_requests/",
          "url": "https://www.reddit.com/r/kiroIDE/comments/1ndcvhn/free_until_sept_15_but_im_out_of_requests/",
          "author": "juliandurian",
          "comments": [
            {
              "id": "ndg11iv",
              "body": "You have to enable overages. They said they were giving something like 1000 vibe and 250 additional spec (double check those numbers) in overages.",
              "score": 3,
              "created_utc": 1757511268,
              "author": "Quid66"
            },
            {
              "id": "ndg1408",
              "body": "It’s free isn’t it?\n\nNot unlimited and free?",
              "score": 2,
              "created_utc": 1757511290,
              "author": "UnpredictiveList"
            },
            {
              "id": "ndglrwx",
              "body": "They said if you upgrade before the 15th they'll refund you on the 15th. So if you're out of requests go ahead and upgrade and you'll get your money back on the 15th.\n\nSource: [https://kiro.dev/blog/free-until-september-15/](https://kiro.dev/blog/free-until-september-15/)\n\n# If I purchase a subscription today is it free until September 15th?\n\nIf you purchase a subscription anytime before September...",
              "score": 1,
              "created_utc": 1757517305,
              "author": "True-Collection-6262"
            },
            {
              "id": "ndld5mr",
              "body": "But only if you are in the list of countries they offer",
              "score": 1,
              "created_utc": 1757573365,
              "author": "TheExiledMonk"
            }
          ]
        },
        {
          "id": "1neqrjh",
          "title": "What is the difference between Vibe and Specs?",
          "selftext": "I am using kiro from last one month. I am not able to understand what is the difference between Vibe and Specs. I usually use Vibe only . ",
          "score": 9,
          "num_comments": 12,
          "created_utc": 1757641630,
          "subreddit": "kiroIDE",
          "permalink": "/r/kiroIDE/comments/1neqrjh/what_is_the_difference_between_vibe_and_specs/",
          "url": "https://www.reddit.com/r/kiroIDE/comments/1neqrjh/what_is_the_difference_between_vibe_and_specs/",
          "author": "LibrarianOdd3533",
          "comments": [
            {
              "id": "ndqsl1r",
              "body": "Specs mode is a special mode of working with AI where you first generate specification documents for user stories, architecture design, and a list of tasks, so that later AI can work on those tasks one by one. It's a very powerful concept that's getting more and more popular in AI ecosystem lately.  \n  \nTry one of these 3 videos, they're a good overall introduction to Kiro and specs in particular....",
              "score": 5,
              "created_utc": 1757642290,
              "author": "gustojs"
            },
            {
              "id": "ndqu1om",
              "body": "So can we say if there is small big fix or feature then we can go with vibe but if we have big features and requirements not clear then spec?",
              "score": 3,
              "created_utc": 1757642818,
              "author": "LibrarianOdd3533"
            },
            {
              "id": "ndquews",
              "body": "Yes, that's the plan. But you can build even a whole MVP for an app using one set of specifications. This requires spec requests available though, which are not included in free plan. Hopefully they'll do something about it soon. There are changes to pricing coming up next week so we'll see if they solve it.",
              "score": 1,
              "created_utc": 1757642952,
              "author": "gustojs"
            },
            {
              "id": "ndqtuht",
              "body": "Thanks bro, I will look into this 🙂",
              "score": 1,
              "created_utc": 1757642745,
              "author": "LibrarianOdd3533"
            }
          ]
        },
        {
          "id": "1nchamx",
          "title": "How long did you wait for the access code? (let's keep this updated)",
          "selftext": "So there's been always a lot of people in various places asking how long it takes to get off the waitlist. But the waiting time is fluent and since the team doesn't share any metrics, we can only estimate it if others share their experience.  \n  \nWhen did you sign up for the waitlist (more or less) and when did you get the code?\n\n\\---\n\nMy own story is pretty outdated. I signed up for the waitlist on day 1 (July 17th) and got the code around a week after they started sending them out (August 8th).\n\nThat said, I did have access before (as anyone who signed into Kiro before they implemented the checking process).",
          "score": 10,
          "num_comments": 5,
          "created_utc": 1757420236,
          "subreddit": "kiroIDE",
          "permalink": "/r/kiroIDE/comments/1nchamx/how_long_did_you_wait_for_the_access_code_lets/",
          "url": "https://www.reddit.com/r/kiroIDE/comments/1nchamx/how_long_did_you_wait_for_the_access_code_lets/",
          "author": "gustojs",
          "comments": [
            {
              "id": "nddlg6g",
              "body": "Took around 40 days....applied mid July got in August end",
              "score": 2,
              "created_utc": 1757470548,
              "author": "Loose_Associate_103"
            },
            {
              "id": "ndrpcis",
              "body": "It's only getting more popular, but I think they will do a full release soon, maybe after 15th when the free use ends\n\nAnd yeah, let me twist the knife: I registered before the whitelist, so... 2 minutes",
              "score": 2,
              "created_utc": 1757656185,
              "author": "MidnightTwo"
            },
            {
              "id": "ndff6xx",
              "body": "I got access. It’s better compared to Cursor and VS in terms of features, but the token usage is very high.",
              "score": 1,
              "created_utc": 1757503455,
              "author": "vyh19"
            },
            {
              "id": "ndga40g",
              "body": "How long did you wait for access?",
              "score": 1,
              "created_utc": 1757513986,
              "author": "gustojs"
            }
          ]
        },
        {
          "id": "1nbyiki",
          "title": "Credit usage doesn’t make sense",
          "selftext": "Opened Kiro after few days break. Check admin - 0 credits used out of 100. \nSaw i needed to upgrade UI. \nAfter upgrade, 8 credits used. \nAnyone can explain how credits are being used up by Kiro?",
          "score": 7,
          "num_comments": 1,
          "created_utc": 1757362430,
          "subreddit": "kiroIDE",
          "permalink": "/r/kiroIDE/comments/1nbyiki/credit_usage_doesnt_make_sense/",
          "url": "https://www.reddit.com/r/kiroIDE/comments/1nbyiki/credit_usage_doesnt_make_sense/",
          "author": "LetLongjumping",
          "comments": [
            {
              "id": "nd6ww0t",
              "body": "You're thinking a little too loud and kiro counts this as requests. If you don't want to use kiro requests between coding sessions you should uninstall and reinstall.",
              "score": 3,
              "created_utc": 1757382595,
              "author": "missionmeme"
            }
          ]
        },
        {
          "id": "1neqjil",
          "title": "Article - Top 8 tips when working with Kiro",
          "selftext": "The content is mostly newcomer level but there are some cool tips for more advanced users too. It's good to see such articles are slowly showing up.\n\nThe author is [Erik Hanchett](https://x.com/ErikCH), dev advocate in AWS and now Kiro team. You can remember him from the last Weekly Kiro Show.\n\n[https://x.com/ErikCH/status/1966294313337569501](https://x.com/ErikCH/status/1966294313337569501)",
          "score": 6,
          "num_comments": 1,
          "created_utc": 1757640966,
          "subreddit": "kiroIDE",
          "permalink": "/r/kiroIDE/comments/1neqjil/article_top_8_tips_when_working_with_kiro/",
          "url": "https://kiro.hashnode.dev/top-8-tips-when-working-with-kiro",
          "author": "gustojs",
          "comments": [
            {
              "id": "ndqp29m",
              "body": "The ancient art of metadata is sadly lost though.",
              "score": 1,
              "created_utc": 1757641026,
              "author": "gustojs"
            }
          ]
        },
        {
          "id": "1nbv097",
          "title": "Will Kiro change their pricing plans on this month?",
          "selftext": "Does anyone know if Kiro is going to change their pricing this month or it was only about refunds and free credits? And we will still get 225 vibe requests for 20$?",
          "score": 7,
          "num_comments": 11,
          "created_utc": 1757354558,
          "subreddit": "kiroIDE",
          "permalink": "/r/kiroIDE/comments/1nbv097/will_kiro_change_their_pricing_plans_on_this_month/",
          "url": "https://www.reddit.com/r/kiroIDE/comments/1nbv097/will_kiro_change_their_pricing_plans_on_this_month/",
          "author": "patostar89",
          "comments": [
            {
              "id": "nd4n52y",
              "body": "No, They don’t. We have contacted their support regarding the pricing, and here is the answer:\n\nI understand your frustration with the current pricing and terms. After consulting with the Kiro team, I regret to inform you that we are unable to make changes to the pricing or offer any alterations to the existing terms at this time.\n\nPlease be assured that your feedback is valuable to us. We have ca...",
              "score": 3,
              "created_utc": 1757356329,
              "author": "Samolevsky"
            },
            {
              "id": "nd5l39q",
              "body": "Oh I am so disappointed, I was going to reconsider it if their new pricing is good, now I will stick to Trae and Qoder, Kiro was really my favorite, but I would waste the 225 in 3 or 4 days, they suck.",
              "score": 3,
              "created_utc": 1757366281,
              "author": "patostar89"
            },
            {
              "id": "nd6tb6b",
              "body": "Honestly this sounds like a copypaste'able message you were just sent without paying much attention. Which is, of course, disappointing in itself, but I wouldn't make conclusions on the near-future pricing based on this answer.",
              "score": 2,
              "created_utc": 1757381329,
              "author": "gustojs"
            },
            {
              "id": "nd5a554",
              "body": "i’m holding out hope they will combine the requests or at least make a vibe only plan i can join otherwise ill most likely do copilot or kilo",
              "score": 2,
              "created_utc": 1757363084,
              "author": "tomm1313"
            }
          ]
        },
        {
          "id": "1nh20ir",
          "title": "Can't spend spec requests without vibe requests?",
          "selftext": "Seems like a bug to me? I used up my vibe credits for the month but have \\~800 spec credits left. However, I can't make new specs since it takes vibe credits to ask for it to render a spec. \n\nAnyone know a way around this?",
          "score": 5,
          "num_comments": 3,
          "created_utc": 1757881837,
          "subreddit": "kiroIDE",
          "permalink": "/r/kiroIDE/comments/1nh20ir/cant_spend_spec_requests_without_vibe_requests/",
          "url": "https://www.reddit.com/r/kiroIDE/comments/1nh20ir/cant_spend_spec_requests_without_vibe_requests/",
          "author": "Dependent_Duty_5614",
          "comments": [
            {
              "id": "ne8mvzo",
              "body": "This is the game they want you to play. It's to get u to buy more credits when u run out of the other. There's a reason Europe tried to ban this kind of hidden cost in videos games with digital currencies. Its anti-consumer.",
              "score": 1,
              "created_utc": 1757884952,
              "author": "Nobody-SM-0000"
            },
            {
              "id": "ne8oizr",
              "body": "Use the thunder icon to start a task. You cannot use prompt",
              "score": 1,
              "created_utc": 1757885454,
              "author": "Dodokii"
            },
            {
              "id": "neazdcm",
              "body": "Everything is a feature in Kiro. They are designed to irritate and frustrate users. \n\nGood luck to them.",
              "score": 1,
              "created_utc": 1757918168,
              "author": "randommarkets"
            }
          ]
        },
        {
          "id": "1nfbwa9",
          "title": "only showing one model in Kiro and asking me to select another model.",
          "selftext": "The model you've selected is experiencing a high volume of traffic. Try changing the model and re-running your prompt. getting this error.  any facing this issue ? or anything I am missing ? \n\nhttps://preview.redd.it/0ctd8jon8sof1.png?width=1000&format=png&auto=webp&s=7be338d27a7beca18b03a0016c30d06fdef60a4d\n\n",
          "score": 5,
          "num_comments": 3,
          "created_utc": 1757704106,
          "subreddit": "kiroIDE",
          "permalink": "/r/kiroIDE/comments/1nfbwa9/only_showing_one_model_in_kiro_and_asking_me_to/",
          "url": "https://www.reddit.com/r/kiroIDE/comments/1nfbwa9/only_showing_one_model_in_kiro_and_asking_me_to/",
          "author": "aviboy2006",
          "comments": [
            {
              "id": "ndwq3fp",
              "body": "There used to be 3.7 available to select, not anymore. They forgot to change the fluff.",
              "score": 2,
              "created_utc": 1757721067,
              "author": "gustojs"
            },
            {
              "id": "ndy22bu",
              "body": "Ideally in Cursor I get options to change either charGPT or Claude sonnet 3.7. But now options itself not there then error message should be something else. Not like select another model.",
              "score": 1,
              "created_utc": 1757740406,
              "author": "aviboy2006"
            },
            {
              "id": "ndz8a0i",
              "body": "Used to be 4.1 also",
              "score": 1,
              "created_utc": 1757763999,
              "author": "nebulousx"
            }
          ]
        },
        {
          "id": "1ngk2qs",
          "title": "Till when is kiro free? 14 sept 23:59 or 15 sept 23:59?",
          "selftext": "Edit: I asked them they said 15 sept 23:59 local time.",
          "score": 5,
          "num_comments": 8,
          "created_utc": 1757832079,
          "subreddit": "kiroIDE",
          "permalink": "/r/kiroIDE/comments/1ngk2qs/till_when_is_kiro_free_14_sept_2359_or_15_sept/",
          "url": "https://www.reddit.com/r/kiroIDE/comments/1ngk2qs/till_when_is_kiro_free_14_sept_2359_or_15_sept/",
          "author": "Just_Difficulty9836",
          "comments": [
            {
              "id": "ne630t6",
              "body": "We will share more details on the plans going forward on Monday, September 15. Until then, users can continue using the product — including on the 15th — for free.",
              "score": 5,
              "created_utc": 1757858839,
              "author": "ai_product"
            },
            {
              "id": "ne5bgui",
              "body": "I don’t know about anyone else. But I’ve been having major trouble with Kiro the past few days to a point where it is basically unusable.\n\nConstantly freezing, getting stuck in loops or throwing random errors when everything appears to be fine. \n\nI’m guessing they are struggling with the demand as everyone is trying to finish their projects before the free period ends.\n\nDebating with myself whethe...",
              "score": 3,
              "created_utc": 1757847761,
              "author": "YetAnotherInterneter"
            },
            {
              "id": "ne54tr1",
              "body": "From the announcements:  \n\\> If you purchase a subscription anytime before September 14, you can use it for free until September 14th.\n\nSo that would be 14 sept 23:59\n\nBut since ai\\_product updated us here, 15th is free too.",
              "score": 2,
              "created_utc": 1757843983,
              "author": "gustojs"
            },
            {
              "id": "ne6xqcn",
              "body": "It doesn’t matter, I’m not using it any more…",
              "score": 1,
              "created_utc": 1757867994,
              "author": "smashmouthftball"
            }
          ]
        },
        {
          "id": "1ncb1zo",
          "title": "Kiro AI IDE",
          "selftext": "Today I got Kiro waitlist access and it is really helpful in the projects better than Trae and same as of cursor ",
          "score": 4,
          "num_comments": 0,
          "created_utc": 1757397413,
          "subreddit": "kiroIDE",
          "permalink": "/r/kiroIDE/comments/1ncb1zo/kiro_ai_ide/",
          "url": "https://www.reddit.com/r/kiroIDE/comments/1ncb1zo/kiro_ai_ide/",
          "author": "Dr-Scientist-",
          "comments": []
        },
        {
          "id": "1nfapuc",
          "title": "Still usage errors while using spec?",
          "selftext": "Used 178 specs just today and reached my total monthly limit. How is that even possible if spec uses vibe for the tasks??",
          "score": 3,
          "num_comments": 5,
          "created_utc": 1757701322,
          "subreddit": "kiroIDE",
          "permalink": "/r/kiroIDE/comments/1nfapuc/still_usage_errors_while_using_spec/",
          "url": "https://www.reddit.com/r/kiroIDE/comments/1nfapuc/still_usage_errors_while_using_spec/",
          "author": "Late-Toe4259",
          "comments": [
            {
              "id": "ndvcgfy",
              "body": "that should consume 1 spec when you click start tasks, if you ask a question or cancel the process during that Spec, it will consume Vibes",
              "score": 2,
              "created_utc": 1757705138,
              "author": "Toastedpubes"
            },
            {
              "id": "ndv5rsc",
              "body": "Specs dont use Vibes? \n\nI just did my spec buildout in gpt5, passed it over to Kiro Spec, and that generated 14 tasks. Each one of those tasks was 1 Spec",
              "score": 1,
              "created_utc": 1757703166,
              "author": "Toastedpubes"
            },
            {
              "id": "ndv6bc0",
              "body": "I start the tasks manually and add them manually to queue. This should use only vibe „tokens“ isn’t it?",
              "score": 1,
              "created_utc": 1757703326,
              "author": "Late-Toe4259"
            },
            {
              "id": "ndv76mp",
              "body": "what is manually starting the tasks? Copy and pasting the Spec into a Vibe chat?",
              "score": 1,
              "created_utc": 1757703580,
              "author": "Toastedpubes"
            }
          ]
        }
      ]
    }
  },
  {
    "id": "mfksywuoz92g59vca",
    "generated_at": "2025-09-15T07:28:46.800Z",
    "name": "r/TaylorSwift Fan Community",
    "description": "Sentiment analysis of passionate fan discussions about Taylor Swift's music, concerts, and latest releases.",
    "subreddits": [
      "TaylorSwift"
    ],
    "dateRange": {
      "startDate": "2025-09-08",
      "endDate": "2025-09-15"
    },
    "totalPosts": 20,
    "totalComments": 1550,
    "data": {
      "summary": {
        "totalPosts": 20,
        "totalComments": 1550,
        "subreddits": [
          "TaylorSwift"
        ],
        "dateRange": {
          "startDate": "2025-09-08",
          "endDate": "2025-09-15"
        }
      },
      "analysis": {
        "overall_sentiment": {
          "average_score": 0.82,
          "sentiment_distribution": {
            "positive": 85,
            "neutral": 12,
            "negative": 3
          },
          "dominant_themes": [
            "taylor",
            "swift",
            "album",
            "music",
            "song",
            "love",
            "fan",
            "concert",
            "tour",
            "lyrics"
          ],
          "key_emotions": [
            "excitement",
            "love",
            "admiration",
            "passion",
            "fandom"
          ],
          "summary": "The overall sentiment is positive (positive 65%). Key themes include: appreciation, enthusiasm, criticism."
        },
        "individual_scores": [
          {
            "index": 1,
            "score": 0.8,
            "sentiment": "positive",
            "confidence": 0.9,
            "themes": [
              "congratulations",
              "engagement",
              "celebrity"
            ],
            "emotions": [],
            "source": {
              "type": "post_title",
              "postId": "1nee2ol",
              "subreddit": "TaylorSwift"
            }
          },
          {
            "index": 2,
            "score": 0.6,
            "sentiment": "positive",
            "confidence": 0.8,
            "themes": [
              "humor",
              "teaching",
              "entertainment"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1nee2ol",
              "commentId": "ndo0rm7",
              "subreddit": "TaylorSwift"
            }
          },
          {
            "index": 3,
            "score": 0.7,
            "sentiment": "positive",
            "confidence": 0.9,
            "themes": [
              "school",
              "theme",
              "enthusiasm"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1nee2ol",
              "commentId": "ndp7l8v",
              "subreddit": "TaylorSwift"
            }
          },
          {
            "index": 4,
            "score": 0.8,
            "sentiment": "positive",
            "confidence": 0.9,
            "themes": [
              "humor",
              "wordplay",
              "wedding"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1nee2ol",
              "commentId": "ndqr3fe",
              "subreddit": "TaylorSwift"
            }
          },
          {
            "index": 5,
            "score": 0.9,
            "sentiment": "positive",
            "confidence": 0.9,
            "themes": [
              "praise",
              "appreciation",
              "enthusiasm"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1nee2ol",
              "commentId": "ndqueny",
              "subreddit": "TaylorSwift"
            }
          }
        ],
        "by_subreddit": {
          "TaylorSwift": {
            "scores": [
              0.8,
              0.6,
              0.7,
              0.8,
              0.9,
              -0.2,
              0.6,
              0.7,
              0,
              0.3,
              0.4,
              0.3,
              0.1,
              0.7,
              0.2,
              0.4,
              0.8,
              0.5,
              0.7,
              0.5,
              0.6,
              0.4,
              0.6,
              0.5,
              0.8,
              0.7,
              0.6,
              0.8,
              0.8,
              0.7,
              0.5,
              0.7,
              0.4,
              0.6,
              0.3,
              0.6,
              0.9,
              -0.2,
              0.3,
              0.5,
              0.9,
              0.8,
              0.5,
              0.6,
              0.7,
              0.4,
              -0.3,
              0.7,
              0.5,
              0.2,
              0.3,
              -0.2,
              0.4,
              0.8,
              0.9,
              -0.3,
              0.6,
              0.4,
              0.9,
              0.2,
              0.1,
              0.5,
              -0.4,
              0.6,
              0.9,
              0.3,
              0.2,
              -0.2,
              0.8,
              0.8,
              0.4,
              0.3,
              0.7,
              0.6,
              0.5,
              -0.3,
              0.1,
              -0.4,
              0,
              -0.2,
              0,
              -0.3,
              0,
              -0.5,
              -0.3,
              -0.6,
              -0.2,
              0.1,
              0,
              0,
              0.1,
              0.2,
              -0.1,
              0,
              -0.5,
              -0.4,
              0.2,
              -0.2,
              0.1,
              0.3,
              0.8,
              0.7,
              0.2,
              -0.1,
              0.3,
              0.6,
              0,
              -0.2,
              -0.1,
              0.5,
              0.2,
              0.1,
              -0.3,
              0.2,
              0.1,
              0.3,
              0,
              0,
              -0.1,
              0.2,
              0.9,
              0.3,
              0.8,
              0.9,
              0.8,
              0.7,
              0.5,
              0.7,
              0.8,
              0.6,
              0.8,
              0.9,
              0.7,
              0.8,
              0.6,
              0.9,
              0.9,
              0.9,
              0.9,
              0.9,
              0.8,
              0.8,
              0.7,
              0.6,
              0.7,
              0.8,
              0.9,
              0.8,
              0.8,
              0.6,
              0.9,
              0.9,
              0.8,
              0.5,
              0.8,
              0.8,
              0.8,
              0.8,
              0.8,
              0.8,
              0.7,
              0.8,
              0.9,
              0.8,
              0.8,
              0.7,
              0.7,
              0.8,
              0,
              0.7,
              0.8,
              0.9,
              0.9,
              0.9,
              0.5,
              0.9,
              0.6,
              0.9,
              0.8,
              0.85,
              0.6,
              0.8,
              0.6,
              -0.6,
              0,
              0,
              -0.3,
              -0.2,
              0,
              0.5,
              0.9,
              0.8,
              0.6,
              0.7,
              0.3,
              0.9,
              0.8,
              0.3,
              0.8,
              0.9,
              0.5,
              0.3,
              0.9,
              0.8,
              0.7,
              0.9,
              0.8,
              0,
              0.6,
              0.7,
              0.7,
              -0.2,
              0.8,
              0.9,
              0.8,
              0.9,
              0.9,
              0.9,
              0.9,
              0.9,
              0.9,
              0.3,
              0.9,
              0.8,
              0.7,
              0,
              0.8,
              0.9,
              0.8,
              0.8,
              0.9,
              0.7,
              -0.2,
              0.8,
              0.3,
              0.5,
              0.9,
              -0.3,
              0.9,
              0.8,
              0,
              0.7,
              0.4,
              0,
              0.7,
              0.6,
              0.4,
              0.6,
              0.3,
              0.5,
              0.8,
              0.6,
              0.5,
              0.4,
              0.7,
              0.8,
              0.7,
              0.9,
              0.7,
              0.9,
              0.7,
              0.8,
              0.6,
              0.5,
              0.8,
              0,
              0.4,
              0.9,
              0.8,
              0.8,
              0.8,
              0.6,
              0,
              0.3,
              0.7,
              0.4,
              0.8,
              0.7,
              0.9,
              0.7,
              0.6,
              0.5,
              0.6,
              0.9,
              0.9,
              0.7,
              0.2,
              0.7,
              0.8,
              0.8,
              0.7,
              0.7,
              0.2,
              0.8,
              0.7,
              0.8,
              0.9,
              0.6,
              0.9,
              0.9,
              0.8,
              0.9,
              0.8,
              0.9,
              0.7,
              0.9,
              0.7,
              0.8,
              0.7,
              0.9,
              0.8,
              0.9,
              0.9,
              0.8,
              0.8,
              0.7,
              0.9,
              0.8,
              0.7,
              0.8,
              0.9,
              0.95,
              0.8,
              0.85,
              0.7,
              0.9,
              0.85,
              0.8,
              0.75,
              0.3,
              0.9,
              0.85,
              0.75,
              0.6,
              0.7,
              0.9,
              0.3,
              0.6,
              0.7,
              0.85,
              0.8,
              0,
              0.9,
              0.85,
              0.9,
              0,
              0.8,
              0.8,
              0.85,
              0.95,
              0.85,
              0.7,
              0.6,
              0.7,
              0.8,
              0.7,
              0.7,
              0.8,
              0.7,
              0.7,
              0.7,
              0.75,
              0.8,
              0.7,
              0.7,
              0.7,
              0.8,
              0.75,
              0.7,
              0.4,
              0.7,
              0.8,
              0.8,
              0.3,
              0.6,
              0.4,
              0.8,
              0.8,
              0.5,
              0.6,
              0.5,
              0.9,
              0.8,
              0.2,
              0.6,
              0.5,
              0,
              0.5,
              0.7,
              0.4,
              0.7,
              0,
              0.6,
              0.9,
              0.9,
              0.3,
              0.8,
              0.8,
              0.9,
              0.5,
              0.9,
              0.6,
              0.9,
              0.9,
              0.8,
              0.7,
              0.9,
              0.9,
              0.6,
              0.8,
              0.9,
              0.9,
              0.9,
              0.5,
              0,
              0.8,
              0.7,
              0.9,
              0.8,
              0.9,
              0.6,
              0.9,
              0.8,
              0.9,
              0.9,
              0.7,
              0.2,
              0.8,
              0.9,
              0.9,
              0.7,
              0.9,
              0.7,
              0.8,
              0.8,
              0.3,
              0.4,
              0.7,
              0,
              0.1,
              0.5,
              0.2,
              -0.2,
              -0.4,
              0.3,
              0.2,
              0.6,
              0.7,
              0.3,
              0,
              0.2,
              0.1,
              0.2,
              0.4,
              0.3,
              0.2,
              0.5,
              0.2,
              0.1,
              0.6,
              0,
              0.1,
              0,
              0.1,
              0.2,
              0.3,
              0.4,
              0.8,
              0.8,
              0.8,
              0.2,
              0.6,
              0.4,
              0.8,
              -0.3,
              0,
              0,
              0.6,
              -0.4,
              0,
              0,
              0,
              0.3,
              0.5,
              0.2,
              0,
              0,
              0.7,
              0.4,
              0.2,
              0.5,
              0.3,
              0.6,
              -0.2,
              0.4,
              0.5,
              0.7,
              0.3,
              0.4,
              0.6,
              0.7,
              0.5,
              0.2,
              0.6,
              0.8,
              0.6,
              0.4,
              0.5,
              0.3,
              0.4,
              0.4,
              0.6,
              0.5,
              0.7,
              0,
              0.3,
              0,
              0.9,
              0.6,
              0.7,
              0,
              0.9,
              0.8,
              0.7,
              0.7,
              0.3,
              0.4,
              0.2,
              0.8,
              0.6,
              0.4,
              0.3,
              -0.2,
              0,
              0.9,
              0.3,
              0.7,
              0.8,
              0.6,
              0.4,
              0,
              0.5,
              0.6,
              0.7,
              0.9,
              0.8,
              0.9,
              0.8,
              0.9,
              0.6,
              0.5,
              0.7,
              0.1,
              0.4,
              0.5,
              0.6,
              0.3,
              0.8,
              0.6,
              0.8,
              0.7,
              0.9,
              0,
              0,
              -0.2,
              0,
              0,
              0,
              -0.1,
              -0.3,
              0.3,
              0.9,
              -0.2,
              -0.1,
              0.8,
              0.4,
              0.3,
              0.1,
              -0.2,
              -0.7,
              -0.6,
              -0.3,
              -0.4,
              -0.5,
              0.4,
              -0.8,
              -0.5,
              -0.8,
              -0.7,
              -0.6,
              0.2,
              0.5,
              -0.7,
              -0.5,
              -0.6,
              -0.5,
              -0.6,
              -0.8,
              -0.5,
              -0.4,
              -0.7,
              -0.6,
              -0.4,
              -0.3,
              -0.6,
              -0.4,
              -0.2,
              -0.6,
              -0.5,
              -0.3,
              -0.4,
              -0.4,
              -0.2,
              -0.6,
              -0.5,
              -0.7,
              -0.8,
              -0.6,
              -0.7,
              -0.3,
              -0.4,
              -0.2,
              -0.3,
              0.3,
              -0.5,
              -0.4,
              -0.6,
              -0.7,
              -0.8,
              -0.5,
              -0.4,
              -0.6,
              -0.2,
              0,
              -0.7,
              -0.2,
              -0.6,
              0.2,
              -0.3,
              0,
              0.7,
              -0.8,
              -0.4,
              -0.5,
              -0.4,
              -0.7,
              -0.6,
              -0.5,
              -0.4,
              -0.3,
              -0.7,
              0,
              -0.2,
              -0.4,
              -0.3,
              -0.6,
              -0.7,
              -0.6,
              0,
              -0.3,
              -0.7,
              -0.2,
              0.2,
              -0.5,
              -0.8,
              -0.6,
              -0.5,
              -0.4,
              -0.6,
              -0.7,
              -0.3,
              0.6,
              -0.4,
              0.1,
              0.2,
              -0.6,
              -0.5,
              0.4,
              0.5,
              -0.3,
              -0.2,
              0.2,
              0.4,
              -0.7,
              0.1,
              -0.3,
              -0.2,
              -0.4,
              -0.5,
              -0.4,
              -0.2,
              0.6,
              0.8,
              0.4,
              0.5,
              0.7,
              0.1,
              0.3,
              0,
              0.6,
              0.8,
              0.6,
              0.8,
              0.9,
              0.7,
              -0.1,
              0.3,
              0.8,
              0.7,
              0.7,
              0.4,
              -0.1,
              0.2,
              0.3,
              0.2,
              -0.3,
              0.7,
              0.6,
              0.5,
              0,
              0.5,
              0.4,
              0.6,
              0.7,
              0.8,
              0.8,
              0.6,
              0.7,
              0.8,
              0.7,
              0.8,
              0.7,
              0.8,
              0.6,
              0.9,
              0.7,
              0.6,
              0.5,
              0.7,
              0.8,
              0.9,
              0.3,
              0.4,
              0.2,
              0.8,
              0.6,
              0.7,
              0.9,
              0.6,
              0.8,
              0.8,
              0.9,
              -0.2,
              -0.3,
              -0.4,
              0.3,
              0.1,
              0.4,
              -0.1,
              0,
              0.9,
              0.8,
              0.9,
              -0.8,
              -0.2,
              0.7,
              0.5,
              0.8,
              0.6,
              0.4,
              0.8,
              0.9,
              0.6,
              0.8,
              0.6,
              0.5,
              -0.2,
              0.7,
              0.8,
              -0.3,
              0.6,
              0.5,
              0.9,
              -0.4,
              -0.5,
              0.8,
              0.7,
              -0.1,
              0.4,
              0.2,
              -0.2,
              0.6,
              -0.3,
              0.8,
              0.9,
              0.7,
              -0.2,
              -0.3,
              0.6,
              0.5,
              0.8,
              0.7,
              0.6,
              0.8,
              0.9,
              0.7,
              0.6,
              0.7,
              0.6,
              -0.2,
              0.3,
              0.4,
              0.7,
              0.9,
              0.9,
              0.5,
              0.6,
              0.7,
              0.4,
              0.6,
              -0.2,
              -0.1,
              -0.3,
              0.6,
              -0.2,
              -0.3,
              -0.2,
              0.8,
              -0.1,
              0.5,
              -0.2,
              0.7,
              0.6,
              0.6,
              0.7,
              0.8,
              0.6,
              0.4,
              0.9,
              0.8,
              0.2,
              0.9,
              0.7,
              0.8,
              0.8,
              0.7,
              0.6,
              0.9,
              0.6,
              0.9,
              0.3,
              0.7,
              0.8,
              0.7,
              0.9,
              0.3,
              0.6,
              0.4,
              -0.3,
              0.3,
              0.3,
              0.3,
              0.7,
              0.6,
              0.1,
              0.4,
              0.5,
              0.6,
              0.8,
              0.6,
              0.8,
              0.5,
              0.4,
              0.7,
              0.5,
              0.6,
              0.4,
              0.7,
              0.7,
              0.5,
              -0.2,
              -0.3,
              -0.4,
              0.5,
              0.5,
              0.6,
              0.8,
              -0.5,
              -0.4,
              0.2,
              -0.2,
              -0.3,
              0,
              0.2,
              -0.1,
              0.6,
              0.9,
              0.7,
              0.8,
              0.9,
              0.8,
              0,
              0,
              -0.2,
              0.3,
              0.9,
              0.8,
              0.7,
              0.6,
              0.8,
              0.7,
              0.4,
              0.5,
              0.6,
              0.8,
              0.8,
              0.5,
              0.7,
              0.7,
              0.3,
              0.6,
              0.9,
              0.8,
              0.7,
              0.9,
              -0.7,
              0.5,
              0.8,
              0.6,
              0.9,
              0.3,
              0.7,
              0.2,
              -0.3,
              0.7,
              0.1,
              0.4,
              0.6,
              0.7,
              0.8,
              -0.6,
              0.7,
              0.9,
              0.8,
              0.8,
              -0.7,
              0,
              -0.3,
              0.9,
              0.8,
              0.5,
              0.6,
              0.8,
              0.7,
              0.4,
              0.9,
              -0.5,
              -0.8,
              -0.3,
              0.1,
              -0.2,
              0.6,
              -0.4,
              0.7,
              0.3,
              -0.4,
              0.8,
              0.6,
              -0.4,
              0.7,
              0.8,
              0.9,
              0.3,
              0.7,
              0.6,
              0.7,
              0.8,
              0.4,
              0.6,
              0.6,
              0.8,
              0.6,
              0.7,
              0.8,
              0.8,
              0.9,
              0.8,
              0.8,
              0.7,
              0.9,
              0.8,
              0.8,
              0.8,
              0.3,
              0,
              0.7,
              0.4,
              -0.2,
              0,
              0,
              0.9,
              0.7,
              0,
              0.3,
              0.6,
              -0.2,
              0.5,
              0,
              0.3,
              0,
              0.6,
              0,
              0.7,
              -0.1,
              0.4,
              -0.8,
              0.6,
              0.8,
              -0.5,
              0.2,
              -0.4,
              0.3,
              -0.2,
              -0.1,
              0.1,
              -0.6,
              -0.8,
              -0.2,
              -0.7,
              -0.3,
              -0.8
            ],
            "positive": 665,
            "neutral": 180,
            "negative": 171,
            "mixed": null,
            "average_score": 0.39369544131910816,
            "total_analyzed": 1031
          }
        },
        "timeline": [
          {
            "date": "2025-09-08",
            "average_score": 0.5670212765957445,
            "positive": 150,
            "neutral": 16,
            "negative": 18,
            "total": 188
          },
          {
            "date": "2025-09-09",
            "average_score": 0.48031496062992113,
            "positive": 94,
            "neutral": 17,
            "negative": 16,
            "total": 127
          },
          {
            "date": "2025-09-10",
            "average_score": 0.49458874458874447,
            "positive": 162,
            "neutral": 48,
            "negative": 17,
            "total": 231
          },
          {
            "date": "2025-09-11",
            "average_score": 0.5310344827586208,
            "positive": 50,
            "neutral": 5,
            "negative": 3,
            "total": 58
          },
          {
            "date": "2025-09-12",
            "average_score": 0.11224832214765097,
            "positive": 118,
            "neutral": 64,
            "negative": 109,
            "total": 298
          },
          {
            "date": "2025-09-13",
            "average_score": 0.536,
            "positive": 16,
            "neutral": 7,
            "negative": 2,
            "total": 25
          },
          {
            "date": "2025-09-14",
            "average_score": 0.446153846153846,
            "positive": 75,
            "neutral": 23,
            "negative": 6,
            "total": 104
          }
        ],
        "ai_insights": {
          "TaylorSwift": "Based on the posts from r/TaylorSwift, here is my analysis:\n\nOverall Community Mood and Attitudes:\n- The community appears to be enthusiastic, engaged, and excited about Taylor Swift's latest projects and announcements. There is a general sense of anticipation and positivity.\n- Fans are highly appreciative of Taylor's creative endeavors, whether it's her music, videos, fashion, or merchandise. They show a deep connection to her artistry.\n- There is a strong sense of community, with fans supporting and celebrating each other's fan-made content and experiences.\n\nCommon Themes, Concerns, and Topics of Interest:\n- New album and era announcements (e.g., \"Showgirl\" album) generate a lot of discussion and speculation.\n- Fans are interested in Easter eggs, hidden messages, and clues about Taylor's upcoming projects.\n- There is a focus on Taylor's personal life, especially her engagement to Travis.\n- Fans enjoy creating and sharing fan art, crafts, and other creative projects inspired by Taylor's music and imagery.\n- Discussions around Taylor's fashion, beauty, and style choices are common.\n\nPatterns in Upvoted/Discussed Content:\n- Posts that showcase fan-made content, especially high-quality or creative pieces, tend to be heavily upvoted and discussed.\n- Announcements or teasers about new Taylor projects and eras generate a lot of excitement and engagement.\n- Positive, supportive, and appreciative posts about Taylor and her work are often the most popular.\n\nEmerging Trends or Shifts in Opinion:\n- There seems to be a growing frustration with Taylor's marketing team and their use of excessive countdowns and teasers that don't deliver much substantial content.\n- While the community remains highly enthusiastic, some fans express fatigue with the hype and prefer more direct communication and content from Taylor.\n\nPain Points or Frustrations:\n- The main frustration appears to be around the perceived over-hyping of minor updates or teasers, which some fans find disappointing.\n- There is a desire for more substantial and meaningful content from Taylor, rather than endless countdowns and short video clips.\n\nCurrent State of the Community:\n- The r/TaylorSwift community is thriving, with a high level of engagement and a strong sense of community.\n- Fans remain passionate and dedicated, but there are signs of some frustration with the marketing tactics used by Taylor's team.\n- Overall, the community is eagerly anticipating Taylor's next project and era, while continuing to celebrate her past work and their shared fandom."
        },
        "framework_analysis": {
          "success": true,
          "analysis": "**COMMUNITY PROFILING**\n\n• Community Type: Fan/Entertainment\n• Demographic Indicators: Predominantly female, young adult to adult (18-35)\n• Emotional Baseline: Overwhelmingly positive and enthusiastic\n• Community Character: The TaylorSwift subreddit is a highly engaged, creative fan community that celebrates both the artist and fan-created content. The community shows strong support for fan art, crafts, and personal expressions of fandom while maintaining respectful discourse.\n\n**PATTERN DISCOVERY**\n\n🔍 Key Findings:\n\n1. Surprising Pattern #1:\n   Creative fan content consistently outperforms news/updates in engagement, suggesting the community values personal expression over information sharing\n\n2. Surprising Pattern #2:\n   High engagement on DIY/craft posts (LEGO, knitting, nail art) indicates a strong maker culture within the fandom\n\n3. Surprising Pattern #3:\n   Travis Kelce-related content generates consistently high engagement without the typical controversy celebrity relationships usually cause\n\n💬 Controversy Triggers:\n• Marketing tactics and countdown disappointments\n• iTunes/platform exclusivity\n• Quality differences between original and re-recorded versions\n• Merchandise pricing and availability\n\n📊 Success/Failure Predictors:\n• Success indicators: Personal creativity, humor, positive relationship discussion, fan art\n• Failure indicators: Marketing criticism, platform complaints, negativity about re-recordings\n\n**TEMPORAL ANALYSIS**\n\n⏰ Time-Based Patterns:\n\nDaily Cycles:\n• Morning: Lower engagement, more news discussion\n• Afternoon: Peak creative content sharing\n• Evening: Highest overall engagement and discussion\n\nWeekly Trends:\n• Weekdays show higher engagement than weekends\n• Peak engagement occurs mid-week\n• Content quality over timing appears more important\n\nSentiment Evolution:\n• Generally maintains positive sentiment (0.39 average)\n• Dips during marketing announcements\n• Peaks during creative content sharing\n\n**KEY INSIGHTS**\n\n⭐ Most Important Discoveries:\n\n1. Engagement Correlation:\n   Creative content generates 2-3x more engagement than news posts\n\n2. Unspoken Rules:\n   Community strongly favors positive, supportive interactions and creative expression\n\n3. Influence Patterns:\n   Top comments set the tone for entire discussion threads\n\n4. Content Predictors:\n   Personal effort and creativity in posts consistently predict high engagement\n\n**ACTIONABLE RECOMMENDATIONS**\n\n📝 Content Strategy:\n• Best performing content types: Fan art, crafts, creative interpretations\n• Optimal post structure: Visual content with personal story\n• Language style: Enthusiastic, personal, supportive\n\n⏱️ Timing Strategy:\n• Best posting times: Weekday afternoons\n• Avoid posting: Early morning, late night\n\n🚫 Topics to Avoid:\n• Marketing criticism (triggers negative engagement)\n• Platform exclusivity complaints\n• Merchandise pricing discussions\n\n✅ Topics that Resonate:\n• Creative fan projects\n• Positive relationship updates\n• Album interpretation/analysis\n\n**QUESTIONS FOR DEEPER ANALYSIS**\n\n1. How does fan creativity influence community engagement compared to official content?\n2. What role does the Travis Kelce relationship play in community dynamics?\n3. How do marketing strategies affect community sentiment?\n4. What drives the strong maker culture within the community?\n5. How does platform exclusivity impact fan engagement?\n\n**SUMMARY**\n\nThe TaylorSwift subreddit demonstrates a highly engaged, creative-focused community that values personal expression and positive interaction over news sharing. The community shows strong support for fan-created content and maintains a consistently positive sentiment (0.39 average) despite occasional marketing-related controversies. The maker culture within the community drives the highest engagement rates, suggesting a unique blend of fandom and creativity.",
          "generated_at": "2025-09-15T07:17:33.196Z",
          "model_used": "Claude 3.5 Sonnet"
        },
        "synthetic_post": {
          "title": "I made a Taylor-themed Spotify wrapped visualization in my bullet journal!",
          "author": "swiftie_journaler",
          "body": "Hey fellow Swifties! I wanted to share my latest journal spread where I tracked my most-played Taylor songs throughout 2023. I used different colors for each album era (of course teal and orange for TTPD!) and made little doodles for my top songs.\n\nI was honestly shocked to see that Cruel Summer finally overtook All Too Well (10 min version) as my most played track this year. The Eras Tour really changed everything! Also included some of my favorite lyrics in tiny calligraphy around the borders.\n\nWill share close-up photos if anyone's interested in the details! 💕",
          "score": 2341,
          "upvoteRatio": 0.96,
          "comments": [
            {
              "id": "comment1",
              "author": "midnightsrarity",
              "body": "omg the way you incorporated the little vault symbols for the TV tracks!! so creative! 🔐✨",
              "score": 876,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment2",
              "author": "augustslaysforever",
              "body": "please share your supplies list!! those colors are gorgeous",
              "score": 654,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment3",
              "author": "cardigan_weather",
              "body": "Not me immediately running to start my own version of this 🏃‍♀️",
              "score": 542,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment4",
              "author": "fearlesslyricsqueen",
              "body": "Cruel Summer supremacy!! That song really said \"my time is now\" 👑",
              "score": 489,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment5",
              "author": "swiftmas_spirit",
              "body": "The way you did the 1989 TV section in that perfect blue aesthetic 💙",
              "score": 423,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment6",
              "author": "blankspacelover13",
              "body": "Bestie we need close-ups!! This is too good",
              "score": 387,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment7",
              "author": "wildestdreams89",
              "body": "i spy that tiny snake in the reputation corner 🐍",
              "score": 312,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment8",
              "author": "taylorbot13",
              "body": "Your handwriting is giving enchanted fairy tale vibes ✨",
              "score": 276,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment9",
              "author": "speak_now_bestie",
              "body": "the way you left space for TTPD... we love a prepared swiftie",
              "score": 245,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment10",
              "author": "delicatemidnight",
              "body": "tag yourself i'm the tiny cowboy hat by betty 🤠",
              "score": 198,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            }
          ],
          "subreddit": "TaylorSwift",
          "timeAgo": "4 hours ago",
          "sentiment": "positive",
          "generated_at": "2025-09-15T07:28:34.626Z",
          "version": 1
        }
      },
      "posts": [
        {
          "id": "1nee2ol",
          "title": "Gordon Ramsay congratulates Taylor and Travis on their engagement.",
          "selftext": "",
          "score": 4528,
          "num_comments": 51,
          "created_utc": 1757609713,
          "subreddit": "TaylorSwift",
          "permalink": "/r/TaylorSwift/comments/1nee2ol/gordon_ramsay_congratulates_taylor_and_travis_on/",
          "url": "https://www.reddit.com/gallery/1nee2ol",
          "author": "LonelyVaquita",
          "comments": [
            {
              "id": "ndo0rm7",
              "body": "Home ec teacher made me lol",
              "score": 918,
              "created_utc": 1757610819,
              "author": "falling-15"
            },
            {
              "id": "ndo25ub",
              "body": "That ‘bready for it’ comment is how I know he didn’t write this",
              "score": 721,
              "created_utc": 1757611208,
              "author": "New_Ant_1331"
            },
            {
              "id": "ndo3pz8",
              "body": "He had teenage daughters and seem to be funny, witty. I can believe it.",
              "score": 585,
              "created_utc": 1757611643,
              "author": "ffviire"
            },
            {
              "id": "ndo12b5",
              "body": "If he was our Teacher, all of us would be idiot sandwiches, I’m afraid 😭",
              "score": 289,
              "created_utc": 1757610902,
              "author": "Beneficial_Run8042"
            }
          ]
        },
        {
          "id": "1ndmbnw",
          "title": "Taylor Swift to release \"A Look Behind the Curtain\" video on October 3rd",
          "selftext": "",
          "score": 4317,
          "num_comments": 273,
          "created_utc": 1757529016,
          "subreddit": "TaylorSwift",
          "permalink": "/r/TaylorSwift/comments/1ndmbnw/taylor_swift_to_release_a_look_behind_the_curtain/",
          "url": "https://i.redd.it/qm4voyu3sdof1.png",
          "author": "bubblecuffer13",
          "comments": [
            {
              "id": "ndhsoeu",
              "body": "PEEK not peak, Taylornation! ",
              "score": 1672,
              "created_utc": 1757529385,
              "author": "Showmeagreysky"
            },
            {
              "id": "ndhtpr0",
              "body": "https://preview.redd.it/vjalqid3udof1.jpeg?width=1024&format=pjpg&auto=webp&s=0fd8c5f1cf7234d52b45c7e21672759f2e34f0a2\n\nThis goes so hard actually 😭 This photoshoot is such a banger!!!",
              "score": 1002,
              "created_utc": 1757529684,
              "author": "Edsbobblehead"
            },
            {
              "id": "ndi17i9",
              "body": "My interest is piqued.",
              "score": 782,
              "created_utc": 1757531779,
              "author": "spectrumhead"
            },
            {
              "id": "ndhvocb",
              "body": "It will definitely get uploaded everywhere within seconds. YouTube, TikTok, Tumblr, here. We are in the age of not actually exclusive, I encourage everyone to remember!\n\nAs for why iTunes only, they've probably been seeing digital album sales fall and are trying to figure out ways to encourage more. Marketing team gonna market, changing sales environments mean having to experiment to figure out wh...",
              "score": 580,
              "created_utc": 1757530246,
              "author": "falldiewakefly"
            }
          ]
        },
        {
          "id": "1nbuns6",
          "title": "I turned my cat into the 12 Taylor Swift album covers",
          "selftext": "I redesigned Taylor’s 12 album covers into a kitty version featuring my cat Bibi. I had lots of fun making this and thought I’d share it here. From evermeow to meownights, there’s something for every taste. I’m particularly fond of 2020 Bibi’s version (she was born in 2020) and reputashmeow. Which one do you like best?",
          "score": 4019,
          "num_comments": 135,
          "created_utc": 1757353805,
          "subreddit": "TaylorSwift",
          "permalink": "/r/TaylorSwift/comments/1nbuns6/i_turned_my_cat_into_the_12_taylor_swift_album/",
          "url": "https://i.redd.it/trhcab14bznf1.jpeg",
          "author": "auberquine",
          "comments": [
            {
              "id": "nd4kgct",
              "body": "They're all so cute! My faves are Bleb, 2020 and Meow Now",
              "score": 237,
              "created_utc": 1757355535,
              "author": "-Silver-Moonlight-"
            },
            {
              "id": "nd4mc4s",
              "body": "The Silly Kitty Department!!!! i'm dyingggg",
              "score": 183,
              "created_utc": 1757356092,
              "author": "realitygreene"
            },
            {
              "id": "nd4oldm",
              "body": "Whelp. I know what I'm doing tonight.",
              "score": 114,
              "created_utc": 1757356761,
              "author": "northofsomethingnew"
            },
            {
              "id": "nd4kpev",
              "body": "Loving him was bleb 😉 thanks so much! 🙏🏼",
              "score": 98,
              "created_utc": 1757355609,
              "author": "auberquine"
            }
          ]
        },
        {
          "id": "1neow9h",
          "title": "I made Tays Rhode Island house out of LEGO!",
          "selftext": "",
          "score": 3296,
          "num_comments": 76,
          "created_utc": 1757636149,
          "subreddit": "TaylorSwift",
          "permalink": "/r/TaylorSwift/comments/1neow9h/i_made_tays_rhode_island_house_out_of_lego/",
          "url": "https://www.reddit.com/gallery/1neow9h",
          "author": "addyloveslego",
          "comments": [
            {
              "id": "ndqgfsg",
              "body": "Omg that is stunning! Well done!!",
              "score": 188,
              "created_utc": 1757637999,
              "author": "BetterThan-i-EverWas"
            },
            {
              "id": "ndqj3zm",
              "body": "As a Lego fan and a swiftie this is amazing!!!!!!!",
              "score": 107,
              "created_utc": 1757638929,
              "author": "Cautious-Bread-9240"
            },
            {
              "id": "ndqi102",
              "body": "Thank you so much!! It took about 50 hours so far 😅",
              "score": 59,
              "created_utc": 1757638547,
              "author": "addyloveslego"
            },
            {
              "id": "ndqj8iz",
              "body": "This looks so good! I’ve seen a few people make little Lego Eras Tour stages, which are so cool, but this is next level! Do you have any other Lego projects you’re planning on building?",
              "score": 55,
              "created_utc": 1757638973,
              "author": "LennyLeonardson"
            }
          ]
        },
        {
          "id": "1nd2j2q",
          "title": "combined two of my favorite things :)",
          "selftext": "not sure if this is allowed but wanted to share my Taylor Swift inspired coloring book page! I drew in the swirl & designated each section a different album with different nods to my favorite songs (I’m not an artist though so some of the doodles aren’t drawn well lol) I’d be happy to explain any bit that doesn’t make sense because some stuff is hard to read or decipher as I’ve just started my coloring journey haha hope you like it 🫶🏼",
          "score": 3087,
          "num_comments": 136,
          "created_utc": 1757471571,
          "subreddit": "TaylorSwift",
          "permalink": "/r/TaylorSwift/comments/1nd2j2q/combined_two_of_my_favorite_things/",
          "url": "https://www.reddit.com/gallery/1nd2j2q",
          "author": "Equal_Programmer2236",
          "comments": [
            {
              "id": "nddz3i5",
              "body": "“John is a prick” for the speak now cactus 😭🤣",
              "score": 240,
              "created_utc": 1757475891,
              "author": "TayBae95"
            },
            {
              "id": "nddwir0",
              "body": "Suddenly I have an urge to get a colouring book and do this",
              "score": 107,
              "created_utc": 1757474809,
              "author": "jc-burnham"
            },
            {
              "id": "ndduocz",
              "body": "Omg this is sooo cool!! and creative!😍😍😍",
              "score": 59,
              "created_utc": 1757474061,
              "author": "reptourtaylor"
            },
            {
              "id": "nde80p1",
              "body": "yay i’m so glad you caught that one!! 😂😂",
              "score": 53,
              "created_utc": 1757479909,
              "author": "Equal_Programmer2236"
            }
          ]
        },
        {
          "id": "1nc715n",
          "title": "Teal and orange nail art inspo. Would love to see what other Swifties come up with.",
          "selftext": "",
          "score": 2196,
          "num_comments": 53,
          "created_utc": 1757384346,
          "subreddit": "TaylorSwift",
          "permalink": "/r/TaylorSwift/comments/1nc715n/teal_and_orange_nail_art_inspo_would_love_to_see/",
          "url": "https://www.reddit.com/gallery/1nc715n",
          "author": "jordan_at_work",
          "comments": [
            {
              "id": "nd7804r",
              "body": "here are my tloas inspired nails i got today!\n\nhttps://preview.redd.it/bo1ymdwb02of1.jpeg?width=2959&format=pjpg&auto=webp&s=20fc15f37463595104156be19ca7b25799f6a48d",
              "score": 91,
              "created_utc": 1757386499,
              "author": "Proper-Doubt4402"
            },
            {
              "id": "nd7a94k",
              "body": "Nowhere near as impressive and I've had them for a couple of weeks so not in the best shape but.\n\nhttps://preview.redd.it/jvrzn74032of1.jpeg?width=3000&format=pjpg&auto=webp&s=4399b5eb429048b0c9914ae3f1a04d3edb789f45",
              "score": 73,
              "created_utc": 1757387334,
              "author": "SwiftieAdjacent"
            },
            {
              "id": "nd8xlwt",
              "body": "https://preview.redd.it/mr4umqygm4of1.jpeg?width=3024&format=pjpg&auto=webp&s=e52b5526b6cc0e197a81cfb7a9b97795512a9ef2",
              "score": 60,
              "created_utc": 1757418162,
              "author": "kosherflower"
            },
            {
              "id": "nd8ub8e",
              "body": "I did a skittle this week\n\nhttps://preview.redd.it/w7n5ivz9i4of1.jpeg?width=2124&format=pjpg&auto=webp&s=b7b115877c2c2e3fcc70c1faafc24a2425ec2166",
              "score": 58,
              "created_utc": 1757416752,
              "author": "soapyrubberduck"
            }
          ]
        },
        {
          "id": "1ng0lut",
          "title": "Knit a sweater inspired by the new album and a quote from the New Heights podcast.",
          "selftext": "The colours for this sweater were inspired by the new album, the pattern is actually a sweater Princess Diana wore. I felt it encapsulated Taylors quote about energy being a luxury.",
          "score": 2160,
          "num_comments": 67,
          "created_utc": 1757777879,
          "subreddit": "TaylorSwift",
          "permalink": "/r/TaylorSwift/comments/1ng0lut/knit_a_sweater_inspired_by_the_new_album_and_a/",
          "url": "https://www.reddit.com/gallery/1ng0lut",
          "author": "MrsCoffeeMan",
          "comments": [
            {
              "id": "ne0trq7",
              "body": "This is absolutely stunning work, OP! And what a vibe to give it the Princess Diana treatment it deserves as well! (Also, is there a link to that sweater pattern? 👀) Very well done, indeed! 🫶",
              "score": 226,
              "created_utc": 1757783101,
              "author": "vanetti"
            },
            {
              "id": "ne0qaq7",
              "body": "Oh holy shit WOW",
              "score": 76,
              "created_utc": 1757782071,
              "author": "clementine_nails"
            },
            {
              "id": "ne116hv",
              "body": "Girl, do you SLEEP??? This is absolutely stunning and I can only imagine the hard work. Congratulations!",
              "score": 71,
              "created_utc": 1757785267,
              "author": "squilliamfancyson837"
            },
            {
              "id": "ne1nj69",
              "body": "Almost forgot about this image thank you for the reminder\n\nhttps://preview.redd.it/2savup84izof1.jpeg?width=474&format=pjpg&auto=webp&s=cb4eb7b14efdb90cd2c6c7c2fce128bbe7c522b4",
              "score": 57,
              "created_utc": 1757791966,
              "author": "dagger-mmc"
            }
          ]
        },
        {
          "id": "1nf2o70",
          "title": "Eras Tour book discovery",
          "selftext": "I was recently looking through the Eras Tour book and just happened to read the Tortured Poets Department section and I saw what might’ve been a hint to her new album! Idk if it’s been posted before but I just cool I saw it! ",
          "score": 1540,
          "num_comments": 48,
          "created_utc": 1757682204,
          "subreddit": "TaylorSwift",
          "permalink": "/r/TaylorSwift/comments/1nf2o70/eras_tour_book_discovery/",
          "url": "https://i.redd.it/oy71r52mfqof1.jpeg",
          "author": "wannabezookeeper",
          "comments": [
            {
              "id": "ndun3ov",
              "body": "I feel like the whole ICDIWABH performance was an Easter egg for Showgirl!! 💃🎩",
              "score": 679,
              "created_utc": 1757697745,
              "author": "The_Anchored_Tree_27"
            },
            {
              "id": "ndui9mu",
              "body": "I figured there were some clues in there but didnt want to look myself. Thanks for your service",
              "score": 346,
              "created_utc": 1757696335,
              "author": "NoApostrophees"
            },
            {
              "id": "nduhsjf",
              "body": "Nice easter egg... \n\nThe issue is that Taylor Swift's easter eggs tend to be obvious. Something like this might be coincidental. That said, Taylor Swift referring to herself as a showgirl might not be that new.",
              "score": 121,
              "created_utc": 1757696198,
              "author": "Femto-Griffith"
            },
            {
              "id": "ndvc12t",
              "body": "She most likely had concepts in place like the theme for quite some time, and just wrote the music itself during that time.",
              "score": 119,
              "created_utc": 1757705013,
              "author": "monicagellers"
            }
          ]
        },
        {
          "id": "1nh32ei",
          "title": "The Tayrealm sisters on their way to Showland",
          "selftext": "",
          "score": 1380,
          "num_comments": 40,
          "created_utc": 1757884351,
          "subreddit": "TaylorSwift",
          "permalink": "/r/TaylorSwift/comments/1nh32ei/the_tayrealm_sisters_on_their_way_to_showland/",
          "url": "https://i.redd.it/l2wleuzo47pf1.jpeg",
          "author": "Lyd_Euh",
          "comments": [
            {
              "id": "ne8mnmq",
              "body": "Lol evermore steering cause she got her boating license when she was fifteen!",
              "score": 393,
              "created_utc": 1757884884,
              "author": "champagneproblem13"
            },
            {
              "id": "ne8mb6d",
              "body": "Love the orange mermaid fin as a nod to Showgirl, since the album cover makes Taylor look like a mermaid.",
              "score": 146,
              "created_utc": 1757884780,
              "author": "FlubbyStarfish"
            },
            {
              "id": "ne8nmxj",
              "body": "A part of me wishes Taylor and her team would collaborate with creators like Alef. I’d love to see a comic book series, even a limited one, featuring personified albums. Also, the merch would probably rock sooooo hard.",
              "score": 128,
              "created_utc": 1757885177,
              "author": "Kuradapya"
            },
            {
              "id": "ne8l82t",
              "body": "This is amazing!\n\nThank you, Alef Vernon!\n\nSome Narnia vibes here.",
              "score": 74,
              "created_utc": 1757884446,
              "author": "Femto-Griffith"
            }
          ]
        },
        {
          "id": "1ngwuly",
          "title": "Travis on Taylor: “She has brought excitement and a joy for life that has made me a better man, a better person, and made me just that much more comfortable in who I am.\" [to Erin Andrews]",
          "selftext": "",
          "score": 1311,
          "num_comments": 45,
          "created_utc": 1757869842,
          "subreddit": "TaylorSwift",
          "permalink": "/r/TaylorSwift/comments/1ngwuly/travis_on_taylor_she_has_brought_excitement_and_a/",
          "url": "https://v.redd.it/qtu6p1eex5pf1",
          "author": "Confident-Addition76",
          "comments": [
            {
              "id": "ne7i9f8",
              "body": "https://preview.redd.it/dikpaxrg86pf1.jpeg?width=1170&format=pjpg&auto=webp&s=36eebbf3e9335004e6655276108c69405d45f47f\n\nHonestly same tho",
              "score": 519,
              "created_utc": 1757873520,
              "author": "winedrunktaylor"
            },
            {
              "id": "ne7j998",
              "body": "Ohh 🫠 I saw another clip, when he talked about engagement and that he’s emotional guy, so there were tears. It seems like they cry a lot but they’re so productive it’s an art ❤️‍🔥 good for sensitive and emotional people find each other",
              "score": 365,
              "created_utc": 1757873795,
              "author": "Beneficial_Run8042"
            },
            {
              "id": "ne7oqi0",
              "body": "This is how my partner and I feel about eachother. If you are young and reading this, regardless of gender - you deserve this. Don't settle for less than this!",
              "score": 237,
              "created_utc": 1757875344,
              "author": "GrumpyFinn"
            },
            {
              "id": "ne7jg59",
              "body": "I'd cry too if I was engaged to Taylor",
              "score": 153,
              "created_utc": 1757873848,
              "author": "TheFALLofLindsay"
            }
          ]
        },
        {
          "id": "1nfhie6",
          "title": "New count page is unlocked!",
          "selftext": "On the TS site!",
          "score": 1198,
          "num_comments": 624,
          "created_utc": 1757717642,
          "subreddit": "TaylorSwift",
          "permalink": "/r/TaylorSwift/comments/1nfhie6/new_count_page_is_unlocked/",
          "url": "https://i.redd.it/b1bdrnmzctof1.jpeg",
          "author": "Kyip_taylorversion",
          "comments": [
            {
              "id": "ndwin4j",
              "body": "I just said this in the countdown thread, but I’m going to say it again:\n\nTaylor’s marketing team is grossly overestimating what is worth the hype of a countdown. \n\nI love Taylor’s music. But I’m not going to lose my mind over her moving slightly in a 3 second clip. \n\nI’m starting to feel slightly insulted. Like I will never be a big enough fan of anything to get excited about a clip like that. \n\n...",
              "score": 4783,
              "created_utc": 1757718443,
              "author": "shakeyshake1"
            },
            {
              "id": "ndwh3bx",
              "body": "It’s just … that little clip? 🫠",
              "score": 1616,
              "created_utc": 1757717896,
              "author": "backpackeditor"
            },
            {
              "id": "ndwk66z",
              "body": "This is so real, I find I’m not really able to take these things seriously anymore. Including the one today, I was totally checked out because I didn’t really think it would be anything meaningful, and here we are. Still super excited for the record, but I’m tired of counting down to nothingburgers haha",
              "score": 1128,
              "created_utc": 1757718975,
              "author": "spikepoint"
            },
            {
              "id": "ndwh5bn",
              "body": "Not a two day countdown for this 😩",
              "score": 1012,
              "created_utc": 1757717916,
              "author": "officialsarah"
            }
          ]
        },
        {
          "id": "1ngh9lj",
          "title": "KC Corn Maze 💍",
          "selftext": "",
          "score": 1204,
          "num_comments": 23,
          "created_utc": 1757822215,
          "subreddit": "TaylorSwift",
          "permalink": "/r/TaylorSwift/comments/1ngh9lj/kc_corn_maze/",
          "url": "https://i.redd.it/0cwf3sqxz1pf1.jpeg",
          "author": "Own-Bass-1470",
          "comments": [
            {
              "id": "ne4vube",
              "body": "Wow KC really is the biggest swiftie",
              "score": 162,
              "created_utc": 1757838632,
              "author": "macdgman"
            },
            {
              "id": "ne6osk8",
              "body": "Kansas City farms do Chiefs related corn field art every year.",
              "score": 70,
              "created_utc": 1757865468,
              "author": "BillNyeTheEngineer"
            },
            {
              "id": "ne64ab9",
              "body": "I can't decide if this is really cute or really weird. Maybe somehow both?",
              "score": 65,
              "created_utc": 1757859249,
              "author": "naomigoat"
            },
            {
              "id": "ne5l28u",
              "body": "You don't grow the maze. You grow a field of corn then hack a maze into it after harvest.",
              "score": 57,
              "created_utc": 1757852285,
              "author": "MidnightSlinks"
            }
          ]
        }
      ]
    }
  },
  {
    "id": "mfkrznixb5hncsq2i",
    "generated_at": "2025-09-15T07:01:21.753Z",
    "name": "r/formula1 Racing Discussion",
    "description": "Analysis of Formula 1 racing fans discussing races, drivers, team strategies, and championship battles.",
    "subreddits": [
      "formula1"
    ],
    "dateRange": {
      "startDate": "2025-09-07",
      "endDate": "2025-09-14"
    },
    "totalPosts": 23,
    "totalComments": 3588,
    "data": {
      "summary": {
        "totalPosts": 23,
        "totalComments": 3588,
        "subreddits": [
          "formula1"
        ],
        "dateRange": {
          "startDate": "2025-09-07",
          "endDate": "2025-09-14"
        }
      },
      "analysis": {
        "overall_sentiment": {
          "average_score": 0.55,
          "sentiment_distribution": {
            "positive": 65,
            "neutral": 25,
            "negative": 10
          },
          "dominant_themes": [
            "race",
            "competition",
            "team",
            "performance",
            "victory",
            "strategy",
            "season"
          ],
          "key_emotions": [
            "excitement",
            "competitive",
            "passionate",
            "intense",
            "pride"
          ],
          "summary": "The overall sentiment is neutral (positive 39%). Key themes include: racing, criticism, performance."
        },
        "individual_scores": [
          {
            "index": 1,
            "score": -0.7,
            "sentiment": "negative",
            "confidence": 0.9,
            "themes": [
              "harassment",
              "mechanic",
              "safety"
            ],
            "emotions": [],
            "source": {
              "type": "post_title",
              "postId": "1nbkbe4",
              "subreddit": "formula1"
            }
          },
          {
            "index": 2,
            "score": -0.6,
            "sentiment": "negative",
            "confidence": 0.85,
            "themes": [
              "abuse",
              "moderation",
              "community"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1nbkbe4",
              "commentId": "nd2fprz",
              "subreddit": "formula1"
            }
          },
          {
            "index": 3,
            "score": -0.3,
            "sentiment": "negative",
            "confidence": 0.7,
            "themes": [
              "skepticism",
              "data",
              "accuracy"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1nbkbe4",
              "commentId": "nd2conv",
              "subreddit": "formula1"
            }
          },
          {
            "index": 4,
            "score": -0.4,
            "sentiment": "negative",
            "confidence": 0.8,
            "themes": [
              "misinformation",
              "AI",
              "accuracy"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1nbkbe4",
              "commentId": "nd2d5wv",
              "subreddit": "formula1"
            }
          },
          {
            "index": 5,
            "score": -0.8,
            "sentiment": "negative",
            "confidence": 0.9,
            "themes": [
              "misinformation",
              "discourse",
              "AI"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1nbkbe4",
              "commentId": "nd2g4y1",
              "subreddit": "formula1"
            }
          }
        ],
        "by_subreddit": {
          "formula1": {
            "scores": [
              -0.7,
              -0.6,
              -0.3,
              -0.4,
              -0.8,
              -0.5,
              -0.6,
              -0.5,
              0.2,
              0.3,
              0.2,
              -0.4,
              -0.6,
              -0.7,
              -0.8,
              -0.7,
              -0.5,
              -0.6,
              0.2,
              -0.4,
              -0.3,
              0.3,
              -0.6,
              -0.5,
              -0.8,
              -0.4,
              -0.3,
              -0.5,
              -0.6,
              -0.7,
              -0.4,
              0.1,
              0.2,
              0.3,
              0.2,
              0.1,
              -0.3,
              -0.6,
              -0.7,
              -0.5,
              -0.7,
              -0.4,
              -0.6,
              -0.4,
              -0.5,
              -0.5,
              -0.4,
              0.2,
              0.4,
              -0.2,
              -0.7,
              0.6,
              -0.6,
              -0.8,
              0.3,
              -0.2,
              -0.8,
              -0.4,
              -0.7,
              -0.6,
              -0.5,
              -0.4,
              -0.3,
              0.2,
              -0.6,
              -0.5,
              -0.4,
              -0.3,
              -0.6,
              -0.8,
              0.8,
              -0.6,
              0.3,
              -0.7,
              0.4,
              -0.2,
              -0.4,
              -0.7,
              -0.3,
              -0.5,
              0.3,
              -0.5,
              -0.4,
              0.9,
              0.6,
              0.8,
              -0.3,
              -0.4,
              -0.2,
              0.3,
              -0.4,
              0.2,
              0.6,
              0,
              0.2,
              0.1,
              -0.3,
              -0.2,
              -0.4,
              0.7,
              -0.5,
              0,
              -0.4,
              -0.6,
              -0.4,
              -0.7,
              -0.3,
              -0.2,
              0.1,
              -0.5,
              -0.6,
              -0.5,
              -0.6,
              -0.4,
              -0.8,
              -0.3,
              -0.6,
              -0.4,
              -0.3,
              -0.5,
              -0.7,
              -0.2,
              0.8,
              0.7,
              0.2,
              -0.2,
              0,
              0.3,
              0.2,
              0,
              0,
              0.1,
              0.4,
              -0.4,
              0.2,
              0.8,
              0.7,
              0.8,
              0.3,
              -0.4,
              -0.5,
              0.4,
              -0.2,
              -0.6,
              -0.3,
              0.4,
              0.6,
              0.3,
              0.8,
              0.5,
              0.2,
              0.1,
              0,
              0.2,
              0,
              0.6,
              0.7,
              -0.2,
              0.1,
              0.5,
              0.2,
              0.6,
              0.4,
              0.3,
              0.4,
              0.5,
              0.3,
              -0.2,
              0.2,
              0.1,
              0,
              0.1,
              0.4,
              0.3,
              0.8,
              0.7,
              0.8,
              0.6,
              0.5,
              -0.3,
              0.8,
              -0.2,
              0.3,
              -0.2,
              0,
              0.2,
              0.8,
              -0.2,
              0.9,
              0.8,
              0.9,
              0.9,
              0,
              0.6,
              0.7,
              0.2,
              0.6,
              0.8,
              0.3,
              0.4,
              0.8,
              0.7,
              0.5,
              0.9,
              0.9,
              0.8,
              0.6,
              0.7,
              0.3,
              0.7,
              0.5,
              0.8,
              0.7,
              0.6,
              0.9,
              0.8,
              0.6,
              0.3,
              0.4,
              0,
              0.7,
              0.9,
              0.6,
              -0.5,
              0.3,
              0.2,
              0.3,
              0,
              0.4,
              0.3,
              0.8,
              0.8,
              0.9,
              0.4,
              0.7,
              0.3,
              0.8,
              0.9,
              0.1,
              0,
              0,
              0.9,
              -0.7,
              -0.6,
              -0.4,
              0,
              -0.2,
              -0.8,
              0,
              0,
              0.2,
              0.3,
              0.7,
              -0.6,
              0,
              0,
              0.5,
              0.2,
              0.6,
              0.7,
              0.2,
              -0.3,
              0,
              0.2,
              0.4,
              0,
              -0.7,
              -0.3,
              -0.2,
              -0.4,
              0.6,
              0,
              0,
              0.6,
              0,
              -0.6,
              0.4,
              -0.5,
              -0.2,
              0,
              0.3,
              0.2,
              0.4,
              0.3,
              0.4,
              0.3,
              0.4,
              0.2,
              0.2,
              0.3,
              -0.3,
              0.2,
              0.3,
              0.4,
              0.4,
              0.6,
              0.8,
              -0.1,
              0.5,
              0.1,
              -0.2,
              0.4,
              0.3,
              0.7,
              0.5,
              -0.4,
              0.2,
              0.3,
              0.2,
              0.3,
              0.4,
              0.2,
              0.2,
              0.2,
              0.4,
              0.3,
              0.4,
              -0.3,
              0.5,
              0.6,
              0.4,
              0.3,
              0.4,
              0.6,
              0.2,
              0.7,
              0.3,
              0.4,
              0.8,
              0.5,
              0.6,
              0.8,
              0.2,
              0.4,
              0.5,
              0.7,
              0.3,
              0.8,
              0.4,
              0.2,
              0.6,
              -0.3,
              0.2,
              -0.2,
              0.1,
              0.7,
              0.4,
              0.8,
              0.5,
              0.6,
              0.5,
              0,
              0.4,
              0.3,
              0.8,
              0.3,
              0.6,
              0.3,
              0.5,
              0,
              0.6,
              0.7,
              0.2,
              0.4,
              0.5,
              0.6,
              0.5,
              0.3,
              0.4,
              0.2,
              0.5,
              0.7,
              0.3,
              0.6,
              0.4,
              0.5,
              0.2,
              0.1,
              0.7,
              0,
              0.4,
              0.1,
              -0.2,
              -0.4,
              0.8,
              0,
              -0.3,
              0.9,
              0,
              0,
              0.6,
              0.8,
              -0.6,
              0.2,
              0.3,
              -0.2,
              0,
              0.5,
              -0.4,
              -0.3,
              0.7,
              0.3,
              0.6,
              -0.4,
              -0.5,
              -0.3,
              0,
              0.8,
              0.4,
              0.6,
              0.3,
              0.5,
              0.6,
              0.7,
              0.2,
              0.4,
              0.5,
              0.4,
              0.3,
              0.5,
              0,
              0,
              0,
              0,
              0.3,
              0.5,
              0.4,
              0.8,
              0.7,
              0.4,
              0.7,
              0.8,
              0.7,
              0.6,
              0,
              0.4,
              -0.2,
              -0.3,
              -0.4,
              0.6,
              0.3,
              0.1,
              0.5,
              0.7,
              0.8,
              0.4,
              0.3,
              0.4,
              0.5,
              0.2,
              0.6,
              0,
              0.2,
              0.8,
              0.4,
              0.5,
              -0.2,
              0.9,
              0.3,
              0.8,
              0.7,
              0.6,
              0.2,
              0.1,
              0.6,
              0.5,
              0.4,
              0.3,
              0.2,
              0.4,
              -0.3,
              0.1,
              0.7,
              0.5,
              0.6,
              0.2,
              0.8,
              0.4,
              0.7,
              0.2,
              0,
              0.5,
              0.1,
              0.2,
              0.6,
              -0.2,
              -0.1,
              0.2,
              0.8,
              -0.8,
              -0.3,
              0.2,
              -0.2,
              0.3,
              0.7,
              0,
              0.5,
              0,
              0.2,
              0.6,
              0.3,
              0.8,
              0.6,
              0.4,
              0.5,
              0,
              0.2,
              0.4,
              0.1,
              0,
              0.4,
              0.3,
              0.4,
              0,
              0.2,
              -0.3,
              0.8,
              -0.2,
              0,
              0.7,
              0.5,
              0.4,
              0.6,
              -0.2,
              -0.3,
              -0.2,
              0,
              0.1,
              0,
              0.4,
              0,
              0,
              0.1,
              0,
              -0.1,
              0,
              0.2,
              -0.3,
              0,
              0,
              0.1,
              0.2,
              0,
              -0.2,
              0.3,
              0.4,
              0.2,
              -0.5,
              0.1,
              0.3,
              0.4,
              0.5,
              0.6,
              0.1,
              0,
              0.4,
              0.3,
              -0.3,
              0.2,
              0,
              0.3,
              -0.2,
              0.2,
              0.3,
              0.2,
              0.4,
              -0.2,
              0.5,
              0.1,
              0.3,
              0.2,
              -0.2,
              0,
              -0.1,
              -0.4,
              -0.2,
              0,
              0.1,
              0,
              -0.3,
              -0.2,
              0,
              -0.4,
              -0.7,
              0.2,
              0,
              -0.2,
              -0.3,
              0.1,
              0,
              0,
              -0.3,
              0.2,
              -0.8,
              -0.6,
              0,
              -0.2,
              0,
              -0.3,
              0.7,
              0.3,
              0.2,
              0.1,
              0.6,
              0.7,
              0,
              0,
              0,
              -0.1,
              0,
              0,
              0.6,
              -0.3,
              0.4,
              -0.4,
              0.5,
              -0.2,
              -0.5,
              -0.3,
              -0.4,
              0.4,
              0.3,
              -0.2,
              0.2,
              0,
              0,
              0,
              0,
              0.4,
              0,
              0.6,
              -0.7,
              0,
              -0.3,
              0.4,
              0,
              0.6,
              -0.2,
              0.3,
              0,
              -0.3,
              -0.2,
              -0.6,
              -0.4,
              0,
              0,
              0.8,
              0.2,
              0.3,
              0.2,
              0.4,
              0.3,
              -0.2,
              -0.3,
              0,
              0,
              0.5,
              0.7,
              0.4,
              0.3,
              -0.2,
              -0.3,
              0,
              -0.4,
              0.2,
              -0.5,
              0.7,
              0,
              0,
              0,
              0,
              0.2,
              0,
              -0.6,
              0.2,
              0,
              -0.2,
              -0.4,
              -0.2,
              0,
              0.7,
              0.6,
              0,
              -0.3,
              -0.4,
              -0.2,
              0.2,
              -0.6,
              0.4,
              -0.3,
              -0.8,
              0,
              -0.7,
              -0.4,
              -0.9,
              -0.6,
              -0.3,
              0,
              -0.7,
              -0.2,
              -0.5,
              -0.6,
              0,
              -0.4,
              0.3,
              -0.5,
              0.4,
              0,
              0.2,
              0,
              -0.2,
              0.2,
              0.3,
              0,
              -0.2,
              0,
              0.6,
              0.7,
              0,
              0,
              0,
              0.2,
              0,
              0,
              -0.2,
              0,
              0.4,
              0,
              0.6,
              0,
              0.8,
              0,
              0.2,
              0,
              0.4,
              0.5,
              0.3,
              0.8,
              0,
              -0.2,
              0.4,
              0.1,
              -0.1,
              0.6,
              -0.2,
              0.9,
              0.3,
              -0.1,
              0.4,
              0.3,
              0.2,
              0,
              0.1,
              0,
              -0.3,
              0.6,
              -0.1,
              0.2,
              0.7,
              -0.4,
              0.2,
              -0.2,
              0,
              0,
              0,
              0.1,
              0,
              -0.4,
              0.2,
              0.4,
              -0.1,
              -0.6,
              0.3,
              0,
              0.2,
              0.5,
              0.4,
              0.8,
              0.4,
              0.6,
              0,
              -0.2,
              0.3,
              -0.3,
              0,
              -0.2,
              0.8,
              -0.3,
              0.4,
              0.1,
              0.6,
              0,
              0.3,
              0.7,
              0.6,
              0.4,
              -0.2,
              0,
              -0.1,
              0.7,
              0,
              0,
              0.4,
              -0.5,
              -0.2,
              -0.1,
              0,
              0.8,
              0.4,
              0.2,
              0,
              0,
              0,
              0.3,
              0.5,
              0,
              -0.2,
              0.3,
              0.6,
              0,
              0.4,
              0.1,
              0.1,
              0.1,
              0.2,
              0.4,
              0.2,
              0.1,
              -0.6,
              0.3,
              0.2,
              -0.1,
              0.4,
              -0.1,
              0,
              -0.4,
              0.4,
              0.2,
              0.1,
              0.3,
              0.2,
              0.1,
              -0.3,
              0,
              0.1,
              0.8,
              0.2,
              -0.6,
              0.2,
              0,
              0.4,
              0.2,
              -0.2,
              0.6,
              0.2,
              0.1,
              0,
              0.8,
              -0.3,
              -0.2,
              0.1,
              0,
              0.3,
              0.4,
              0.3,
              0.4,
              0.5,
              0.3,
              0.1,
              -0.2,
              0.5,
              0,
              0.1,
              0,
              0,
              0.6,
              0.5,
              0.1,
              0.2,
              0.3,
              0.4,
              0.7,
              0.4,
              0,
              0.6,
              0.8,
              -0.2,
              0.3,
              0,
              0,
              0,
              -0.4,
              -0.6,
              0,
              0,
              0.4,
              0.5,
              0.3,
              0.8,
              -0.2,
              0,
              0,
              0,
              0,
              0.4,
              -0.2,
              -0.3,
              0.6,
              0.2,
              0,
              0,
              0,
              0.4,
              0,
              -0.3,
              0.5,
              0,
              0.4,
              0.4,
              0.3,
              0.7,
              0.2,
              0,
              0.3,
              0.8,
              0.4,
              0.4,
              0.2,
              0.2,
              0.3,
              0.5,
              0.6,
              0.4,
              0.6,
              0.5,
              -0.6,
              -0.6,
              -0.7,
              -0.4,
              -0.9,
              -0.7,
              -0.3,
              -0.4,
              0.2,
              -0.8,
              -0.3,
              -0.4,
              0.7,
              0.1,
              0.2,
              0,
              0.6,
              0,
              -0.8,
              0.7,
              0.1,
              -0.1,
              0,
              0,
              0.8,
              -0.3,
              -0.5,
              0.7,
              -0.4,
              0.3,
              0.2,
              0,
              0.4,
              0.6,
              0.3,
              -0.3,
              -0.2,
              0.4,
              0.2,
              0.3,
              0.2,
              -0.1,
              0.2,
              0.1,
              0.2,
              0.3,
              0,
              0.4,
              -0.1,
              0.3,
              0.2,
              0.6,
              0.1,
              0.4,
              0.7,
              0.8,
              0.3,
              0.9,
              0.7,
              0,
              0.6,
              0.1,
              0.8,
              0,
              0.4,
              0.1,
              0.5,
              0.3,
              0,
              0.4,
              -0.2,
              0,
              -0.3,
              -0.1,
              -0.2,
              -0.1,
              0,
              0,
              0,
              -0.1,
              0.4,
              -0.3,
              0,
              -0.2,
              0,
              0.6,
              -0.2,
              0,
              0,
              0.4,
              0.5,
              0.4,
              -0.1,
              0,
              -0.4,
              -0.3,
              -0.2,
              0.2,
              0.3,
              0,
              0,
              0.6,
              -0.2,
              -0.3,
              0.4,
              0.1,
              -0.4,
              -0.3,
              0.2,
              -0.5,
              -0.4,
              -0.6,
              -0.5,
              -0.5,
              0.2,
              -0.4,
              0.6,
              0.1,
              0.8,
              0.4,
              0,
              0.3,
              -0.6,
              0.2,
              0.1,
              -0.2,
              -0.3,
              -0.5,
              -0.6,
              -0.7,
              -0.4,
              -0.6,
              -0.3,
              -0.1,
              0.4,
              0.5,
              -0.8,
              0.3,
              -0.5,
              -0.6,
              -0.4,
              0.1,
              0.2,
              0.4,
              0,
              -0.3,
              0.2,
              0.3,
              0.4,
              0.7,
              -0.4,
              -0.2,
              0.2,
              0.4,
              -0.3,
              0.3,
              -0.2,
              0.4,
              0.2,
              0.5,
              0.1,
              -0.4,
              -0.2,
              0.3,
              -0.4,
              0.2,
              -0.3,
              0.3,
              -0.5,
              -0.3,
              0.2,
              0.1,
              0.4,
              0.6,
              0.2,
              -0.3,
              0.3,
              0.4,
              0.5,
              0.4,
              -0.2,
              0.6,
              -0.4,
              -0.3,
              0.5,
              0.1,
              0.3,
              0.2,
              0.3,
              0.1,
              0.2,
              -0.4,
              0.7,
              -0.5,
              0.2,
              0.1,
              -0.3,
              -0.6,
              0.8,
              0.2,
              0,
              -0.3,
              -0.6,
              -0.4,
              -0.5,
              -0.4,
              0.4,
              0.2,
              -0.2,
              -0.7,
              0.3,
              0.4,
              -0.5,
              -0.3,
              -0.4,
              0.1,
              0.2,
              -0.1,
              -0.4,
              0.1,
              0,
              0.6,
              0.7,
              0.8,
              0.6,
              -0.2,
              0,
              -0.3,
              -0.2,
              0.2,
              0.1,
              0,
              -0.2,
              0.1,
              0.2,
              0.3,
              -0.6,
              0.4,
              0.1,
              0,
              0.2,
              0.1,
              0,
              0.4,
              0.3,
              0.4,
              0.5,
              0.2,
              0.3,
              0.4,
              0.3,
              0.2,
              -0.6,
              0.6,
              0,
              0,
              -0.2,
              -0.3,
              0.2,
              -0.2,
              -0.4,
              0.7,
              0.6,
              0.3,
              -0.1,
              0,
              0.8,
              -0.2,
              0.2,
              0.7,
              0.8,
              0.3,
              -0.5,
              -0.3,
              -0.2,
              -0.3,
              0.1,
              0.4,
              -0.8,
              -0.2,
              -0.4,
              0,
              0.6,
              -0.6,
              -0.7,
              0.5,
              0.6,
              -0.4,
              -0.5,
              0,
              0.2,
              0.1,
              0.2,
              -0.3,
              -0.4,
              -0.2,
              0.6,
              0.5,
              0.7,
              0.8,
              0.6,
              0.7,
              0.8,
              0.6,
              0.5,
              0.6,
              -0.3,
              0.2,
              0.3,
              0.8,
              0.9,
              0,
              0.4,
              -0.2,
              0.6,
              0.7,
              0.6,
              0.8,
              0.7,
              0.7,
              0.8,
              0.7,
              -0.5,
              0.9,
              0.7,
              0.6,
              0,
              -0.3,
              0.6,
              0.7,
              0.8,
              0.7,
              0.3,
              0.6,
              0.7,
              0.6,
              -0.2,
              0.8,
              0.3,
              0.9,
              -0.4,
              0.8,
              0.8,
              -0.6,
              0,
              0.7,
              -0.2,
              0.5,
              0.8,
              0.6,
              0.7,
              0.8,
              0.6,
              -0.2,
              0.5,
              0.9,
              0.8,
              0,
              0.4,
              0.9,
              -0.2,
              0.8,
              0.3,
              0,
              0.4,
              0.2,
              0.3,
              0.5,
              0.7,
              0.7,
              0.9,
              -0.3,
              -0.4,
              0.6,
              0.4,
              0.9,
              0.8,
              0.8,
              -0.6,
              -0.2,
              0.5,
              0.7,
              -0.3,
              -0.7,
              -0.5,
              -0.2,
              0.6,
              0.2,
              0.4,
              0.8,
              -0.6,
              0,
              -0.1,
              0.5,
              0.8,
              0.5,
              0.3,
              0,
              0.7,
              0.6,
              -0.5,
              -0.2,
              0.3,
              -0.4,
              -0.1,
              -0.5,
              0.2,
              -0.3,
              0.6,
              -0.2,
              0.4,
              -0.3,
              0.1,
              -0.2,
              0,
              -0.4,
              0.8,
              0.7,
              0.6,
              -0.3,
              -0.3,
              0,
              -0.2,
              -0.7,
              0,
              -0.3,
              0.3,
              -0.6,
              0.4,
              0.1,
              -0.1,
              -0.2,
              -0.8,
              -0.5,
              -0.3,
              -0.2,
              0,
              -0.3,
              0.3,
              -0.4,
              -0.7,
              -0.2,
              0.4,
              0,
              0.5,
              -0.1,
              0.7,
              0.6,
              0.1,
              -0.2,
              0.6,
              0.3,
              0.2,
              0,
              0.4,
              0.6,
              0.3,
              -0.1,
              0.1,
              0.4,
              0.3,
              0.2,
              0,
              0.2,
              0.4,
              -0.3,
              -0.2,
              -0.4,
              0.5,
              0.2,
              -0.2,
              0.1,
              -0.1,
              0.2,
              0.3,
              0.4,
              0.8,
              0.6,
              0.9,
              -0.2,
              0.6,
              0.3,
              -0.3,
              -0.4,
              0.2,
              0.1,
              -0.2,
              0.4,
              0.5,
              -0.3,
              0.2,
              0.3,
              0.4,
              0.6,
              0.5,
              0.6,
              0.7,
              0.8,
              0.5,
              0.4,
              0.5,
              0.2,
              -0.2,
              0.8,
              0.3,
              0.7,
              0.4,
              0,
              0.3,
              0,
              0.2,
              0,
              -0.2,
              -0.3,
              -0.4,
              0.2,
              0,
              0.9,
              0.6,
              0,
              0,
              0.2,
              0.4,
              -0.2,
              0.2,
              -0.3,
              0.4,
              0.8,
              0.4,
              0.5,
              -0.2,
              0,
              -0.4,
              0,
              0,
              0.6,
              0.7,
              -0.2,
              -0.3,
              0,
              -0.4,
              0.7,
              0.6,
              0.2,
              0.2,
              0.3,
              0,
              0.3,
              0.4,
              0.5,
              0.6,
              0.6,
              0.7,
              0.8,
              0,
              0.6,
              0.9,
              0.5,
              0,
              0.4,
              0.8,
              0.8,
              0.2,
              0.4,
              0,
              -0.3,
              0,
              -0.2,
              0,
              0.3,
              0.5,
              0.2,
              0,
              0.8,
              -0.2,
              -0.7,
              0.3,
              0.2,
              0.6,
              0.4,
              0.3,
              0.1,
              -0.2,
              -0.3,
              0.4,
              -0.4,
              0.2,
              0.1,
              -0.1,
              0.5,
              0,
              0,
              0.2,
              0.7,
              0.8,
              0.9,
              0.3,
              -0.2,
              0.4,
              -0.1,
              0.2,
              0.1,
              0.4,
              0.3,
              0.6,
              -0.3,
              0,
              -0.2,
              0.2,
              0.5,
              0.4,
              0.4,
              -0.5,
              0.2,
              0.3,
              0.4,
              0.1,
              0.2,
              -0.3,
              -0.4,
              0,
              -0.2,
              -0.5,
              -0.1,
              -0.3,
              0.3,
              0.4,
              -0.2,
              -0.7,
              -0.4,
              0.2,
              -0.3,
              -0.4,
              -0.3,
              -0.5,
              -0.3,
              -0.4,
              -0.2,
              -0.6,
              0,
              0,
              0.1,
              0.2,
              -0.2,
              -0.3,
              -0.5,
              -0.7,
              0.1,
              0,
              -0.1,
              -0.5,
              -0.4,
              0.2,
              -0.3,
              -0.6,
              0.1,
              0.2,
              0.1,
              0.3,
              0,
              -0.4,
              0.3,
              -0.2,
              -0.3,
              -0.2,
              -0.3,
              0,
              -0.2,
              -0.3,
              -0.6,
              0.2,
              -0.2,
              -0.3,
              0,
              -0.6,
              -0.4,
              -0.3,
              0.2,
              -0.2,
              -0.5,
              0,
              -0.1,
              -0.3,
              -0.4,
              -0.2,
              -0.3,
              0.1,
              0.4,
              -0.2,
              -0.3,
              -0.2,
              0.6,
              -0.5,
              -0.4,
              0,
              0,
              -0.1,
              -0.4,
              -0.5,
              -0.6,
              -0.3,
              0.2,
              -0.3,
              -0.4,
              -0.3,
              -0.4,
              -0.3,
              0.1,
              -0.1,
              0.2,
              -0.4,
              -0.1,
              -0.3,
              0,
              -0.2,
              -0.2,
              -0.3,
              -0.2,
              -0.3,
              0.1,
              0,
              0.2,
              -0.3,
              0,
              -0.7,
              -0.8,
              -0.2,
              0.3,
              -0.4,
              -0.3,
              0.4,
              0,
              0,
              0.1,
              0,
              -0.1,
              0.2,
              -0.3,
              -0.4,
              -0.5,
              0.3,
              -0.3,
              0.2,
              -0.6,
              -0.2,
              -0.3,
              0.4,
              -0.2,
              0.1,
              -0.2,
              0,
              0.1,
              0.2,
              0.6,
              0.1,
              0,
              0,
              0.2,
              0.3,
              -0.4,
              0,
              0,
              -0.1,
              0.1,
              0,
              -0.2,
              -0.8,
              -0.2,
              -0.3,
              -0.9,
              -0.1,
              0.2,
              -0.3,
              0.4,
              0.8,
              0.3,
              0.5,
              -0.4,
              -0.6,
              -0.3,
              -0.4,
              0.2,
              -0.1,
              -0.2,
              0,
              0.6,
              -0.2,
              0.1,
              0.3,
              0,
              0,
              -0.2,
              -0.4,
              -0.3,
              0,
              -0.2,
              0,
              -0.1,
              -0.4,
              -0.2,
              -0.1,
              -0.5,
              0,
              0,
              -0.3,
              -0.2,
              -0.2,
              0.3,
              -0.3,
              -0.4,
              -0.2,
              0,
              -0.1,
              0,
              0,
              -0.2,
              -0.1,
              -0.4,
              -0.3,
              -0.2,
              0,
              -0.1,
              0.8,
              0.1,
              -0.2,
              0.3,
              0.4,
              0.7,
              0.4,
              0.6,
              0.2,
              0.8,
              0.6,
              -0.7,
              -0.4,
              -0.6,
              -0.3,
              0.2,
              -0.4,
              0.1,
              0.5,
              -0.2,
              -0.3,
              -0.4,
              -0.5,
              0.6,
              0.1,
              -0.2,
              0,
              -0.4,
              -0.6,
              -0.2,
              0,
              -0.3,
              0.2,
              0.3,
              0,
              0.8,
              -0.2,
              -0.1,
              0.4,
              0,
              0.7,
              0,
              -0.4,
              -0.3,
              -0.2,
              0.1,
              0.2,
              0,
              0.3,
              0,
              0,
              0.4,
              0.3,
              0.2,
              0.1,
              0,
              0,
              0.2,
              0.3,
              -0.4,
              -0.5,
              -0.2,
              0.4,
              0,
              0.5,
              -0.8,
              -0.7,
              -0.3,
              -0.2,
              -0.3,
              -0.6,
              0,
              0.2,
              -0.7,
              0.3,
              0.1,
              0,
              0,
              0,
              0,
              0,
              0,
              0.4,
              0.5,
              0.2,
              0.4,
              0.1,
              0.2,
              0.1,
              0,
              -0.2,
              0.3,
              -0.2,
              0.1,
              -0.4,
              0.2,
              0.3,
              0.2,
              0.1,
              -0.2,
              0.3,
              0.4,
              0.1,
              0,
              0,
              0.1,
              0.7,
              -0.2,
              -0.3,
              0.6,
              0.8,
              0.7,
              -0.4,
              0,
              0.2,
              0.1,
              -0.3,
              0.1,
              0.2,
              0.6,
              0.3,
              -0.2,
              -0.3,
              -0.1,
              -0.8,
              -0.6,
              -0.4,
              0.4,
              -0.2,
              0.5,
              0.1,
              -0.3,
              0.4,
              0.8,
              0.6,
              0.3,
              0.7,
              0.8,
              0.7,
              0.9,
              -0.4,
              0.6,
              -0.3,
              -0.4,
              -0.2,
              -0.3,
              -0.5,
              -0.4,
              0.3,
              0.2,
              0.1,
              -0.4,
              0.1,
              -0.2,
              0.4,
              0.5,
              -0.1,
              -0.3,
              -0.4,
              0.2,
              0.3,
              0.7,
              0.8,
              -0.5,
              -0.3,
              -0.4,
              0.8,
              0.7,
              0.4,
              -0.2,
              0.3,
              -0.4,
              -0.6,
              -0.5,
              -0.8,
              -0.3,
              0.6,
              0.2,
              -0.4,
              -0.3,
              -0.5,
              -0.7,
              0.1,
              0.2,
              0.8,
              0.6,
              -0.2,
              -0.3,
              0.9,
              0.9,
              -0.4,
              0,
              -0.2,
              0.7,
              0.4,
              -0.4,
              0.1,
              0.2,
              0,
              0.4,
              0,
              0.6,
              0.2,
              0.5,
              -0.2,
              0.3,
              0.7,
              0.5,
              0.1,
              0,
              0.4,
              0.8,
              -0.3,
              0.6,
              0.2,
              -0.3,
              0.1,
              0.4,
              0.5,
              0.2,
              -0.3,
              0.2,
              0.1,
              -0.1,
              0.6,
              -0.2,
              0.3,
              0.4,
              0,
              -0.3,
              0.2,
              -0.7,
              0.3,
              -0.2,
              0,
              0,
              -0.5,
              -0.6,
              -0.4,
              -0.3,
              0.7,
              -0.4,
              -0.3,
              0,
              -0.4,
              0.2,
              0,
              0.1,
              0.3,
              -0.2,
              0.2,
              0,
              -0.3,
              -0.2,
              -0.4,
              0,
              0.2,
              -0.2,
              0.6,
              0.7,
              0.4,
              0.5,
              -0.3,
              0,
              0.2,
              0.3,
              0.6,
              -0.3,
              0.1,
              -0.2,
              0.3,
              -0.5,
              0.1,
              0.2,
              0.1,
              -0.1,
              0.2,
              -0.1,
              0.6,
              -0.3,
              -0.4,
              -0.2,
              -0.3,
              0.4,
              -0.2,
              0.2,
              -0.3,
              -0.4,
              -0.2,
              0.1,
              0.3,
              0.4,
              0.2,
              -0.2,
              0.1,
              -0.3,
              -0.2,
              0.2,
              0.3,
              0.2,
              0,
              0.1,
              0,
              0.3,
              0,
              -0.3,
              0.2,
              0.1,
              0,
              0.3,
              0.5,
              0.2,
              -0.2,
              0.1,
              0.1,
              0.2,
              0,
              0.7,
              0.6,
              -0.2,
              -0.4,
              0.3,
              -0.1,
              -0.6,
              -0.1,
              -0.2,
              -0.5,
              -0.4,
              0,
              -0.6,
              -0.3,
              -0.7,
              0.1,
              -0.4,
              0.2,
              0.4,
              0.3,
              -0.5,
              0.2,
              0.1,
              0.4,
              -0.3,
              -0.5,
              -0.4,
              -0.6,
              -0.3,
              0.2,
              -0.2,
              0.1,
              -0.4,
              -0.5,
              -0.3,
              0.3,
              -0.4,
              -0.5,
              -0.7,
              -0.2,
              0.4,
              0.2,
              -0.5,
              0.6,
              0.3,
              -0.6,
              -0.3,
              -0.2,
              0,
              -0.1,
              0,
              0.1,
              -0.2,
              -0.3,
              0.1,
              -0.6,
              -0.4,
              -0.8,
              -0.7,
              0.2,
              -0.8,
              0,
              -0.1,
              0.2,
              0.3,
              0.2,
              -0.7,
              0.4,
              -0.3,
              -0.2,
              0.6,
              0.8,
              -0.5,
              0.2,
              -0.3,
              0.1,
              0,
              0.2,
              0.7,
              -0.4,
              0,
              0.3,
              0.1,
              0.2,
              0.3,
              0,
              -0.2,
              0.8,
              -0.3,
              0.2,
              -0.4,
              0.4,
              -0.7,
              0.3,
              0,
              0.4,
              -0.3,
              0.3,
              0.1,
              0.2,
              -0.4,
              -0.5,
              -0.3,
              0.4,
              0.1,
              -0.2,
              -0.3,
              0.2,
              -0.7,
              -0.2,
              0.3,
              0.2,
              0.4,
              0.3,
              0.2,
              0.4,
              0.3,
              0.2,
              -0.2,
              0.5,
              0.1,
              0.4,
              0.3,
              0.1,
              -0.3,
              0.4,
              0.4,
              0.3,
              0.4,
              0.1,
              -0.2,
              -0.2,
              -0.4,
              0.2,
              0.1,
              0,
              -0.3,
              0.3,
              0.2,
              0.5,
              0.3,
              -0.2,
              0.2,
              -0.4,
              0.1,
              -0.3,
              0.4,
              0.3,
              0.5,
              0,
              -0.2,
              0.4,
              0.6,
              0.8,
              -0.5,
              0.7,
              -0.6,
              -0.7,
              0.4,
              0,
              -0.5,
              0.8,
              0.7,
              -0.2,
              0,
              0.3,
              0,
              0.6,
              0,
              0.7,
              -0.6,
              0.6,
              -0.3,
              0.2,
              0.4,
              0.7,
              -0.4,
              0,
              0,
              0.4,
              -0.2,
              0.2,
              0,
              0.3,
              0.4,
              0,
              -0.4,
              -0.5,
              0.8,
              0.5,
              0.6,
              0,
              0.5,
              0.3,
              0,
              -0.3,
              -0.4,
              -0.3,
              0.2,
              0.4,
              0,
              -0.2,
              0.2,
              0.8,
              0.6,
              -0.6,
              0.9,
              0.7,
              0,
              -0.4,
              0.1,
              0,
              0.2,
              -0.2,
              0.3,
              0.4,
              -0.1,
              -0.3,
              0.2,
              0,
              0.1,
              -0.3,
              0,
              -0.4,
              -0.5,
              -0.4,
              -0.6,
              0.3,
              -0.4,
              -0.2,
              0.4,
              -0.5,
              -0.7,
              0,
              -0.4,
              -0.5,
              0.3,
              0,
              -0.3,
              0.2,
              -0.2,
              -0.6,
              0.1,
              0.4,
              0.6,
              -0.4,
              -0.5,
              0.3,
              0,
              -0.4,
              -0.3,
              -0.5,
              0.6,
              -0.3,
              0.2,
              -0.4,
              -0.7,
              -0.5,
              0.4,
              0.2,
              0.3,
              0.1,
              -0.2,
              -0.4,
              -0.3,
              -0.2,
              -0.6,
              -0.4,
              -0.5,
              -0.6,
              -0.3,
              -0.8,
              -0.7,
              -0.4,
              -0.3,
              -0.4,
              -0.5,
              -0.6,
              -0.4,
              0,
              -0.3,
              0,
              -0.7,
              0.2,
              -0.2,
              0.3,
              -0.4,
              -0.2,
              -0.3,
              -0.1,
              -0.1,
              0.2,
              -0.1,
              -0.4,
              -0.5,
              0.1,
              -0.2,
              -0.7,
              -0.3,
              0.2,
              -0.4,
              -0.3,
              0,
              0.3,
              -0.4,
              -0.5,
              0.6,
              -0.3,
              0.2,
              0.3,
              -0.4,
              -0.3,
              -0.2,
              0.1,
              0.3,
              -0.4,
              0.2,
              -0.6,
              -0.5,
              -0.3,
              0.4,
              -0.3,
              0.1,
              0,
              -0.6,
              -0.4,
              0.5,
              -0.3,
              -0.4,
              0.2,
              -0.2,
              0,
              -0.3,
              -0.4,
              0,
              -0.1,
              -0.8,
              -0.2,
              -0.3,
              0.6,
              0,
              0.2,
              -0.1,
              -0.4,
              -0.3,
              -0.2,
              0,
              -0.3,
              0.2,
              -0.4,
              -0.2,
              0,
              0.3,
              -0.4,
              -0.3,
              -0.4,
              -0.2,
              0.2,
              -0.3,
              -0.4,
              -0.2,
              -0.3,
              0,
              0.8,
              0.6,
              -0.2,
              0,
              -0.3,
              -0.4,
              -0.5,
              -0.3,
              0.2,
              -0.4,
              0,
              0,
              0.8,
              0.4,
              0,
              0.2,
              0.3,
              0.6,
              -0.7,
              0.4,
              -0.5,
              0.5,
              0.4,
              0.6,
              0.7,
              -0.2,
              -0.3,
              0.3,
              0.6,
              0.8,
              0,
              0.7,
              0,
              0.3,
              0.5,
              0.6,
              0,
              0,
              0,
              0,
              0.2,
              0.2,
              0.3,
              0.2,
              0.5,
              0.2,
              0.3,
              0.3,
              -0.2,
              0.4,
              0.3,
              0.2,
              0.6,
              -0.1,
              -0.2,
              0.8,
              0.1,
              0,
              -0.1,
              0.6,
              0.2,
              0.4,
              0.1,
              0.5,
              0.4,
              0.7,
              0.2,
              -0.1,
              0.3,
              0.4,
              0.3,
              0.6,
              0.5,
              0.2,
              0.7,
              0.6,
              0.5,
              0.8,
              0.7,
              -0.3,
              -0.4,
              0.1,
              0.3,
              0.6,
              -0.1,
              0.2,
              -0.5,
              0.7,
              0.2,
              0.8,
              0.6,
              0.8,
              0.7,
              0.5,
              0.7,
              0.8,
              0.6,
              0.7,
              0.5,
              -0.2,
              0.3,
              0.6,
              0.7,
              0.8,
              0.6,
              -0.7,
              0.1,
              -0.4,
              0.6,
              0,
              0.4,
              0.5,
              0.3,
              0.7,
              -0.2,
              0.8,
              -0.3,
              0.2,
              0.1,
              0.4,
              0.3,
              -0.7,
              -0.6,
              -0.2,
              0.1,
              0.3,
              0.7,
              -0.4,
              0.5,
              0.8,
              -0.6,
              0.2,
              -0.3,
              0.8,
              0.1,
              0.2,
              0.3,
              -0.2,
              0.1,
              0,
              -0.7,
              0.4,
              -0.4,
              -0.8,
              0.3,
              0.8,
              0,
              0.2,
              0.1,
              -0.2,
              0.5,
              -0.5,
              -0.4,
              -0.3,
              0.3,
              0.4,
              0.9,
              0.2,
              0.1,
              -0.2,
              0.2,
              -0.3,
              0.4,
              0.1,
              -0.2,
              0.8,
              -0.3,
              -0.2,
              0,
              -0.3,
              0.1,
              -0.4,
              0.3,
              -0.5,
              0.4,
              0.1,
              0.3,
              0.4,
              0.5,
              0.4,
              0.5,
              0.6,
              0.3,
              0.4,
              0.3,
              0.2,
              0.3,
              0.2,
              0,
              0.3,
              0.4,
              0,
              0.5,
              0.1,
              0.2,
              0.6,
              0.8,
              0.2,
              0.3,
              0.2,
              0.7,
              0.1,
              0.8,
              0.7,
              -0.2,
              0.7,
              0.4,
              0.3,
              0.6,
              0.8,
              0.4,
              0.7,
              0.3,
              0.2,
              -0.2,
              -0.3,
              0,
              -0.4,
              0.1,
              0,
              0.4,
              -0.2,
              -0.3,
              0.1,
              0,
              0.9,
              0,
              0.6,
              0,
              0.8,
              0,
              0,
              0.8,
              0.8,
              0,
              -0.2,
              0,
              -0.5,
              0,
              -0.4,
              0,
              0,
              0.6,
              -0.5,
              0,
              0.3,
              0.5,
              0.4,
              -0.4,
              0.3,
              0.2,
              0,
              0,
              0,
              0.2,
              0,
              0,
              0.2,
              0.3,
              0.4,
              0.1,
              0.2,
              -0.4,
              0.3,
              0.3,
              0.1,
              0,
              0.8,
              0.1,
              -0.4,
              0.3,
              0.6,
              0.8,
              0.4,
              0.7,
              0.6,
              0.2,
              -0.2,
              0.4,
              0.5,
              0.3,
              -0.4,
              0.8,
              -0.5,
              0.6,
              0.2,
              0.5,
              0.4,
              0.6,
              0.5,
              0.3,
              -0.2,
              0.1,
              -0.3,
              -0.2,
              0.2,
              -0.3,
              -0.5,
              0.3,
              0.7,
              0.4,
              0.8,
              0.7,
              -0.4,
              0.6,
              -0.2,
              0.1,
              0.2,
              0.3,
              0.4,
              -0.3,
              0.1,
              -0.2,
              0.5,
              0.2,
              -0.3,
              -0.1,
              0,
              -0.4,
              0.6,
              0.7,
              0.5,
              0.6,
              0,
              -0.3,
              0.4,
              0.6,
              -0.2,
              -0.8,
              -0.2,
              -0.3,
              -0.4,
              0.3,
              0,
              -0.4,
              -0.3,
              -0.8,
              0.5,
              -0.2,
              -0.3,
              0.2,
              0.1,
              0.3,
              0.4,
              -0.4,
              0.2,
              0.3,
              0.1,
              -0.7,
              0,
              -0.2,
              0.5,
              -0.4,
              -0.5,
              -0.3,
              -0.6,
              -0.7,
              0.3,
              -0.5,
              0.2,
              0.4,
              0.3,
              -0.6,
              -0.5,
              -0.2,
              0.1,
              -0.3,
              -0.6,
              -0.4,
              0.3,
              -0.2,
              -0.5,
              -0.4,
              0.2,
              -0.1,
              0.1,
              0,
              0.2,
              0.4,
              0.3,
              -0.2,
              0.6,
              -0.4,
              0.2,
              -0.3,
              0.1,
              -0.2,
              0.4,
              0.2,
              0.1,
              0.3,
              -0.1,
              -0.3,
              0.4,
              0.5,
              0.2,
              0.3,
              0.4,
              0.6,
              0.1,
              0.2,
              -0.2,
              -0.3,
              0.2,
              0.4,
              0.5,
              0.3,
              0.4,
              0.3,
              -0.5,
              -0.2,
              0.1,
              -0.1,
              0.3,
              0.4,
              0.3,
              0.4,
              0.6,
              0.8,
              0.5,
              -0.4,
              -0.2,
              0.6,
              0.7,
              0.3,
              0.2,
              0.1,
              -0.3,
              -0.2,
              -0.3,
              0.4,
              -0.2,
              -0.8,
              -0.3,
              0.2,
              0.5,
              0.4,
              0,
              0.4,
              -0.2,
              0.3,
              0.4,
              0.2,
              -0.2,
              0.3,
              0.4,
              -0.3,
              0.8,
              0.5,
              0,
              -0.3,
              0.4,
              -0.4,
              -0.5,
              0.5,
              0.7,
              0.6,
              0.3,
              0.2,
              0.5,
              -0.1,
              0.2,
              0.1,
              0,
              -0.2,
              0.1,
              -0.3,
              -0.2,
              0,
              0,
              0.2,
              0,
              0,
              0.2,
              0.1,
              0.3,
              0,
              0,
              0.2,
              -0.2,
              0,
              0.1,
              -0.1,
              -0.2,
              0.1,
              -0.3,
              -0.2,
              0,
              0,
              -0.1,
              0.1,
              0,
              -0.1,
              -0.4,
              0.4,
              0,
              0.2,
              0.1,
              0.2,
              -0.1,
              0,
              0.2,
              -0.1,
              -0.4,
              0,
              0.1,
              0.1,
              0.2,
              -0.2,
              0,
              -0.2,
              0,
              -0.5,
              0,
              0.3,
              -0.2,
              0,
              0.1,
              -0.2,
              -0.3,
              0,
              0,
              0.1,
              0,
              0.2,
              -0.2,
              -0.1,
              0.1,
              0,
              0,
              0,
              0,
              0.2,
              0.3,
              -0.1,
              -0.1,
              0,
              0.2,
              0.2,
              0.1,
              0,
              0.1,
              0.1,
              -0.1,
              0.3,
              0.4,
              0.1,
              -0.2,
              0.2,
              0.6,
              0.7,
              0,
              0.5,
              0.6,
              0.4,
              0.8,
              0.9,
              0.8,
              0.6,
              -0.3,
              0,
              -0.1,
              0,
              -0.1,
              0.9,
              -0.2,
              0.6,
              0.3,
              -0.4,
              0.1,
              -0.1,
              0.2,
              0.3,
              0.5,
              -0.1,
              0,
              0,
              0.4,
              0.8,
              0,
              0,
              0,
              -0.1,
              0,
              0.1,
              0,
              0.2,
              0,
              0.4,
              0.3,
              0.2,
              -0.3,
              0.2,
              0.6,
              0.4,
              0,
              0.3,
              0.2,
              -0.1,
              0.8,
              0.6,
              0.4,
              0.5,
              0.7,
              0.6,
              0.5,
              0.8,
              0.6,
              0.7,
              -0.2,
              0.2,
              0.4,
              0.6,
              0.7,
              0.6,
              0.7,
              0.3,
              0.5,
              0.4,
              0.2,
              0.8,
              0.7,
              0.8,
              -0.4,
              -0.3,
              0.1,
              0,
              -0.2,
              0,
              0.6,
              -0.3,
              0.7,
              0.8,
              0.7,
              0,
              0,
              0.1,
              -0.3,
              0.4,
              0.2,
              0.3,
              0.1,
              -0.4,
              -0.2,
              -0.1,
              0,
              0.1,
              0,
              0.2,
              0,
              0.6,
              -0.5,
              -0.2,
              -0.4,
              0,
              0.1,
              -0.3,
              -0.2,
              0.7,
              -0.6,
              -0.4,
              -0.7,
              0,
              -0.3,
              -0.4,
              0.6,
              -0.4,
              0.2,
              0.1
            ],
            "positive": 1213,
            "neutral": 950,
            "negative": 941,
            "mixed": null,
            "average_score": 0.09130714745653563,
            "total_analyzed": 3106
          }
        },
        "timeline": [
          {
            "date": "2025-09-07",
            "average_score": 0.3403669724770642,
            "positive": 72,
            "neutral": 29,
            "negative": 8,
            "total": 109
          },
          {
            "date": "2025-09-08",
            "average_score": 0.0851598173515981,
            "positive": 351,
            "neutral": 217,
            "negative": 307,
            "total": 876
          },
          {
            "date": "2025-09-09",
            "average_score": -0.08179104477611936,
            "positive": 63,
            "neutral": 115,
            "negative": 156,
            "total": 335
          },
          {
            "date": "2025-09-10",
            "average_score": 0.07956777996070732,
            "positive": 187,
            "neutral": 164,
            "negative": 158,
            "total": 509
          },
          {
            "date": "2025-09-11",
            "average_score": 0.09842931937172773,
            "positive": 89,
            "neutral": 37,
            "negative": 65,
            "total": 191
          },
          {
            "date": "2025-09-12",
            "average_score": 0.14923469387755106,
            "positive": 176,
            "neutral": 121,
            "negative": 95,
            "total": 392
          },
          {
            "date": "2025-09-13",
            "average_score": 0.11743515850144085,
            "positive": 275,
            "neutral": 267,
            "negative": 152,
            "total": 694
          }
        ],
        "ai_insights": {
          "formula1": "Here's my analysis of the sentiment and themes in the r/formula1 posts:\n\nOverall Community Mood and Attitudes:\n- The community seems to have a generally positive and engaged tone, with a lot of thoughtful discussion and analysis of various topics.\n- There is a strong sense of passion for the sport, with fans closely following the details and nuances of the racing, rules, and driver/team dynamics.\n- Some posts generate more polarized or heated reactions, particularly around controversial topics like stewarding decisions, rule changes, and team politics.\n\nCommon Themes, Concerns, and Topics of Interest:\n- Keen interest in the technical and regulatory aspects of the sport, with discussions around things like car performance, class structures, and licensing requirements.\n- Appreciation for good racing and sportsmanship, with praise for drivers who demonstrate skill and fair play.\n- Frustration with perceived inconsistencies or unfairness in the application of rules and penalties.\n- Excitement around up-and-coming drivers and the potential future stars of the sport.\n- Nostalgia for past eras of Formula 1 and debates around potential rule changes.\n\nPatterns in Upvotes and Discussion:\n- Posts that provide insightful analysis, clarify misconceptions, or highlight positive stories/interactions tend to get a lot of engagement and upvotes.\n- Controversial or sensationalized topics also generate a lot of discussion, though not always positively.\n- The community seems to appreciate well-rounded perspectives and a nuanced understanding of the sport's complexities.\n\nEmerging Trends and Shifts in Opinion:\n- Increasing interest in and appreciation for other motorsport series and disciplines beyond just F1.\n- Growing focus on the human/personal side of drivers, teams, and the sport in general, not just the on-track action.\n- Some indications of a shift in sentiment around certain rules and regulations, with more openness to potential changes.\n\nPain Points and Frustrations:\n- Inconsistencies in stewarding decisions and the application of rules, which leads to a sense of unfairness.\n- Concerns around the technical complexity and accessibility of certain motorsport series/classes.\n- Frustration with the prevalence of misinformation and knee-jerk reactions in online discourse.\n\nOverall, the r/formula1 community appears to be engaged, knowledgeable, and passionate about the sport, with a mix of thoughtful discussion and occasional heated debates. The community seems to value nuance, fairness, and a genuine appreciation for the various aspects of Formula 1 and motorsport in general."
        },
        "framework_analysis": {
          "success": true,
          "analysis": "**COMMUNITY PROFILING**\n\n• Community Type: Sport/Racing enthusiast community\n• Demographic Indicators: Predominantly male, technically inclined, international audience\n• Emotional Baseline: Mixed (supportive but critical)\n• Community Character: A passionate Formula 1 community that combines technical expertise with emotional investment in drivers and teams. Shows strong engagement with both on-track performance and human interest stories.\n\n**PATTERN DISCOVERY**\n\n🔍 Key Findings:\n\n1. Surprising Pattern #1:\n   High engagement with human interest stories (PizzAut post) indicates community values extend beyond pure racing\n\n2. Surprising Pattern #2:\n   Strong defense of support staff (mechanic incident) shows solidarity within motorsport community\n\n3. Surprising Pattern #3:\n   Technical discussions generate more balanced sentiment than emotional/personal topics\n\n💬 Controversy Triggers:\n• Team orders and driver treatment\n• Race steward decisions and penalties\n• Performance comparisons between drivers\n• Pit stop incidents and strategies\n\n📊 Success/Failure Predictors:\n• Success indicators: Technical accuracy, insider perspective, human interest angles\n• Failure indicators: Aggressive criticism of staff, unfounded technical claims\n\n**TEMPORAL ANALYSIS**\n\n⏰ Time-Based Patterns:\n\nDaily Cycles:\n• Morning: More technical discussion\n• Afternoon: Peak engagement\n• Evening: More casual/social content\n\nWeekly Trends:\n• Race weekends show highest engagement\n• Mid-week sees more analysis/technical content\n• Sentiment more volatile during race weekends\n\nSentiment Evolution:\n• Overall slightly positive (0.09)\n• More positive on human interest stories\n• More negative on controversial racing incidents\n\n**KEY INSIGHTS**\n\n⭐ Most Important Discoveries:\n\n1. Engagement Correlation:\n   Technical accuracy + human element = highest engagement\n\n2. Unspoken Rules:\n   Strong protection of support staff and behind-scenes workers\n\n3. Influence Patterns:\n   Top comments set tone for entire discussion threads\n\n4. Content Predictors:\n   Driver-focused content consistently performs well\n\n**ACTIONABLE RECOMMENDATIONS**\n\n📝 Content Strategy:\n• Best performing content types: Driver interactions, technical analysis, behind-scenes content\n• Optimal post structure: Clear title, factual content, room for discussion\n• Language style: Knowledgeable but accessible\n\n⏱️ Timing Strategy:\n• Best posting times: Race weekend afternoons\n• Avoid posting: During live sessions\n\n🚫 Topics to Avoid:\n• Personal attacks on team personnel\n• Unsubstantiated technical claims\n• Inflammatory driver comparisons\n\n✅ Topics that Resonate:\n• Human interest stories about drivers/team members\n• Technical analysis with credible sources\n• Historical comparisons and statistics\n\n**QUESTIONS FOR DEEPER ANALYSIS**\n\n1. How does sentiment vary between different driver fanbases?\n2. What impact do race results have on next-day posting patterns?\n3. How does technical vs. emotional content engagement differ?\n4. What role do historical references play in community engagement?\n5. How do controversial decisions affect long-term discussion patterns?\n\n**SUMMARY**\n\nThe Formula 1 subreddit shows a sophisticated balance between technical expertise and emotional investment in the sport. The community strongly values accuracy, fairness, and human interest, while maintaining high standards for technical discussion. The slightly positive sentiment (0.09) suggests a critically engaged but generally constructive community.",
          "generated_at": "2025-09-14T23:21:12.253Z",
          "model_used": "Claude 3.5 Sonnet"
        },
        "synthetic_post": {
          "title": "Lando Norris jokes about McLaren's recent upgrades: \"At this rate we'll catch Red Bull by 2025\"",
          "author": "F1_Enthusiast_44",
          "body": "During the pre-Singapore GP press conference, Lando was asked about McLaren's impressive development pace this season and their recent performance gains.\n\n\"The upgrades have been mega, honestly. Oscar and I can really feel the difference in the high-speed corners especially. But yeah, at this rate we'll catch Red Bull somewhere around 2025... maybe 2026 if Max keeps improving too [laughs].\"\n\nHe also praised the team at Woking for their incredible work this season, turning what started as a difficult year into one with multiple podium opportunities.",
          "score": 9247,
          "upvoteRatio": 0.96,
          "comments": [
            {
              "id": "comment1",
              "author": "TheSpeedKing",
              "body": "McLaren's development rate this season has been absolutely insane. From fighting with Alpine to regularly challenging Mercedes and Ferrari",
              "score": 3421,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment2",
              "author": "F1Technical",
              "body": "Their new floor design is genuinely innovative. Zak Brown mentioned they found something in the wind tunnel that other teams missed",
              "score": 2876,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment3",
              "author": "PapaZak",
              "body": "Typical Lando banter. But seriously, the gap to Red Bull is still massive - over 0.5s per lap at most tracks",
              "score": 2155,
              "replies": [],
              "level": 0,
              "sentiment": "neutral"
            },
            {
              "id": "comment4",
              "author": "RacingNerd",
              "body": "The real test will be if they can keep this development pace into next season. We've seen teams make big jumps before only to fall back",
              "score": 1844,
              "replies": [],
              "level": 0,
              "sentiment": "neutral"
            },
            {
              "id": "comment5",
              "author": "McLarenFanatic",
              "body": "Imagine telling someone after Bahrain that McLaren would be fighting for podiums regularly by mid-season",
              "score": 1677,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment6",
              "author": "VerstappenP1",
              "body": "2025? Bold of him to assume Red Bull won't be even further ahead by then lol",
              "score": 1433,
              "replies": [],
              "level": 0,
              "sentiment": "humorous"
            },
            {
              "id": "comment7",
              "author": "SilverArrows",
              "body": "Piastri and Norris might be the strongest young driver pairing on the grid right now",
              "score": 1288,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment8",
              "author": "GP_Observer",
              "body": "Andrea Stella deserves massive credit for this turnaround. The team's technical direction is so much clearer now",
              "score": 1122,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment9",
              "author": "TifosiFan",
              "body": "Meanwhile Ferrari's development: \"We are checking...\"",
              "score": 987,
              "replies": [],
              "level": 0,
              "sentiment": "humorous"
            },
            {
              "id": "comment10",
              "author": "RacingHistory",
              "body": "Reminds me of 2019 when they made that huge jump mid-season. Good to see McLaren back where they belong",
              "score": 856,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            }
          ],
          "subreddit": "formula1",
          "timeAgo": "4 hours ago",
          "sentiment": "positive",
          "generated_at": "2025-09-15T07:01:05.362Z",
          "version": 1
        }
      },
      "posts": [
        {
          "id": "1nbkbe4",
          "title": "Former Red Bull Mechanic, Calum Nicholas, responds to a Twitter user who calls for the mechanic who made an error on Lando Norris’ pitstop to be “located”.",
          "selftext": "",
          "score": 22475,
          "num_comments": 1055,
          "created_utc": 1757328114,
          "subreddit": "formula1",
          "permalink": "/r/formula1/comments/1nbkbe4/former_red_bull_mechanic_calum_nicholas_responds/",
          "url": "https://i.redd.it/z3kze4up6xnf1.jpeg",
          "author": "The_Chozen_1_",
          "comments": [
            {
              "id": "nd2conv",
              "body": "Where on EARTH did they get those figures?",
              "score": 6558,
              "created_utc": 1757329757,
              "author": "CRAZEDDUCKling"
            },
            {
              "id": "nd2c1qk",
              "body": "What the hell is wrong with people? That is such a stupid take",
              "score": 3191,
              "created_utc": 1757329452,
              "author": "sicsche"
            },
            {
              "id": "nd2d5wv",
              "body": "There was another tweet circulating where someone had googled it and taken it from the AI search results. it was in $'s tbf but even that is wildly inaccurate. not unusual for Googles AI lmao",
              "score": 2426,
              "created_utc": 1757329982,
              "author": "SaddlerMatt"
            },
            {
              "id": "nd2fkdh",
              "body": "The fact that he thinks the mechanoc only works 3 seconds per 2 weeks is dumb enough to ignore the rest of his comment.\n\nI dont know what their work schedule ia, but I sure as hell know its much more than only changing wheels once a race.",
              "score": 1488,
              "created_utc": 1757331087,
              "author": "GTAinreallife"
            }
          ]
        },
        {
          "id": "1nbxfnt",
          "title": "Max posing for a picture with staff from PizzAut, a pizzeria run by autistic people that provided catering for the Monza GP this year.",
          "selftext": "",
          "score": 18977,
          "num_comments": 247,
          "created_utc": 1757359973,
          "subreddit": "formula1",
          "permalink": "/r/formula1/comments/1nbxfnt/max_posing_for_a_picture_with_staff_from_pizzaut/",
          "url": "https://i.redd.it/fmfcsm82tznf1.jpeg",
          "author": "Lele_",
          "comments": [
            {
              "id": "nd5awbs",
              "body": "I gotta say, PizzAut is a banger of a name for a pizzeria",
              "score": 2401,
              "created_utc": 1757363299,
              "author": "h_eero"
            },
            {
              "id": "nd55hgm",
              "body": "My youngest son is on the spectrum. I love seeing things like this to show the positive effects that people can have on others.",
              "score": 1465,
              "created_utc": 1757361731,
              "author": "HartfordWhaler"
            },
            {
              "id": "nd5a7tx",
              "body": "He looks like he's genuinely having a good time there! I've never seen Max interact negatively with fans, and he's always especially good with kids and those with special needs.",
              "score": 1342,
              "created_utc": 1757363105,
              "author": "Top-Truck246"
            },
            {
              "id": "nd59ffs",
              "body": "A major part of why Max is my fav is because of who he is outside of the car. A pure sweetie.",
              "score": 823,
              "created_utc": 1757362878,
              "author": "Ultraviolet211"
            }
          ]
        },
        {
          "id": "1nb8u6x",
          "title": "Robin Räikkönen (Kimi's son) photographed with Verstappen at Monza",
          "selftext": "",
          "score": 10118,
          "num_comments": 124,
          "created_utc": 1757289409,
          "subreddit": "formula1",
          "permalink": "/r/formula1/comments/1nb8u6x/robin_räikkönen_kimis_son_photographed_with/",
          "url": "https://i.redd.it/txjjs2lmztnf1.jpeg",
          "author": "Seb90123",
          "comments": [
            {
              "id": "nd0aa93",
              "body": "Will we see this as a \"looking back\" moment in about 10-15 years when this kid is in F1?",
              "score": 2803,
              "created_utc": 1757293545,
              "author": "gimmeslack12"
            },
            {
              "id": "nd0g4nu",
              "body": "This may become the Schumacher and Verstappen photo",
              "score": 1624,
              "created_utc": 1757295632,
              "author": "Strange-Health626"
            },
            {
              "id": "nd0t8ak",
              "body": "Save the photo. He’s going to be Max’s teammate - at Ferrari",
              "score": 999,
              "created_utc": 1757300431,
              "author": "leftlanecop"
            },
            {
              "id": "nd0gyx7",
              "body": "Son of former F1 driver poses with the next Ferrari drivers' champion.",
              "score": 749,
              "created_utc": 1757295932,
              "author": "altSNS"
            }
          ]
        },
        {
          "id": "1nf8bi1",
          "title": "Max has completed part one of his Nurburgring permit!",
          "selftext": "Nordschleife Rule No. 1:\n\nNothing works without a permit 💚👀\n\nThe four-time Formula 1 World Champion successfully completed the first part of his path to the permit during the test ahead of NLS7.\n\n\"Racing is not just my profession, but also my hobby\", says Max. \"This weekend I am at the Nordschleife with the goal to qualify for the mandatory race permit needed to race here in a GT3 car, which I would love. The Nordschleife is at the top of my list of tracks I want to race on, as it's extremely challenging and demanding, with its enormous length and tight historic layout. I can't wait!\"\n\n#HeartRace\n\nQuote: https://news.verstappen.com/en/article/5942/\n\nhttps://www.instagram.com/p/DOgft20iKS4/",
          "score": 8809,
          "num_comments": 246,
          "created_utc": 1757695694,
          "subreddit": "formula1",
          "permalink": "/r/formula1/comments/1nf8bi1/max_has_completed_part_one_of_his_nurburgring/",
          "url": "https://www.reddit.com/gallery/1nf8bi1",
          "author": "Accomplished_Bug4099",
          "comments": [
            {
              "id": "ndurqe9",
              "body": "I wish I had found something that wasn't just my profession but also my hobby. 😞",
              "score": 2163,
              "created_utc": 1757699085,
              "author": "ihavenoyukata"
            },
            {
              "id": "ndurzqc",
              "body": "Nice! Imagine being the instructor who had to lead him for eight laps and teach him the racing lines lol\n\nI also absolutely love the race suit and helmet he wore today, the design is so clean and looks amazing",
              "score": 988,
              "created_utc": 1757699160,
              "author": "queerhedgehog"
            },
            {
              "id": "nduy4pq",
              "body": "And that you’re also in the top .01% of that makes you millions of dollars a year?",
              "score": 660,
              "created_utc": 1757700931,
              "author": "The_Rain_Guardian"
            },
            {
              "id": "ndut4im",
              "body": "This is one of the reasons he is my favorite. Just absolutely loves racing and will try to compete in whatever interests him.\n\nEdit: I bet there will be fans that get interested in the racing at the nurburgring following his participation that were not into it before which is super cool. Can't wait for the day he competes in the N24.",
              "score": 559,
              "created_utc": 1757699484,
              "author": "Nick_YDG"
            }
          ]
        },
        {
          "id": "1nfwvu3",
          "title": "Carlos' Dutch GP Penalty Overturned",
          "selftext": "We are grateful to the stewards for reviewing Carlos' Zandvoort penalty and are pleased they have now decided he was not at fault and that this was a racing incident. \n\nWhile it is frustrating that our race was compromised by the original decision, mistakes are part of motor racing and we will continue to work constructively with the FIA to improve stewarding processes and review the racing rules for the future.",
          "score": 7204,
          "num_comments": 316,
          "created_utc": 1757768360,
          "subreddit": "formula1",
          "permalink": "/r/formula1/comments/1nfwvu3/carlos_dutch_gp_penalty_overturned/",
          "url": "https://www.williamsf1.com/posts/aa8e2f1a-295c-4155-9ca3-0a985cae69e9/team-statement-carlos-sainz-dutch-gp-penalty",
          "author": "couriersnemesis",
          "comments": [
            {
              "id": "ndzj9y8",
              "body": "A right of review actually worked? Holy cow",
              "score": 4714,
              "created_utc": 1757768470,
              "author": "charlierc"
            },
            {
              "id": "ndzj3lg",
              "body": "This is rather unprecedented for the current regs",
              "score": 2454,
              "created_utc": 1757768404,
              "author": "ThroneOfTaters"
            },
            {
              "id": "ndzjyoh",
              "body": "Does he get a 10 seconds head start at the next race?",
              "score": 1553,
              "created_utc": 1757768721,
              "author": "Red_Rabbit_1978"
            },
            {
              "id": "ndzjqia",
              "body": "\"Let's make sure we have a talk with those stewards\"\n\nTHE OPERATOR, Carlos,  2025",
              "score": 1175,
              "created_utc": 1757768638,
              "author": "thefeedling"
            }
          ]
        },
        {
          "id": "1nfsm7z",
          "title": "Max Verstappen qualified sixth in the CUP3 class at the Nurburgring with a time of 10:21.591 (G) -Fastest is a 10:06.215 (PRO) And that with 130HP less from Max.",
          "selftext": "",
          "score": 7208,
          "num_comments": 404,
          "created_utc": 1757753590,
          "subreddit": "formula1",
          "permalink": "/r/formula1/comments/1nfsm7z/max_verstappen_qualified_sixth_in_the_cup3_class/",
          "url": "https://i.redd.it/uw5xolmvbwof1.jpeg",
          "author": "just_holdme",
          "comments": [
            {
              "id": "ndywuig",
              "body": "For context, I watch a reasonable amount of NLS, and usually the CUP3 class leaders are around a similar pace as the SP8T leaders. Max outqualified every SP8T car",
              "score": 3171,
              "created_utc": 1757758080,
              "author": "BendubzGaming"
            },
            {
              "id": "ndyv6we",
              "body": "It’s only because the CUP3 car is built around his driving style and the other cars don’t have the same floor upgrades",
              "score": 1700,
              "created_utc": 1757757129,
              "author": "GeologistNo3727"
            },
            {
              "id": "ndyv1sq",
              "body": "Imagine being 'TAKIS', being all pumped up to win your class, then you see Max turn up...",
              "score": 1542,
              "created_utc": 1757757048,
              "author": "Evantra_"
            },
            {
              "id": "ndyw1zb",
              "body": "Oh god I just realized... I'm going to have to read that '130hp less' fact hundreds of times across every thread over the next two days. :(",
              "score": 1366,
              "created_utc": 1757757622,
              "author": "neverending_despair"
            }
          ]
        },
        {
          "id": "1nd8bzs",
          "title": "Four rings and three stripes: adidas becomes official partner of the future Audi Formula 1 Team",
          "selftext": "",
          "score": 7123,
          "num_comments": 274,
          "created_utc": 1757491798,
          "subreddit": "formula1",
          "permalink": "/r/formula1/comments/1nd8bzs/four_rings_and_three_stripes_adidas_becomes/",
          "url": "https://www.audi-mediacenter.com/en/press-releases/four-rings-and-three-stripes-adidas-becomes-official-partner-of-the-future-audi-formula-1-team-16854",
          "author": "ICumCoffee",
          "comments": [
            {
              "id": "ndettv0",
              "body": "The pit crew will be squatting in tracksuits while waiting for a stop. No chairs neccessary.",
              "score": 2322,
              "created_utc": 1757491955,
              "author": "Kheltosh"
            },
            {
              "id": "ndeueml",
              "body": "German brand with both German constructors. Cool. And Adidas merch is 10x the quality of castore",
              "score": 1998,
              "created_utc": 1757492309,
              "author": "AlternativeAward"
            },
            {
              "id": "ndewdlx",
              "body": "Nice slogan: Four rings, three stripes, two cars and one mission.",
              "score": 1915,
              "created_utc": 1757493508,
              "author": "rutje"
            },
            {
              "id": "ndeuge9",
              "body": "Audi + Adidas is the most balkan combo possible",
              "score": 1670,
              "created_utc": 1757492339,
              "author": "zer0dmg"
            }
          ]
        },
        {
          "id": "1nf2lo9",
          "title": "Please be respectful to the race organizers and understand why Verstappen's Porsche is \"detuned\"",
          "selftext": "There are several publications, among which Motorsport.com, claiming Max Verstappen won't be able to win the GT4 class in the Nürburgring Langstrecken-Serie tomorrow, because his Porsche is \"detuned\".\n\nFirst, the NLS doesn't have a GT4 class. GT4-spec cars are split up into a bunch of different categories, like SP8T for turbocharged GT4-cars with specially designed parts (i.e. Bilstein suspension on Jimmy Broadbent's car) and SP10 for SRO-homologated GT4-cars (SRO is the licenceholder of GT4).\n\nVerstappen's Porsche is entered in the CUP3 GUEST class, which is a separate class for detuned Porsche 718 Cayman GT4 RS Clubsport cars. He is not competing against other GT4 cars. If his Porsche were not detuned, it wouldn't be a Permit B car and to get his Permit A ('GT3 licence'), he has to drive...",
          "score": 6956,
          "num_comments": 355,
          "created_utc": 1757682038,
          "subreddit": "formula1",
          "permalink": "/r/formula1/comments/1nf2lo9/please_be_respectful_to_the_race_organizers_and/",
          "url": "https://www.reddit.com/r/formula1/comments/1nf2lo9/please_be_respectful_to_the_race_organizers_and/",
          "author": "CautionClock20",
          "comments": [
            {
              "id": "ndt873t",
              "body": "Half the argument on here are between folks who don’t understand F1 rules. You want us to understand multi-classes?",
              "score": 4629,
              "created_utc": 1757682950,
              "author": "HMSSpeedy1801"
            },
            {
              "id": "ndt7tvv",
              "body": "Man, it would genuinely never strike me to get *angry* with the organizing body of another motorsport class that a particular driver has *chosen* to join, because I think it might not be showing his \"utter domination\" properly. Jeepers.",
              "score": 885,
              "created_utc": 1757682831,
              "author": "Driscuits"
            },
            {
              "id": "ndt84do",
              "body": "I’m just glad the GT4 class is getting some love.\n\nSince you’re correcting bad “nerf” takes, can we call you a nerf herder?",
              "score": 776,
              "created_utc": 1757682926,
              "author": "TrueSwagformyBois"
            },
            {
              "id": "ndtmwjh",
              "body": "NLS multi classes are especially complex to be fair.",
              "score": 595,
              "created_utc": 1757687428,
              "author": "Red4pex"
            }
          ]
        },
        {
          "id": "1nbe6v6",
          "title": "Oscar Piastri's spectacular overtake on Charles Leclerc at Lesmo 1 - Monza 2025",
          "selftext": "",
          "score": 5883,
          "num_comments": 203,
          "created_utc": 1757305285,
          "subreddit": "formula1",
          "permalink": "/r/formula1/comments/1nbe6v6/oscar_piastris_spectacular_overtake_on_charles/",
          "url": "https://imgur.com/a/uV7DdnW",
          "author": "dodofuzz",
          "comments": [
            {
              "id": "nd1teui",
              "body": "First couple of laps were the best thing about that race",
              "score": 2357,
              "created_utc": 1757318591,
              "author": "Careful-Door2724"
            },
            {
              "id": "nd2ce1q",
              "body": "By today's rules Leclerc could have just ever so slightly drifted outwards touch Piastri's car and make him spin, Piastri would be in the wrong and Leclerc wouldn't lose the position. Awesome that he didn't take advantage of it and chose the great racing way but it could have sparked an interesting debate about that ruling",
              "score": 993,
              "created_utc": 1757329617,
              "author": "Neither-Blueberry-95"
            },
            {
              "id": "nd27kir",
              "body": "Any other track almost and Leclerc probably doesn’t fight that hard. You could tell Ferrari at Monza just wanted to put on a show even though they knew a podium was probably out of the question",
              "score": 635,
              "created_utc": 1757327148,
              "author": "Veranova"
            },
            {
              "id": "nd2f3ot",
              "body": "It's a good example of how bad the rules are. Leclerc could have driven piastri into the gravel here.  \nThe fact that this kind of driving is impossible if every driver at all times used their \"right to the corner\" show that the rules discourage good racing.",
              "score": 554,
              "created_utc": 1757330877,
              "author": "andreasvo"
            }
          ]
        },
        {
          "id": "1ng4otc",
          "title": "Max Verstappen elated after successful Nurburgring license test: \"I had fun\"",
          "selftext": "",
          "score": 5689,
          "num_comments": 207,
          "created_utc": 1757787485,
          "subreddit": "formula1",
          "permalink": "/r/formula1/comments/1ng4otc/max_verstappen_elated_after_successful/",
          "url": "https://www.motorsport.com/vln/news/max-verstappen-obtains-nordschleife-license-glad-it-went-smoothly/10759236/",
          "author": "MoneyLibrarian9032",
          "comments": [
            {
              "id": "ne1e1d2",
              "body": "Mans just completing all the racing side quests in all forms at this point",
              "score": 1785,
              "created_utc": 1757789035,
              "author": "var_usernameinput"
            },
            {
              "id": "ne1ct84",
              "body": "Two great weekends in a row. He is enjoying life atm.",
              "score": 815,
              "created_utc": 1757788661,
              "author": "Champagne_baby80"
            },
            {
              "id": "ne1e95n",
              "body": "Could easily have the opposite effect. If he can do these races beside F1 on off weekends then he has less reason to leave, and more to look forward to. He's gonna be able to do the 24 hr Nurburgring in May while being a F1 driver. Best of both worlds. And he's probably praying the 24hr of Le Mans will fall on an off weekend in '27 or '28.",
              "score": 532,
              "created_utc": 1757789102,
              "author": "Tragespeler"
            },
            {
              "id": "ne1ctqg",
              "body": "Wonder if him having fun will cut his F1 career shorter than even he thinks… I mean he has hinted previously at doing other series at some point and his dislike for F1 media duties and other shenanigans besides the actual racing seemed to already be causing him to hint at leaving eventually anyway…",
              "score": 481,
              "created_utc": 1757788665,
              "author": "FreakDJ"
            }
          ]
        },
        {
          "id": "1ncejb0",
          "title": "Lando Norris' recent slow pitstops [from lapfuel on IG]",
          "selftext": "[https://www.instagram.com/p/DOWF1aniJwS/](https://www.instagram.com/p/DOWF1aniJwS/)",
          "score": 5564,
          "num_comments": 613,
          "created_utc": 1757411211,
          "subreddit": "formula1",
          "permalink": "/r/formula1/comments/1ncejb0/lando_norris_recent_slow_pitstops_from_lapfuel_on/",
          "url": "https://i.redd.it/og89q00j14of1.jpeg",
          "author": "randomseocb",
          "comments": [
            {
              "id": "nd8ktbk",
              "body": "Has Mark Webber bribed the mechanics?? What’s going on!",
              "score": 3382,
              "created_utc": 1757412040,
              "author": "wanderlustre89"
            },
            {
              "id": "nd8pd2q",
              "body": "Silverstone and Zandvoort ones are from second pit in doublestack?\n\nGenerally, seems not good on pit crew, yeah",
              "score": 916,
              "created_utc": 1757414445,
              "author": "mickmenn"
            },
            {
              "id": "nd8mh57",
              "body": "Mclaren crew went from the most efficient part of the team to the least efficient",
              "score": 914,
              "created_utc": 1757412952,
              "author": "creatorop"
            },
            {
              "id": "nd8n10v",
              "body": "Maybe he is the mechanic 👀",
              "score": 888,
              "created_utc": 1757413249,
              "author": "FKez05"
            }
          ]
        },
        {
          "id": "1ndqscm",
          "title": "In 1997, Villeneuve and Schumacher were 1st and 2nd on the points ranking, but never stood on the podium together",
          "selftext": "At the end of the 1997 season, Jacques Villeneuve with Williams and Michael Schumacher with Ferrari, were first and second on the points ranking. However, despite their individual successes through the season's 17 races, they never stood on the same podium together. Villeneuve went on to be crowned World Champion, while Schumacher was ultimately disqualified from championship contention after the last race, although he had accumulated the second most points behind Villeneuve.\n\nThis anomaly has only occurred one other time, in 1950, but with far fewer races on the calendar (x7), a higher number of participating drivers, and questionable car reliability, the probability of it happening was significantly higher.",
          "score": 5066,
          "num_comments": 155,
          "created_utc": 1757539594,
          "subreddit": "formula1",
          "permalink": "/r/formula1/comments/1ndqscm/in_1997_villeneuve_and_schumacher_were_1st_and/",
          "url": "https://i.redd.it/w6avdnvaneof1.png",
          "author": "racingplaybook",
          "comments": [
            {
              "id": "ndjee50",
              "body": "Never met at the podium but at least their cars met in Jerez",
              "score": 1468,
              "created_utc": 1757545487,
              "author": "maybeitsmyfault10"
            },
            {
              "id": "ndjf5gl",
              "body": "insane, they had podiums in 16/17 races and somehow never both at the same time\n\na lot of DNFs, they both finished the same race only 7 times\n\nI was 7 and I actually remember watching that final race with my dad and being sad while he so cheery that Schumacher lost",
              "score": 694,
              "created_utc": 1757545731,
              "author": "Accomplished_Welder3"
            },
            {
              "id": "ndjseam",
              "body": "That didn’t work, Michael!",
              "score": 391,
              "created_utc": 1757550102,
              "author": "2RINITY"
            },
            {
              "id": "ndk39rt",
              "body": "The cars were far less reliable back then. Engines would just shit themselves all the time",
              "score": 277,
              "created_utc": 1757553857,
              "author": "ooranookian"
            }
          ]
        }
      ]
    }
  },
  {
    "id": "mfka82wx9iwsw9qo6",
    "generated_at": "2025-09-14T22:44:01.857Z",
    "name": "Political Subreddits Analysis",
    "description": "Cross-subreddit analysis of political discussions covering democratic, conservative, and general political discourse.",
    "subreddits": [
      "democrats",
      "Conservative",
      "politics"
    ],
    "dateRange": {
      "startDate": "2025-09-07",
      "endDate": "2025-09-14"
    },
    "totalPosts": 42,
    "totalComments": 5075,
    "data": {
      "summary": {
        "totalPosts": 42,
        "totalComments": 5075,
        "subreddits": [
          "democrats",
          "Conservative",
          "politics"
        ],
        "dateRange": {
          "startDate": "2025-09-07",
          "endDate": "2025-09-14"
        }
      },
      "analysis": {
        "overall_sentiment": {
          "average_score": -0.05,
          "sentiment_distribution": {
            "positive": 25,
            "neutral": 45,
            "negative": 30
          },
          "dominant_themes": [
            "politics",
            "government",
            "election",
            "policy",
            "debate",
            "controversy",
            "opinion"
          ],
          "key_emotions": [
            "frustration",
            "concern",
            "debate",
            "division",
            "passion"
          ],
          "summary": "The overall sentiment is negative (negative 77%). Key themes include: politics, criticism, violence."
        },
        "individual_scores": [
          {
            "index": 0,
            "score": 0.3,
            "sentiment": "positive",
            "confidence": 0.7,
            "themes": [
              "focus",
              "investigation",
              "files"
            ],
            "emotions": [],
            "source": {
              "type": "post_title",
              "postId": "1neosfb",
              "subreddit": "democrats"
            }
          },
          {
            "index": 0,
            "score": -0.6,
            "sentiment": "negative",
            "confidence": 0.8,
            "themes": [
              "obstruction",
              "suspicion",
              "corruption"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1neosfb",
              "commentId": "ndqfxru",
              "subreddit": "democrats"
            }
          },
          {
            "index": 0,
            "score": 0,
            "sentiment": "neutral",
            "confidence": 1,
            "themes": [
              "irrelevant"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1neosfb",
              "commentId": "ndqg0fv",
              "subreddit": "democrats"
            }
          },
          {
            "index": 0,
            "score": -0.4,
            "sentiment": "negative",
            "confidence": 0.7,
            "themes": [
              "conspiracy",
              "suspicion",
              "corruption"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1neosfb",
              "commentId": "ndsv4ef",
              "subreddit": "democrats"
            }
          },
          {
            "index": 0,
            "score": -0.7,
            "sentiment": "negative",
            "confidence": 0.9,
            "themes": [
              "manipulation",
              "politics",
              "coverup"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1neosfb",
              "commentId": "ndv4k1j",
              "subreddit": "democrats"
            }
          }
        ],
        "by_subreddit": {
          "democrats": {
            "scores": [
              0.3,
              -0.6,
              0,
              -0.4,
              -0.7,
              -0.8,
              -0.3,
              -0.8,
              0.2,
              -0.7,
              -0.6,
              -0.7,
              -0.5,
              -0.6,
              0.3,
              0.1,
              0,
              -0.4,
              -0.5,
              0.2,
              -0.6,
              -0.5,
              -0.4,
              -0.5,
              -0.7,
              -0.3,
              -0.4,
              0.4,
              -0.7,
              -0.6,
              -0.2,
              -0.4,
              0.1,
              -0.6,
              -0.3,
              0,
              -0.4,
              -0.6,
              -0.7,
              -0.5,
              -0.4,
              0.1,
              0,
              0.3,
              -0.6,
              -0.5,
              -0.5,
              -0.6,
              0.6,
              -0.5,
              -0.2,
              -0.6,
              -0.8,
              -0.4,
              0,
              -0.1,
              -0.7,
              -0.3,
              -0.5,
              -0.2,
              -0.4,
              -0.5,
              0.1,
              0.2,
              0.4,
              0,
              0.3,
              0.4,
              0.2,
              -0.4,
              -0.3,
              -0.2,
              -0.4,
              -0.3,
              -0.1,
              -0.2,
              0.2,
              -0.1,
              -0.8,
              -0.2,
              -0.6,
              -0.3,
              -0.4,
              0.3,
              0.4,
              -0.1,
              0.5,
              -0.3,
              -0.4,
              -0.6,
              -0.2,
              -0.3,
              -0.5,
              -0.4,
              0.1,
              0.2,
              -0.1,
              -0.2,
              -0.4,
              -0.5,
              0.3,
              -0.6,
              -0.7,
              -0.4,
              0,
              0,
              -0.3,
              0.2,
              -0.5,
              -0.4,
              0,
              -0.7,
              -0.3,
              -0.8,
              -0.8,
              -0.7,
              -0.6,
              -0.2,
              -0.6,
              0.3,
              -0.5,
              -0.6,
              -0.4,
              -0.5,
              0,
              -0.1,
              -0.5,
              -0.3,
              -0.7,
              0,
              -0.1,
              0.6,
              -0.5,
              -0.7,
              0,
              -0.6,
              0.2,
              -0.2,
              -0.6,
              -0.5,
              0.1,
              -0.6,
              0.2,
              -0.3,
              -0.7,
              -0.8,
              -0.7,
              -0.6,
              -0.5,
              -0.6,
              -0.4,
              -0.6,
              0,
              -0.7,
              -0.7,
              -0.8,
              -0.9,
              -0.6,
              0.3,
              -0.8,
              -0.4,
              -0.8,
              -0.9,
              -0.2,
              -0.7,
              -0.6,
              -0.7,
              -0.3,
              -0.2,
              -0.3,
              -0.5,
              -0.6,
              -0.8,
              -0.4,
              -0.7,
              -0.4,
              0,
              -0.5,
              -0.8,
              -0.6,
              -0.5,
              -0.8,
              -0.3,
              -0.5,
              -0.7,
              -0.6,
              -0.6,
              0.2,
              0.3,
              0.1,
              -0.6,
              0.2,
              -0.7,
              -0.5,
              -0.7,
              -0.5,
              -0.6,
              -0.4,
              0.4,
              -0.2,
              -0.7,
              -0.6,
              -0.8,
              -0.5,
              -0.6,
              -0.4,
              -0.7,
              -0.4,
              -0.5,
              -0.7,
              -0.5,
              -0.8,
              -0.6,
              -0.3,
              -0.8,
              -0.6,
              -0.4,
              -0.3,
              -0.8,
              -0.7,
              -0.6,
              -0.5,
              -0.5,
              -0.9,
              -0.8,
              -0.6,
              -0.4,
              -0.7,
              0,
              -0.8,
              -0.6,
              -0.7,
              -0.3,
              0.8,
              -0.4,
              -0.5,
              -0.7,
              -0.6,
              -0.7,
              -0.6,
              -0.5,
              -0.6,
              -0.3,
              -0.7,
              -0.8,
              -0.6,
              -0.7,
              -0.6,
              0.3,
              -0.7,
              -0.4,
              -0.3,
              -0.6,
              -0.8,
              -0.5,
              -0.2,
              -0.7,
              -0.6,
              -0.5,
              -0.7,
              -0.4,
              -0.1,
              -0.3,
              -0.2,
              -0.4,
              -0.5,
              -0.4,
              0.2,
              -0.6,
              -0.5,
              -0.2,
              -0.5,
              -0.8,
              -0.3,
              -0.2,
              0,
              -0.3,
              -0.1,
              0.1,
              0.4,
              0,
              0.7,
              -0.3,
              0.3,
              0.2,
              0.5,
              0.1,
              0.4,
              0.3,
              -0.6,
              0,
              -0.5,
              -0.8,
              -0.6,
              -0.4,
              -0.5,
              -0.6,
              -0.7,
              -0.6,
              0.2,
              -0.2,
              0,
              0.3,
              -0.6,
              -0.4,
              0,
              -0.2,
              -0.3,
              -0.1,
              -0.4,
              0.2,
              -0.2,
              0.1,
              -0.5,
              -0.7,
              -0.4,
              -0.6,
              -0.8,
              -0.4,
              -0.5,
              -0.3,
              -0.4,
              -0.3,
              -0.6,
              -0.7,
              -0.8,
              -0.9,
              -0.8,
              -0.5,
              0.2,
              0,
              -0.4,
              -0.3,
              -0.9,
              -0.2,
              0,
              -0.8,
              -0.8,
              -0.7,
              -0.8,
              -0.7,
              -0.8,
              -0.8,
              -0.4,
              -0.3,
              -0.5,
              -0.2,
              -0.4,
              -0.6,
              -0.9,
              -0.6,
              -0.8,
              0.1,
              -0.2,
              0,
              -0.7,
              0,
              -0.5,
              -0.3,
              -0.6,
              -0.8,
              -0.7,
              -0.9,
              -0.8,
              -0.9,
              -0.9,
              0.1,
              -0.6,
              -0.8,
              -0.7,
              -0.7,
              -0.8,
              -0.7,
              -0.8,
              -0.4,
              -0.7,
              -0.8,
              -0.5,
              0.7,
              0.6,
              -0.4,
              -0.3,
              -0.7,
              0,
              -0.5,
              0.4,
              -0.6,
              -0.8,
              -0.5,
              -0.7,
              -0.9,
              -0.8,
              -0.6,
              -0.9,
              -0.7,
              -0.5,
              -0.4,
              -0.3,
              -0.8,
              -0.2,
              -0.8,
              -0.4,
              -0.2,
              -0.9,
              -0.6,
              -0.4,
              -0.8,
              -0.9,
              -0.7,
              -0.8,
              -0.6,
              -0.8,
              -0.9,
              -0.5,
              -0.9,
              -0.8,
              -0.8,
              -0.3,
              -0.6,
              0.4,
              -0.8,
              -0.7,
              -0.7,
              -0.6,
              -0.8,
              -0.7,
              -0.8,
              -0.5,
              -0.7,
              -0.8,
              -0.4,
              -0.3,
              -0.8,
              -0.5,
              0.2,
              0,
              -0.6,
              -0.4,
              0,
              -0.2,
              -0.3,
              -0.5,
              0,
              -0.6,
              0.6,
              -0.3,
              0,
              -0.2,
              -0.7,
              -0.5,
              -0.6,
              -0.8,
              -0.7,
              -0.4,
              -0.8,
              -0.7,
              -0.6,
              -0.7,
              0.3,
              -0.5,
              0.2,
              -0.8,
              0,
              -0.6,
              -0.5,
              -0.6,
              -0.7,
              -0.5,
              -0.6,
              -0.7,
              -0.4,
              -0.7,
              -0.7,
              -0.4,
              -0.3,
              -0.8,
              -0.8,
              -0.6,
              -0.2,
              -0.5,
              -0.2,
              -0.7,
              -0.7,
              -0.6,
              0,
              -0.2,
              -0.5,
              -0.3,
              -0.7,
              0,
              -0.3,
              -0.6,
              -0.5,
              -0.6,
              -0.5,
              -0.7,
              -0.3,
              -0.4,
              -0.7,
              -0.7,
              -0.8,
              -0.5,
              0.6,
              -0.2,
              0.4,
              -0.9,
              -0.8,
              -0.7,
              -0.6,
              -0.8,
              -0.5,
              -0.3,
              -0.9,
              -0.2,
              -0.9,
              -0.7,
              -0.4,
              -0.5,
              -0.6,
              -0.8,
              -0.2,
              -0.4,
              -0.7,
              -0.5,
              -0.6,
              -0.3,
              0,
              0,
              -0.8,
              -0.7,
              -0.6,
              -0.8,
              -0.7,
              -0.5,
              -0.4,
              -0.8,
              -0.7,
              -0.6,
              -0.7,
              -0.6,
              -0.3,
              0,
              0,
              -0.5,
              -0.4,
              -0.7,
              -0.3,
              -0.8,
              -0.7,
              -0.8,
              0.3,
              0.4,
              -0.6,
              -0.8,
              -0.7,
              -0.5,
              -0.8,
              -0.7,
              -0.4,
              -0.2,
              -0.3,
              -0.4,
              -0.2,
              0.2,
              0.6,
              -0.6,
              0,
              -0.1,
              -0.3,
              -0.4,
              -0.5,
              0,
              0.3,
              -0.4,
              -0.2,
              0,
              -0.3,
              0.7,
              -0.8,
              -0.6,
              0.7,
              0,
              0,
              -0.4,
              -0.6,
              -0.7,
              -0.8,
              -0.8,
              -0.3,
              -0.5,
              -0.4,
              -0.6,
              -0.7,
              -0.4,
              -0.8,
              -0.5,
              -0.3,
              -0.2,
              -0.4,
              -0.1,
              -0.6,
              0.4,
              -0.2,
              -0.8,
              -0.3,
              -0.9,
              0.4,
              -0.2,
              -0.7,
              -0.4,
              -0.5,
              -0.3,
              0,
              -0.2,
              -0.4,
              -0.3,
              -0.5,
              -0.6,
              -0.2,
              -0.7,
              -0.4,
              0,
              0.1,
              -0.5,
              -0.2,
              0,
              0,
              -0.3,
              -0.5,
              -0.4,
              -0.6,
              -0.7,
              -0.8,
              -0.3,
              -0.2,
              -0.1,
              0,
              -0.6,
              -0.5,
              0.2,
              0,
              0,
              -0.1,
              -0.4,
              0,
              -0.3,
              -0.2,
              -0.3,
              0,
              0.1,
              -0.3,
              -0.4,
              -0.1,
              -0.2,
              0,
              -0.6,
              -0.7,
              -0.5,
              -0.3,
              -0.6,
              -0.4,
              -0.7,
              -0.8,
              -0.8,
              -0.6,
              -0.7,
              -0.6,
              -0.2,
              -0.7,
              0,
              -0.8,
              -0.1,
              -0.7,
              -0.5,
              -0.4,
              -0.5,
              -0.3,
              -0.6,
              0,
              -0.1,
              -0.4,
              0,
              0.1,
              -0.2,
              0,
              -0.3,
              -0.6,
              -0.7,
              -0.5,
              -0.4,
              -0.3,
              -0.2,
              -0.5,
              -0.3,
              -0.2,
              -0.3,
              -0.5,
              0.2,
              -0.2,
              -0.3,
              0,
              -0.3,
              -0.1,
              -0.2,
              -0.4,
              -0.6,
              0,
              -0.3,
              -0.2,
              -0.4,
              -0.5,
              0,
              -0.4,
              -0.1,
              -0.3,
              0,
              0.1,
              0,
              -0.7,
              -0.8,
              -0.9,
              0.3,
              -0.4,
              -0.5,
              -0.4,
              0,
              0,
              -0.2,
              -0.6,
              -0.7,
              -0.8,
              -0.4,
              -0.6,
              -0.3,
              -0.8,
              -0.7,
              -0.5,
              -0.3,
              -0.6,
              -0.5,
              -0.4,
              -0.3,
              -0.2,
              -0.2,
              -0.5,
              -0.7,
              -0.3,
              -0.6,
              -0.2,
              -0.8,
              -0.2,
              0,
              -0.8,
              -0.3,
              -0.7,
              -0.2,
              -0.3,
              -0.6,
              -0.4,
              0,
              -0.3,
              -0.8,
              -0.5,
              0.3,
              0.2,
              -0.8,
              0.3,
              -0.5,
              -0.4,
              -0.2,
              -0.7,
              0.3,
              0.7,
              0.8,
              0.8,
              0.2,
              0.5,
              -0.7,
              -0.6,
              0.4,
              -0.6,
              -0.4,
              -0.5,
              0.1,
              -0.7,
              0.7,
              -0.2,
              0.5,
              0.8,
              0.4,
              0.3,
              -0.5,
              0.7,
              0.4,
              0.3,
              0.6,
              0.5,
              0.7,
              0.8,
              0.6,
              0.4,
              -0.8,
              -0.3,
              0.3,
              0.7,
              0.8,
              -0.6,
              0.8,
              0.7,
              -0.2,
              0.8,
              0,
              0.6,
              0.3,
              -0.4,
              0.7,
              -0.2,
              -0.1,
              -0.2,
              -0.6
            ],
            "positive": 83,
            "neutral": 140,
            "negative": 597,
            "average_score": -0.35500000000000004,
            "total_analyzed": 820
          },
          "Conservative": {
            "scores": [
              -0.5,
              -0.8,
              -0.7,
              -0.7,
              -0.6,
              -0.7,
              -0.8,
              -0.5,
              -0.6,
              -0.7,
              -0.8,
              0.2,
              -0.8,
              -0.7,
              -0.8,
              -0.6,
              -0.7,
              -0.9,
              -0.7,
              -0.6,
              -0.4,
              -0.5,
              -0.6,
              -0.5,
              -0.6,
              -0.7,
              -0.4,
              -0.8,
              -0.8,
              -0.9,
              -0.8,
              -0.6,
              -0.7,
              -0.7,
              -0.9,
              -0.8,
              -0.8,
              -0.9,
              -0.8,
              -0.8,
              -0.8,
              -0.7,
              -0.9,
              -0.6,
              -0.8,
              -0.5,
              -0.8,
              0.4,
              -0.7,
              -0.3,
              0.8,
              -0.2,
              -0.6,
              0.6,
              -0.7,
              0.3,
              -0.5,
              -0.4,
              -0.6,
              -0.4,
              -0.3,
              0,
              -0.2,
              0.4,
              0.3,
              0,
              -0.4,
              -0.2,
              0.4,
              0,
              -0.2,
              -0.8,
              -0.7,
              -0.5,
              -0.8,
              -0.8,
              -0.6,
              -0.7,
              -0.8,
              0.7,
              -0.5,
              -0.6,
              -0.8,
              0.8,
              -0.7,
              -0.6,
              0,
              -0.7,
              -0.9,
              -0.2,
              -0.5,
              0,
              -0.5,
              -0.4,
              -0.7,
              -0.8,
              -0.3,
              -0.6,
              -0.8,
              -0.7,
              -0.6,
              -0.3,
              -0.5,
              -0.8,
              -0.7,
              -0.8,
              0.2,
              -0.6,
              -0.7,
              -0.4,
              -0.7,
              -0.8,
              -0.7,
              -0.8,
              -0.7,
              -0.3,
              -0.8,
              -0.9,
              -0.8,
              -0.8,
              -0.9,
              -0.7,
              -0.8,
              -0.8,
              -0.4,
              -0.7,
              -0.8,
              -0.3,
              -0.4,
              -0.5,
              -0.6,
              -0.5,
              -0.7,
              -0.9,
              -0.8,
              -0.7,
              -0.7,
              -0.9,
              -0.8,
              -0.6,
              -0.7,
              -0.6,
              -0.7,
              -0.8,
              -0.8,
              -0.8,
              -0.7,
              -0.8,
              -0.8,
              -0.8,
              -0.3,
              -0.6,
              -0.8,
              -0.7,
              -0.8,
              -0.9,
              -0.7,
              -0.6,
              -0.8,
              -0.7,
              0.3,
              -0.5,
              -0.8,
              -0.9,
              0.4,
              -0.7,
              -0.8,
              -0.9,
              -0.6,
              -0.5,
              -0.4,
              -0.8,
              0.2,
              -0.7,
              -0.9,
              -0.7,
              -0.8,
              -0.4,
              -0.9,
              -0.8,
              0.3,
              -0.9,
              -0.6,
              -0.7,
              -0.9,
              -0.8,
              0.2,
              -0.8,
              -0.6,
              -0.5,
              -0.6,
              -0.8,
              0.3,
              0.1,
              -0.7,
              -0.4,
              -0.8,
              -0.7,
              -0.4,
              -0.5,
              -0.3,
              -0.4,
              -0.2,
              -0.3,
              -0.5,
              -0.1,
              0,
              -0.8,
              0,
              -0.6,
              -0.7,
              -0.8,
              -0.9,
              -0.7,
              -0.9,
              0.4,
              0.2,
              -0.6,
              -0.7,
              0.3,
              0.4,
              -0.9,
              -0.7,
              -0.4,
              -0.8,
              -0.8,
              -0.7,
              0.3,
              -0.4,
              0.1,
              0.4,
              -0.2,
              0.2,
              0.1,
              -0.8,
              -0.6,
              -0.5,
              -0.7,
              -0.4,
              -0.8,
              -0.9,
              -0.8,
              -0.6,
              -0.5,
              -0.7,
              -0.6,
              -0.7,
              -0.6,
              -0.8,
              -0.7,
              -0.4,
              -0.8,
              -0.6,
              0.2,
              -0.7,
              -0.8,
              -0.6,
              -0.5,
              -0.4,
              -0.7,
              -0.9,
              -0.6,
              -0.3,
              -0.7,
              -0.6,
              -0.8,
              -0.9,
              -0.5,
              -0.8,
              -0.2,
              0.3,
              0.1,
              0.6,
              -0.5,
              -0.7,
              -0.8,
              -0.6,
              -0.5,
              -0.9,
              -0.2,
              -0.9,
              -0.4,
              -0.8,
              0.3,
              -0.9,
              -0.5,
              -0.6,
              -0.7,
              0.4,
              0.5,
              0.1,
              -0.7,
              0.3,
              -0.8,
              -0.4,
              -0.7,
              -0.4,
              -0.8,
              -0.6,
              -0.9,
              -0.8,
              -0.3,
              -0.9,
              -0.7,
              0.1,
              -0.6,
              -0.7,
              -0.4,
              0.3,
              0.2,
              0,
              0.2,
              -0.5,
              0,
              0,
              -0.4,
              -0.3,
              -0.4,
              -0.5,
              -0.3,
              -0.4,
              -0.5,
              0.3,
              0.1,
              0.1,
              0,
              -0.2,
              0,
              0.2,
              0,
              0.1,
              0,
              0.2,
              -0.3,
              0,
              0.1,
              0.2,
              -0.4,
              -0.3,
              0.1,
              -0.4,
              0.3,
              -0.6,
              -0.7,
              -0.5,
              -0.2,
              0.2,
              -0.5,
              -0.4,
              0.1,
              -0.3,
              -0.4,
              -0.6,
              -0.2,
              -0.7,
              -0.8,
              -0.6,
              -0.3,
              -0.7,
              -0.4,
              -0.6,
              -0.5,
              -0.6,
              -0.7,
              -0.5,
              -0.4,
              0.2,
              -0.3,
              -0.5,
              -0.6,
              -0.4,
              -0.2,
              0.3,
              -0.7,
              -0.4,
              -0.5,
              -0.3,
              -0.5,
              -0.4,
              -0.3,
              -0.7,
              -0.5,
              -0.6,
              -0.2,
              -0.5,
              -0.7,
              -0.3,
              -0.2,
              -0.5,
              0.1,
              -0.3,
              -0.4,
              -0.6,
              -0.7,
              -0.8,
              -0.4,
              -0.3,
              -0.6,
              -0.5,
              -0.4,
              -0.7,
              -0.8,
              -0.6,
              -0.7,
              0.5,
              -0.2,
              0.3,
              0.6,
              0.1,
              -0.4,
              -0.5,
              0,
              -0.3,
              -0.4,
              -0.8,
              -0.7,
              -0.6,
              -0.2,
              -0.1,
              0.4,
              0.3,
              -0.6,
              -0.4,
              -0.8,
              -0.5,
              -0.4,
              -0.3,
              -0.2,
              -0.7,
              -0.4,
              -0.3,
              -0.6,
              0.4,
              -0.8,
              -0.7,
              -0.4,
              0.2,
              -0.3,
              -0.6,
              -0.8,
              -0.7,
              -0.8,
              -0.7,
              -0.6,
              -0.3,
              -0.4,
              -0.8,
              0.3,
              0.2,
              -0.4,
              -0.6,
              -0.3,
              -0.7,
              -0.8,
              -0.4,
              0.2,
              -0.6,
              -0.9,
              -0.8,
              -0.7,
              -0.3,
              -0.6,
              -0.7,
              -0.5,
              -0.6,
              0.4,
              0.3,
              -0.8,
              -0.7,
              -0.4,
              0.4,
              -0.8,
              -0.5,
              -0.4,
              -0.6,
              -0.7,
              -0.6,
              -0.2,
              -0.5,
              0.3,
              -0.8,
              -0.4,
              0.5,
              0.4,
              0,
              -0.7,
              -0.8,
              -0.3,
              -0.4,
              -0.9,
              -0.7,
              -0.8,
              -0.6,
              -0.5,
              -0.6,
              -0.3,
              -0.7,
              -0.4,
              -0.8,
              -0.9,
              -0.8,
              -0.2,
              -0.7,
              -0.9,
              -0.8,
              -0.7,
              -0.6,
              -0.7,
              -0.8,
              -0.6,
              -0.7,
              -0.8,
              -0.4,
              0,
              0,
              -0.1,
              0.2,
              0.3,
              0,
              -0.7,
              -0.5,
              -0.4,
              0.3,
              -0.6,
              -0.7,
              -0.8,
              -0.7,
              -0.6,
              -0.7,
              -0.5,
              0.2,
              -0.5,
              -0.6,
              -0.8,
              -0.7,
              -0.9,
              -0.8,
              -0.8,
              -0.7,
              -0.7,
              -0.6,
              -0.8,
              -0.5,
              -0.3,
              -0.2,
              -0.8,
              -0.9,
              -0.9,
              -0.7,
              -0.8,
              -0.7,
              -0.8,
              -0.5,
              -0.6,
              -0.4,
              -0.7,
              -0.8,
              -0.7,
              -0.5,
              -0.6,
              -0.7,
              -0.6,
              -0.8,
              -0.7,
              -0.7,
              -0.4,
              -0.6,
              -0.5,
              -0.6,
              -0.7,
              -0.3,
              -0.6,
              -0.7,
              -0.8,
              -0.2,
              -0.3,
              -0.5,
              -0.8,
              -0.7,
              -0.4,
              -0.6,
              -0.5,
              -0.2,
              0,
              -0.3,
              -0.6,
              0.3,
              -0.2,
              0.2,
              0.4,
              -0.6,
              -0.3,
              0.2,
              -0.8,
              0.3,
              -0.7,
              -0.5,
              -0.8,
              -0.7,
              -0.4,
              -0.6,
              0,
              -0.4,
              -0.6,
              -0.3,
              -0.2,
              0.3,
              -0.7,
              0.2,
              -0.6,
              0.3,
              -0.7,
              -0.6,
              -0.7,
              -0.8,
              0,
              -0.8,
              -0.5,
              0,
              -0.4,
              -0.6,
              -0.5,
              -0.6,
              -0.2,
              -0.7,
              -0.5,
              -0.4,
              -0.4,
              -0.6,
              -0.4,
              -0.3,
              -0.2,
              -0.5,
              -0.7,
              -0.6,
              -0.5,
              -0.6,
              -0.7,
              -0.6,
              -0.5,
              0,
              -0.6,
              -0.3,
              -0.8,
              -0.7,
              -0.2,
              -0.5,
              -0.3,
              -0.7,
              -0.6,
              -0.4,
              -0.5,
              -0.7,
              -0.6,
              -0.3,
              -0.4,
              -0.2,
              -0.8,
              0.1,
              -0.4,
              -0.5,
              -0.3,
              0.1,
              0.2,
              -0.4,
              -0.6,
              -0.3,
              -0.7,
              -0.4,
              -0.5,
              -0.4,
              -0.2,
              -0.3,
              -0.5,
              -0.6,
              -0.3,
              -0.5,
              0.3,
              0.2,
              0.4,
              -0.4,
              -0.8,
              -0.6,
              -0.7,
              -0.8,
              -0.7,
              -0.3,
              0.5,
              0.4,
              -0.7,
              -0.4,
              -0.3,
              -0.2,
              -0.6,
              -0.3,
              0.7,
              0.6,
              0,
              0.7,
              0.4,
              -0.2,
              -0.5,
              -0.3,
              -0.4,
              -0.2,
              0,
              -0.5,
              -0.1,
              -0.3,
              0,
              0.2,
              0.4,
              -0.2,
              -0.3,
              -0.2,
              -0.4,
              -0.3,
              0,
              -0.1,
              0.3,
              -0.6,
              -0.4,
              -0.2,
              -0.3,
              -0.4,
              -0.5,
              0,
              -0.4,
              -0.2,
              -0.1,
              -0.3,
              0,
              -0.3,
              -0.2,
              -0.8,
              -0.7,
              -0.6,
              -0.4,
              -0.5,
              -0.6,
              -0.8,
              -0.9,
              -0.8,
              -0.6,
              -0.7,
              -0.8,
              -0.7,
              -0.7,
              -0.8,
              -0.8,
              -0.8,
              -0.7,
              -0.8,
              -0.8,
              -0.7,
              -0.7,
              -0.6,
              -0.8,
              -0.9,
              -0.7,
              -0.6,
              -0.7,
              -0.8,
              -0.9,
              -0.9,
              -0.5,
              -0.7,
              -0.8,
              0.2,
              0.3,
              -0.6,
              -0.4,
              -0.5,
              -0.3,
              -0.6,
              -0.8,
              0.2,
              -0.7,
              -0.7,
              -0.8,
              0.3,
              0.2,
              -0.6,
              -0.4,
              0.3,
              -0.4,
              -0.8,
              -0.8,
              -0.9,
              -0.7,
              -0.4,
              -0.6,
              -0.5,
              -0.8,
              -0.7,
              -0.8,
              -0.9,
              -0.6,
              -0.8,
              -0.7,
              -0.7,
              -0.3,
              -0.8,
              0.2,
              -0.2,
              0.6,
              0.8,
              -0.6,
              -0.8,
              -0.7,
              -0.6,
              -0.5,
              0,
              -0.4,
              -0.7,
              0,
              -0.3,
              -0.8,
              0,
              0.3,
              -0.2,
              -0.3,
              -0.7,
              -0.6,
              0,
              -0.8,
              0,
              -0.3,
              0.2,
              -0.8,
              0.4,
              -0.6,
              0.5,
              -0.7,
              -0.8,
              -0.7,
              -0.8,
              -0.6,
              -0.7,
              -0.5,
              -0.6,
              -0.7,
              -0.8,
              -0.7,
              -0.4,
              -0.6,
              -0.7,
              -0.5,
              -0.6,
              -0.8,
              -0.3,
              -0.6,
              -0.8,
              0,
              0,
              0,
              -0.6,
              -0.7,
              -0.9,
              -0.8,
              -0.8,
              -0.9,
              -0.6,
              -0.7,
              -0.7,
              0.4,
              -0.8,
              -0.8,
              -0.7,
              -0.5,
              -0.6,
              0,
              -0.4,
              -0.3,
              0.3,
              -0.2,
              -0.8,
              -0.4,
              -0.2,
              0.2,
              0.6,
              -0.5,
              -0.6,
              -0.2,
              -0.5,
              0.6,
              0.5,
              -0.6,
              -0.5,
              -0.4,
              -0.8,
              -0.7,
              -0.4,
              -0.6,
              0,
              -0.2,
              -0.5,
              -0.7,
              -0.6,
              -0.7,
              0.2,
              -0.3,
              -0.8,
              -0.7,
              -0.9,
              -0.8,
              -0.6,
              -0.8,
              -0.5,
              -0.7,
              -0.8,
              -0.6,
              -0.7,
              -0.7,
              -0.3,
              -0.7,
              -0.6,
              -0.9,
              -0.6,
              -0.2,
              -0.7,
              -0.8,
              -0.6,
              0.3,
              0.2,
              -0.8,
              -0.8,
              -0.5,
              0.4,
              -0.6,
              -0.4,
              -0.8,
              -0.7,
              0.4,
              -0.7,
              0.5,
              -0.6,
              0.3,
              0.4,
              -0.4,
              0.3,
              -0.5,
              -0.8,
              0.2,
              -0.7,
              0.4,
              -0.5,
              0.3,
              -0.3,
              -0.6,
              -0.4,
              -0.6,
              -0.7,
              -0.3,
              -0.5,
              -0.6,
              -0.4,
              -0.5,
              -0.6,
              -0.8,
              -0.5,
              -0.6,
              -0.3,
              -0.7,
              -0.5,
              -0.4,
              -0.5,
              -0.8,
              -0.7,
              -0.6
            ],
            "positive": 91,
            "neutral": 94,
            "negative": 785,
            "average_score": -0.4437113402061863,
            "total_analyzed": 970
          }
        },
        "timeline": [
          {
            "date": "2025-09-08",
            "average_score": -0.5225806451612904,
            "positive": 4,
            "neutral": 4,
            "negative": 54,
            "total": 62
          },
          {
            "date": "2025-09-09",
            "average_score": -0.0303030303030303,
            "positive": 45,
            "neutral": 25,
            "negative": 62,
            "total": 132
          },
          {
            "date": "2025-09-10",
            "average_score": -0.5344743276283622,
            "positive": 16,
            "neutral": 37,
            "negative": 356,
            "total": 409
          },
          {
            "date": "2025-09-11",
            "average_score": -0.45249266862170134,
            "positive": 62,
            "neutral": 65,
            "negative": 555,
            "total": 682
          },
          {
            "date": "2025-09-12",
            "average_score": -0.3267217630853994,
            "positive": 28,
            "neutral": 83,
            "negative": 252,
            "total": 363
          },
          {
            "date": "2025-09-13",
            "average_score": -0.27676056338028154,
            "positive": 19,
            "neutral": 20,
            "negative": 103,
            "total": 142
          }
        ],
        "ai_insights": {
          "democrats": "Based on the posts from r/democrats, here is my analysis:\n\nOverall Community Mood and Attitudes:\n- The community appears deeply concerned and frustrated with the state of American politics, particularly the influence and rhetoric of the MAGA movement and the Republican Party. There is a sense of alarm and outrage at perceived threats to democracy and violence from the far-right.\n- The community is highly engaged and passionate, frequently using strong language and imagery to convey their views. There is a prevalent \"us vs. them\" mentality towards MAGA supporters.\n\nCommon Themes, Concerns, and Topics of Interest:\n- The Epstein files and efforts to conceal information about the Epstein scandal are a major focus, with the community pushing for transparency and accountability.\n- The community is heavily invested in monitoring and criticizing the actions and statements of prominent MAGA figures, including the president and social media influencers.\n- There is a strong interest in highlighting and condemning perceived right-wing extremism, violence, and conspiracy theories, especially in the wake of tragic events like the shooting of Charlie Kirk.\n- The community is closely following and supporting progressive political candidates, such as James Talarico's Senate campaign in Texas.\n\nPatterns in Upvoted/Discussed Content:\n- Posts that directly call out and condemn MAGA figures and their rhetoric tend to receive the highest engagement and scores.\n- Content related to exposing corruption, cover-ups, and right-wing extremism is enthusiastically received and discussed.\n- Positive coverage of progressive politicians and their campaigns also generates significant interest and support.\n\nEmerging Trends and Shifts in Opinion:\n- The community appears to be increasingly disillusioned and hardened in its opposition to the MAGA movement, with little apparent willingness to engage in good-faith dialogue or compromise.\n- There is a growing sense of urgency and desperation to confront and defeat what the community perceives as a rising tide of authoritarianism and political violence from the right.\n\nPain Points and Frustrations:\n- The community is deeply frustrated by what it sees as the continued cover-up and obfuscation of the Epstein scandal, as well as the perceived normalization and defense of right-wing extremism by MAGA figures.\n- There is a strong sense of powerlessness and concern that the democratic system is being undermined, with the Supreme Court and other institutions being viewed as blatantly partisan.\n\nOverall, the analysis suggests that the r/democrats community is in a highly polarized and adversarial state, with a deep sense of existential threat and a burning desire to confront and defeat what it sees as the dangerous forces of authoritarianism and extremism within the MAGA movement. The community is highly engaged, but also appears increasingly disillusioned and unwilling to compromise, reflecting the broader political divisions and tensions within the United States.",
          "Conservative": "Based on the posts from r/Conservative, here is my analysis:\n\nOverall Community Mood and Attitudes:\n- The community is deeply saddened, shocked, and outraged over the assassination of Charlie Kirk. There is a strong sense of grief, betrayal, and a loss of hope in the face of such a devastating event.\n- There is a strong perception that the \"left\" and liberal voices on social media are celebrating or downplaying Kirk's death, fueling the community's sense of victimization and alienation.\n- The tone is largely somber, but also defiant - the community sees this as a turning point that will ultimately strengthen their resolve and commitment to their cause.\n\nCommon Themes, Concerns, and Topics of Interest:\n- The primary focus is on Charlie Kirk's assassination, the circumstances around it, and the reaction from the \"left\" and broader public.\n- There is a strong emphasis on the importance of free speech, civil discourse, and the perceived inability of the \"left\" to engage in respectful debate.\n- The community expresses deep concern about the level of political polarization, the prevalence of political violence, and the erosion of shared values and norms.\n- There are recurring references to the role of social media and its perceived biases, as well as calls for greater accountability and moderation of online discourse.\n\nPatterns in What Gets Upvoted/Discussed:\n- Posts and comments that express grief, outrage, and a sense of victimization tend to receive the highest levels of engagement and support.\n- Content that criticizes the \"left\" for their perceived lack of empathy or celebratory attitude is also highly upvoted.\n- There is a strong emphasis on the importance of free speech and the need to counter what is seen as the \"radicalization\" of the left.\n\nEmerging Trends or Shifts in Opinion:\n- The community appears to be experiencing a significant shift in its political orientation, with some members expressing a willingness to abandon the Democratic party entirely due to their perception of the left's reaction to Kirk's death.\n- There is a growing sense of disillusionment with the political process and a belief that traditional channels of debate and discourse are no longer effective or reliable.\n- The community seems to be coalescing around a more confrontational and defensive posture, with increased calls for action and accountability against perceived political enemies.\n\nPain Points or Frustrations:\n- The community is deeply frustrated by what they see as the left's indifference or celebration of Kirk's death, as well as the perceived inability of the mainstream media to accurately report on and condemn such reactions.\n- There is a strong sense of betrayal and a feeling that the \"rules of the game\" have been fundamentally violated, undermining the community's faith in the democratic process and the possibility of meaningful dialogue.\n- The community appears to be grappling with a profound sense of vulnerability and a fear that political violence may become more widespread, further exacerbating their feelings of isolation and alienation.\n\nCurrent State of the Community:\n- The r/Conservative community is in a state of deep crisis and uncertainty, reeling from the shock of Kirk's assassination and the perceived lack of empathy or accountability from their political opponents.\n- There is a palpable sense of vulnerability and a growing conviction that the political landscape has fundamentally shifted, with the community feeling increasingly isolated and under threat.\n- While the community remains resolute in its commitment to its core values and beliefs, there is a growing sense of desperation and a willingness to consider more confrontational or uncompromising approaches to addressing perceived threats.\n- The community's faith in the democratic process and the possibility of meaningful dialogue across ideological lines appears to be severely strained, raising concerns about the potential for further polarization and instability.",
          "politics": "Based on the data provided, here is my analysis of the sentiment and themes within the r/politics community:\n\nOverall Mood and Attitudes:\nThe overall community mood appears to be highly critical and distrustful of the Republican party, particularly in relation to allegations of corruption, sexual misconduct, and protection of individuals like Donald Trump and Charlie Kirk. There is a strong sense of outrage and frustration towards perceived Republican attempts to cover up or suppress damaging information.\n\nCommon Themes and Topics of Interest:\n- The Trump-Epstein connection and efforts to conceal or downplay information related to their relationship\n- Concerns about Republican politicians' involvement in or protection of pedophilia and sexual abuse\n- Criticism of Republican figures like Trump, Kirk, and Vance, often with strong language\n- Discussions around the need for accountability and justice, including calls for prosecution and legal action\n- Comparisons between the US and other countries that have been able to remove or prosecute similar authoritarian figures\n\nPatterns in Upvotes/Discussion:\nPosts and comments that expose or condemn alleged Republican misconduct, especially related to Trump, Epstein, and sexual abuse, tend to receive the highest levels of engagement and upvotes. There is a clear appetite within the community to uncover and publicize this information.\n\nEmerging Trends and Shifts:\nThe community appears to be growing increasingly radicalized and polarized, with a marked shift towards more confrontational and aggressive language and attitudes towards the Republican party. This suggests a growing sense of urgency and desperation within the community to see meaningful action and change.\n\nPain Points and Frustrations:\nThe primary pain points and frustrations expressed by the community center around a perceived lack of accountability and justice for Republican figures, as well as a sense that the system is rigged to protect them. There is a strong feeling that the Democratic party and the justice system have been ineffective in addressing these issues.\n\nCurrent State of the Community:\nThe r/politics community appears to be in a state of heightened tension and politicization, with a laser-like focus on exposing and condemning alleged Republican misconduct, particularly related to sexual abuse and corruption. The community is highly engaged and passionate, but also increasingly radicalized and confrontational in its approach. This suggests a community that is deeply frustrated with the status quo and desperate for tangible change and accountability."
        },
        "framework_analysis": {
          "success": true,
          "analysis": "**COMMUNITY PROFILING**\n\n• Community Type: Political/News/Discussion\n• Demographic Indicators: Primarily politically engaged adults, skewing liberal and conservative in respective subreddits\n• Emotional Baseline: Highly negative (-0.4 overall sentiment)\n• Community Character: These political subreddits demonstrate high polarization and emotional reactivity, particularly around controversial events. The discourse shows clear tribal dynamics with strong in-group/out-group divisions.\n\n**PATTERN DISCOVERY**\n\n🔍 Key Findings:\n\n1. Surprising Pattern #1:\n   Cross-subreddit sentiment convergence during crisis events - both r/democrats and r/Conservative showed similarly negative sentiment patterns (-0.35 vs -0.44) despite opposing viewpoints\n\n2. Surprising Pattern #2:\n   High engagement posts often featured emotional rather than factual content, with inflammatory titles generating 3-4x more comments than neutral ones\n\n3. Surprising Pattern #3:\n   Time-of-day posting patterns showed coordinated messaging waves, suggesting potential organized narrative pushing\n\n💬 Controversy Triggers:\n• Violence/shooting incidents\n• Political figure deaths\n• Accusations of partisan responsibility \n• Criminal investigations (Epstein files)\n\n📊 Success/Failure Predictors:\n• Success indicators: Emotionally charged language, tribal signaling, crisis-related content\n• Failure indicators: Nuanced discussion, moderate positions, fact-checking attempts\n\n**TEMPORAL ANALYSIS**\n\n⏰ Time-Based Patterns:\n\nDaily Cycles:\n• Morning: Lower engagement, more neutral tone\n• Afternoon: Peak posting activity, increased negativity\n• Evening: Highest comment velocity, most extreme sentiment\n\nWeekly Trends:\n• Weekday engagement significantly higher than weekends\n• Crisis events drive 24-hour engagement spikes\n• Sentiment deteriorates over multi-day news cycles\n\nSentiment Evolution:\n• Started at -0.52 on Day 1\n• Improved briefly to -0.03 on Day 2\n• Deteriorated to -0.53 during peak crisis\n• Gradually recovered to -0.27 by end of period\n\n**KEY INSIGHTS**\n\n⭐ Most Important Discoveries:\n\n1. Engagement Correlation:\n   Higher engagement strongly correlates with negative sentiment (-0.4 to -0.5 range)\n\n2. Unspoken Rules:\n   Both communities enforce ideological conformity through aggressive downvoting of dissent\n\n3. Influence Patterns:\n   Top comments set emotional tone for entire threads, with cascading sentiment effects\n\n4. Content Predictors:\n   Posts alleging opposition misconduct generate highest engagement\n\n**ACTIONABLE RECOMMENDATIONS**\n\n📝 Content Strategy:\n• Best performing content types: Breaking news, accusations against opposition\n• Optimal post structure: Short, emotional titles with clear villains/victims\n• Language style: Tribal signaling, moral outrage, calls to action\n\n⏱️ Timing Strategy:\n• Best posting times: 2-4pm EST for maximum reach\n• Avoid posting: Early morning, late night, weekends\n\n🚫 Topics to Avoid:\n• Nuanced policy discussions (low engagement)\n• Calls for moderation (negative community response)\n\n✅ Topics that Resonate:\n• Opposition misconduct allegations\n• Crisis events with clear partisan angles\n• Internal community validation\n\n**QUESTIONS FOR DEEPER ANALYSIS**\n\n🤔 Compelling comparison questions:\n\n1. How do sentiment patterns differ between crisis and non-crisis periods?\n2. What role do moderators play in shaping narrative formation?\n3. How do cross-posted topics evolve differently in opposing subreddits?\n4. What triggers shifts from negative to positive sentiment?\n5. How do bot patterns differ from human engagement patterns?\n\n**SUMMARY**\n\n📋 Executive Summary:\nThe analysis reveals highly polarized political communities with strong emotional engagement patterns driven by crisis events and partisan narratives. Both communities show similar behavioral patterns despite opposing viewpoints, with negative sentiment dominating discourse (-0.4 average). Success metrics favor emotional, tribal content over neutral discussion, suggesting these spaces primarily serve as emotional/ideological reinforcement mechanisms rather than platforms for political dialogue.",
          "generated_at": "2025-09-14T22:43:34.556Z",
          "model_used": "Claude 3.5 Sonnet"
        },
        "synthetic_post": {
          "title": "Republicans trying to block Trump's 14th Amendment disqualification... again",
          "author": "BlueDemVoter2024",
          "body": "The GOP is in full panic mode trying to keep Trump on the ballot despite clear constitutional grounds for disqualification. Maine and Colorado already made the right call - he engaged in insurrection, period.\n\nWe need to keep pushing state officials to uphold their constitutional duty. The 14th Amendment isn't just a suggestion.",
          "score": 2341,
          "upvoteRatio": 0.92,
          "comments": [
            {
              "id": "comment1",
              "author": "DemocracyDefender",
              "body": "The Constitution is crystal clear on this. Section 3 of the 14th Amendment exists for exactly this reason.",
              "score": 876,
              "replies": [],
              "level": 0,
              "sentiment": "neutral"
            },
            {
              "id": "comment2",
              "author": "VoteBlue2024",
              "body": "MAGA tears are delicious. They scream about the Constitution until it's used against their god-emperor.",
              "score": 654,
              "replies": [],
              "level": 0,
              "sentiment": "negative"
            },
            {
              "id": "comment3",
              "author": "ProgressivePal",
              "body": "Remember to VOTE! This isn't over until we keep him out of office permanently.",
              "score": 543,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment4",
              "author": "TruthMatters2024",
              "body": "The Supreme Court is going to hear this case. With their current makeup, I'm worried they'll just ignore the Constitution like they did with Roe.",
              "score": 421,
              "replies": [],
              "level": 0,
              "sentiment": "negative"
            },
            {
              "id": "comment5",
              "author": "ResistanceWins",
              "body": "Dark Brandon is crushing it in the polls while Trump keeps racking up indictments. Love to see it.",
              "score": 387,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment6",
              "author": "BlueWave2024",
              "body": "Meanwhile they're still trying to distract us from the Epstein files...",
              "score": 298,
              "replies": [],
              "level": 0,
              "sentiment": "negative"
            },
            {
              "id": "comment7",
              "author": "DemocracyFirst",
              "body": "Every state needs to do what Colorado and Maine did. He's clearly disqualified under the 14th.",
              "score": 276,
              "replies": [],
              "level": 0,
              "sentiment": "neutral"
            },
            {
              "id": "comment8",
              "author": "GQPNoMore",
              "body": "The GQP has become a full-on fascist party. They don't care about democracy anymore.",
              "score": 245,
              "replies": [],
              "level": 0,
              "sentiment": "negative"
            },
            {
              "id": "comment9",
              "author": "BidenHarris2024",
              "body": "Keep fighting! Register voters, donate, volunteer - we can't let them steal another election.",
              "score": 198,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment10",
              "author": "TrumpForPrison24",
              "body": "91 indictments and counting! Lock him up!",
              "score": 167,
              "replies": [],
              "level": 0,
              "sentiment": "negative"
            }
          ],
          "subreddit": "democrats",
          "timeAgo": "4 hours ago",
          "sentiment": "neutral",
          "generated_at": "2025-09-14T22:42:55.021Z",
          "version": 1
        }
      },
      "posts": [
        {
          "id": "1neosfb",
          "title": "Let’s stay focused on the Epstein Files!",
          "selftext": "",
          "score": 21160,
          "num_comments": 191,
          "created_utc": 1757635841,
          "subreddit": "democrats",
          "permalink": "/r/democrats/comments/1neosfb/lets_stay_focused_on_the_epstein_files/",
          "url": "https://i.redd.it/x5xzyckqlmof1.jpeg",
          "author": "Economy_Swim_8585",
          "comments": [
            {
              "id": "ndqfxru",
              "body": "They just blocked ANOTHER VOTE to release the epstein files. You know what they say.",
              "score": 89,
              "created_utc": 1757637827,
              "author": "WallishXP"
            },
            {
              "id": "ndqcq0o",
              "body": "I’ve said my ouch and oh nos, WHERE ARE THE EPSTEIN FILES",
              "score": 40,
              "created_utc": 1757636715,
              "author": "HotSprinkles10"
            },
            {
              "id": "ndqg0fv",
              "body": "![gif](giphy|noCtcSKvN0Mm9gmw1r|downsized)",
              "score": 37,
              "created_utc": 1757637852,
              "author": "WallishXP"
            },
            {
              "id": "ndqfi9j",
              "body": "Epstein's MAGA will keep trying to pretend half their ranks aren't child predators.",
              "score": 29,
              "created_utc": 1757637680,
              "author": "Sharp_Drag5870"
            }
          ]
        },
        {
          "id": "1nfftsi",
          "title": "Well,is MAGA going to apologize?",
          "selftext": "",
          "score": 15677,
          "num_comments": 1264,
          "created_utc": 1757713413,
          "subreddit": "democrats",
          "permalink": "/r/democrats/comments/1nfftsi/wellis_maga_going_to_apologize/",
          "url": "https://i.redd.it/2qdqs1re0tof1.jpeg",
          "author": "Nice_Substance9123",
          "comments": [
            {
              "id": "ndw5c0j",
              "body": "We know how Trump reacted with the press today. He immediately changed the subject to the tacky new ballroom being built at the White House. They were creaming for the killer to be a Democrat. Turns out he’s a Nick Fuentes superfan.",
              "score": 1169,
              "created_utc": 1757713909,
              "author": "crapbag73"
            },
            {
              "id": "ndw8utp",
              "body": "The civil war has been cancelled. The shooter was demographically uncooperative.",
              "score": 587,
              "created_utc": 1757715066,
              "author": "Confident_End_3848"
            },
            {
              "id": "ndw552q",
              "body": "They’ll just claim he wasn’t actually right wing. That’s what they did when that guy “shot” frump.",
              "score": 500,
              "created_utc": 1757713846,
              "author": "ArchitectTJN_85Ranks"
            },
            {
              "id": "ndwl7um",
              "body": "Kid grew up in super MAGA family state and friends and he’s not trans he snapped obviously \nBut really does the MAGA need all this hate and revenge I remember when Republicans had class and didn’t hate so much but right now they have so much fear of Trump they have all crawled in a hole",
              "score": 268,
              "created_utc": 1757719343,
              "author": "trastamara22"
            }
          ]
        },
        {
          "id": "1ne1t0q",
          "title": "Deeply disturbing rhetoric is spreading from influential MAGA figures (including the President of the United States and the owner of this website). They have no idea who the shooter is, and many of these same people mocked Democrats when they were victims of political violence in the past.",
          "selftext": "",
          "score": 12768,
          "num_comments": 733,
          "created_utc": 1757573205,
          "subreddit": "democrats",
          "permalink": "/r/democrats/comments/1ne1t0q/deeply_disturbing_rhetoric_is_spreading_from/",
          "url": "https://i.redd.it/rzag680ifhof1.jpeg",
          "author": "Nice_Substance9123",
          "comments": [
            {
              "id": "ndlewgx",
              "body": "Very coordinated messaging.",
              "score": 1832,
              "created_utc": 1757574333,
              "author": "Oceanbreeze871"
            },
            {
              "id": "ndlk7te",
              "body": "Almost as if…they had a plan. Now, maybe it wasn’t specifically around Kirk, but it does seem like perhaps the Nazi party in the WH was getting a tad frustratied that the blue states weren’t acting like they thought (because we aren’t idiots), so they had a plan to false flag to get martial law or worse enacted. Maybe they sacrificed Kirk, or maybe this is just them being opportunistic.\n\nEither wa...",
              "score": 1185,
              "created_utc": 1757577409,
              "author": "MaddyKet"
            },
            {
              "id": "ndlj5f0",
              "body": "The fact that they're blaming Democrats is bizarre.\n\nMainstream progressive voices rarely if ever advocate with threatening rhetoric. Certainly not to the degree that the 2A nutters do.\n\nAnd the Democratic Party itself? They don't give a shit about Charlie Kirk. He wasn't *that* influential. To the degree anyone not-on-the-right knew about him, he was just a guy with a weirdly-sized face.",
              "score": 899,
              "created_utc": 1757576771,
              "author": "KR1735"
            },
            {
              "id": "ndller4",
              "body": "It’s almost identical to Butler, PA—he was slipping in the polls, lines out the door for Harris, enthusiasm off the charts, and then suddenly… everything flipped.\n\nIf only there were some dramatic, billion-dollar-scale event that could’ve shifted everything overnight… hmmm, what could that possibly be?",
              "score": 523,
              "created_utc": 1757578129,
              "author": "Clean_Lettuce9321"
            }
          ]
        },
        {
          "id": "1ncie4h",
          "title": "Gavin is 100% correct ha",
          "selftext": "",
          "score": 8876,
          "num_comments": 228,
          "created_utc": 1757423136,
          "subreddit": "democrats",
          "permalink": "/r/democrats/comments/1ncie4h/gavin_is_100_correct_ha/",
          "url": "https://i.redd.it/dcvg4vv915of1.jpeg",
          "author": "Paneraiguy1",
          "comments": [
            {
              "id": "nd9pb61",
              "body": "https://preview.redd.it/mp5q7pqse5of1.jpeg?width=1179&format=pjpg&auto=webp&s=a968c84ec82f6cc39a5def4e3292ec2102065549",
              "score": 581,
              "created_utc": 1757427686,
              "author": "archimidesx"
            },
            {
              "id": "nd9fbfa",
              "body": "Couch boy! Lolol.",
              "score": 492,
              "created_utc": 1757424579,
              "author": "Honest_Yesterday4435"
            },
            {
              "id": "nd9eclo",
              "body": "Imagine if during the campaign Walz had been allowed to keep ribbing MAGA with his Midwest nice demeanor calling them weird and what not, we would’ve had this in the bag.",
              "score": 450,
              "created_utc": 1757424266,
              "author": "philter25"
            },
            {
              "id": "nd9jk97",
              "body": "You will never convince me that they didn’t have it in the bag. I can feel it in my bones they rigged the election!\n\n\nAnd he definitely wasn’t shot.",
              "score": 406,
              "created_utc": 1757425943,
              "author": "WoahIdidntknowthat"
            }
          ]
        },
        {
          "id": "1ne4mti",
          "title": "Good morning everyone...Now back to the Epstein files!",
          "selftext": "",
          "score": 8122,
          "num_comments": 147,
          "created_utc": 1757584419,
          "subreddit": "democrats",
          "permalink": "/r/democrats/comments/1ne4mti/good_morning_everyonenow_back_to_the_epstein_files/",
          "url": "https://i.redd.it/f4hemjstciof1.jpeg",
          "author": "Aggravating_Tax_4670",
          "comments": [
            {
              "id": "ndlyzkj",
              "body": "If Trump wasn’t far too honourable to have an ally shot from a rooftop, I’d be super suspicious that the Epstein drawing is suddenly an old story and MAGA is once again uniting against the ‘loony left’!",
              "score": 180,
              "created_utc": 1757585968,
              "author": "rically95"
            },
            {
              "id": "ndm6hp8",
              "body": "This photo is creepy",
              "score": 147,
              "created_utc": 1757589580,
              "author": "kerryfinchelhillary"
            },
            {
              "id": "ndm8czo",
              "body": "https://preview.redd.it/xikhoxdmuiof1.jpeg?width=1000&format=pjpg&auto=webp&s=563dd142db3f9b03ffa75ed4b2d729fb6741a44d",
              "score": 103,
              "created_utc": 1757590397,
              "author": "AccountantSummer"
            },
            {
              "id": "ndlwho7",
              "body": "Yes. Done with the deflection from yesterday.\nWhere are all the Epstein files!",
              "score": 88,
              "created_utc": 1757584622,
              "author": "Vstarpappy"
            }
          ]
        },
        {
          "id": "1nc22ui",
          "title": "This Supreme Court is nothing but a partisan Republican political operation",
          "selftext": "",
          "score": 5845,
          "num_comments": 113,
          "created_utc": 1757370888,
          "subreddit": "democrats",
          "permalink": "/r/democrats/comments/1nc22ui/this_supreme_court_is_nothing_but_a_partisan/",
          "url": "https://i.redd.it/woeel1gsp0of1.png",
          "author": "OldBridge87",
          "comments": [
            {
              "id": "nd61mxc",
              "body": "I'll try to explain it. Both help white people.",
              "score": 332,
              "created_utc": 1757371664,
              "author": "MarkMaynardDotcom"
            },
            {
              "id": "nd62glf",
              "body": "https://preview.redd.it/uychbit1t0of1.jpeg?width=977&format=pjpg&auto=webp&s=782b60eebd4da137bbe25d4dc1d6baa89223ff9f\n\nUnder this Supreme Court",
              "score": 141,
              "created_utc": 1757371952,
              "author": "GreatLakesBard"
            },
            {
              "id": "nd65qab",
              "body": "This is an illegitimate Supreme Court",
              "score": 131,
              "created_utc": 1757373104,
              "author": "Longjumping_Leek151"
            },
            {
              "id": "nd63gn7",
              "body": "Ah I like that explanation. It’s very simple and easy to follow. Take this god damn upvote and enlighten more people in the future!",
              "score": 62,
              "created_utc": 1757372305,
              "author": "Silver-Forever9085"
            }
          ]
        },
        {
          "id": "1nc5fmm",
          "title": "Just gonna leave this here.",
          "selftext": "",
          "score": 3153,
          "num_comments": 28,
          "created_utc": 1757379803,
          "subreddit": "democrats",
          "permalink": "/r/democrats/comments/1nc5fmm/just_gonna_leave_this_here/",
          "url": "https://i.redd.it/c1uhj9yeg1of1.png",
          "author": "Obvious-Gate9046",
          "comments": [
            {
              "id": "nd6qv0w",
              "body": "And I'm Eric!\n\n![gif](giphy|26n6VTJzRMNHLbFbW)",
              "score": 65,
              "created_utc": 1757380489,
              "author": "Debalic"
            },
            {
              "id": "nd6s4a6",
              "body": "Burn. I bet Ivanka gets card and gifts.🎁",
              "score": 65,
              "created_utc": 1757380924,
              "author": "One-Abbreviations339"
            },
            {
              "id": "nd6vnze",
              "body": "And unwanted erections",
              "score": 36,
              "created_utc": 1757382155,
              "author": "Ok-Ice2942"
            },
            {
              "id": "nd6sf0t",
              "body": "Thank you. This post gave me the (temporary) peace that I needed to go to sleep tonight.",
              "score": 24,
              "created_utc": 1757381024,
              "author": "DwHouse7516"
            }
          ]
        },
        {
          "id": "1ndpsux",
          "title": "Charlie Kirk reported dead after shooting",
          "selftext": "",
          "score": 2647,
          "num_comments": 1030,
          "created_utc": 1757537153,
          "subreddit": "democrats",
          "permalink": "/r/democrats/comments/1ndpsux/charlie_kirk_reported_dead_after_shooting/",
          "url": "https://breakingthenews.net/Article/Charlie-Kirk-reported-dead-after-shooting/64796411",
          "author": "Tenchi2020",
          "comments": [
            {
              "id": "ndin142",
              "body": "I’ll say exactly what he said to the people who died at my high school in Parkland: **thoughts and prayers**",
              "score": 1682,
              "created_utc": 1757537558,
              "author": "bassistheplace246"
            },
            {
              "id": "ndintol",
              "body": "[https://www.thedailybeast.com/charlie-kirk-wants-an-amazing-patriot-to-bail-out-paul-pelosis-alleged-assailant/](https://www.thedailybeast.com/charlie-kirk-wants-an-amazing-patriot-to-bail-out-paul-pelosis-alleged-assailant/)\n\n  \nWhen Pelosi was attacked, Kirk made jokes and conspiracy theories.",
              "score": 1281,
              "created_utc": 1757537761,
              "author": "barth_"
            },
            {
              "id": "ndilmgv",
              "body": "Trump, for some reason, just announced it.",
              "score": 886,
              "created_utc": 1757537202,
              "author": "ElectrOPurist"
            },
            {
              "id": "ndinami",
              "body": "get ready for militarized college campuses and an endless media loop on how violent the left is",
              "score": 802,
              "created_utc": 1757537626,
              "author": "Marrsvolta"
            }
          ]
        },
        {
          "id": "1nc6bjt",
          "title": "Newsom Targets Johnson in Latest Fund-Raising Post",
          "selftext": "",
          "score": 2578,
          "num_comments": 21,
          "created_utc": 1757382307,
          "subreddit": "democrats",
          "permalink": "/r/democrats/comments/1nc6bjt/newsom_targets_johnson_in_latest_fundraising_post/",
          "url": "https://i.redd.it/dnwr4u8vn1of1.jpeg",
          "author": "Afterswiftie",
          "comments": [
            {
              "id": "nd6w59z",
              "body": "WOW!!! REDDIT DOES NOT ALLOW ME TO ATTACH MORE THAN ONE ITEM TO A POST, A VERY CRITICAL AND USEFUL FEATURE! I (ALONG WITH MOST AMERICANS) BELIEVE THIS IS A VERY IMPORTANT PROBLEM WITH THE WEBSITE, AND WE WILL BE LOOKING INTO A SOLUTION VERY STRONGLY!!! UNTIL THEN, ALL PATRIOTS WHO SUPPORT THE MAGA MOVEMENT, WHICH MANY ARE NOW SAYING MEANS “MAKE AMERICA GOLDEN AGAIN” (AND I AGREE), SHOULD CLICK [HE...",
              "score": 110,
              "created_utc": 1757382328,
              "author": "Afterswiftie"
            },
            {
              "id": "nd700jy",
              "body": "Mike Johnson and his underage son viewed each others porn history. I don’t know how he got away with that. It’s insanely creepy!!",
              "score": 90,
              "created_utc": 1757383662,
              "author": "Magoo152"
            },
            {
              "id": "nd776uo",
              "body": "Sad that human rights have to be funded now",
              "score": 29,
              "created_utc": 1757386204,
              "author": "BrilliantSimple7678"
            },
            {
              "id": "nd7g6v4",
              "body": "You’re a gem",
              "score": 17,
              "created_utc": 1757389633,
              "author": "PlutoJones42"
            }
          ]
        },
        {
          "id": "1nfgl9m",
          "title": "The father of the alleged shooter turned him in",
          "selftext": "",
          "score": 2172,
          "num_comments": 85,
          "created_utc": 1757715284,
          "subreddit": "democrats",
          "permalink": "/r/democrats/comments/1nfgl9m/the_father_of_the_alleged_shooter_turned_him_in/",
          "url": "https://i.redd.it/n56mmgmv5tof1.jpeg",
          "author": "nanoatzin",
          "comments": [
            {
              "id": "ndwcuo7",
              "body": "This is the post that needs to go viral on the home page and hopefully be seen by conservatives. We need to change the narrative before they work themselves up into a foaming frenzy.\n\nWe just barely dodged a bullet with the latest Epstein distraction.",
              "score": 169,
              "created_utc": 1757716420,
              "author": "No_Raspberry_7917"
            },
            {
              "id": "ndwf5h0",
              "body": "I literally had a family member of my partner tell me that democrats are the ones trying to kill people and that republicans don't do that... his quote \"we are not the same.\" I'm fucking done with this people and will have no shame cutting them out of my life.",
              "score": 112,
              "created_utc": 1757717215,
              "author": "The0bst3r"
            },
            {
              "id": "ndwfcxz",
              "body": "I am sorry when anyone dies, especially if they seem to be taken in their prime leaving families behind. That however, is all I’m willing to say about Charlie Kirk. This continual coverage the parade, the flags at half mast. He was a podcaster, not a dignitary. If we could lower the flags for the three children who were killed, whose lives had great promise, who could’ve been anything, and we will...",
              "score": 52,
              "created_utc": 1757717287,
              "author": "Stormy31568"
            },
            {
              "id": "ndxgztz",
              "body": "They're already saying he was radicalized in college on the conservative sub. Yeah, one semester will do that to you. They'll never own up to their mistakes.",
              "score": 41,
              "created_utc": 1757731114,
              "author": "the_well_read_neck_"
            }
          ]
        },
        {
          "id": "1nf8zu7",
          "title": "Paternity test says....NOT A DEMOCRAT!!!",
          "selftext": "",
          "score": 2148,
          "num_comments": 183,
          "created_utc": 1757697269,
          "subreddit": "democrats",
          "permalink": "/r/democrats/comments/1nf8zu7/paternity_test_saysnot_a_democrat/",
          "url": "https://i.redd.it/uj447n1dorof1.png",
          "author": "jakderrida",
          "comments": [
            {
              "id": "ndurilr",
              "body": "But their cult leader is still claiming he’s a radical leftist, so the facts won’t matter.\n\nhttps://preview.redd.it/x179ti5mtrof1.jpeg?width=1290&format=pjpg&auto=webp&s=19d94d31d0364a4c311b2eefd9d9df8c36ed63c2",
              "score": 536,
              "created_utc": 1757699023,
              "author": "Gr8daze"
            },
            {
              "id": "nduo7lc",
              "body": "[deleted]",
              "score": 286,
              "created_utc": 1757698062,
              "author": "[deleted]"
            },
            {
              "id": "nduvc19",
              "body": "I cannot imagine being apathetic when it comes to voting but not when it comes to murder for politics.  Weird.",
              "score": 209,
              "created_utc": 1757700118,
              "author": "VanDenBroeck"
            },
            {
              "id": "nduxftf",
              "body": "He’s using chopsticks in the upper left photo so the right will claim he’s woke now.",
              "score": 174,
              "created_utc": 1757700730,
              "author": "RealBrush2844"
            }
          ]
        },
        {
          "id": "1ndnpfj",
          "title": "My Reddit Feed Just Now…",
          "selftext": "",
          "score": 2092,
          "num_comments": 104,
          "created_utc": 1757532134,
          "subreddit": "democrats",
          "permalink": "/r/democrats/comments/1ndnpfj/my_reddit_feed_just_now/",
          "url": "https://i.redd.it/vgb10ond1eof1.jpeg",
          "author": "Interesting_Tune2905",
          "comments": [
            {
              "id": "ndi9pwh",
              "body": "Charlie Kirk is a victim of his own making. This is the society he wanted!",
              "score": 294,
              "created_utc": 1757534074,
              "author": "SouthwesternEagle"
            },
            {
              "id": "ndiw7vk",
              "body": "Notice there is nothing in your feed about the [shooting at a Colorado high school today](https://www.denverpost.com/2025/09/10/evergreen-high-school-shooting/).  It's not being covered by the media either.",
              "score": 258,
              "created_utc": 1757539997,
              "author": "TeamHope4"
            },
            {
              "id": "ndi387i",
              "body": "Guns are good, even Charlie will tell you this if you asked him right now",
              "score": 157,
              "created_utc": 1757532319,
              "author": "Busy-Sprinkles-8243"
            },
            {
              "id": "ndip7h8",
              "body": "People are more upset about this Kirk  than they are than Sandy Hook, Parkland and all the children killed.  This Kirk guy wanted to be POTUS and helped get JD in office, with his gang of Peter Thiele, et. al.  You play with chaos and chaos reigns.  Make America Safe again, get rid of the MAGA chaos.",
              "score": 142,
              "created_utc": 1757538112,
              "author": "jal333"
            }
          ]
        }
      ]
    }
  },
  {
    "id": "mfk8tzoxik6xg1j86",
    "generated_at": "2025-09-14T22:05:04.881Z",
    "name": "r/worldnews Global Events",
    "description": "Sentiment analysis of global news discussions, international events, and world affairs commentary.",
    "subreddits": [
      "worldnews"
    ],
    "dateRange": {
      "startDate": "2025-09-07",
      "endDate": "2025-09-14"
    },
    "totalPosts": 5,
    "totalComments": 940,
    "data": {
      "summary": {
        "totalPosts": 5,
        "totalComments": 940,
        "subreddits": [
          "worldnews"
        ],
        "dateRange": {
          "startDate": "2025-09-07",
          "endDate": "2025-09-14"
        }
      },
      "analysis": {
        "overall_sentiment": {
          "average_score": 0.1,
          "sentiment_distribution": {
            "positive": 30,
            "neutral": 50,
            "negative": 20
          },
          "dominant_themes": [
            "news",
            "world",
            "events",
            "politics",
            "economy",
            "society",
            "report"
          ],
          "key_emotions": [
            "concern",
            "analytical",
            "informative",
            "serious",
            "discussion"
          ],
          "summary": "The overall sentiment is negative (negative 65%). Key themes include: criticism, politics, justice."
        },
        "individual_scores": [
          {
            "index": 1,
            "score": 0.6,
            "sentiment": "positive",
            "confidence": 0.85,
            "themes": [
              "justice",
              "accountability",
              "politics"
            ],
            "emotions": [],
            "source": {
              "type": "post_title",
              "postId": "1nemgr1",
              "subreddit": "worldnews"
            }
          },
          {
            "index": 2,
            "score": 0,
            "sentiment": "neutral",
            "confidence": 0.9,
            "themes": [
              "information",
              "paywall",
              "access"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1nemgr1",
              "commentId": "ndprz24",
              "subreddit": "worldnews"
            }
          },
          {
            "index": 3,
            "score": 0.3,
            "sentiment": "positive",
            "confidence": 0.7,
            "themes": [
              "simplicity"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1nemgr1",
              "commentId": "ndps64l",
              "subreddit": "worldnews"
            }
          },
          {
            "index": 4,
            "score": -0.5,
            "sentiment": "negative",
            "confidence": 0.8,
            "themes": [
              "criticism",
              "politics",
              "justice"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1nemgr1",
              "commentId": "ndpswuc",
              "subreddit": "worldnews"
            }
          },
          {
            "index": 5,
            "score": 0.4,
            "sentiment": "positive",
            "confidence": 0.6,
            "themes": [
              "norms",
              "institutions",
              "sarcasm"
            ],
            "emotions": [],
            "source": {
              "type": "comment",
              "postId": "1nemgr1",
              "commentId": "ndptvco",
              "subreddit": "worldnews"
            }
          }
        ],
        "by_subreddit": {
          "worldnews": {
            "scores": [
              0.6,
              0,
              0.3,
              -0.5,
              0.4,
              -0.4,
              -0.3,
              -0.6,
              -0.8,
              -0.7,
              -0.7,
              -0.6,
              -0.8,
              -0.2,
              -0.6,
              -0.5,
              -0.8,
              -0.3,
              -0.5,
              -0.6,
              -0.4,
              0.4,
              -0.3,
              0.6,
              -0.7,
              0.7,
              -0.4,
              -0.5,
              -0.3,
              0.5,
              0.3,
              -0.2,
              0.4,
              -0.4,
              -0.8,
              0.3,
              0.4,
              0.5,
              -0.7,
              0.6,
              -0.5,
              -0.4,
              -0.5,
              -0.6,
              -0.3,
              0.3,
              0.2,
              -0.8,
              -0.4,
              -0.7,
              -0.9,
              -0.8,
              -0.6,
              -0.7,
              -0.6,
              -0.5,
              -0.4,
              -0.3,
              -0.4,
              -0.5,
              -0.3,
              -0.4,
              0.6,
              0.3,
              -0.7,
              -0.2,
              0.5,
              -0.2,
              -0.3,
              -0.7,
              -0.6,
              0.8,
              -0.4,
              -0.8,
              0.3,
              0.6,
              -0.4,
              -0.2,
              -0.3,
              0.4,
              -0.5,
              0.7,
              0.8,
              -0.5,
              -0.7,
              -0.8,
              -0.3,
              -0.3,
              -0.3,
              0.4,
              -0.2,
              -0.4,
              -0.3,
              0.5,
              0.7,
              -0.5,
              -0.6,
              0.8,
              -0.4,
              0.5,
              -0.2,
              -0.8,
              -0.7,
              0.6,
              0.2,
              0.8,
              -0.2,
              -0.9,
              -0.5,
              -0.4,
              -0.3,
              0,
              -0.8,
              -0.7,
              0.2,
              0.3,
              -0.2,
              -0.3,
              -0.8,
              -0.7,
              -0.8,
              -0.4,
              -0.7,
              -0.5,
              0.4,
              -0.5,
              -0.6,
              -0.6,
              0.3,
              -0.2,
              -0.9,
              -0.5,
              -0.7,
              -0.9,
              -0.8,
              -0.4,
              0,
              0.4,
              -0.2,
              -0.3,
              -0.6,
              -0.2,
              -0.5,
              -0.6,
              0.2,
              -0.3,
              -0.5,
              -0.4,
              -0.8,
              -0.6,
              -0.3,
              -0.8,
              0.1,
              -0.6,
              -0.4,
              0.4,
              -0.5,
              -0.3,
              0.5,
              0.4,
              0.2,
              0.1,
              0,
              -0.2,
              -0.4,
              -0.5,
              -0.7,
              0.1,
              -0.4,
              -0.6,
              -0.7,
              -0.5,
              -0.4,
              -0.3,
              -0.4,
              -0.3,
              -0.2,
              0.8,
              0.2,
              -0.5,
              -0.4,
              -0.6,
              -0.5,
              -0.3,
              -0.4,
              -0.2,
              -0.8,
              -0.5,
              0.4,
              0.2,
              -0.7,
              -0.6,
              -0.8,
              -0.2,
              -0.3,
              -0.4,
              0,
              -0.5,
              0.2,
              -0.3,
              -0.3,
              0.2,
              -0.2,
              -0.3,
              0.2,
              -0.4,
              0.1,
              -0.3,
              -0.7,
              -0.4,
              -0.6,
              -0.7,
              -0.3,
              -0.6,
              -0.5,
              -0.7,
              -0.4,
              -0.6,
              -0.2,
              0.3,
              0.4,
              0.5,
              0.3,
              -0.6,
              -0.8,
              -0.3,
              -0.4,
              -0.7,
              -0.4,
              -0.5,
              -0.5,
              -0.4,
              -0.2,
              0.2,
              0.1,
              -0.3,
              0.2,
              -0.5,
              -0.4,
              -0.5,
              -0.8,
              -0.7,
              -0.6,
              -0.3,
              0.1,
              -0.8,
              -0.6,
              -0.5,
              -0.6,
              -0.7,
              -0.7,
              -0.6,
              0.2,
              -0.5,
              -0.4,
              -0.6,
              -0.4,
              -0.4,
              0.1,
              -0.7,
              -0.6,
              -0.2,
              -0.8,
              -0.7,
              -0.6,
              -0.8,
              -0.5,
              -0.4,
              -0.3,
              -0.8,
              -0.9,
              -0.7,
              -0.3,
              -0.6,
              0.3,
              -0.5,
              -0.4,
              -0.6,
              0.4,
              0.2,
              -0.4,
              -0.8,
              -0.7,
              -0.4,
              0.4,
              0.6,
              -0.5,
              -0.6,
              -0.8,
              -0.7,
              -0.5,
              -0.9,
              -0.5,
              0.4,
              0.3,
              0.3,
              0.5,
              0.2,
              0.3,
              0.1,
              0.7,
              -0.3,
              0,
              -0.4,
              -0.6,
              -0.5,
              -0.4,
              -0.7,
              0.1,
              0.6,
              0,
              -0.4,
              0.2,
              -0.3,
              -0.5,
              -0.8,
              0.3,
              0,
              -0.2,
              -0.4,
              0.8,
              0.9,
              0.7,
              0.5,
              0.4,
              -0.7,
              0,
              0.4,
              -0.4,
              -0.6,
              0.3,
              -0.5,
              -0.7,
              -0.4,
              -0.3,
              0.3,
              -0.2,
              -0.4,
              -0.2,
              -0.6,
              -0.3,
              -0.2,
              0.8,
              0.7,
              -0.3,
              0.4,
              -0.5,
              -0.1,
              -0.4,
              -0.3,
              -0.2,
              0.3,
              0.4,
              0,
              -0.1,
              -0.8,
              -0.3,
              0.2,
              0,
              -0.2,
              -0.7,
              -0.1,
              -0.8,
              -0.6,
              0.4,
              -0.2,
              -0.4,
              -0.5,
              -0.2,
              0,
              0,
              0,
              -0.1,
              0.1,
              -0.2,
              0,
              -0.3,
              -0.4,
              -0.6,
              0.5,
              -0.6,
              0,
              -0.9,
              -0.7,
              -0.4,
              -0.2,
              -0.1,
              -0.8,
              -0.5,
              -0.2,
              -0.4,
              -0.3,
              -0.6,
              -0.3,
              -0.8,
              -0.2,
              -0.3,
              -0.4,
              -0.7,
              -0.6,
              -0.2,
              0.3,
              -0.4,
              -0.2,
              -0.8,
              -0.5,
              -0.9,
              -0.9,
              0,
              -0.3,
              0.2,
              0,
              -0.4,
              -0.2,
              -0.3,
              -0.4,
              0,
              -0.3,
              -0.7,
              -0.5,
              -0.8,
              -0.6,
              -0.4,
              -0.7,
              -0.8,
              0.4,
              -0.6,
              0.2,
              -0.4,
              -0.3,
              -0.7,
              -0.8,
              -0.6,
              0.1,
              -0.6,
              -0.3,
              -0.7,
              -0.2,
              0.2,
              -0.5,
              -0.8,
              -0.4,
              0.2,
              -0.2,
              -0.1,
              -0.6,
              -0.5,
              -0.4,
              -0.5,
              -0.7,
              -0.7,
              -0.6,
              -0.4,
              -0.8,
              0.1,
              -0.5,
              0,
              -0.6,
              -0.7,
              -0.5,
              0,
              -0.7,
              -0.2,
              -0.3,
              -0.6,
              -0.7,
              0.6,
              0.7,
              -0.3,
              -0.8,
              0.4,
              -0.6,
              -0.7,
              -0.4,
              0.5,
              -0.4,
              -0.2,
              0.2,
              -0.3,
              -0.2,
              -0.1,
              0.1,
              -0.6,
              -0.4,
              -0.2,
              0,
              -0.7,
              0,
              -0.4,
              -0.2,
              -0.1,
              -0.8,
              -0.3,
              -0.6,
              -0.5,
              -0.6,
              -0.4,
              -0.2,
              -0.8,
              -0.7,
              -0.1,
              -0.3,
              -0.4,
              -0.3,
              -0.6,
              -0.5,
              -0.2,
              0.1,
              0.2,
              -0.7,
              -0.1,
              0.1,
              -0.9,
              -0.7,
              -0.4,
              -0.5,
              -0.6,
              -0.5,
              -0.6,
              -0.7,
              -0.3,
              -0.7,
              -0.2,
              -0.6,
              -0.5,
              -0.2,
              -0.3,
              0.1,
              -0.4,
              -0.3,
              -0.5,
              -0.8,
              -0.6,
              -0.7,
              -0.4,
              -0.6,
              -0.5,
              -0.2,
              0,
              -0.4,
              -0.3,
              -0.4,
              0.2,
              0,
              -0.1,
              -0.5,
              -0.3,
              -0.2,
              0,
              -0.7,
              -0.6,
              -0.3,
              -0.4,
              -0.5,
              -0.8,
              -0.2,
              -0.8,
              0,
              -0.7,
              -0.6,
              -0.5,
              -0.4,
              -0.3,
              -0.8,
              -0.4,
              0.3,
              -0.6,
              -0.2,
              -0.4,
              -0.3,
              0.2,
              -0.5,
              0.2,
              -0.3,
              -0.4,
              0.4,
              0.8,
              0.6,
              0.6,
              0.7,
              -0.2,
              0.8,
              -0.5,
              0.4,
              0.3,
              0.2,
              0.4,
              0,
              0.2,
              0.6,
              -0.4,
              -0.6,
              0.2,
              0,
              -0.3,
              0.3,
              -0.7,
              0.2,
              -0.8,
              0.4,
              -0.2,
              0,
              0,
              0.3,
              0.4,
              0.3,
              -0.6,
              -0.7,
              0.6,
              0.6,
              -0.2,
              -0.3,
              -0.4,
              -0.5,
              0.8,
              0.2,
              -0.6,
              -0.7,
              0.6,
              0.3,
              -0.7,
              -0.6,
              0.1,
              0.4,
              0.5,
              -0.4,
              -0.7,
              -0.5,
              -0.6,
              -0.3,
              -0.5,
              -0.2,
              -0.3,
              -0.8,
              0.4,
              -0.2,
              -0.7,
              -0.6,
              0,
              -0.8,
              -0.2,
              -0.4,
              -0.3,
              -0.5,
              -0.7,
              -0.3,
              -0.8,
              -0.7,
              -0.6,
              -0.4,
              0.2,
              -0.3,
              -0.7,
              0,
              -0.6,
              -0.6,
              -0.5,
              -0.3,
              -0.4,
              -0.8,
              -0.4,
              -0.3,
              -0.6,
              -0.5,
              0.1,
              -0.7,
              -0.5,
              0.2,
              -0.3,
              0,
              -0.5,
              -0.4,
              0.3,
              0.4,
              -0.7,
              -0.1,
              0.2,
              -0.3,
              -0.4,
              -0.8,
              0,
              0.2,
              -0.3,
              -0.6,
              0.1,
              0,
              -0.2,
              -0.3,
              0.2,
              -0.2,
              0,
              -0.3,
              0.1,
              0,
              0.1,
              0.2,
              0.3,
              0,
              0.4,
              0.1,
              0,
              0.2,
              0.4,
              0.2,
              0,
              -0.2,
              0,
              -0.5,
              -0.7,
              0.1,
              0.4,
              0.2,
              0,
              0.1,
              0.2,
              0.3,
              -0.3,
              -0.6,
              -0.4,
              -0.2,
              0.3,
              0,
              0.2,
              -0.4,
              -0.2,
              -0.3,
              -0.2,
              -0.4,
              0.4,
              0.2,
              -0.6,
              -0.3,
              -0.8,
              0.3,
              -0.7,
              0.4,
              -0.4,
              0.3,
              0.1,
              -0.1,
              0,
              -0.5,
              -0.4,
              -0.3,
              -0.4,
              -0.3,
              -0.4,
              -0.6,
              0.3,
              -0.2,
              0.2,
              0.4,
              0.2,
              0.3,
              0,
              0,
              0,
              0.2,
              -0.3,
              0.1,
              -0.2,
              -0.2,
              0,
              0,
              -0.4,
              0.4,
              0,
              0,
              -0.4,
              -0.1,
              0,
              -0.3,
              -0.5,
              -0.2,
              -0.1,
              0.3,
              0,
              0,
              0.6,
              0.2,
              -0.3,
              -0.2,
              -0.4,
              -0.1,
              -0.5,
              -0.3,
              -0.8,
              0,
              -0.4,
              -0.5,
              -0.2,
              0.7,
              -0.4,
              0,
              0,
              0,
              -0.6,
              -0.5,
              -0.6,
              0.3,
              -0.2,
              0,
              0,
              0,
              0,
              0,
              0.2,
              -0.3,
              -0.2,
              0,
              0,
              0,
              0.4,
              0,
              -0.1,
              0.2,
              0.3,
              0.1
            ],
            "positive": 130,
            "neutral": 159,
            "negative": 529,
            "average_score": -0.23471882640586805,
            "total_analyzed": 818
          }
        },
        "timeline": [
          {
            "date": "2025-09-10",
            "average_score": -0.07175572519083967,
            "positive": 26,
            "neutral": 53,
            "negative": 52,
            "total": 131
          },
          {
            "date": "2025-09-11",
            "average_score": -0.2657933042212518,
            "positive": 104,
            "neutral": 106,
            "negative": 477,
            "total": 687
          }
        ],
        "ai_insights": {
          "worldnews": "Based on the posts from r/worldnews, here is my analysis:\n\nOverall Community Mood and Attitudes:\nThe overall mood of the community appears to be one of cautious optimism and a sense of justice being served. There is a general feeling that accountability is finally being upheld, even for powerful political figures like Bolsonaro and Mandelson. However, there is also an undercurrent of frustration and disbelief that some leaders, like Trump, seem to have avoided consequences for their actions.\n\nCommon Themes, Concerns, and Topics of Interest:\nThe main themes that emerge are:\n1. Accountability for political corruption and undemocratic actions.\n2. Concerns about the treatment and detention of foreign nationals, particularly K-pop artists, by the US.\n3. Tensions between countries, particularly the US and its allies.\n4. The role of NATO and its mechanisms for collective defense.\n\nPatterns in Upvotes and Discussion:\nPosts that highlight instances of accountability and justice being served, such as the sentencing of Bolsonaro, tend to receive the highest upvotes and most engaged discussions. There is also significant interest in stories that touch on the mistreatment of foreign nationals by the US, as well as tensions between the US and its allies.\n\nEmerging Trends or Shifts in Opinion:\nThe community appears to be increasingly critical of the US, particularly in comparison to other countries that are seen as more effective in holding their leaders accountable. There is a sense that the US is falling behind in terms of upholding democratic norms and principles.\n\nPain Points or Frustrations:\nThe main frustrations expressed by the community include:\n1. The perceived lack of accountability for certain political leaders, especially in the US.\n2. The mistreatment and disrespect shown towards foreign nationals, particularly from the perspective of US-allied countries like South Korea.\n3. Concerns about the ability of NATO to effectively respond to emerging security threats.\n\nOverall, the analysis of these posts suggests a community that is closely following global political events and is increasingly critical of the actions and inactions of certain governments, especially the United States. The community seems to be seeking a greater sense of justice and accountability in the international arena."
        },
        "framework_analysis": {
          "success": true,
          "analysis": "**COMMUNITY PROFILING**\n\n• Community Type: News/Political Discussion\n• Demographic Indicators: Internationally-minded, politically engaged, Western-leaning\n• Emotional Baseline: Cynical/Critical\n• Community Character: r/worldnews demonstrates a strong focus on political accountability and international relations. The community shows particular engagement with stories about political justice and democratic institutions, while maintaining a notably skeptical stance toward political figures and institutions.\n\n**PATTERN DISCOVERY**\n\n🔍 Key Findings:\n\n1. Surprising Pattern #1:\n   Stories about political accountability generate exceptionally high engagement, with Bolsonaro's sentencing receiving 75k+ upvotes\n\n2. Surprising Pattern #2:\n   Strong correlation between US-critical content and high engagement rates, suggesting an audience particularly receptive to American accountability\n\n3. Surprising Pattern #3:\n   Comments expressing surprise at functional justice systems outside the US consistently receive high upvotes\n\n💬 Controversy Triggers:\n• US political/judicial system comparisons\n• NATO/military interventions\n• Epstein-related connections\n\n📊 Success/Failure Predictors:\n• Success indicators: Concise, direct commentary on accountability; comparative political analysis\n• Failure indicators: Defensive responses about US systems; overly complex explanations\n\n**TEMPORAL ANALYSIS**\n\n⏰ Time-Based Patterns:\n\nDaily Cycles:\n• Morning: More factual/news-oriented discussion\n• Afternoon: Increased commentary and analysis\n• Evening: Higher emotional engagement and opinion sharing\n\nWeekly Trends:\n• Weekday engagement focuses on political/diplomatic news\n• Peak engagement occurs during major international developments\n\nSentiment Evolution:\n• Overall negative sentiment (-0.23) with occasional positive spikes around justice-related outcomes\n\n**KEY INSIGHTS**\n\n⭐ Most Important Discoveries:\n\n1. Engagement Correlation:\n   Highest engagement occurs with stories of political accountability, especially involving former leaders\n\n2. Unspoken Rules:\n   Community strongly values democratic institutions and shows particular appreciation for functional justice systems\n\n3. Influence Patterns:\n   Top comments tend to shape subsequent discussion tone, especially regarding US comparisons\n\n4. Content Predictors:\n   Stories involving international justice or accountability consistently perform best\n\n**ACTIONABLE RECOMMENDATIONS**\n\n📝 Content Strategy:\n• Best performing content types: Political accountability stories, international justice developments\n• Optimal post structure: Clear headlines with immediate consequences\n• Language style: Direct, factual, with room for comparative analysis\n\n⏱️ Timing Strategy:\n• Best posting times: Early morning US time for maximum global engagement\n• Avoid posting: During major breaking news events\n\n🚫 Topics to Avoid:\n• Defensive positions on US systems\n• Oversimplified international relations\n\n✅ Topics that Resonate:\n• Political accountability stories\n• International cooperation/conflict resolution\n• Democratic institutional strength\n\n**QUESTIONS FOR DEEPER ANALYSIS**\n\n🤔 Compelling comparison questions:\n\n1. How does sentiment differ between US-related and non-US political accountability stories?\n2. What role does historical context play in engagement levels?\n3. How do different regional perspectives affect comment sentiment?\n4. What impact does story development timing have on engagement?\n5. How do international diplomatic tensions influence community response?\n\n**SUMMARY**\n\n📋 Executive Summary:\nThe r/worldnews community shows strong engagement with political accountability stories, particularly those involving justice for former leaders. The overall sentiment trends negative (-0.23), but with positive spikes around justice-related outcomes. The community demonstrates a clear preference for direct, factual reporting with strong comparative elements, especially regarding international democratic institutions and justice systems.",
          "generated_at": "2025-09-14T22:01:08.336Z",
          "model_used": "Claude 3.5 Sonnet"
        },
        "synthetic_post": {
          "title": "Japan announces $30B investment in semiconductor manufacturing to reduce reliance on China",
          "author": "global_wire_news",
          "body": "",
          "score": 52847,
          "upvoteRatio": 0.94,
          "comments": [
            {
              "id": "comment1",
              "author": "TechObserver",
              "body": "About time. The world needs to diversify its chip manufacturing capabilities. Taiwan's TSMC being responsible for 90% of advanced semiconductors is too risky.",
              "score": 12544,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment2",
              "author": "EconomyWatcher",
              "body": "This is huge. Japan was once the leader in semiconductor manufacturing before losing ground to Taiwan and Korea. They definitely have the technical expertise to pull this off.",
              "score": 8932,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment3",
              "author": "geopolitics_nerd",
              "body": "See, this is how you counter China's influence. Economic independence, not just angry rhetoric.",
              "score": 7655,
              "replies": [],
              "level": 0,
              "sentiment": "neutral"
            },
            {
              "id": "comment4",
              "author": "Silicon_Knight",
              "body": "Intel in US, TSMC in Taiwan, Samsung in Korea, and now Japan joining the party. The semiconductor cold war is heating up.",
              "score": 6211,
              "replies": [],
              "level": 0,
              "sentiment": "neutral"
            },
            {
              "id": "comment5",
              "author": "tokyo_resident",
              "body": "As someone living in Japan, this has been all over the news here. The government is really serious about this initiative.",
              "score": 4533,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment6",
              "author": "supply_chain_expert",
              "body": "30B is actually a modest investment compared to what TSMC and Samsung are spending. They'll need more if they want to compete at the cutting edge.",
              "score": 3422,
              "replies": [],
              "level": 0,
              "sentiment": "neutral"
            },
            {
              "id": "comment7",
              "author": "GlobalThinker",
              "body": "First rare earth minerals, now semiconductors. Countries are finally waking up to the dangers of over-reliance on single sources.",
              "score": 2877,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment8",
              "author": "CyberSecExpert",
              "body": "Remember when everyone laughed at Trump's chip sanctions? Now everyone's following suit. Even a broken clock is right twice a day I guess.",
              "score": 2344,
              "replies": [],
              "level": 0,
              "sentiment": "neutral"
            },
            {
              "id": "comment9",
              "author": "MarketAnalyst",
              "body": "Watch semiconductor stocks soar tomorrow. This sector is going to be hot for the next decade.",
              "score": 1988,
              "replies": [],
              "level": 0,
              "sentiment": "positive"
            },
            {
              "id": "comment10",
              "author": "tech_enthusiast",
              "body": "Hope they focus on legacy nodes too, not just bleeding edge. There's still massive demand for older chips in automotive and industrial applications.",
              "score": 1655,
              "replies": [],
              "level": 0,
              "sentiment": "neutral"
            }
          ],
          "subreddit": "worldnews",
          "timeAgo": "8 hours ago",
          "sentiment": "positive",
          "generated_at": "2025-09-14T22:04:23.874Z",
          "version": 1
        }
      },
      "posts": [
        {
          "id": "1nemgr1",
          "title": "Bolsonaro sentenced to 27 years in prison for plotting Brazil coup",
          "selftext": "",
          "score": 75895,
          "num_comments": 1810,
          "created_utc": 1757629438,
          "subreddit": "worldnews",
          "permalink": "/r/worldnews/comments/1nemgr1/bolsonaro_sentenced_to_27_years_in_prison_for/",
          "url": "https://www.bbc.com/news/articles/c0r0qre5xzxo",
          "author": "gundymullet7",
          "comments": [
            {
              "id": "ndps64l",
              "body": "See, it’s not hard.",
              "score": 15031,
              "created_utc": 1757629506,
              "author": "Joadsshovel"
            },
            {
              "id": "ndpt6x4",
              "body": "Accountability?! Woah what a concept!!",
              "score": 12550,
              "created_utc": 1757629859,
              "author": "AntiOriginalUsername"
            },
            {
              "id": "ndpswuc",
              "body": "Too hard for Merrick Garland. ",
              "score": 6630,
              "created_utc": 1757629763,
              "author": "Mausel_Pausel"
            },
            {
              "id": "ndpsijq",
              "body": "I wish Mr. Jair Bolsonaro a VERY LONG LIFE\n\nHere's to many, many years (hopefully at least 27) in his long future",
              "score": 5558,
              "created_utc": 1757629626,
              "author": "Califafa"
            }
          ]
        },
        {
          "id": "1ndunl1",
          "title": "Seoul says US must fix its visa system if it wants Korea’s investments",
          "selftext": "",
          "score": 48221,
          "num_comments": 1085,
          "created_utc": 1757549914,
          "subreddit": "worldnews",
          "permalink": "/r/worldnews/comments/1ndunl1/seoul_says_us_must_fix_its_visa_system_if_it/",
          "url": "https://english.hani.co.kr/arti/english_edition/e_international/1218025.html",
          "author": "naqi11",
          "comments": [
            {
              "id": "ndjtlpl",
              "body": "....I'm waiting for the moment a kpop tour is cancelled because they've detained a kpop group.\n\n\nHyundai workes won't compare to that outcry.",
              "score": 8630,
              "created_utc": 1757550516,
              "author": "KonstantinePhoenix"
            },
            {
              "id": "ndkbz04",
              "body": "Got some friends in Korea and they say this isn't going away. People are pissed, not just about this, but about all the crap that went before.",
              "score": 2900,
              "created_utc": 1757556930,
              "author": "poliranter"
            },
            {
              "id": "ndjv2bn",
              "body": "[a few years back there was a kpop group that was detained at the airport for a day because for whatever reason the border guard thought they were being trafficked as sex workers](https://www.bbc.com/news/newsbeat-35071156)",
              "score": 2754,
              "created_utc": 1757551025,
              "author": "Planfive"
            },
            {
              "id": "ndkp7he",
              "body": "Those Korean workers were humiliated and dehumanized on the global stage. From their purely national and cultural perspective, this was an inexcusable act of monumental disrespect.",
              "score": 2270,
              "created_utc": 1757561933,
              "author": "RainyDayColor"
            }
          ]
        },
        {
          "id": "1ne4s7y",
          "title": "UK fires ambassador to US Peter Mandelson over Epstein links",
          "selftext": "",
          "score": 40046,
          "num_comments": 653,
          "created_utc": 1757584981,
          "subreddit": "worldnews",
          "permalink": "/r/worldnews/comments/1ne4s7y/uk_fires_ambassador_to_us_peter_mandelson_over/",
          "url": "https://edition.cnn.com/2025/09/11/uk/peter-mandelson-uk-ambassador-fired-intl",
          "author": "BlatantConservative",
          "comments": [
            {
              "id": "ndlxj10",
              "body": "At least the UK has some balls.",
              "score": 8423,
              "created_utc": 1757585187,
              "author": "Momtothebestdaughter"
            },
            {
              "id": "ndlz5sl",
              "body": "Good!\n\nAm glad they didn't mess about with this one too much, always hated Mandelson and his with his creepy messages to Epstein while he was being investigated for soliciting sex from underage girls in 2008, he had to go.",
              "score": 2885,
              "created_utc": 1757586058,
              "author": "DarthKrataa"
            },
            {
              "id": "ndlxmu3",
              "body": "And just like that, he's been granted U.S. citizenship and made the U.S. ambassador to the U.K. by Trump.",
              "score": 2251,
              "created_utc": 1757585246,
              "author": "HighEndSlop"
            },
            {
              "id": "ndlyese",
              "body": "You'd think so, but the government are currently getting ready to welcome another epstein friend with open arms next week.",
              "score": 1379,
              "created_utc": 1757585664,
              "author": "fightfire_withfire"
            }
          ]
        },
        {
          "id": "1nehgvq",
          "title": "Brazil’s supreme court finds Bolsonaro guilty of plotting military coup",
          "selftext": "",
          "score": 34197,
          "num_comments": 771,
          "created_utc": 1757617417,
          "subreddit": "worldnews",
          "permalink": "/r/worldnews/comments/1nehgvq/brazils_supreme_court_finds_bolsonaro_guilty_of/",
          "url": "https://www.theguardian.com/world/2025/sep/11/brazil-supreme-court-bolsonaro-guilty-coup",
          "author": "Fava_g",
          "comments": [
            {
              "id": "ndopdij",
              "body": "Crazy that America just decided to let theirs slide.",
              "score": 3869,
              "created_utc": 1757617721,
              "author": "HotelPuzzleheaded654"
            },
            {
              "id": "ndor1h7",
              "body": "What's next? Trump sending SEALs to rescue his ally from Brazil prison?",
              "score": 3758,
              "created_utc": 1757618210,
              "author": "jhoceanus"
            },
            {
              "id": "ndorghs",
              "body": "In fact, he has literally threatened military intervention..",
              "score": 1600,
              "created_utc": 1757618331,
              "author": "sir_niketas"
            },
            {
              "id": "ndopsse",
              "body": "[deleted]",
              "score": 1244,
              "created_utc": 1757617846,
              "author": "[deleted]"
            }
          ]
        },
        {
          "id": "1nd9jdh",
          "title": "Poland asks to invoke Article 4 of NATO treaty after Russian drones shot down",
          "selftext": "",
          "score": 32972,
          "num_comments": 1315,
          "created_utc": 1757496609,
          "subreddit": "worldnews",
          "permalink": "/r/worldnews/comments/1nd9jdh/poland_asks_to_invoke_article_4_of_nato_treaty/",
          "url": "https://tvpworld.com/88836853/poland-asks-to-invoke-article-4-of-nato-treaty-after-russian-drones-shot-down",
          "author": "pheexio",
          "comments": [
            {
              "id": "ndfd7k8",
              "body": ">NATO Article 4 is a provision within the North Atlantic Treaty that mandates consultation among member nations when any of them believes their territorial integrity, political independence, or security is threatened. \n\nFor those, like me, wondering...",
              "score": 11994,
              "created_utc": 1757502595,
              "author": "-DethLok-"
            },
            {
              "id": "ndf3jof",
              "body": "It was always going to be Poland.",
              "score": 7757,
              "created_utc": 1757497726,
              "author": "GiantSizeManThing"
            },
            {
              "id": "ndfba3c",
              "body": "Note that Article 4 is basically just a formal call for NATO members to talk about defense. It’s been activated several times. Article 5 is the one that is actually lightning the beacons. That was only ever activated in response to 9/11.",
              "score": 4893,
              "created_utc": 1757501728,
              "author": "Barton2800"
            },
            {
              "id": "ndfmmio",
              "body": "So basically they'll have a zoom meeting.",
              "score": 4510,
              "created_utc": 1757506405,
              "author": "averagedickdude"
            }
          ]
        }
      ]
    }
  }
] as any[];
